import { markRaw as Ii, defineComponent as Ce, h as V, withDirectives as Ct, computed as b, getCurrentInstance as Ae, ref as G, onBeforeUnmount as _t, Transition as Qt, watch as me, onMounted as wt, nextTick as lt, shallowReactive as hu, vShow as Nt, inject as Me, openBlock as z, createBlock as ae, withCtx as L, createElementBlock as re, Fragment as Ve, renderList as dt, unref as o, normalizeClass as Ft, createVNode as D, createTextVNode as ve, toDisplayString as J, reactive as Rl, onUnmounted as $i, Teleport as gu, onDeactivated as zl, normalizeStyle as yu, renderSlot as Sn, createCommentVNode as ce, toRefs as ct, createSlots as vl, createElementVNode as ee, resolveDynamicComponent as eo, onBeforeUpdate as Fi, onActivated as Mn, toRaw as wl, onBeforeMount as to, onUpdated as _u, isRef as Gt, normalizeProps as lo, guardReactiveProps as no, withKeys as dl, withModifiers as nl, pushScopeId as Ai, popScopeId as Oi, useCssVars as Su, provide as Bi, KeepAlive as wu } from "vue";
import na from "vuedraggable";
import { defineStore as Dn } from "pinia";
import xu from "axios";
const De = (e) => Ii(Ce(e)), aa = (e) => Ii(e);
function We(e, t) {
  return e !== void 0 && e() || t;
}
function Li(e, t) {
  if (e !== void 0) {
    const l = e();
    if (l != null)
      return l.slice();
  }
  return t;
}
function al(e, t) {
  return e !== void 0 ? t.concat(e()) : t;
}
function ku(e, t) {
  return e === void 0 ? t : t !== void 0 ? t.concat(e()) : e();
}
function Ei(e, t, l, n, a, i) {
  t.key = n + a;
  const r = V(e, t, l);
  return a === !0 ? Ct(r, i()) : r;
}
const jt = De({
  name: "QItemSection",
  props: {
    avatar: Boolean,
    thumbnail: Boolean,
    side: Boolean,
    top: Boolean,
    noWrap: Boolean
  },
  setup(e, { slots: t }) {
    const l = b(
      () => `q-item__section column q-item__section--${e.avatar === !0 || e.side === !0 || e.thumbnail === !0 ? "side" : "main"}` + (e.top === !0 ? " q-item__section--top justify-start" : " justify-center") + (e.avatar === !0 ? " q-item__section--avatar" : "") + (e.thumbnail === !0 ? " q-item__section--thumbnail" : "") + (e.noWrap === !0 ? " q-item__section--nowrap" : "")
    );
    return () => V("div", { class: l.value }, We(t.default));
  }
}), Ya = {
  xs: 18,
  sm: 24,
  md: 32,
  lg: 38,
  xl: 46
}, on = {
  size: String
};
function rn(e, t = Ya) {
  return b(() => e.size !== void 0 ? { fontSize: e.size in t ? `${t[e.size]}px` : e.size } : null);
}
const Mo = "0 0 24 24", Do = (e) => e, Ca = (e) => `ionicons ${e}`, Pi = {
  "mdi-": (e) => `mdi ${e}`,
  "icon-": Do,
  // fontawesome equiv
  "bt-": (e) => `bt ${e}`,
  "eva-": (e) => `eva ${e}`,
  "ion-md": Ca,
  "ion-ios": Ca,
  "ion-logo": Ca,
  "iconfont ": Do,
  "ti-": (e) => `themify-icon ${e}`,
  "bi-": (e) => `bootstrap-icons ${e}`
}, Ri = {
  o_: "-outlined",
  r_: "-round",
  s_: "-sharp"
}, zi = {
  sym_o_: "-outlined",
  sym_r_: "-rounded",
  sym_s_: "-sharp"
}, Cu = new RegExp("^(" + Object.keys(Pi).join("|") + ")"), qu = new RegExp("^(" + Object.keys(Ri).join("|") + ")"), Io = new RegExp("^(" + Object.keys(zi).join("|") + ")"), Vu = /^[Mm]\s?[-+]?\.?\d/, Tu = /^img:/, Mu = /^svguse:/, Du = /^ion-/, Iu = /^(fa-(sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /, Qe = De({
  name: "QIcon",
  props: {
    ...on,
    tag: {
      type: String,
      default: "i"
    },
    name: String,
    color: String,
    left: Boolean,
    right: Boolean
  },
  setup(e, { slots: t }) {
    const { proxy: { $q: l } } = Ae(), n = rn(e), a = b(
      () => "q-icon" + (e.left === !0 ? " on-left" : "") + (e.right === !0 ? " on-right" : "") + (e.color !== void 0 ? ` text-${e.color}` : "")
    ), i = b(() => {
      let r, s = e.name;
      if (s === "none" || !s)
        return { none: !0 };
      if (l.iconMapFn !== null) {
        const u = l.iconMapFn(s);
        if (u !== void 0)
          if (u.icon !== void 0) {
            if (s = u.icon, s === "none" || !s)
              return { none: !0 };
          } else
            return {
              cls: u.cls,
              content: u.content !== void 0 ? u.content : " "
            };
      }
      if (Vu.test(s) === !0) {
        const [u, m = Mo] = s.split("|");
        return {
          svg: !0,
          viewBox: m,
          nodes: u.split("&&").map((p) => {
            const [f, _, v] = p.split("@@");
            return V("path", { style: _, d: f, transform: v });
          })
        };
      }
      if (Tu.test(s) === !0)
        return {
          img: !0,
          src: s.substring(4)
        };
      if (Mu.test(s) === !0) {
        const [u, m = Mo] = s.split("|");
        return {
          svguse: !0,
          src: u.substring(7),
          viewBox: m
        };
      }
      let d = " ";
      const c = s.match(Cu);
      if (c !== null)
        r = Pi[c[1]](s);
      else if (Iu.test(s) === !0)
        r = s;
      else if (Du.test(s) === !0)
        r = `ionicons ion-${l.platform.is.ios === !0 ? "ios" : "md"}${s.substring(3)}`;
      else if (Io.test(s) === !0) {
        r = "notranslate material-symbols";
        const u = s.match(Io);
        u !== null && (s = s.substring(6), r += zi[u[1]]), d = s;
      } else {
        r = "notranslate material-icons";
        const u = s.match(qu);
        u !== null && (s = s.substring(2), r += Ri[u[1]]), d = s;
      }
      return {
        cls: r,
        content: d
      };
    });
    return () => {
      const r = {
        class: a.value,
        style: n.value,
        "aria-hidden": "true",
        role: "presentation"
      };
      return i.value.none === !0 ? V(e.tag, r, We(t.default)) : i.value.img === !0 ? V("span", r, al(t.default, [
        V("img", { src: i.value.src })
      ])) : i.value.svg === !0 ? V("span", r, al(t.default, [
        V("svg", {
          viewBox: i.value.viewBox || "0 0 24 24"
        }, i.value.nodes)
      ])) : i.value.svguse === !0 ? V("span", r, al(t.default, [
        V("svg", {
          viewBox: i.value.viewBox
        }, [
          V("use", { "xlink:href": i.value.src })
        ])
      ])) : (i.value.cls !== void 0 && (r.class += " " + i.value.cls), V(e.tag, r, al(t.default, [
        i.value.content
      ])));
    };
  }
}), Tt = {
  dark: {
    type: Boolean,
    default: null
  }
};
function Mt(e, t) {
  return b(() => e.dark === null ? t.dark.isActive : e.dark);
}
function jn(e) {
  if (Object(e.$parent) === e.$parent)
    return e.$parent;
  let { parent: t } = e.$;
  for (; Object(t) === t; ) {
    if (Object(t.proxy) === t.proxy)
      return t.proxy;
    t = t.parent;
  }
}
function Ui(e, t) {
  typeof t.type == "symbol" ? Array.isArray(t.children) === !0 && t.children.forEach((l) => {
    Ui(e, l);
  }) : e.add(t);
}
function $u(e) {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((l) => {
    Ui(t, l);
  }), Array.from(t);
}
function ao(e) {
  return e.appContext.config.globalProperties.$router !== void 0;
}
function oa(e) {
  return e.isUnmounted === !0 || e.isDeactivated === !0;
}
function $o(e) {
  return e ? e.aliasOf ? e.aliasOf.path : e.path : "";
}
function Fo(e, t) {
  return (e.aliasOf || e) === (t.aliasOf || t);
}
function Fu(e, t) {
  for (const l in t) {
    const n = t[l], a = e[l];
    if (typeof n == "string") {
      if (n !== a)
        return !1;
    } else if (Array.isArray(a) === !1 || a.length !== n.length || n.some((i, r) => i !== a[r]))
      return !1;
  }
  return !0;
}
function Ao(e, t) {
  return Array.isArray(t) === !0 ? e.length === t.length && e.every((l, n) => l === t[n]) : e.length === 1 && e[0] === t;
}
function Au(e, t) {
  return Array.isArray(e) === !0 ? Ao(e, t) : Array.isArray(t) === !0 ? Ao(t, e) : e === t;
}
function Ou(e, t) {
  if (Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const l in e)
    if (Au(e[l], t[l]) === !1)
      return !1;
  return !0;
}
const ia = {
  // router-link
  to: [String, Object],
  replace: Boolean,
  exact: Boolean,
  activeClass: {
    type: String,
    default: "q-router-link--active"
  },
  exactActiveClass: {
    type: String,
    default: "q-router-link--exact-active"
  },
  // regular <a> link
  href: String,
  target: String,
  // state
  disable: Boolean
};
function Hi({ fallbackTag: e, useDisableForRouterLinkProps: t = !0 } = {}) {
  const l = Ae(), { props: n, proxy: a, emit: i } = l, r = ao(l), s = b(() => n.disable !== !0 && n.href !== void 0), d = t === !0 ? b(
    () => r === !0 && n.disable !== !0 && s.value !== !0 && n.to !== void 0 && n.to !== null && n.to !== ""
  ) : b(
    () => r === !0 && s.value !== !0 && n.to !== void 0 && n.to !== null && n.to !== ""
  ), c = b(() => d.value === !0 ? w(n.to) : null), u = b(() => c.value !== null), m = b(() => s.value === !0 || u.value === !0), p = b(() => n.type === "a" || m.value === !0 ? "a" : n.tag || e || "div"), f = b(() => s.value === !0 ? {
    href: n.href,
    target: n.target
  } : u.value === !0 ? {
    href: c.value.href,
    target: n.target
  } : {}), _ = b(() => {
    if (u.value === !1)
      return -1;
    const { matched: C } = c.value, { length: T } = C, I = C[T - 1];
    if (I === void 0)
      return -1;
    const E = a.$route.matched;
    if (E.length === 0)
      return -1;
    const A = E.findIndex(
      Fo.bind(null, I)
    );
    if (A > -1)
      return A;
    const O = $o(C[T - 2]);
    return (
      // we are dealing with nested routes
      T > 1 && $o(I) === O && E[E.length - 1].path !== O ? E.findIndex(
        Fo.bind(null, C[T - 2])
      ) : A
    );
  }), v = b(
    () => u.value === !0 && _.value !== -1 && Fu(a.$route.params, c.value.params)
  ), y = b(
    () => v.value === !0 && _.value === a.$route.matched.length - 1 && Ou(a.$route.params, c.value.params)
  ), M = b(() => u.value === !0 ? y.value === !0 ? ` ${n.exactActiveClass} ${n.activeClass}` : n.exact === !0 ? "" : v.value === !0 ? ` ${n.activeClass}` : "" : "");
  function w(C) {
    try {
      return a.$router.resolve(C);
    } catch {
    }
    return null;
  }
  function S(C, { returnRouterError: T, to: I = n.to, replace: E = n.replace } = {}) {
    if (n.disable === !0)
      return C.preventDefault(), Promise.resolve(!1);
    if (
      // don't redirect with control keys;
      // should match RouterLink from Vue Router
      C.metaKey || C.altKey || C.ctrlKey || C.shiftKey || C.button !== void 0 && C.button !== 0 || n.target === "_blank"
    )
      return Promise.resolve(!1);
    C.preventDefault();
    const A = a.$router[E === !0 ? "replace" : "push"](I);
    return T === !0 ? A : A.then(() => {
    }).catch(() => {
    });
  }
  function h(C) {
    if (u.value === !0) {
      const T = (I) => S(C, I);
      i("click", C, T), C.defaultPrevented !== !0 && T();
    } else
      i("click", C);
  }
  return {
    hasRouterLink: u,
    hasHrefLink: s,
    hasLink: m,
    linkTag: p,
    resolvedLink: c,
    linkIsActive: v,
    linkIsExactActive: y,
    linkClass: M,
    linkAttrs: f,
    getLink: w,
    navigateToRouterLink: S,
    navigateOnClick: h
  };
}
const $t = {
  hasPassive: !1,
  passiveCapture: !0,
  notPassiveCapture: !0
};
try {
  const e = Object.defineProperty({}, "passive", {
    get() {
      Object.assign($t, {
        hasPassive: !0,
        passive: { passive: !0 },
        notPassive: { passive: !1 },
        passiveCapture: { passive: !0, capture: !0 },
        notPassiveCapture: { passive: !1, capture: !0 }
      });
    }
  });
  window.addEventListener("qtest", null, e), window.removeEventListener("qtest", null, e);
} catch {
}
function In() {
}
function Yi(e) {
  return e.button === 0;
}
function Cl(e) {
  return e.touches && e.touches[0] ? e = e.touches[0] : e.changedTouches && e.changedTouches[0] ? e = e.changedTouches[0] : e.targetTouches && e.targetTouches[0] && (e = e.targetTouches[0]), {
    top: e.clientY,
    left: e.clientX
  };
}
function Bu(e) {
  if (e.path)
    return e.path;
  if (e.composedPath)
    return e.composedPath();
  const t = [];
  let l = e.target;
  for (; l; ) {
    if (t.push(l), l.tagName === "HTML")
      return t.push(document), t.push(window), t;
    l = l.parentElement;
  }
}
function Pt(e) {
  e.stopPropagation();
}
function Ot(e) {
  e.cancelable !== !1 && e.preventDefault();
}
function Ze(e) {
  e.cancelable !== !1 && e.preventDefault(), e.stopPropagation();
}
function Gl(e, t) {
  if (e === void 0 || t === !0 && e.__dragPrevented === !0)
    return;
  const l = t === !0 ? (n) => {
    n.__dragPrevented = !0, n.addEventListener("dragstart", Ot, $t.notPassiveCapture);
  } : (n) => {
    delete n.__dragPrevented, n.removeEventListener("dragstart", Ot, $t.notPassiveCapture);
  };
  e.querySelectorAll("a, img").forEach(l);
}
function Jt(e, t, l) {
  const n = `__q_${t}_evt`;
  e[n] = e[n] !== void 0 ? e[n].concat(l) : l, l.forEach((a) => {
    a[0].addEventListener(a[1], e[a[2]], $t[a[3]]);
  });
}
function fl(e, t) {
  const l = `__q_${t}_evt`;
  e[l] !== void 0 && (e[l].forEach((n) => {
    n[0].removeEventListener(n[1], e[n[2]], $t[n[3]]);
  }), e[l] = void 0);
}
function un(e) {
  return e !== Object(e) || e.isComposing === !0 || e.qKeyEvent === !0;
}
function gl(e, t) {
  return un(e) === !0 ? !1 : [].concat(t).includes(e.keyCode);
}
const Tl = De({
  name: "QItem",
  props: {
    ...Tt,
    ...ia,
    tag: {
      type: String,
      default: "div"
    },
    active: {
      type: Boolean,
      default: null
    },
    clickable: Boolean,
    dense: Boolean,
    insetLevel: Number,
    tabindex: [String, Number],
    focused: Boolean,
    manualFocus: Boolean
  },
  emits: ["click", "keyup"],
  setup(e, { slots: t, emit: l }) {
    const { proxy: { $q: n } } = Ae(), a = Mt(e, n), { hasLink: i, linkAttrs: r, linkClass: s, linkTag: d, navigateOnClick: c } = Hi(), u = G(null), m = G(null), p = b(
      () => e.clickable === !0 || i.value === !0 || e.tag === "label"
    ), f = b(
      () => e.disable !== !0 && p.value === !0
    ), _ = b(
      () => "q-item q-item-type row no-wrap" + (e.dense === !0 ? " q-item--dense" : "") + (a.value === !0 ? " q-item--dark" : "") + (i.value === !0 && e.active === null ? s.value : e.active === !0 ? ` q-item--active${e.activeClass !== void 0 ? ` ${e.activeClass}` : ""}` : "") + (e.disable === !0 ? " disabled" : "") + (f.value === !0 ? " q-item--clickable q-link cursor-pointer " + (e.manualFocus === !0 ? "q-manual-focusable" : "q-focusable q-hoverable") + (e.focused === !0 ? " q-manual-focusable--focused" : "") : "")
    ), v = b(() => e.insetLevel === void 0 ? null : {
      ["padding" + (n.lang.rtl === !0 ? "Right" : "Left")]: 16 + e.insetLevel * 56 + "px"
    });
    function y(S) {
      f.value === !0 && (m.value !== null && (S.qKeyEvent !== !0 && document.activeElement === u.value ? m.value.focus() : document.activeElement === m.value && u.value.focus()), c(S));
    }
    function M(S) {
      if (f.value === !0 && gl(S, 13) === !0) {
        Ze(S), S.qKeyEvent = !0;
        const h = new MouseEvent("click", S);
        h.qKeyEvent = !0, u.value.dispatchEvent(h);
      }
      l("keyup", S);
    }
    function w() {
      const S = Li(t.default, []);
      return f.value === !0 && S.unshift(
        V("div", { class: "q-focus-helper", tabindex: -1, ref: m })
      ), S;
    }
    return () => {
      const S = {
        ref: u,
        class: _.value,
        style: v.value,
        role: "listitem",
        onClick: y,
        onKeyup: M
      };
      return f.value === !0 ? (S.tabindex = e.tabindex || "0", Object.assign(S, r.value)) : p.value === !0 && (S["aria-disabled"] = "true"), V(
        d.value,
        S,
        w()
      );
    };
  }
}), Wn = De({
  name: "QList",
  props: {
    ...Tt,
    bordered: Boolean,
    dense: Boolean,
    separator: Boolean,
    padding: Boolean,
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(e, { slots: t }) {
    const l = Ae(), n = Mt(e, l.proxy.$q), a = b(
      () => "q-list" + (e.bordered === !0 ? " q-list--bordered" : "") + (e.dense === !0 ? " q-list--dense" : "") + (e.separator === !0 ? " q-list--separator" : "") + (n.value === !0 ? " q-list--dark" : "") + (e.padding === !0 ? " q-list--padding" : "")
    );
    return () => V(e.tag, { class: a.value }, We(t.default));
  }
}), ql = De({
  name: "QItemLabel",
  props: {
    overline: Boolean,
    caption: Boolean,
    header: Boolean,
    lines: [Number, String]
  },
  setup(e, { slots: t }) {
    const l = b(() => parseInt(e.lines, 10)), n = b(
      () => "q-item__label" + (e.overline === !0 ? " q-item__label--overline text-overline" : "") + (e.caption === !0 ? " q-item__label--caption text-caption" : "") + (e.header === !0 ? " q-item__label--header" : "") + (l.value === 1 ? " ellipsis" : "")
    ), a = b(() => e.lines !== void 0 && l.value > 1 ? {
      overflow: "hidden",
      display: "-webkit-box",
      "-webkit-box-orient": "vertical",
      "-webkit-line-clamp": l.value
    } : null);
    return () => V("div", {
      style: a.value,
      class: n.value
    }, We(t.default));
  }
}), Lu = De({
  name: "QSlideTransition",
  props: {
    appear: Boolean,
    duration: {
      type: Number,
      default: 300
    }
  },
  emits: ["show", "hide"],
  setup(e, { slots: t, emit: l }) {
    let n = !1, a, i, r = null, s = null, d, c;
    function u() {
      a && a(), a = null, n = !1, r !== null && (clearTimeout(r), r = null), s !== null && (clearTimeout(s), s = null), i !== void 0 && i.removeEventListener("transitionend", d), d = null;
    }
    function m(v, y, M) {
      y !== void 0 && (v.style.height = `${y}px`), v.style.transition = `height ${e.duration}ms cubic-bezier(.25, .8, .50, 1)`, n = !0, a = M;
    }
    function p(v, y) {
      v.style.overflowY = null, v.style.height = null, v.style.transition = null, u(), y !== c && l(y);
    }
    function f(v, y) {
      let M = 0;
      i = v, n === !0 ? (u(), M = v.offsetHeight === v.scrollHeight ? 0 : void 0) : (c = "hide", v.style.overflowY = "hidden"), m(v, M, y), r = setTimeout(() => {
        r = null, v.style.height = `${v.scrollHeight}px`, d = (w) => {
          s = null, (Object(w) !== w || w.target === v) && p(v, "show");
        }, v.addEventListener("transitionend", d), s = setTimeout(d, e.duration * 1.1);
      }, 100);
    }
    function _(v, y) {
      let M;
      i = v, n === !0 ? u() : (c = "show", v.style.overflowY = "hidden", M = v.scrollHeight), m(v, M, y), r = setTimeout(() => {
        r = null, v.style.height = 0, d = (w) => {
          s = null, (Object(w) !== w || w.target === v) && p(v, "hide");
        }, v.addEventListener("transitionend", d), s = setTimeout(d, e.duration * 1.1);
      }, 100);
    }
    return _t(() => {
      n === !0 && u();
    }), () => V(Qt, {
      css: !1,
      appear: e.appear,
      onEnter: f,
      onLeave: _
    }, t.default);
  }
}), Eu = {
  true: "inset",
  item: "item-inset",
  "item-thumbnail": "item-thumbnail-inset"
}, qa = {
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 24
}, ln = De({
  name: "QSeparator",
  props: {
    ...Tt,
    spaced: [Boolean, String],
    inset: [Boolean, String],
    vertical: Boolean,
    color: String,
    size: String
  },
  setup(e) {
    const t = Ae(), l = Mt(e, t.proxy.$q), n = b(() => e.vertical === !0 ? "vertical" : "horizontal"), a = b(() => ` q-separator--${n.value}`), i = b(() => e.inset !== !1 ? `${a.value}-${Eu[e.inset]}` : ""), r = b(
      () => `q-separator${a.value}${i.value}` + (e.color !== void 0 ? ` bg-${e.color}` : "") + (l.value === !0 ? " q-separator--dark" : "")
    ), s = b(() => {
      const d = {};
      if (e.size !== void 0 && (d[e.vertical === !0 ? "width" : "height"] = e.size), e.spaced !== !1) {
        const c = e.spaced === !0 ? `${qa.md}px` : e.spaced in qa ? `${qa[e.spaced]}px` : e.spaced, u = e.vertical === !0 ? ["Left", "Right"] : ["Top", "Bottom"];
        d[`margin${u[0]}`] = d[`margin${u[1]}`] = c;
      }
      return d;
    });
    return () => V("hr", {
      class: r.value,
      style: s.value,
      "aria-orientation": n.value
    });
  }
}), ra = {
  modelValue: {
    type: Boolean,
    default: null
  },
  "onUpdate:modelValue": [Function, Array]
}, ua = [
  "beforeShow",
  "show",
  "beforeHide",
  "hide"
];
function sa({
  showing: e,
  canShow: t,
  // optional
  hideOnRouteChange: l,
  // optional
  handleShow: n,
  // optional
  handleHide: a,
  // optional
  processOnMount: i
  // optional
}) {
  const r = Ae(), { props: s, emit: d, proxy: c } = r;
  let u;
  function m(w) {
    e.value === !0 ? _(w) : p(w);
  }
  function p(w) {
    if (s.disable === !0 || w !== void 0 && w.qAnchorHandled === !0 || t !== void 0 && t(w) !== !0)
      return;
    const S = s["onUpdate:modelValue"] !== void 0;
    S === !0 && (d("update:modelValue", !0), u = w, lt(() => {
      u === w && (u = void 0);
    })), (s.modelValue === null || S === !1) && f(w);
  }
  function f(w) {
    e.value !== !0 && (e.value = !0, d("beforeShow", w), n !== void 0 ? n(w) : d("show", w));
  }
  function _(w) {
    if (s.disable === !0)
      return;
    const S = s["onUpdate:modelValue"] !== void 0;
    S === !0 && (d("update:modelValue", !1), u = w, lt(() => {
      u === w && (u = void 0);
    })), (s.modelValue === null || S === !1) && v(w);
  }
  function v(w) {
    e.value !== !1 && (e.value = !1, d("beforeHide", w), a !== void 0 ? a(w) : d("hide", w));
  }
  function y(w) {
    s.disable === !0 && w === !0 ? s["onUpdate:modelValue"] !== void 0 && d("update:modelValue", !1) : w === !0 !== e.value && (w === !0 ? f : v)(u);
  }
  me(() => s.modelValue, y), l !== void 0 && ao(r) === !0 && me(() => c.$route.fullPath, () => {
    l.value === !0 && e.value === !0 && _();
  }), i === !0 && wt(() => {
    y(s.modelValue);
  });
  const M = { show: p, hide: _, toggle: m };
  return Object.assign(c, M), M;
}
let Va, Bn = 0;
const Et = new Array(256);
for (let e = 0; e < 256; e++)
  Et[e] = (e + 256).toString(16).substring(1);
const Pu = (() => {
  const e = typeof crypto < "u" ? crypto : typeof window < "u" ? window.crypto || window.msCrypto : void 0;
  if (e !== void 0) {
    if (e.randomBytes !== void 0)
      return e.randomBytes;
    if (e.getRandomValues !== void 0)
      return (t) => {
        const l = new Uint8Array(t);
        return e.getRandomValues(l), l;
      };
  }
  return (t) => {
    const l = [];
    for (let n = t; n > 0; n--)
      l.push(Math.floor(Math.random() * 256));
    return l;
  };
})(), Oo = 4096;
function wn() {
  (Va === void 0 || Bn + 16 > Oo) && (Bn = 0, Va = Pu(Oo));
  const e = Array.prototype.slice.call(Va, Bn, Bn += 16);
  return e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, Et[e[0]] + Et[e[1]] + Et[e[2]] + Et[e[3]] + "-" + Et[e[4]] + Et[e[5]] + "-" + Et[e[6]] + Et[e[7]] + "-" + Et[e[8]] + Et[e[9]] + "-" + Et[e[10]] + Et[e[11]] + Et[e[12]] + Et[e[13]] + Et[e[14]] + Et[e[15]];
}
const Il = hu({}), Ru = Object.keys(ia), oo = De({
  name: "QExpansionItem",
  props: {
    ...ia,
    ...ra,
    ...Tt,
    icon: String,
    label: String,
    labelLines: [Number, String],
    caption: String,
    captionLines: [Number, String],
    dense: Boolean,
    toggleAriaLabel: String,
    expandIcon: String,
    expandedIcon: String,
    expandIconClass: [Array, String, Object],
    duration: Number,
    headerInsetLevel: Number,
    contentInsetLevel: Number,
    expandSeparator: Boolean,
    defaultOpened: Boolean,
    hideExpandIcon: Boolean,
    expandIconToggle: Boolean,
    switchToggleSide: Boolean,
    denseToggle: Boolean,
    group: String,
    popup: Boolean,
    headerStyle: [Array, String, Object],
    headerClass: [Array, String, Object]
  },
  emits: [
    ...ua,
    "click",
    "afterShow",
    "afterHide"
  ],
  setup(e, { slots: t, emit: l }) {
    const { proxy: { $q: n } } = Ae(), a = Mt(e, n), i = G(
      e.modelValue !== null ? e.modelValue : e.defaultOpened
    ), r = G(null), s = wn(), { show: d, hide: c, toggle: u } = sa({ showing: i });
    let m, p;
    const f = b(
      () => `q-expansion-item q-item-type q-expansion-item--${i.value === !0 ? "expanded" : "collapsed"} q-expansion-item--${e.popup === !0 ? "popup" : "standard"}`
    ), _ = b(() => e.contentInsetLevel === void 0 ? null : {
      ["padding" + (n.lang.rtl === !0 ? "Right" : "Left")]: e.contentInsetLevel * 56 + "px"
    }), v = b(
      () => e.disable !== !0 && (e.href !== void 0 || e.to !== void 0 && e.to !== null && e.to !== "")
    ), y = b(() => {
      const q = {};
      return Ru.forEach((Y) => {
        q[Y] = e[Y];
      }), q;
    }), M = b(
      () => v.value === !0 || e.expandIconToggle !== !0
    ), w = b(() => e.expandedIcon !== void 0 && i.value === !0 ? e.expandedIcon : e.expandIcon || n.iconSet.expansionItem[e.denseToggle === !0 ? "denseIcon" : "icon"]), S = b(
      () => e.disable !== !0 && (v.value === !0 || e.expandIconToggle === !0)
    ), h = b(() => ({
      expanded: i.value === !0,
      detailsId: e.targetUid,
      toggle: u,
      show: d,
      hide: c
    })), C = b(() => {
      const q = e.toggleAriaLabel !== void 0 ? e.toggleAriaLabel : n.lang.label[i.value === !0 ? "collapse" : "expand"](e.label);
      return {
        role: "button",
        "aria-expanded": i.value === !0 ? "true" : "false",
        "aria-controls": s,
        "aria-label": q
      };
    });
    me(() => e.group, (q) => {
      p !== void 0 && p(), q !== void 0 && P();
    });
    function T(q) {
      v.value !== !0 && u(q), l("click", q);
    }
    function I(q) {
      q.keyCode === 13 && E(q, !0);
    }
    function E(q, Y) {
      Y !== !0 && r.value !== null && r.value.focus(), u(q), Ze(q);
    }
    function A() {
      l("afterShow");
    }
    function O() {
      l("afterHide");
    }
    function P() {
      m === void 0 && (m = wn()), i.value === !0 && (Il[e.group] = m);
      const q = me(i, (K) => {
        K === !0 ? Il[e.group] = m : Il[e.group] === m && delete Il[e.group];
      }), Y = me(
        () => Il[e.group],
        (K, Q) => {
          Q === m && K !== void 0 && K !== m && c();
        }
      );
      p = () => {
        q(), Y(), Il[e.group] === m && delete Il[e.group], p = void 0;
      };
    }
    function $() {
      const q = {
        class: [
          `q-focusable relative-position cursor-pointer${e.denseToggle === !0 && e.switchToggleSide === !0 ? " items-end" : ""}`,
          e.expandIconClass
        ],
        side: e.switchToggleSide !== !0,
        avatar: e.switchToggleSide
      }, Y = [
        V(Qe, {
          class: "q-expansion-item__toggle-icon" + (e.expandedIcon === void 0 && i.value === !0 ? " q-expansion-item__toggle-icon--rotated" : ""),
          name: w.value
        })
      ];
      return S.value === !0 && (Object.assign(q, {
        tabindex: 0,
        ...C.value,
        onClick: E,
        onKeyup: I
      }), Y.unshift(
        V("div", {
          ref: r,
          class: "q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded",
          tabindex: -1
        })
      )), V(jt, q, () => Y);
    }
    function k() {
      let q;
      return t.header !== void 0 ? q = [].concat(t.header(h.value)) : (q = [
        V(jt, () => [
          V(ql, { lines: e.labelLines }, () => e.label || ""),
          e.caption ? V(ql, { lines: e.captionLines, caption: !0 }, () => e.caption) : null
        ])
      ], e.icon && q[e.switchToggleSide === !0 ? "push" : "unshift"](
        V(jt, {
          side: e.switchToggleSide === !0,
          avatar: e.switchToggleSide !== !0
        }, () => V(Qe, { name: e.icon }))
      )), e.disable !== !0 && e.hideExpandIcon !== !0 && q[e.switchToggleSide === !0 ? "unshift" : "push"](
        $()
      ), q;
    }
    function g() {
      const q = {
        ref: "item",
        style: e.headerStyle,
        class: e.headerClass,
        dark: a.value,
        disable: e.disable,
        dense: e.dense,
        insetLevel: e.headerInsetLevel
      };
      return M.value === !0 && (q.clickable = !0, q.onClick = T, Object.assign(
        q,
        v.value === !0 ? y.value : C.value
      )), V(Tl, q, k);
    }
    function x() {
      return Ct(
        V("div", {
          key: "e-content",
          class: "q-expansion-item__content relative-position",
          style: _.value,
          id: s
        }, We(t.default)),
        [[
          Nt,
          i.value
        ]]
      );
    }
    function B() {
      const q = [
        g(),
        V(Lu, {
          duration: e.duration,
          onShow: A,
          onHide: O
        }, x)
      ];
      return e.expandSeparator === !0 && q.push(
        V(ln, {
          class: "q-expansion-item__border q-expansion-item__border--top absolute-top",
          dark: a.value
        }),
        V(ln, {
          class: "q-expansion-item__border q-expansion-item__border--bottom absolute-bottom",
          dark: a.value
        })
      ), q;
    }
    return e.group !== void 0 && P(), _t(() => {
      p !== void 0 && p();
    }), () => V("div", { class: f.value }, [
      V("div", { class: "q-expansion-item__container relative-position" }, B())
    ]);
  }
}), Le = {
  api: {
    name: "API",
    component: "ApiTab"
  },
  conditional: {
    name: "Conditional",
    component: "ConditionalTab"
  },
  data: {
    name: "Data",
    component: "DataTab"
  },
  display: {
    name: "Display",
    component: "DisplayTab"
  },
  internationalization: {
    name: "Internationalization",
    component: "InternationalizationTab"
  },
  validation: {
    name: "Validation",
    component: "ValidationTab"
  }
}, sn = Dn("UsfBuilderControls", {
  actions: {
    addCustomControl(e, t) {
      e in this.controls || (this.controls[e] = t), this.controlsGroups.customs.controls.includes(e) || this.controlsGroups.customs.controls.push(e);
    }
  },
  getters: {
    controlsGroupWithControls(e) {
      return Object.values(e.controlsGroups).map((t) => ({
        ...t,
        controls: t.controls.map((l) => e.controls[l]).filter((l) => !l.notInControlList)
      })).filter((t) => t.controls.length > 0);
    }
  },
  state: () => ({
    admin: !1,
    controls: {
      UsfRow: {
        id: "UsfRow",
        name: "Row",
        localeName: "row",
        icon: "mdi-table-row",
        nested: ["UsfCol"],
        usfType: "layout",
        usfSubtypes: ["grid", "repeatable"],
        categoryColor: "deep-purple lighten-3",
        settingsModalTabs: [
          Le.api,
          Le.display,
          Le.conditional,
          Le.internationalization
        ],
        toAdd: {
          component: "UsfRow",
          fields: [],
          type: "row"
        },
        hasInternationalization: !1
      },
      UsfCol: {
        id: "UsfCol",
        name: "Column",
        localeName: "column",
        icon: "mdi-table-column",
        usfType: "layout",
        usfSubtypes: [],
        toAdd: {
          component: "UsfCol",
          fields: [],
          width: "12"
        },
        hasInternationalization: !1
      },
      UsfAccordion: {
        id: "UsfAccordion",
        name: "Panel",
        localeName: "panel",
        icon: "mdi-table-column",
        nested: ["UsfPanel"],
        usfType: "layout",
        usfSubtypes: ["accordion"],
        settingsModalTabs: [
          Le.api,
          Le.display,
          Le.internationalization
        ],
        toAdd: {
          component: "UsfAccordion",
          fields: []
        },
        hasInternationalization: !1
      },
      UsfPanel: {
        id: "UsfPanel",
        name: "Panel",
        localeName: "panel",
        icon: "mdi-table-column",
        usfType: "layout",
        usfSubtypes: [],
        settingsModalTabs: [],
        toAdd: {
          component: "UsfPanel",
          content: "Title new panel",
          fields: []
        },
        hasInternationalization: !1
      },
      UsfContent: {
        id: "UsfContent",
        name: "Content",
        localeName: "content",
        icon: "mdi-comment-text",
        usfType: "layout",
        usfSubtypes: ["editable"],
        categoryColor: "deep-purple lighten-3",
        settingsModalTabs: [
          Le.api,
          Le.data,
          Le.conditional
        ],
        toAdd: {
          component: "UsfContent",
          content: ""
        },
        hasInternationalization: !0
      },
      UsfText: {
        id: "UsfText",
        name: "Text",
        localeName: "text",
        icon: "mdi-text-short",
        types: [
          {
            label: "text",
            value: "text"
          },
          {
            label: "number",
            value: "number"
          },
          {
            label: "url",
            value: "url"
          },
          {
            label: "email",
            value: "email"
          },
          {
            label: "password",
            value: "password"
          },
          {
            label: "tel",
            value: "tel"
          }
        ],
        usfType: "input",
        usfSubtypes: ["text", "boxInput", "type", "defaultValue", "defaultTokenValue", "repeatable"],
        categoryColor: "blue-grey lighten-3",
        settingsModalTabs: [
          Le.api,
          Le.display,
          Le.validation,
          Le.conditional,
          Le.internationalization
        ],
        toAdd: {
          component: "UsfText",
          type: "text"
        },
        hasInternationalization: !0
      },
      UsfTextArea: {
        id: "UsfTextArea",
        name: "Text area",
        localeName: "textArea",
        icon: "mdi-text-long",
        types: [
          {
            label: "textarea",
            value: "textarea"
          },
          {
            label: "wysiwyg",
            value: "wysiwyg"
          }
        ],
        usfType: "input",
        usfSubtypes: ["text", "boxInput", "type", "repeatable"],
        categoryColor: "blue-grey lighten-3",
        settingsModalTabs: [
          Le.api,
          Le.display,
          Le.validation,
          Le.conditional,
          Le.internationalization
        ],
        toAdd: {
          component: "UsfTextArea",
          type: "textarea"
        },
        hasInternationalization: !0
      },
      UsfSelect: {
        id: "UsfSelect",
        name: "Select",
        localeName: "select",
        icon: "mdi-filter-variant",
        usfType: "input",
        usfSubtypes: ["boxInput", "selectable", "withOptions", "selectElement", "repeatable"],
        categoryColor: "blue-grey lighten-3",
        settingsModalTabs: [
          Le.api,
          Le.display,
          Le.data,
          Le.validation,
          Le.conditional,
          Le.internationalization
        ],
        toAdd: {
          component: "UsfSelect",
          options: [],
          defaultOption: null
        },
        hasInternationalization: !0
      },
      UsfCheckboxSwitch: {
        id: "UsfCheckboxSwitch",
        name: "Checkbox & switch",
        localeName: "checkboxSwitch",
        icon: "mdi-checkbox-marked",
        types: [
          {
            label: "Checkbox",
            value: "checkbox"
          },
          {
            label: "Switch",
            value: "switch"
          }
        ],
        usfType: "input",
        usfSubtypes: ["type"],
        categoryColor: "blue-grey lighten-3",
        settingsModalTabs: [
          Le.api,
          Le.display,
          Le.validation,
          Le.conditional,
          Le.internationalization
        ],
        toAdd: {
          component: "UsfCheckboxSwitch",
          type: "checkbox"
        },
        hasInternationalization: !0
      },
      UsfRadioGroup: {
        id: "UsfRadioGroup",
        name: "Radio group",
        localeName: "radioGroup",
        icon: "mdi-radiobox-marked",
        usfType: "input",
        usfSubtypes: ["withOptions", "repeatable"],
        categoryColor: "blue-grey lighten-3",
        settingsModalTabs: [
          Le.api,
          Le.display,
          Le.data,
          Le.validation,
          Le.conditional,
          Le.internationalization
        ],
        toAdd: {
          component: "UsfRadioGroup",
          options: []
        },
        hasInternationalization: !0
      },
      UsfDateTime: {
        id: "UsfDateTime",
        name: "Date & time",
        localeName: "dateTime",
        icon: "mdi-calendar",
        types: [
          {
            label: "Date",
            value: "date"
          },
          {
            label: "Time",
            value: "time"
          }
        ],
        styles: [
          {
            label: "Standard",
            value: "standard"
          },
          {
            label: "Birthday",
            value: "birthday"
          }
        ],
        usfType: "input",
        usfSubtypes: ["type", "style", "dateTime", "defaultValue", "defaultTokenValue", "boxInput", "repeatable"],
        categoryColor: "blue-grey lighten-3",
        settingsModalTabs: [
          Le.api,
          Le.display,
          Le.validation,
          Le.conditional,
          Le.internationalization
        ],
        toAdd: {
          component: "UsfDateTime",
          type: "date",
          style: "standard"
        },
        hasInternationalization: !0
      },
      UsfFile: {
        id: "UsfFile",
        name: "File",
        localeName: "file",
        icon: "mdi-file-multiple",
        usfType: "input",
        usfSubtypes: ["boxInput", "selectable", "file", "repeatable"],
        categoryColor: "blue-grey lighten-3",
        settingsModalTabs: [
          Le.api,
          Le.display,
          Le.validation,
          Le.conditional,
          Le.internationalization
        ],
        toAdd: {
          accept: "*/*",
          component: "UsfFile",
          max: 5242860
        },
        hasInternationalization: !0
      }
    },
    controlsGroups: {
      layouts: {
        id: "layouts",
        name: "Layouts",
        icon: "mdi-view-dashboard",
        color: "primary",
        controls: [
          "UsfAccordion",
          "UsfRow",
          "UsfContent"
        ]
      },
      inputs: {
        id: "inputs",
        name: "Inputs",
        color: "primary",
        icon: "mdi-form-textbox",
        controls: [
          "UsfText",
          "UsfTextArea",
          "UsfSelect",
          "UsfCheckboxSwitch",
          "UsfRadioGroup",
          "UsfDateTime",
          "UsfFile"
        ]
      },
      customs: {
        id: "customs",
        name: "Customs",
        color: "primary",
        icon: "mdi-plus-box",
        controls: []
      }
    },
    controlsGroupsRoot: [
      "layouts",
      "inputs",
      "customs"
    ]
  })
}), Yt = () => Math.random().toString(36).substring(2, 16), Bo = (e) => typeof e == "string", zu = (e) => typeof e == "object" && e !== null, Uu = (e) => e === void 0 ? "[object Undefined]" : e === null ? "[object Null]" : toString.call(e), Lo = (e) => {
  if (!zu(e) || Uu(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}, Zl = (e, t) => {
  if (e === void 0)
    return !1;
  const l = t.split(".");
  let n = { ...e };
  return l.every((a) => n[a] === void 0 ? !1 : (n = n[a], !0));
}, Lt = Dn("UsfFormSettings", {
  getters: {
    isAttributeArray(e) {
      return (t, l) => Zl(e.templates, t) && Zl(e.templates[t], l) && e.templates[t][l].type.name === "Array";
    },
    templateAttributes(e) {
      return (t) => Zl(e.templates, t) ? Object.keys(e.templates[t]).map((l) => ({ name: l, id: `${t}.${l}` })) : [];
    },
    templatesNames: (e) => Object.keys(e.templates),
    userTokenInfo: (e) => Object.keys(e.templates.user ?? {})
  },
  state: () => ({
    autoCompletionIsActive: !1,
    hasPreviewButton: !0,
    iconLibraryList: [],
    iconNameFn: null,
    isAdmin: !0,
    isHybridForm: !0,
    optionValueIsId: !1,
    previewIsSave: !0,
    radioEmitValue: !1,
    selectEmitValue: !1,
    selectOnlyArray: !1,
    settingsDialogMaximized: !1,
    templates: {},
    user: {}
  })
}), Eo = (e) => ({
  current: e,
  defaultLocale: e,
  locales: {
    [e]: {
      rtl: !1
    }
  }
}), st = Dn("UsfTranslation", {
  actions: {
    /**
     * It adds an empty object to each locale in the messages object
     *
     * @param {string} fieldId - The id of the element to add.
     */
    addItemInAllLocales(e) {
      Object.keys(this.messages.locales).forEach((t) => {
        this.messages.locales[t][e] = {};
      });
    },
    /**
     * It's adding a new field in one locale.
     *
     * @param {string} locale
     * @param {string} fieldId
     */
    addItemInOneLocale(e, t) {
      this.messages.locales[e][t] = {};
    },
    /**
     * Add a new locale in the locale list & add all fields in the new locale.
     *
     * @param {string} newLocaleName
     * @param {boolean} rtl
     */
    addLocale(e, t = !1) {
      const l = { rtl: t };
      return Object.keys(this.messages.locales[this.messages.defaultLocale || "fr"] || []).forEach((n) => {
        n !== "rtl" && (l[n] = {});
      }), this.messages.locales[e] = l, l;
    },
    /**
     * Delete a locale completely.
     *
     * @param {string} localeDeleted
     */
    deleteLocale(e) {
      if (e !== this.messages.defaultLocale) {
        delete this.messages.locales[e];
        return;
      }
      throw new Error("[Store: translationStore.deleteLocale] You can't delete the default locale.");
    },
    /**
     * Initialize the messages object.
     * If the messages object is empty, it will create a new one with the default locale.
     * If the messages object is not empty, it will use the given messages object.
     *
     * @param {FormMessages} messages
     * @param {string} defaultLocale
     */
    initMessages(e, t = "fr") {
      if (!e.locales || !e.defaultLocale || !Object.keys(e.locales).length) {
        this.messages = Eo(t);
        return;
      }
      this.messages = e;
    },
    /**
     * It removes an attribute from an item in all locales.
     *
     * @param {string} itemId - The id of the item you want to remove the attribute from.
     * @param attribute - keyof FieldWithId
     */
    removeItemAttributeInAllLocales(e, t) {
      for (const l in this.messages.locales)
        e in this.messages.locales[l] && t in this.messages.locales[l][e] && delete this.messages.locales[l][e][t];
    },
    /**
     * It removes the item with the given id from all locales.
     *
     * @param {string} itemId - The id of the message to remove.
     */
    removeItemInAllLocales(e) {
      for (const t in this.messages.locales)
        e in this.messages.locales[t] && delete this.messages.locales[t][e];
    },
    /**
     * Update the RTL status of the locale
     *
     * @param {boolean} newStatus
     * @param {string} locale
     */
    updateRltStatusOfLocale(e, t) {
      t in this.messages.locales && (this.messages.locales[t].rtl = e);
    },
    /**
     * Update one translation for one field.
     *
     * @param {string} itemId
     * @param {string} locale
     * @param {string} attribute
     * @param {string} translation
     * @param {boolean} isOption - boolean - the item translated is an option
     * @param {boolean} isAfterUpdateField - boolean - not update field if it's this method who call updateTranslation
     */
    updateTranslation(e, t, l, n, a = !1, i = !1) {
      if (t !== "" && (this.messages.locales[t] || this.addLocale(t, !1), this.messages.locales[t][e] || this.addItemInOneLocale(t, e), this.messages.locales[t][e][l] = n, t === this.messages.defaultLocale)) {
        const r = Ee();
        !i && !a && r.updateField(e, l, n, !0), a && r.updateOption(e, l, n, !0);
      }
    }
  },
  getters: {
    currentLocale(e) {
      return e.messages.current || e.messages.defaultLocale;
    },
    listOfLocales(e) {
      return Object.keys(e.messages.locales);
    },
    locales(e) {
      return Object.entries(e.messages.locales).map(([t, { rtl: l }]) => ({ locale: t, rtl: l }));
    },
    translated(e) {
      return (t, l, n = "fields", a = !1) => {
        var d, c, u, m, p, f, _, v, y, M, w, S, h, C, T, I, E, A, O, P, $, k;
        const i = Lt(), r = (g) => g.replace(
          /{{\s*([a-zA-Z0-9_-]+)\.([a-zA-Z0-9_-]+)\s*}}/g,
          (x, B, q) => {
            var K;
            if (B !== "user")
              return "";
            const Y = (K = i.user) == null ? void 0 : K[q];
            return Y ? Array.isArray(Y) ? Y.join(", ") : `${Y}` : "";
          }
        );
        if (e.messages.current && ((u = (c = (d = e.messages.locales) == null ? void 0 : d[e.messages.current]) == null ? void 0 : c[t]) != null && u[l]))
          return a ? r((f = (p = (m = e.messages.locales) == null ? void 0 : m[e.messages.current]) == null ? void 0 : p[t]) == null ? void 0 : f[l]) : (y = (v = (_ = e.messages.locales) == null ? void 0 : _[e.messages.current]) == null ? void 0 : v[t]) == null ? void 0 : y[l];
        if (e.messages.current !== e.messages.defaultLocale && ((S = (w = (M = e.messages.locales) == null ? void 0 : M[e.messages.defaultLocale]) == null ? void 0 : w[t]) != null && S[l]))
          return a ? r((T = (C = (h = e.messages.locales) == null ? void 0 : h[e.messages.defaultLocale]) == null ? void 0 : C[t]) == null ? void 0 : T[l]) : (A = (E = (I = e.messages.locales) == null ? void 0 : I[e.messages.defaultLocale]) == null ? void 0 : E[t]) == null ? void 0 : A[l];
        const s = Ee();
        return a ? r(
          n === "fields" && l !== "tooltip" ? ((O = s.fields[t]) == null ? void 0 : O[l]) || "" : ((P = s.options[t]) == null ? void 0 : P[l]) || ""
        ) : n === "fields" && l !== "tooltip" ? (($ = s.fields[t]) == null ? void 0 : $[l]) || "" : ((k = s.options[t]) == null ? void 0 : k[l]) || "";
      };
    },
    translation(e) {
      return (t, l, n) => {
        var a, i;
        return ((i = (a = e.messages.locales[l]) == null ? void 0 : a[t]) == null ? void 0 : i[n]) || "";
      };
    }
  },
  state: () => ({
    messages: Eo("fr")
  })
}), Po = () => ["label", "placeholder", "prefix", "suffix", "hint", "content", "fieldset"], Ee = Dn("UsfForm", {
  actions: {
    /**
     * Add a dependency between two fields.
     * The dependency type can be 'dependsOn' or 'conditional'.
     * The dependency type 'dependsOn' means that the field of type 'select' will have options that will only be displayed if a value has been selected at the parent level.
     * The dependency type 'conditional' means that the field will only be displayed if a value has been selected at the parent level.
     *
     * @param parentFieldId
     * @param fieldId
     * @param dependencyType
     */
    addDependency(e, t, l) {
      if (!this.fieldDependencies[e]) {
        this.fieldDependencies[e] = { [t]: [l] };
        return;
      }
      if (!this.fieldDependencies[e][t]) {
        this.fieldDependencies[e][t] = [l];
        return;
      }
      this.fieldDependencies[e][t].includes(l) || this.fieldDependencies[e][t].push(l);
    },
    /**
     * Add the field on the root array or in the repeat group.
     *
     * @param {string} to
     * @param {number} atIndex
     * @param {Field} fieldWithoutId
     * @param {boolean} hasInternationalization
     * @returns {FieldAddedInformation}
     */
    addField(e, t, l, n) {
      const a = Yt();
      if (e === "root") {
        const i = [...this.root];
        i.splice(t, 0, a), this.root = i;
      } else {
        const i = this.fields[e];
        if (i)
          "fields" in i ? i.fields.splice(t, 0, a) : i.fields = [a];
        else
          throw new Error(`[Store: formStore.addField] => Parent field with id ${e} does not exist`);
      }
      return this.fields[a] = { ...l, id: a }, n && st().addItemInAllLocales(a), { ...l, id: a };
    },
    /**
     * It adds an option id to a field and to the options object list.
     *
     * @param {string} to - string - the id of the field to add the option to
     * @param {Option} optionWithoutId - Option
     * @returns { id: string }
     */
    addOption(e, t) {
      var i;
      const l = Yt();
      if (!this.fields[e])
        throw new Error(`[Store: formStore.addOption] => Parent field with id ${e} does not exist`);
      return "options" in this.fields[e] || (this.fields[e].options = []), "owner" in this.fields[e] || (t.owner = e), Lt().optionValueIsId && (t.value = l), (i = this.fields[e].options) == null || i.push(l), this.options[l] = {
        ...t,
        id: l
      }, st().addItemInAllLocales(l), { id: l };
    },
    /**
     * It adds an option id to a field and to the options object list.
     *
     * @param {string} to - string - the id of the field to add the option to
     * @param {Object} options[]
     * @param {string} options.label
     * @param {string} options.value
     * @returns {string[]}
     */
    addOptions(e, t) {
      if (!this.fields[e])
        throw new Error(`[Store: formStore.addOptions] => Parent field with id ${e} does not exist`);
      "options" in this.fields[e] || (this.fields[e].options = []);
      const l = st();
      return this.fields[e].options = t.map((n) => {
        const a = Yt();
        return this.options[a] = { ...n, id: a, owner: e }, l.addItemInAllLocales(a), l.updateTranslation(a, l.currentLocale, "label", n.label, !0), a;
      }), this.fields[e].options;
    },
    /**
     * With the ids of the fields, re-build the field array.
     *
     * @param {string} fieldId
     * @returns {StartField}
     */
    denormalizeField(e) {
      var l, n, a;
      if (!this.fields[e])
        throw new Error(`[Store: formStore.denormalizeField] => Cannot denormalize the field with id ${e}, the field does not exist`);
      const t = { ...this.fields[e] };
      return (l = t.options) != null && l.length && (t.options = t.options.map((i) => this.options[i])), (n = t.fields) != null && n.length && (t.fields = (a = t.fields) == null ? void 0 : a.map(this.denormalizeField)), t;
    },
    /**
     * Duplicate a field.
     * If the duplicated field is a select or a radio group, the options are duplicated.
     *
     * @param {string}fieldId
     * @param {number}fieldIndex
     */
    duplicateField(e, t) {
      var _, v;
      const l = this.fields[e];
      let n = t + 1;
      if (!l)
        throw new Error(`[Store: formStore.duplicateField] => Cannot duplicate the field with id ${e}, the field does not exist`);
      const { id: a, ...i } = l, { component: r, exist: s, parentId: d, type: c, visible: u, ...m } = i, p = { component: r, exist: s, parentId: d, type: c, visible: u };
      if (l.parentId !== "root") {
        const y = this.fields[l.parentId];
        if (!y)
          throw new Error(`[Store: formStore.duplicateField] => Cannot duplicate the field with id ${e}, the parent field does not exist`);
        if (y.component === "UsfCol") {
          const M = this.fields[y.parentId];
          if (!M)
            throw new Error(`[Store: formStore.duplicateField] => Cannot duplicate the field with id ${e}, the row does not exist`);
          const w = (_ = M.fields) == null ? void 0 : _.indexOf(y.id);
          if (w === void 0)
            throw new Error(`[Store: formStore.duplicateField] => Cannot duplicate the field with id ${e}, the column is not in the row`);
          M.type === "row" && this.updateField(y.id, "width", `${parseInt(y.width ?? "12") / 2}`);
          const S = this.duplicateField(y.id, w);
          p.parentId = S.id, n = 0;
        }
      }
      ["UsfSelect", "UsfRadioGroup"].includes(i.component) && (p.options = []), ["UsfCol"].includes(i.component) && (p.fields = []);
      const f = this.addField(p.parentId, n, p, !0);
      for (const y in m) {
        const M = m[y];
        switch (y) {
          case "name":
            this.updateField(f.id, "name", `${M}-copy`);
            break;
          case "options":
            this.updateField(f.id, "options", []), (v = l.options) == null || v.forEach((w) => {
              const { id: S, ...h } = this.options[w];
              this.addOption(f.id, h);
            });
            break;
          case "fields":
            this.updateField(f.id, "fields", []);
            break;
          case "defaultOption":
            this.updateField(f.id, "defaultOption", null);
            break;
          default:
            this.updateField(f.id, y, M);
            break;
        }
      }
      return f;
    },
    /**
     * Init the field dependencies.
     *
     * @param field
     * @param id
     */
    initDependenciesForAField(e, t) {
      var l, n, a, i, r, s, d, c;
      e.dependsOn && this.addDependency(e.dependsOn, t, "dependsOn"), (n = (l = e.conditional) == null ? void 0 : l.basic) != null && n.exist && this.readCondition((i = (a = e.conditional) == null ? void 0 : a.basic) == null ? void 0 : i.exist, t), (s = (r = e.conditional) == null ? void 0 : r.basic) != null && s.required && this.readCondition((c = (d = e.conditional) == null ? void 0 : d.basic) == null ? void 0 : c.required, t);
    },
    /**
     * Get all fields and init the dependencies for each.
     */
    initDependenciesForAllFields() {
      this.fieldDependencies = {};
      for (const e in this.fields)
        this.initDependenciesForAField(this.fields[e], e);
    },
    /**
     * We're taking the field at the index we want to move, removing it from the array, and then inserting it at the index
     * we want to move it to.
     *
     * @param {string} parentId - The id of the parent field.
     * @param {number} index - The index of the field you want to move.
     * @param {'up' | 'down'} direction - 'up' | 'down'
     */
    moveField(e, t, l) {
      const n = this.fields[e];
      if (!n)
        throw new Error(`[Store: formStore.moveField] => Cannot move the field with index ${t}, the parent field with id ${e} does not exist`);
      if (!n.fields)
        throw new Error(`[Store: formStore.moveField] => Cannot move the field with index ${t}, the parent field with id ${e} does not have any fields`);
      if (n.fields.length === 1)
        throw new Error(`[Store: formStore.moveField] => Cannot move the field with index ${t}, the parent field with id ${e} has less than 2 fields`);
      if (t === 0 && l === "up")
        throw new Error(`[Store: formStore.moveField] => Cannot move the field with index ${t} in the field ${e}, the field is already at the top`);
      if (t === n.fields.length - 1 && l === "down")
        throw new Error(`[Store: formStore.moveField] => Cannot move the field with index ${t} in the field ${e}, the field is already at the bottom`);
      n.fields.splice(
        l === "up" ? t - 1 : t + 1,
        0,
        this.fields[e].fields.splice(t, 1)[0]
      );
    },
    /**
     * It takes the option at the given index, removes it from the array, and then inserts it at the index above or below
     * it, depending on the direction.
     *
     * @param {string} fieldId - The id of the parent field.
     * @param {number} index - The index of the option you want to move.
     * @param {'up' | 'down'} direction - 'up' | 'down'
     */
    moveOption(e, t, l) {
      const n = this.fields[e];
      if (!n)
        throw new Error(`[Store: formStore.moveOption] => Cannot move the option with index ${t}, the parent field with id ${e} does not exist`);
      if (!n.options)
        throw new Error(`[Store: formStore.moveOption] => Cannot move the option with index ${t}, the parent field with id ${e} does not have any options`);
      if (n.options.length === 1)
        throw new Error(`[Store: formStore.moveOption] => Cannot move the option with index ${t}, the parent field with id ${e} has less than 2 options`);
      if (t === 0 && l === "up")
        throw new Error(`[Store: formStore.moveOption] => Cannot move the option with index ${t} in the field ${e}, the option is already at the top`);
      if (t === n.options.length - 1 && l === "down")
        throw new Error(`[Store: formStore.moveOption] => Cannot move the option with index ${t} in the field ${e}, the option is already at the bottom`);
      n.options.splice(
        l === "up" ? t - 1 : t + 1,
        0,
        this.fields[e].options.splice(t, 1)[0]
      );
    },
    /**
     * Build a field object from the startField object.
     * If the startField has options, replace the option array with an option id array.
     * If the startField has fields, replace the fields array with a field id array.
     * Add the field with the id in the fields object in the state.
     * Return the field id.
     *
     * @param {StartField} field
     * @returns {string}
     */
    normalizeField(e) {
      const t = e.id ?? Yt(), { options: l, fields: n, ...a } = e;
      return this.initDependenciesForAField(e, t), l !== void 0 && (a.options = l != null && l.length ? l.map(this.normalizeOption) : []), n !== void 0 && (a.fields = n.length ? n.map(this.normalizeField) : []), this.fields[t] = { ...a, id: t }, t;
    },
    /**
     * Check if the option has an id, if not, create one.
     * Add the option to the options object in the state.
     * Return the option id.
     *
     * @param {Option} option
     * @returns {string}
     */
    normalizeOption(e) {
      const t = e.id ?? Yt();
      return this.options[t] = {
        ...e,
        id: t
      }, t;
    },
    /**
     * With the StartField array, normalize the array and get a field id array.
     * Add this array in the root key in the state.
     *
     * @param {StartField[]} fields
     */
    normalizeRootFields(e) {
      this.root = e.map(this.normalizeField);
    },
    /**
     * It adds a field to the form store.
     * The id of the source item in the event must be "root".
     *
     * @param {DropEvent} event - DraggableEvent
     */
    onAddItem(e) {
      var m;
      if (!((m = e.to) != null && m.id))
        throw new Error("[Store: formStore.onAddItem] => You must add an id to the target element to be able to add a field");
      const t = sn(), {
        hasInternationalization: l,
        nested: n,
        toAdd: a,
        usfSubtypes: i
      } = t.controls[e.item.dataset.itemId], r = JSON.parse(JSON.stringify(a));
      let s = [];
      Array.isArray(n) && n.length && (s = n.map((p) => JSON.parse(JSON.stringify(t.controls[p].toAdd))));
      let d = [];
      i.includes("withOptions") && (d = [...new Array(3)].map((p, f) => ({
        label: `Option ${f + 1}`,
        value: `option${f + 1}`
      })), r.defaultOption = null);
      const c = {
        parentId: e.to.id,
        exist: !0,
        visible: !0,
        ...r
      }, u = this.addField(
        e.to.id,
        e.newIndex,
        // clone deep to avoid reference
        c,
        l
      );
      return s.length && s.forEach((p, f) => {
        this.addField(
          u.id,
          f,
          { parentId: u.id, exist: !0, visible: !0, ...p },
          t.controls[p.component].hasInternationalization
        );
      }), d.length && d.forEach((p) => {
        this.addOption(u.id, p);
      }), u;
    },
    /**
     * If the event is moved, then splice the root array at the new index, and insert the item that was removed from the
     * old index
     *
     * No error is thrown if the event is not moved, because if the event is moved in other places, it will be removed.
     *
     * @param {DraggableEvent} event - DraggableEvent
     */
    onMoveFieldPosition(e) {
      if (e.moved)
        try {
          this.root.splice(
            e.moved.newIndex,
            0,
            this.root.splice(e.moved.oldIndex, 1)[0]
          );
        } catch (t) {
          throw new Error(`[Store: formStore.onMoveFieldPosition] => ${t.message}`);
        }
    },
    /**
     * If the event is moved, then splice the root array at the new index, and insert the item that was removed from the
     * old index
     * @param {DropEvent} event - DropEvent
     */
    onMoveFieldPositionToSubItem(e) {
      var n, a, i, r;
      if (!((n = e.from) != null && n.id))
        throw new Error("[Store: formStore.onMoveFieldPositionToSubItem] => The event must have a from property");
      if (e.from.id === "builder-controls")
        return;
      if (!((a = e.to) != null && a.id))
        throw new Error("[Store: formStore.onMoveFieldPositionToSubItem] => The event must have a to property");
      if (e.from === e.to)
        throw new Error("[Store: formStore.onMoveFieldPositionToSubItem] => The event must have a different from and to property");
      const t = e.from.id === "root" ? this.root.splice(e.oldIndex, 1)[0] : (i = this.fields[e.from.id].fields) == null ? void 0 : i.splice(e.oldIndex, 1)[0], l = this.fields[t];
      if (l.parentId = e.to.id, e.to.id === "root") {
        this.root.splice(e.newIndex, 0, t);
        return;
      }
      this.fields[e.to.id].fields || (this.fields[e.to.id].fields = []), (r = this.fields[e.to.id].fields) == null || r.splice(e.newIndex, 0, t);
    },
    /**
     * Read conditions to add them in the dependencies.
     *
     * @param conditions
     * @param id
     */
    readCondition(e, t) {
      e.forEach((l) => {
        var n, a, i, r, s, d;
        ((n = l.fieldA) == null ? void 0 : n.value) !== "child" && ((a = l.fieldA) != null && a.id) && !((i = l.fieldA) != null && i.id.startsWith("user.")) && this.addDependency(l.fieldA.id, t, "conditional"), ((r = l.fieldB) == null ? void 0 : r.value) !== "child" && ((s = l.fieldB) != null && s.id) && !((d = l.fieldB) != null && d.id.startsWith("user.")) && this.addDependency(l.fieldB.id, t, "conditional"), l.child && this.readCondition(l.child.subConditions, t);
      });
    },
    /**
     * It removes all options from a field.
     *
     * @param {string} fieldId - The id of the field you want to remove the option from.
     */
    removeAllOptions(e) {
      var t;
      (t = this.fields[e].options) == null || t.forEach((l) => {
        this.removeOption(l, e);
      });
    },
    /**
     * If the field with the given id exists, delete the given attribute from it.
     *
     * The first line of the function is a type guard.
     * It checks if the field with the given id exists.
     * If it does, the function continues.
     * If it doesn't, the function returns
     *
     * @param {string} id - The id of the field you want to remove the attribute from.
     * @param attribute - The attribute to remove from the field.
     */
    removeAttribute(e, t) {
      this.fields[e] && delete this.fields[e][t], Po().includes(t) && st().removeItemAttributeInAllLocales(e, t);
    },
    removeDependency(e, t, l) {
      this.fieldDependencies[e][t] = this.fieldDependencies[e][t].filter((n) => n !== l), this.fieldDependencies[e][t].length === 0 && delete this.fieldDependencies[e][t], Object.keys(this.fieldDependencies[e]).length === 0 && delete this.fieldDependencies[e];
    },
    /**
     * Build the field with all its dependencies (options, child fields...).
     * If it has options, delete options in the option list and in all locale in the internationalization object.
     * Use to normalize and the denormalize methods tf it has a child field, to delete recursively all its children.
     * Finally, delete this field in the field list.
     *
     * @param {string} id - the id of the field to be removed
     * @param {string} parentId - the id of the parent field
     * @param {number} index - the index of the field in the parent's children array
     */
    removeField(e, t, l) {
      var i, r, s, d;
      const n = this.fields[e];
      if (!n)
        throw new Error(`[Store: formStore.removeField] => The field with the id ${e} does not exist`);
      if ((i = n.options) != null && i.length && n.options.forEach((c) => {
        delete this.options[c];
      }), (r = n.fields) != null && r.length)
        for (let c = ((s = n.fields) == null ? void 0 : s.length) - 1; c >= 0; c--)
          this.removeField(n.fields[c], e, c);
      st().removeItemInAllLocales(e), this.removeFieldInDependencies(e), delete this.fields[e], t === "root" ? this.root.splice(l, 1) : (d = this.fields[t].fields) == null || d.splice(l, 1);
    },
    /**
     * Remove the field id in the dependencies.
     * E.g. if the field deleted, was a dependency of another field, it will be removed from the dependencies.
     *
     * @param id
     */
    removeFieldInDependencies(e) {
      for (const t in this.fieldDependencies)
        this.fieldDependencies[t][e] && delete this.fieldDependencies[t][e], Object.keys(this.fieldDependencies[t]).length === 0 && delete this.fieldDependencies[t];
    },
    /**
     * Remove an option :
     * - Remove the option id on the options array in the parent field
     * - Remove the option in the option list
     * - Remove the option in all locales.
     * - Remove the option from the displayedBy array of other options
     *
     * @param {string} optionId
     * @param {string} fieldId
     */
    removeOption(e, t) {
      var i, r, s;
      if (!this.options[e])
        throw new Error(`[Store: formStore.removeOption] => The option with the id ${e} does not exist`);
      const l = this.fields[t];
      if (!l)
        throw new Error(`[Store: formStore.removeOption] => The field with the id ${t} does not exist`);
      l.options = (i = l.options) == null ? void 0 : i.filter((d) => d !== e), delete this.options[e], st().removeItemInAllLocales(e);
      const a = Object.values(this.fields).filter((d) => l.id === d.dependsOn);
      for (const d of a) {
        const c = ((r = d.options) == null ? void 0 : r.map((u) => this.options[u])) ?? [];
        for (const u of c)
          u.displayedBy = (s = u.displayedBy) == null ? void 0 : s.filter((m) => m !== e);
      }
    },
    /**
     * Reset the options tooltip of a field.
     *
     * @param fieldId
     */
    resetOptionsTooltip(e) {
      var l, n;
      const t = st();
      (n = (l = this.fields[e]) == null ? void 0 : l.options) == null || n.forEach((a) => {
        var i;
        (i = this.options[a]) == null || delete i.tooltip, t.removeItemAttributeInAllLocales(a, "tooltip");
      });
    },
    /**
     * Sort the options of a field by label or value, in ascending or descending order.
     *
     * @param {string} fieldId - The id of the field you want to sort the options of
     * @param {'label' | 'value'} by - 'label' | 'value'
     * @param {'desc' | 'asc'} direction - 'desc' | 'asc'
     */
    sortOptions(e, t, l) {
      var n;
      if (!this.fields[e])
        throw new Error(`[Store: formStore.sortOptions] => The field with the id ${e} does not exist`);
      (n = this.fields[e].options) == null || n.sort((a, i) => {
        const r = this.options[a][t], s = this.options[i][t];
        return r < s ? l === "desc" ? 1 : -1 : r > s ? l === "desc" ? -1 : 1 : 0;
      });
    },
    /**
     * If the field exists, update it.
     *
     * @param {string} fieldId - string - the id of the field we want to update
     * @param attribute - keyof FieldWithId - the name of the field option we want to update
     * @param {never} newValue - the new value we want to assign to the field
     * @param {string} isUpdateAfterTranslation - boolean - if the update is after a translation not update the translation
     * @param {boolean} noRemove - boolean - true if we don't want to remove the attribute if the value is empty
     */
    updateField(e, t, l, n = !1, a = !1) {
      if (!this.fields[e])
        throw new Error(`[Store: formStore.updateField] => Field with id ${e} does not exist`);
      if (!a && l === "" || l === null ? this.removeAttribute(e, t) : this.fields[e][t] = l, !n && Po().includes(t) && typeof l == "string") {
        const i = st();
        i.updateTranslation(
          e,
          i.messages.defaultLocale,
          t,
          l,
          !1,
          !0
        );
      }
    },
    /**
     * Update an attribute value in option. If the attribute is the label, update this value in the default locale.
     *
     * @param {string} optionId
     * @param {string} optionAttribute
     * @param {string} value
     * @param {string} isUpdateAfterTranslation - boolean - if the update is after a translation not update the translation
     */
    updateOption(e, t, l, n = !1) {
      if (!this.options[e])
        throw new Error(`[Store: formStore.updateOption] => The option with the id ${e} does not exist`);
      if (t === "displayedBy") {
        this.options[e].displayedBy = l;
        return;
      }
      if (this.options[e][t] = l, t === "label" && !n) {
        const a = st();
        a.updateTranslation(
          e,
          a.messages.defaultLocale,
          t,
          l,
          !0
        );
      }
    }
  },
  getters: {
    getFieldDescription(e) {
      return (t, l) => {
        if (!t)
          return "";
        const n = e.fields[t];
        return n ? {}.VITE_APP_DEPLOYMENT_ENV === "dev" ? `${l ? l + " - " : ""}${n == null ? void 0 : n.id}` + (n != null && n.name ? ` - ${n == null ? void 0 : n.name}` : "") : `${l || ""}` + (n != null && n.name ? `${l ? " - " : ""}${n == null ? void 0 : n.name}` : "") : "";
      };
    },
    getFields: (e) => Object.values(e.fields),
    getOptionByIdOrValue(e) {
      return (t) => {
        const l = e.options[t];
        return l || Object.values(e.options).find((n) => n.value === t) || void 0;
      };
    },
    getOptionsByIdOrValue(e) {
      return (t) => {
        const l = /* @__PURE__ */ new Set();
        return t.forEach((n) => {
          const a = e.options[n] || Object.values(e.options).find((i) => i.value === n);
          a && l.add(a);
        }), [...l];
      };
    },
    getOtherFieldsName(e) {
      return (t) => t ? Object.values(e.fields).filter((l) => l.name && l.id !== t).map((l) => l.name) : [];
    },
    hasFields(e) {
      return e.root.length > 0;
    }
  },
  state: () => ({
    autoCompletionArchive: !1,
    fieldDependencies: {},
    fields: {},
    isHybridForm: !1,
    options: {},
    root: []
  })
}), Hu = /* @__PURE__ */ Ce({
  __name: "BuilderControls",
  setup(e) {
    const t = sn(), l = Ee(), n = Me("_uct");
    return (a, i) => (z(), ae(Wn, { bordered: "" }, {
      default: L(() => [
        (z(!0), re(Ve, null, dt(o(t).controlsGroupWithControls, (r) => (z(), ae(oo, {
          key: `group-${r.id}`,
          class: Ft([`group-${r.id}`]),
          icon: r.icon,
          label: o(n)(`builder.controls.groups.${r.id}`)
        }, {
          default: L(() => [
            D(Wn, null, {
              default: L(() => [
                D(o(na), {
                  id: "builder-controls",
                  group: { name: "formbuilder", pull: "clone", put: !1 },
                  list: r.controls,
                  sort: !1,
                  "item-key": "id",
                  onEnd: o(l).onAddItem
                }, {
                  item: L(({ element: s }) => [
                    D(Tl, {
                      "data-item-id": s.id
                    }, {
                      default: L(() => [
                        D(jt, null, {
                          default: L(() => [
                            s.usfType === "custom" ? (z(), re(Ve, { key: 0 }, [
                              ve(J(s.name), 1)
                            ], 64)) : (z(), re(Ve, { key: 1 }, [
                              ve(J(o(n)(`builder.controls.fields.${s.localeName}`)), 1)
                            ], 64))
                          ]),
                          _: 2
                        }, 1024),
                        D(jt, { avatar: "" }, {
                          default: L(() => [
                            D(Qe, {
                              name: s.icon
                            }, null, 8, ["name"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["data-item-id"])
                  ]),
                  _: 2
                }, 1032, ["list", "onEnd"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["class", "icon", "label"]))), 128))
      ]),
      _: 1
    }));
  }
});
const Oe = (e, t) => {
  const l = e.__vccOpts || e;
  for (const [n, a] of t)
    l[n] = a;
  return l;
}, Yu = /* @__PURE__ */ Oe(Hu, [["__scopeId", "data-v-384dc9c2"]]), Vl = De({
  name: "QBanner",
  props: {
    ...Tt,
    inlineActions: Boolean,
    dense: Boolean,
    rounded: Boolean
  },
  setup(e, { slots: t }) {
    const { proxy: { $q: l } } = Ae(), n = Mt(e, l), a = b(
      () => "q-banner row items-center" + (e.dense === !0 ? " q-banner--dense" : "") + (n.value === !0 ? " q-banner--dark q-dark" : "") + (e.rounded === !0 ? " rounded-borders" : "")
    ), i = b(
      () => `q-banner__actions row items-center justify-end col-${e.inlineActions === !0 ? "auto" : "all"}`
    );
    return () => {
      const r = [
        V("div", {
          class: "q-banner__avatar col-auto row items-center self-start"
        }, We(t.avatar)),
        V("div", {
          class: "q-banner__content col text-body2"
        }, We(t.default))
      ], s = We(t.action);
      return s !== void 0 && r.push(
        V("div", { class: i.value }, s)
      ), V("div", {
        class: a.value + (e.inlineActions === !1 && s !== void 0 ? " q-banner--top-padding" : ""),
        role: "alert"
      }, r);
    };
  }
});
function Kt(e, t, l, n) {
  return Object.defineProperty(e, t, {
    get: l,
    set: n,
    enumerable: !0
  }), e;
}
function ju(e, t) {
  for (const l in t)
    Kt(e, l, t[l]);
  return e;
}
const xn = G(
  !1
);
let io;
function Nu(e, t) {
  const l = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(e) || /(opr)[\/]([\w.]+)/.exec(e) || /(vivaldi)[\/]([\w.]+)/.exec(e) || /(chrome|crios)[\/]([\w.]+)/.exec(e) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(firefox|fxios)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+)/.exec(e) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(e) || [];
  return {
    browser: l[5] || l[3] || l[1] || "",
    version: l[2] || l[4] || "0",
    versionNumber: l[4] || l[2] || "0",
    platform: t[0] || ""
  };
}
function Wu(e) {
  return /(ipad)/.exec(e) || /(ipod)/.exec(e) || /(windows phone)/.exec(e) || /(iphone)/.exec(e) || /(kindle)/.exec(e) || /(silk)/.exec(e) || /(android)/.exec(e) || /(win)/.exec(e) || /(mac)/.exec(e) || /(linux)/.exec(e) || /(cros)/.exec(e) || /(playbook)/.exec(e) || /(bb)/.exec(e) || /(blackberry)/.exec(e) || [];
}
const ji = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function Qu(e) {
  io = { is: { ...e } }, delete e.mac, delete e.desktop;
  const t = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
  Object.assign(e, {
    mobile: !0,
    ios: !0,
    platform: t,
    [t]: !0
  });
}
function Ku(e) {
  const t = e.toLowerCase(), l = Wu(t), n = Nu(t, l), a = {};
  n.browser && (a[n.browser] = !0, a.version = n.version, a.versionNumber = parseInt(n.versionNumber, 10)), n.platform && (a[n.platform] = !0);
  const i = a.android || a.ios || a.bb || a.blackberry || a.ipad || a.iphone || a.ipod || a.kindle || a.playbook || a.silk || a["windows phone"];
  return i === !0 || t.indexOf("mobile") > -1 ? (a.mobile = !0, a.edga || a.edgios ? (a.edge = !0, n.browser = "edge") : a.crios ? (a.chrome = !0, n.browser = "chrome") : a.fxios && (a.firefox = !0, n.browser = "firefox")) : a.desktop = !0, (a.ipod || a.ipad || a.iphone) && (a.ios = !0), a["windows phone"] && (a.winphone = !0, delete a["windows phone"]), (a.chrome || a.opr || a.safari || a.vivaldi || a.mobile === !0 && a.ios !== !0 && i !== !0) && (a.webkit = !0), a.edg && (n.browser = "edgechromium", a.edgeChromium = !0), (a.safari && a.blackberry || a.bb) && (n.browser = "blackberry", a.blackberry = !0), a.safari && a.playbook && (n.browser = "playbook", a.playbook = !0), a.opr && (n.browser = "opera", a.opera = !0), a.safari && a.android && (n.browser = "android", a.android = !0), a.safari && a.kindle && (n.browser = "kindle", a.kindle = !0), a.safari && a.silk && (n.browser = "silk", a.silk = !0), a.vivaldi && (n.browser = "vivaldi", a.vivaldi = !0), a.name = n.browser, a.platform = n.platform, t.indexOf("electron") > -1 ? a.electron = !0 : document.location.href.indexOf("-extension://") > -1 ? a.bex = !0 : (window.Capacitor !== void 0 ? (a.capacitor = !0, a.nativeMobile = !0, a.nativeMobileWrapper = "capacitor") : (window._cordovaNative !== void 0 || window.cordova !== void 0) && (a.cordova = !0, a.nativeMobile = !0, a.nativeMobileWrapper = "cordova"), ji === !0 && a.mac === !0 && (a.desktop === !0 && a.safari === !0 || a.nativeMobile === !0 && a.android !== !0 && a.ios !== !0 && a.ipad !== !0) && Qu(a)), a;
}
const Ro = navigator.userAgent || navigator.vendor || window.opera, Gu = {
  has: {
    touch: !1,
    webStorage: !1
  },
  within: { iframe: !1 }
}, mt = {
  userAgent: Ro,
  is: Ku(Ro),
  has: {
    touch: ji
  },
  within: {
    iframe: window.self !== window.top
  }
}, ja = {
  install(e) {
    const { $q: t } = e;
    xn.value === !0 ? (e.onSSRHydrated.push(() => {
      Object.assign(t.platform, mt), xn.value = !1, io = void 0;
    }), t.platform = Rl(this)) : t.platform = this;
  }
};
{
  let e;
  Kt(mt.has, "webStorage", () => {
    if (e !== void 0)
      return e;
    try {
      if (window.localStorage)
        return e = !0, !0;
    } catch {
    }
    return e = !1, !1;
  }), mt.is.ios === !0 && window.navigator.vendor.toLowerCase().indexOf("apple"), xn.value === !0 ? Object.assign(ja, mt, io, Gu) : Object.assign(ja, mt);
}
function kn() {
  if (window.getSelection !== void 0) {
    const e = window.getSelection();
    e.empty !== void 0 ? e.empty() : e.removeAllRanges !== void 0 && (e.removeAllRanges(), ja.is.mobile !== !0 && e.addRange(document.createRange()));
  } else
    document.selection !== void 0 && document.selection.empty();
}
const ro = {
  target: {
    default: !0
  },
  noParentEvent: Boolean,
  contextMenu: Boolean
};
function uo({
  showing: e,
  avoidEmit: t,
  // required for QPopupProxy (true)
  configureAnchorEl: l
  // optional
}) {
  const { props: n, proxy: a, emit: i } = Ae(), r = G(null);
  let s = null;
  function d(f) {
    return r.value === null ? !1 : f === void 0 || f.touches === void 0 || f.touches.length <= 1;
  }
  const c = {};
  l === void 0 && (Object.assign(c, {
    hide(f) {
      a.hide(f);
    },
    toggle(f) {
      a.toggle(f), f.qAnchorHandled = !0;
    },
    toggleKey(f) {
      gl(f, 13) === !0 && c.toggle(f);
    },
    contextClick(f) {
      a.hide(f), Ot(f), lt(() => {
        a.show(f), f.qAnchorHandled = !0;
      });
    },
    prevent: Ot,
    mobileTouch(f) {
      if (c.mobileCleanup(f), d(f) !== !0)
        return;
      a.hide(f), r.value.classList.add("non-selectable");
      const _ = f.target;
      Jt(c, "anchor", [
        [_, "touchmove", "mobileCleanup", "passive"],
        [_, "touchend", "mobileCleanup", "passive"],
        [_, "touchcancel", "mobileCleanup", "passive"],
        [r.value, "contextmenu", "prevent", "notPassive"]
      ]), s = setTimeout(() => {
        s = null, a.show(f), f.qAnchorHandled = !0;
      }, 300);
    },
    mobileCleanup(f) {
      r.value.classList.remove("non-selectable"), s !== null && (clearTimeout(s), s = null), e.value === !0 && f !== void 0 && kn();
    }
  }), l = function(f = n.contextMenu) {
    if (n.noParentEvent === !0 || r.value === null)
      return;
    let _;
    f === !0 ? a.$q.platform.is.mobile === !0 ? _ = [
      [r.value, "touchstart", "mobileTouch", "passive"]
    ] : _ = [
      [r.value, "mousedown", "hide", "passive"],
      [r.value, "contextmenu", "contextClick", "notPassive"]
    ] : _ = [
      [r.value, "click", "toggle", "passive"],
      [r.value, "keyup", "toggleKey", "passive"]
    ], Jt(c, "anchor", _);
  });
  function u() {
    fl(c, "anchor");
  }
  function m(f) {
    for (r.value = f; r.value.classList.contains("q-anchor--skip"); )
      r.value = r.value.parentNode;
    l();
  }
  function p() {
    if (n.target === !1 || n.target === "" || a.$el.parentNode === null)
      r.value = null;
    else if (n.target === !0)
      m(a.$el.parentNode);
    else {
      let f = n.target;
      if (typeof n.target == "string")
        try {
          f = document.querySelector(n.target);
        } catch {
          f = void 0;
        }
      f != null ? (r.value = f.$el || f, l()) : (r.value = null, console.error(`Anchor: target "${n.target}" not found`));
    }
  }
  return me(() => n.contextMenu, (f) => {
    r.value !== null && (u(), l(f));
  }), me(() => n.target, () => {
    r.value !== null && u(), p();
  }), me(() => n.noParentEvent, (f) => {
    r.value !== null && (f === !0 ? u() : l());
  }), wt(() => {
    p(), t !== !0 && n.modelValue === !0 && r.value === null && i("update:modelValue", !1);
  }), _t(() => {
    s !== null && clearTimeout(s), u();
  }), {
    anchorEl: r,
    canShow: d,
    anchorEvents: c
  };
}
function Ni(e, t) {
  const l = G(null);
  let n;
  function a(s, d) {
    const c = `${d !== void 0 ? "add" : "remove"}EventListener`, u = d !== void 0 ? d : n;
    s !== window && s[c]("scroll", u, $t.passive), window[c]("scroll", u, $t.passive), n = d;
  }
  function i() {
    l.value !== null && (a(l.value), l.value = null);
  }
  const r = me(() => e.noParentEvent, () => {
    l.value !== null && (i(), t());
  });
  return _t(r), {
    localScrollTarget: l,
    unconfigureScrollTarget: i,
    changeScrollEvent: a
  };
}
let Ol = [], Cn = [];
function Wi(e) {
  Cn = Cn.filter((t) => t !== e);
}
function Zu(e) {
  Wi(e), Cn.push(e);
}
function zo(e) {
  Wi(e), Cn.length === 0 && Ol.length !== 0 && (Ol[Ol.length - 1](), Ol = []);
}
function dn(e) {
  Cn.length === 0 ? e() : Ol.push(e);
}
function Xu(e) {
  Ol = Ol.filter((t) => t !== e);
}
const Uo = {};
let Ju = 1, es = document.body;
function ts(e, t) {
  const l = document.createElement("div");
  if (l.id = t !== void 0 ? `q-portal--${t}--${Ju++}` : e, Uo.globalNodes !== void 0) {
    const n = Uo.globalNodes.class;
    n !== void 0 && (l.className = n);
  }
  return es.appendChild(l), l;
}
function ls(e) {
  e.remove();
}
const Xl = [];
function ns(e) {
  return Xl.find(
    (t) => t.contentEl !== null && t.contentEl.contains(e)
  );
}
function Qi(e, t) {
  do {
    if (e.$options.name === "QMenu") {
      if (e.hide(t), e.$props.separateClosePopup === !0)
        return jn(e);
    } else if (e.__qPortal === !0) {
      const l = jn(e);
      return l !== void 0 && l.$options.name === "QPopupProxy" ? (e.hide(t), l) : e;
    }
    e = jn(e);
  } while (e != null);
}
function as(e, t, l) {
  for (; l !== 0 && e !== void 0 && e !== null; ) {
    if (e.__qPortal === !0) {
      if (l--, e.$options.name === "QMenu") {
        e = Qi(e, t);
        continue;
      }
      e.hide(t);
    }
    e = jn(e);
  }
}
function os(e) {
  for (e = e.parent; e != null; ) {
    if (e.type.name === "QGlobalDialog")
      return !0;
    if (e.type.name === "QDialog" || e.type.name === "QMenu")
      return !1;
    e = e.parent;
  }
  return !1;
}
function so(e, t, l, n) {
  const a = G(!1), i = G(!1);
  let r = null;
  const s = {}, d = n === "dialog" && os(e);
  function c(m) {
    if (m === !0) {
      zo(s), i.value = !0;
      return;
    }
    i.value = !1, a.value === !1 && (d === !1 && r === null && (r = ts(!1, n)), a.value = !0, Xl.push(e.proxy), Zu(s));
  }
  function u(m) {
    if (i.value = !1, m !== !0)
      return;
    zo(s), a.value = !1;
    const p = Xl.indexOf(e.proxy);
    p !== -1 && Xl.splice(p, 1), r !== null && (ls(r), r = null);
  }
  return $i(() => {
    u(!0);
  }), e.proxy.__qPortal = !0, Kt(e.proxy, "contentEl", () => t.value), {
    showPortal: c,
    hidePortal: u,
    portalIsActive: a,
    portalIsAccessible: i,
    renderPortal: () => d === !0 ? l() : a.value === !0 ? [V(gu, { to: r }, l())] : void 0
  };
}
const da = {
  transitionShow: {
    type: String,
    default: "fade"
  },
  transitionHide: {
    type: String,
    default: "fade"
  },
  transitionDuration: {
    type: [String, Number],
    default: 300
  }
};
function co(e, t = () => {
}, l = () => {
}) {
  return {
    transitionProps: b(() => {
      const n = `q-transition--${e.transitionShow || t()}`, a = `q-transition--${e.transitionHide || l()}`;
      return {
        appear: !0,
        enterFromClass: `${n}-enter-from`,
        enterActiveClass: `${n}-enter-active`,
        enterToClass: `${n}-enter-to`,
        leaveFromClass: `${a}-leave-from`,
        leaveActiveClass: `${a}-leave-active`,
        leaveToClass: `${a}-leave-to`
      };
    }),
    transitionStyle: b(() => `--q-transition-duration: ${e.transitionDuration}ms`)
  };
}
function Jl() {
  let e;
  const t = Ae();
  function l() {
    e = void 0;
  }
  return zl(l), _t(l), {
    removeTick: l,
    registerTick(n) {
      e = n, lt(() => {
        e === n && (oa(t) === !1 && e(), e = void 0);
      });
    }
  };
}
function qn() {
  let e = null;
  const t = Ae();
  function l() {
    e !== null && (clearTimeout(e), e = null);
  }
  return zl(l), _t(l), {
    removeTimeout: l,
    registerTimeout(n, a) {
      l(), oa(t) === !1 && (e = setTimeout(n, a));
    }
  };
}
function Na(e, t) {
  const l = e.style;
  for (const n in t)
    l[n] = t[n];
}
function is(e) {
  if (e == null)
    return;
  if (typeof e == "string")
    try {
      return document.querySelector(e) || void 0;
    } catch {
      return;
    }
  const t = o(e);
  if (t)
    return t.$el || t;
}
function Ki(e, t) {
  if (e == null || e.contains(t) === !0)
    return !0;
  for (let l = e.nextElementSibling; l !== null; l = l.nextElementSibling)
    if (l.contains(t))
      return !0;
  return !1;
}
const rs = [null, document, document.body, document.scrollingElement, document.documentElement];
function fo(e, t) {
  let l = is(t);
  if (l === void 0) {
    if (e == null)
      return window;
    l = e.closest(".scroll,.scroll-y,.overflow-auto");
  }
  return rs.includes(l) ? window : l;
}
function us(e) {
  return e === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : e.scrollTop;
}
function ss(e) {
  return e === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : e.scrollLeft;
}
let Ln;
function ds() {
  if (Ln !== void 0)
    return Ln;
  const e = document.createElement("p"), t = document.createElement("div");
  Na(e, {
    width: "100%",
    height: "200px"
  }), Na(t, {
    position: "absolute",
    top: "0px",
    left: "0px",
    visibility: "hidden",
    width: "200px",
    height: "150px",
    overflow: "hidden"
  }), t.appendChild(e), document.body.appendChild(t);
  const l = e.offsetWidth;
  t.style.overflow = "scroll";
  let n = e.offsetWidth;
  return l === n && (n = t.clientWidth), t.remove(), Ln = l - n, Ln;
}
function cs(e, t = !0) {
  return !e || e.nodeType !== Node.ELEMENT_NODE ? !1 : t ? e.scrollHeight > e.clientHeight && (e.classList.contains("scroll") || e.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(e)["overflow-y"])) : e.scrollWidth > e.clientWidth && (e.classList.contains("scroll") || e.classList.contains("overflow-auto") || ["auto", "scroll"].includes(window.getComputedStyle(e)["overflow-x"]));
}
const { notPassiveCapture: Qn } = $t, Bl = [];
function Kn(e) {
  const t = e.target;
  if (t === void 0 || t.nodeType === 8 || t.classList.contains("no-pointer-events") === !0)
    return;
  let l = Xl.length - 1;
  for (; l >= 0; ) {
    const n = Xl[l].$;
    if (n.type.name !== "QDialog")
      break;
    if (n.props.seamless !== !0)
      return;
    l--;
  }
  for (let n = Bl.length - 1; n >= 0; n--) {
    const a = Bl[n];
    if ((a.anchorEl.value === null || a.anchorEl.value.contains(t) === !1) && (t === document.body || a.innerRef.value !== null && a.innerRef.value.contains(t) === !1))
      e.qClickOutside = !0, a.onClickOutside(e);
    else
      return;
  }
}
function Gi(e) {
  Bl.push(e), Bl.length === 1 && (document.addEventListener("mousedown", Kn, Qn), document.addEventListener("touchstart", Kn, Qn));
}
function Gn(e) {
  const t = Bl.findIndex((l) => l === e);
  t > -1 && (Bl.splice(t, 1), Bl.length === 0 && (document.removeEventListener("mousedown", Kn, Qn), document.removeEventListener("touchstart", Kn, Qn)));
}
let Ho, Yo;
function Zn(e) {
  const t = e.split(" ");
  return t.length !== 2 ? !1 : ["top", "center", "bottom"].includes(t[0]) !== !0 ? (console.error("Anchor/Self position must start with one of top/center/bottom"), !1) : ["left", "middle", "right", "start", "end"].includes(t[1]) !== !0 ? (console.error("Anchor/Self position must end with one of left/middle/right/start/end"), !1) : !0;
}
function Zi(e) {
  return e ? !(e.length !== 2 || typeof e[0] != "number" || typeof e[1] != "number") : !0;
}
const Wa = {
  "start#ltr": "left",
  "start#rtl": "right",
  "end#ltr": "right",
  "end#rtl": "left"
};
["left", "middle", "right"].forEach((e) => {
  Wa[`${e}#ltr`] = e, Wa[`${e}#rtl`] = e;
});
function Xn(e, t) {
  const l = e.split(" ");
  return {
    vertical: l[0],
    horizontal: Wa[`${l[1]}#${t === !0 ? "rtl" : "ltr"}`]
  };
}
function fs(e, t) {
  let { top: l, left: n, right: a, bottom: i, width: r, height: s } = e.getBoundingClientRect();
  return t !== void 0 && (l -= t[1], n -= t[0], i += t[1], a += t[0], r += t[0], s += t[1]), {
    top: l,
    bottom: i,
    height: s,
    left: n,
    right: a,
    width: r,
    middle: n + (a - n) / 2,
    center: l + (i - l) / 2
  };
}
function vs(e, t, l) {
  let { top: n, left: a } = e.getBoundingClientRect();
  return n += t.top, a += t.left, l !== void 0 && (n += l[1], a += l[0]), {
    top: n,
    bottom: n + 1,
    height: 1,
    left: a,
    right: a + 1,
    width: 1,
    middle: a,
    center: n
  };
}
function ms(e) {
  return {
    top: 0,
    center: e.offsetHeight / 2,
    bottom: e.offsetHeight,
    left: 0,
    middle: e.offsetWidth / 2,
    right: e.offsetWidth
  };
}
function jo(e, t, l) {
  return {
    top: e[l.anchorOrigin.vertical] - t[l.selfOrigin.vertical],
    left: e[l.anchorOrigin.horizontal] - t[l.selfOrigin.horizontal]
  };
}
function Xi(e) {
  if (mt.is.ios === !0 && window.visualViewport !== void 0) {
    const s = document.body.style, { offsetLeft: d, offsetTop: c } = window.visualViewport;
    d !== Ho && (s.setProperty("--q-pe-left", d + "px"), Ho = d), c !== Yo && (s.setProperty("--q-pe-top", c + "px"), Yo = c);
  }
  const { scrollLeft: t, scrollTop: l } = e.el, n = e.absoluteOffset === void 0 ? fs(e.anchorEl, e.cover === !0 ? [0, 0] : e.offset) : vs(e.anchorEl, e.absoluteOffset, e.offset);
  let a = {
    maxHeight: e.maxHeight,
    maxWidth: e.maxWidth,
    visibility: "visible"
  };
  (e.fit === !0 || e.cover === !0) && (a.minWidth = n.width + "px", e.cover === !0 && (a.minHeight = n.height + "px")), Object.assign(e.el.style, a);
  const i = ms(e.el);
  let r = jo(n, i, e);
  if (e.absoluteOffset === void 0 || e.offset === void 0)
    Ta(r, n, i, e.anchorOrigin, e.selfOrigin);
  else {
    const { top: s, left: d } = r;
    Ta(r, n, i, e.anchorOrigin, e.selfOrigin);
    let c = !1;
    if (r.top !== s) {
      c = !0;
      const u = 2 * e.offset[1];
      n.center = n.top -= u, n.bottom -= u + 2;
    }
    if (r.left !== d) {
      c = !0;
      const u = 2 * e.offset[0];
      n.middle = n.left -= u, n.right -= u + 2;
    }
    c === !0 && (r = jo(n, i, e), Ta(r, n, i, e.anchorOrigin, e.selfOrigin));
  }
  a = {
    top: r.top + "px",
    left: r.left + "px"
  }, r.maxHeight !== void 0 && (a.maxHeight = r.maxHeight + "px", n.height > r.maxHeight && (a.minHeight = a.maxHeight)), r.maxWidth !== void 0 && (a.maxWidth = r.maxWidth + "px", n.width > r.maxWidth && (a.minWidth = a.maxWidth)), Object.assign(e.el.style, a), e.el.scrollTop !== l && (e.el.scrollTop = l), e.el.scrollLeft !== t && (e.el.scrollLeft = t);
}
function Ta(e, t, l, n, a) {
  const i = l.bottom, r = l.right, s = ds(), d = window.innerHeight - s, c = document.body.clientWidth;
  if (e.top < 0 || e.top + i > d)
    if (a.vertical === "center")
      e.top = t[n.vertical] > d / 2 ? Math.max(0, d - i) : 0, e.maxHeight = Math.min(i, d);
    else if (t[n.vertical] > d / 2) {
      const u = Math.min(
        d,
        n.vertical === "center" ? t.center : n.vertical === a.vertical ? t.bottom : t.top
      );
      e.maxHeight = Math.min(i, u), e.top = Math.max(0, u - i);
    } else
      e.top = Math.max(
        0,
        n.vertical === "center" ? t.center : n.vertical === a.vertical ? t.top : t.bottom
      ), e.maxHeight = Math.min(i, d - e.top);
  if (e.left < 0 || e.left + r > c)
    if (e.maxWidth = Math.min(r, c), a.horizontal === "middle")
      e.left = t[n.horizontal] > c / 2 ? Math.max(0, c - r) : 0;
    else if (t[n.horizontal] > c / 2) {
      const u = Math.min(
        c,
        n.horizontal === "middle" ? t.middle : n.horizontal === a.horizontal ? t.right : t.left
      );
      e.maxWidth = Math.min(r, u), e.left = Math.max(0, u - e.maxWidth);
    } else
      e.left = Math.max(
        0,
        n.horizontal === "middle" ? t.middle : n.horizontal === a.horizontal ? t.left : t.right
      ), e.maxWidth = Math.min(r, c - e.left);
}
const nt = De({
  name: "QTooltip",
  inheritAttrs: !1,
  props: {
    ...ro,
    ...ra,
    ...da,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    },
    transitionShow: {
      default: "jump-down"
    },
    transitionHide: {
      default: "jump-up"
    },
    anchor: {
      type: String,
      default: "bottom middle",
      validator: Zn
    },
    self: {
      type: String,
      default: "top middle",
      validator: Zn
    },
    offset: {
      type: Array,
      default: () => [14, 14],
      validator: Zi
    },
    scrollTarget: {
      default: void 0
    },
    delay: {
      type: Number,
      default: 0
    },
    hideDelay: {
      type: Number,
      default: 0
    }
  },
  emits: [
    ...ua
  ],
  setup(e, { slots: t, emit: l, attrs: n }) {
    let a, i;
    const r = Ae(), { proxy: { $q: s } } = r, d = G(null), c = G(!1), u = b(() => Xn(e.anchor, s.lang.rtl)), m = b(() => Xn(e.self, s.lang.rtl)), p = b(() => e.persistent !== !0), { registerTick: f, removeTick: _ } = Jl(), { registerTimeout: v } = qn(), { transitionProps: y, transitionStyle: M } = co(e), { localScrollTarget: w, changeScrollEvent: S, unconfigureScrollTarget: h } = Ni(e, Q), { anchorEl: C, canShow: T, anchorEvents: I } = uo({ showing: c, configureAnchorEl: K }), { show: E, hide: A } = sa({
      showing: c,
      canShow: T,
      handleShow: k,
      handleHide: g,
      hideOnRouteChange: p,
      processOnMount: !0
    });
    Object.assign(I, { delayShow: q, delayHide: Y });
    const { showPortal: O, hidePortal: P, renderPortal: $ } = so(r, d, H, "tooltip");
    if (s.platform.is.mobile === !0) {
      const R = {
        anchorEl: C,
        innerRef: d,
        onClickOutside(te) {
          return A(te), te.target.classList.contains("q-dialog__backdrop") && Ze(te), !0;
        }
      }, ie = b(
        () => (
          // it doesn't has external model
          // (null is the default value)
          e.modelValue === null && e.persistent !== !0 && c.value === !0
        )
      );
      me(ie, (te) => {
        (te === !0 ? Gi : Gn)(R);
      }), _t(() => {
        Gn(R);
      });
    }
    function k(R) {
      O(), f(() => {
        i = new MutationObserver(() => B()), i.observe(d.value, { attributes: !1, childList: !0, characterData: !0, subtree: !0 }), B(), Q();
      }), a === void 0 && (a = me(
        () => s.screen.width + "|" + s.screen.height + "|" + e.self + "|" + e.anchor + "|" + s.lang.rtl,
        B
      )), v(() => {
        O(!0), l("show", R);
      }, e.transitionDuration);
    }
    function g(R) {
      _(), P(), x(), v(() => {
        P(!0), l("hide", R);
      }, e.transitionDuration);
    }
    function x() {
      i !== void 0 && (i.disconnect(), i = void 0), a !== void 0 && (a(), a = void 0), h(), fl(I, "tooltipTemp");
    }
    function B() {
      const R = d.value;
      C.value === null || !R || Xi({
        el: R,
        offset: e.offset,
        anchorEl: C.value,
        anchorOrigin: u.value,
        selfOrigin: m.value,
        maxHeight: e.maxHeight,
        maxWidth: e.maxWidth
      });
    }
    function q(R) {
      if (s.platform.is.mobile === !0) {
        kn(), document.body.classList.add("non-selectable");
        const ie = C.value, te = ["touchmove", "touchcancel", "touchend", "click"].map((oe) => [ie, oe, "delayHide", "passiveCapture"]);
        Jt(I, "tooltipTemp", te);
      }
      v(() => {
        E(R);
      }, e.delay);
    }
    function Y(R) {
      s.platform.is.mobile === !0 && (fl(I, "tooltipTemp"), kn(), setTimeout(() => {
        document.body.classList.remove("non-selectable");
      }, 10)), v(() => {
        A(R);
      }, e.hideDelay);
    }
    function K() {
      if (e.noParentEvent === !0 || C.value === null)
        return;
      const R = s.platform.is.mobile === !0 ? [
        [C.value, "touchstart", "delayShow", "passive"]
      ] : [
        [C.value, "mouseenter", "delayShow", "passive"],
        [C.value, "mouseleave", "delayHide", "passive"]
      ];
      Jt(I, "anchor", R);
    }
    function Q() {
      if (C.value !== null || e.scrollTarget !== void 0) {
        w.value = fo(C.value, e.scrollTarget);
        const R = e.noParentEvent === !0 ? B : A;
        S(w.value, R);
      }
    }
    function W() {
      return c.value === !0 ? V("div", {
        ...n,
        ref: d,
        class: [
          "q-tooltip q-tooltip--style q-position-engine no-pointer-events",
          n.class
        ],
        style: [
          n.style,
          M.value
        ],
        role: "tooltip"
      }, We(t.default)) : null;
    }
    function H() {
      return V(Qt, y.value, W);
    }
    return _t(x), Object.assign(r.proxy, { updatePosition: B }), $;
  }
}), ps = {
  size: {
    type: [Number, String],
    default: "1em"
  },
  color: String
};
function bs(e) {
  return {
    cSize: b(() => e.size in Ya ? `${Ya[e.size]}px` : e.size),
    classes: b(
      () => "q-spinner" + (e.color ? ` text-${e.color}` : "")
    )
  };
}
const Ji = De({
  name: "QSpinner",
  props: {
    ...ps,
    thickness: {
      type: Number,
      default: 5
    }
  },
  setup(e) {
    const { cSize: t, classes: l } = bs(e);
    return () => V("svg", {
      class: l.value + " q-spinner-mat",
      width: t.value,
      height: t.value,
      viewBox: "25 25 50 50"
    }, [
      V("circle", {
        class: "path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": e.thickness,
        "stroke-miterlimit": "10"
      })
    ]);
  }
});
function hs(e, t = 250) {
  let l = !1, n;
  return function() {
    return l === !1 && (l = !0, setTimeout(() => {
      l = !1;
    }, t), n = e.apply(this, arguments)), n;
  };
}
function No(e, t, l, n) {
  l.modifiers.stop === !0 && Pt(e);
  const a = l.modifiers.color;
  let i = l.modifiers.center;
  i = i === !0 || n === !0;
  const r = document.createElement("span"), s = document.createElement("span"), d = Cl(e), { left: c, top: u, width: m, height: p } = t.getBoundingClientRect(), f = Math.sqrt(m * m + p * p), _ = f / 2, v = `${(m - f) / 2}px`, y = i ? v : `${d.left - c - _}px`, M = `${(p - f) / 2}px`, w = i ? M : `${d.top - u - _}px`;
  s.className = "q-ripple__inner", Na(s, {
    height: `${f}px`,
    width: `${f}px`,
    transform: `translate3d(${y},${w},0) scale3d(.2,.2,1)`,
    opacity: 0
  }), r.className = `q-ripple${a ? " text-" + a : ""}`, r.setAttribute("dir", "ltr"), r.appendChild(s), t.appendChild(r);
  const S = () => {
    r.remove(), clearTimeout(h);
  };
  l.abort.push(S);
  let h = setTimeout(() => {
    s.classList.add("q-ripple__inner--enter"), s.style.transform = `translate3d(${v},${M},0) scale3d(1,1,1)`, s.style.opacity = 0.2, h = setTimeout(() => {
      s.classList.remove("q-ripple__inner--enter"), s.classList.add("q-ripple__inner--leave"), s.style.opacity = 0, h = setTimeout(() => {
        r.remove(), l.abort.splice(l.abort.indexOf(S), 1);
      }, 275);
    }, 250);
  }, 50);
}
function Wo(e, { modifiers: t, value: l, arg: n }) {
  const a = Object.assign({}, e.cfg.ripple, t, l);
  e.modifiers = {
    early: a.early === !0,
    stop: a.stop === !0,
    center: a.center === !0,
    color: a.color || n,
    keyCodes: [].concat(a.keyCodes || 13)
  };
}
const ca = aa(
  {
    name: "ripple",
    beforeMount(e, t) {
      const l = t.instance.$.appContext.config.globalProperties.$q.config || {};
      if (l.ripple === !1)
        return;
      const n = {
        cfg: l,
        enabled: t.value !== !1,
        modifiers: {},
        abort: [],
        start(a) {
          n.enabled === !0 && a.qSkipRipple !== !0 && a.type === (n.modifiers.early === !0 ? "pointerdown" : "click") && No(a, e, n, a.qKeyEvent === !0);
        },
        keystart: hs((a) => {
          n.enabled === !0 && a.qSkipRipple !== !0 && gl(a, n.modifiers.keyCodes) === !0 && a.type === `key${n.modifiers.early === !0 ? "down" : "up"}` && No(a, e, n, !0);
        }, 300)
      };
      Wo(n, t), e.__qripple = n, Jt(n, "main", [
        [e, "pointerdown", "start", "passive"],
        [e, "click", "start", "passive"],
        [e, "keydown", "keystart", "passive"],
        [e, "keyup", "keystart", "passive"]
      ]);
    },
    updated(e, t) {
      if (t.oldValue !== t.value) {
        const l = e.__qripple;
        l !== void 0 && (l.enabled = t.value !== !1, l.enabled === !0 && Object(t.value) === t.value && Wo(l, t));
      }
    },
    beforeUnmount(e) {
      const t = e.__qripple;
      t !== void 0 && (t.abort.forEach((l) => {
        l();
      }), fl(t, "main"), delete e._qripple);
    }
  }
), er = {
  left: "start",
  center: "center",
  right: "end",
  between: "between",
  around: "around",
  evenly: "evenly",
  stretch: "stretch"
}, gs = Object.keys(er), tr = {
  align: {
    type: String,
    validator: (e) => gs.includes(e)
  }
};
function lr(e) {
  return b(() => {
    const t = e.align === void 0 ? e.vertical === !0 ? "stretch" : "left" : e.align;
    return `${e.vertical === !0 ? "items" : "justify"}-${er[t]}`;
  });
}
const Qo = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32
}, ys = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
}, _s = ["button", "submit", "reset"], Ss = /[^\s]\/[^\s]/, ws = ["flat", "outline", "push", "unelevated"], nr = (e, t) => e.flat === !0 ? "flat" : e.outline === !0 ? "outline" : e.push === !0 ? "push" : e.unelevated === !0 ? "unelevated" : t, ar = (e) => {
  const t = nr(e);
  return t !== void 0 ? { [t]: !0 } : {};
}, vo = {
  ...on,
  ...ia,
  type: {
    type: String,
    default: "button"
  },
  label: [Number, String],
  icon: String,
  iconRight: String,
  ...ws.reduce(
    (e, t) => (e[t] = Boolean) && e,
    {}
  ),
  square: Boolean,
  round: Boolean,
  rounded: Boolean,
  glossy: Boolean,
  size: String,
  fab: Boolean,
  fabMini: Boolean,
  padding: String,
  color: String,
  textColor: String,
  noCaps: Boolean,
  noWrap: Boolean,
  dense: Boolean,
  tabindex: [Number, String],
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  align: {
    ...tr.align,
    default: "center"
  },
  stack: Boolean,
  stretch: Boolean,
  loading: {
    type: Boolean,
    default: null
  },
  disable: Boolean
};
function xs(e) {
  const t = rn(e, ys), l = lr(e), { hasRouterLink: n, hasLink: a, linkTag: i, linkAttrs: r, navigateOnClick: s } = Hi({
    fallbackTag: "button"
  }), d = b(() => {
    const y = e.fab === !1 && e.fabMini === !1 ? t.value : {};
    return e.padding !== void 0 ? Object.assign({}, y, {
      padding: e.padding.split(/\s+/).map((M) => M in Qo ? Qo[M] + "px" : M).join(" "),
      minWidth: "0",
      minHeight: "0"
    }) : y;
  }), c = b(
    () => e.rounded === !0 || e.fab === !0 || e.fabMini === !0
  ), u = b(
    () => e.disable !== !0 && e.loading !== !0
  ), m = b(() => u.value === !0 ? e.tabindex || 0 : -1), p = b(() => nr(e, "standard")), f = b(() => {
    const y = { tabindex: m.value };
    return a.value === !0 ? Object.assign(y, r.value) : _s.includes(e.type) === !0 && (y.type = e.type), i.value === "a" ? (e.disable === !0 ? y["aria-disabled"] = "true" : y.href === void 0 && (y.role = "button"), n.value !== !0 && Ss.test(e.type) === !0 && (y.type = e.type)) : e.disable === !0 && (y.disabled = "", y["aria-disabled"] = "true"), e.loading === !0 && e.percentage !== void 0 && Object.assign(y, {
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": e.percentage
    }), y;
  }), _ = b(() => {
    let y;
    e.color !== void 0 ? e.flat === !0 || e.outline === !0 ? y = `text-${e.textColor || e.color}` : y = `bg-${e.color} text-${e.textColor || "white"}` : e.textColor && (y = `text-${e.textColor}`);
    const M = e.round === !0 ? "round" : `rectangle${c.value === !0 ? " q-btn--rounded" : e.square === !0 ? " q-btn--square" : ""}`;
    return `q-btn--${p.value} q-btn--${M}` + (y !== void 0 ? " " + y : "") + (u.value === !0 ? " q-btn--actionable q-focusable q-hoverable" : e.disable === !0 ? " disabled" : "") + (e.fab === !0 ? " q-btn--fab" : e.fabMini === !0 ? " q-btn--fab-mini" : "") + (e.noCaps === !0 ? " q-btn--no-uppercase" : "") + (e.dense === !0 ? " q-btn--dense" : "") + (e.stretch === !0 ? " no-border-radius self-stretch" : "") + (e.glossy === !0 ? " glossy" : "") + (e.square ? " q-btn--square" : "");
  }), v = b(
    () => l.value + (e.stack === !0 ? " column" : " row") + (e.noWrap === !0 ? " no-wrap text-no-wrap" : "") + (e.loading === !0 ? " q-btn__content--hidden" : "")
  );
  return {
    classes: _,
    style: d,
    innerClasses: v,
    attributes: f,
    hasLink: a,
    linkTag: i,
    navigateOnClick: s,
    isActionable: u
  };
}
const { passiveCapture: ll } = $t;
let jl = null, Nl = null, Wl = null;
const se = De({
  name: "QBtn",
  props: {
    ...vo,
    percentage: Number,
    darkPercentage: Boolean,
    onTouchstart: [Function, Array]
  },
  emits: ["click", "keydown", "mousedown", "keyup"],
  setup(e, { slots: t, emit: l }) {
    const { proxy: n } = Ae(), {
      classes: a,
      style: i,
      innerClasses: r,
      attributes: s,
      hasLink: d,
      linkTag: c,
      navigateOnClick: u,
      isActionable: m
    } = xs(e), p = G(null), f = G(null);
    let _ = null, v, y = null;
    const M = b(
      () => e.label !== void 0 && e.label !== null && e.label !== ""
    ), w = b(() => e.disable === !0 || e.ripple === !1 ? !1 : {
      keyCodes: d.value === !0 ? [13, 32] : [13],
      ...e.ripple === !0 ? {} : e.ripple
    }), S = b(() => ({ center: e.round })), h = b(() => {
      const g = Math.max(0, Math.min(100, e.percentage));
      return g > 0 ? { transition: "transform 0.6s", transform: `translateX(${g - 100}%)` } : {};
    }), C = b(() => {
      if (e.loading === !0)
        return {
          onMousedown: k,
          onTouchstart: k,
          onClick: k,
          onKeydown: k,
          onKeyup: k
        };
      if (m.value === !0) {
        const g = {
          onClick: I,
          onKeydown: E,
          onMousedown: O
        };
        if (n.$q.platform.has.touch === !0) {
          const x = e.onTouchstart !== void 0 ? "" : "Passive";
          g[`onTouchstart${x}`] = A;
        }
        return g;
      }
      return {
        // needed; especially for disabled <a> tags
        onClick: Ze
      };
    }), T = b(() => ({
      ref: p,
      class: "q-btn q-btn-item non-selectable no-outline " + a.value,
      style: i.value,
      ...s.value,
      ...C.value
    }));
    function I(g) {
      if (p.value !== null) {
        if (g !== void 0) {
          if (g.defaultPrevented === !0)
            return;
          const x = document.activeElement;
          if (e.type === "submit" && x !== document.body && p.value.contains(x) === !1 && x.contains(p.value) === !1) {
            p.value.focus();
            const B = () => {
              document.removeEventListener("keydown", Ze, !0), document.removeEventListener("keyup", B, ll), p.value !== null && p.value.removeEventListener("blur", B, ll);
            };
            document.addEventListener("keydown", Ze, !0), document.addEventListener("keyup", B, ll), p.value.addEventListener("blur", B, ll);
          }
        }
        u(g);
      }
    }
    function E(g) {
      p.value !== null && (l("keydown", g), gl(g, [13, 32]) === !0 && Nl !== p.value && (Nl !== null && $(), g.defaultPrevented !== !0 && (p.value.focus(), Nl = p.value, p.value.classList.add("q-btn--active"), document.addEventListener("keyup", P, !0), p.value.addEventListener("blur", P, ll)), Ze(g)));
    }
    function A(g) {
      p.value !== null && (l("touchstart", g), g.defaultPrevented !== !0 && (jl !== p.value && (jl !== null && $(), jl = p.value, _ = g.target, _.addEventListener("touchcancel", P, ll), _.addEventListener("touchend", P, ll)), v = !0, y !== null && clearTimeout(y), y = setTimeout(() => {
        y = null, v = !1;
      }, 200)));
    }
    function O(g) {
      p.value !== null && (g.qSkipRipple = v === !0, l("mousedown", g), g.defaultPrevented !== !0 && Wl !== p.value && (Wl !== null && $(), Wl = p.value, p.value.classList.add("q-btn--active"), document.addEventListener("mouseup", P, ll)));
    }
    function P(g) {
      if (p.value !== null && !(g !== void 0 && g.type === "blur" && document.activeElement === p.value)) {
        if (g !== void 0 && g.type === "keyup") {
          if (Nl === p.value && gl(g, [13, 32]) === !0) {
            const x = new MouseEvent("click", g);
            x.qKeyEvent = !0, g.defaultPrevented === !0 && Ot(x), g.cancelBubble === !0 && Pt(x), p.value.dispatchEvent(x), Ze(g), g.qKeyEvent = !0;
          }
          l("keyup", g);
        }
        $();
      }
    }
    function $(g) {
      const x = f.value;
      g !== !0 && (jl === p.value || Wl === p.value) && x !== null && x !== document.activeElement && (x.setAttribute("tabindex", -1), x.focus()), jl === p.value && (_ !== null && (_.removeEventListener("touchcancel", P, ll), _.removeEventListener("touchend", P, ll)), jl = _ = null), Wl === p.value && (document.removeEventListener("mouseup", P, ll), Wl = null), Nl === p.value && (document.removeEventListener("keyup", P, !0), p.value !== null && p.value.removeEventListener("blur", P, ll), Nl = null), p.value !== null && p.value.classList.remove("q-btn--active");
    }
    function k(g) {
      Ze(g), g.qSkipRipple = !0;
    }
    return _t(() => {
      $(!0);
    }), Object.assign(n, { click: I }), () => {
      let g = [];
      e.icon !== void 0 && g.push(
        V(Qe, {
          name: e.icon,
          left: e.stack === !1 && M.value === !0,
          role: "img",
          "aria-hidden": "true"
        })
      ), M.value === !0 && g.push(
        V("span", { class: "block" }, [e.label])
      ), g = al(t.default, g), e.iconRight !== void 0 && e.round === !1 && g.push(
        V(Qe, {
          name: e.iconRight,
          right: e.stack === !1 && M.value === !0,
          role: "img",
          "aria-hidden": "true"
        })
      );
      const x = [
        V("span", {
          class: "q-focus-helper",
          ref: f
        })
      ];
      return e.loading === !0 && e.percentage !== void 0 && x.push(
        V("span", {
          class: "q-btn__progress absolute-full overflow-hidden" + (e.darkPercentage === !0 ? " q-btn__progress--dark" : "")
        }, [
          V("span", {
            class: "q-btn__progress-indicator fit block",
            style: h.value
          })
        ])
      ), x.push(
        V("span", {
          class: "q-btn__content text-center col items-center q-anchor--skip " + r.value
        }, g)
      ), e.loading !== null && x.push(
        V(Qt, {
          name: "q-transition--fade"
        }, () => e.loading === !0 ? [
          V("span", {
            key: "loading",
            class: "absolute-full flex flex-center"
          }, t.loading !== void 0 ? t.loading() : [V(Ji)])
        ] : null)
      ), Ct(
        V(
          c.value,
          T.value,
          x
        ),
        [[
          ca,
          w.value,
          void 0,
          S.value
        ]]
      );
    };
  }
}), fa = De({
  name: "QBar",
  props: {
    ...Tt,
    dense: Boolean
  },
  setup(e, { slots: t }) {
    const { proxy: { $q: l } } = Ae(), n = Mt(e, l), a = b(
      () => `q-bar row no-wrap items-center q-bar--${e.dense === !0 ? "dense" : "standard"}  q-bar--${n.value === !0 ? "dark" : "light"}`
    );
    return () => V("div", {
      class: a.value,
      role: "toolbar"
    }, We(t.default));
  }
}), ks = [
  "text",
  "rect",
  "circle",
  "QBtn",
  "QBadge",
  "QChip",
  "QToolbar",
  "QCheckbox",
  "QRadio",
  "QToggle",
  "QSlider",
  "QRange",
  "QInput",
  "QAvatar"
], Cs = [
  "wave",
  "pulse",
  "pulse-x",
  "pulse-y",
  "fade",
  "blink",
  "none"
], qs = De({
  name: "QSkeleton",
  props: {
    ...Tt,
    tag: {
      type: String,
      default: "div"
    },
    type: {
      type: String,
      validator: (e) => ks.includes(e),
      default: "rect"
    },
    animation: {
      type: String,
      validator: (e) => Cs.includes(e),
      default: "wave"
    },
    animationSpeed: {
      type: [String, Number],
      default: 1500
    },
    square: Boolean,
    bordered: Boolean,
    size: String,
    width: String,
    height: String
  },
  setup(e, { slots: t }) {
    const l = Ae(), n = Mt(e, l.proxy.$q), a = b(() => {
      const r = e.size !== void 0 ? [e.size, e.size] : [e.width, e.height];
      return {
        "--q-skeleton-speed": `${e.animationSpeed}ms`,
        width: r[0],
        height: r[1]
      };
    }), i = b(
      () => `q-skeleton q-skeleton--${n.value === !0 ? "dark" : "light"} q-skeleton--type-${e.type}` + (e.animation !== "none" ? ` q-skeleton--anim q-skeleton--anim-${e.animation}` : "") + (e.square === !0 ? " q-skeleton--square" : "") + (e.bordered === !0 ? " q-skeleton--bordered" : "")
    );
    return () => V(e.tag, {
      class: i.value,
      style: a.value
    }, We(t.default));
  }
}), cn = De({
  name: "QCardSection",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    horizontal: Boolean
  },
  setup(e, { slots: t }) {
    const l = b(
      () => `q-card__section q-card__section--${e.horizontal === !0 ? "horiz row no-wrap" : "vert"}`
    );
    return () => V(e.tag, { class: l.value }, We(t.default));
  }
}), fn = De({
  name: "QCard",
  props: {
    ...Tt,
    tag: {
      type: String,
      default: "div"
    },
    square: Boolean,
    flat: Boolean,
    bordered: Boolean
  },
  setup(e, { slots: t }) {
    const { proxy: { $q: l } } = Ae(), n = Mt(e, l), a = b(
      () => "q-card" + (n.value === !0 ? " q-card--dark q-dark" : "") + (e.bordered === !0 ? " q-card--bordered" : "") + (e.square === !0 ? " q-card--square no-border-radius" : "") + (e.flat === !0 ? " q-card--flat no-shadow" : "")
    );
    return () => V(e.tag, { class: a.value }, We(t.default));
  }
}), Vs = V("div", { class: "q-space" }), va = De({
  name: "QSpace",
  setup() {
    return () => Vs;
  }
}), mo = De({
  name: "QCardActions",
  props: {
    ...tr,
    vertical: Boolean
  },
  setup(e, { slots: t }) {
    const l = lr(e), n = b(
      () => `q-card__actions ${l.value} q-card__actions--${e.vertical === !0 ? "vert column" : "horiz row"}`
    );
    return () => V("div", { class: n.value }, We(t.default));
  }
});
function Ts(e, t, l) {
  function n() {
  }
  return _t(() => {
    e.value === !0 && void 0;
  }), {
    removeFromHistory: n,
    addToHistory() {
    }
  };
}
let mn = 0, Ma, Da, hn, Ia = !1, Ko, Go, Zo, $l = null;
function Ms(e) {
  Ds(e) && Ze(e);
}
function Ds(e) {
  if (e.target === document.body || e.target.classList.contains("q-layout__backdrop"))
    return !0;
  const t = Bu(e), l = e.shiftKey && !e.deltaX, n = !l && Math.abs(e.deltaX) <= Math.abs(e.deltaY), a = l || n ? e.deltaY : e.deltaX;
  for (let i = 0; i < t.length; i++) {
    const r = t[i];
    if (cs(r, n))
      return n ? a < 0 && r.scrollTop === 0 ? !0 : a > 0 && r.scrollTop + r.clientHeight === r.scrollHeight : a < 0 && r.scrollLeft === 0 ? !0 : a > 0 && r.scrollLeft + r.clientWidth === r.scrollWidth;
  }
  return !0;
}
function Xo(e) {
  e.target === document && (document.scrollingElement.scrollTop = document.scrollingElement.scrollTop);
}
function En(e) {
  Ia !== !0 && (Ia = !0, requestAnimationFrame(() => {
    Ia = !1;
    const { height: t } = e.target, { clientHeight: l, scrollTop: n } = document.scrollingElement;
    (hn === void 0 || t !== window.innerHeight) && (hn = l - t, document.scrollingElement.scrollTop = n), n > hn && (document.scrollingElement.scrollTop -= Math.ceil((n - hn) / 8));
  }));
}
function Jo(e) {
  const t = document.body, l = window.visualViewport !== void 0;
  if (e === "add") {
    const { overflowY: n, overflowX: a } = window.getComputedStyle(t);
    Ma = ss(window), Da = us(window), Ko = t.style.left, Go = t.style.top, Zo = window.location.href, t.style.left = `-${Ma}px`, t.style.top = `-${Da}px`, a !== "hidden" && (a === "scroll" || t.scrollWidth > window.innerWidth) && t.classList.add("q-body--force-scrollbar-x"), n !== "hidden" && (n === "scroll" || t.scrollHeight > window.innerHeight) && t.classList.add("q-body--force-scrollbar-y"), t.classList.add("q-body--prevent-scroll"), document.qScrollPrevented = !0, mt.is.ios === !0 && (l === !0 ? (window.scrollTo(0, 0), window.visualViewport.addEventListener("resize", En, $t.passiveCapture), window.visualViewport.addEventListener("scroll", En, $t.passiveCapture), window.scrollTo(0, 0)) : window.addEventListener("scroll", Xo, $t.passiveCapture));
  }
  mt.is.desktop === !0 && mt.is.mac === !0 && window[`${e}EventListener`]("wheel", Ms, $t.notPassive), e === "remove" && (mt.is.ios === !0 && (l === !0 ? (window.visualViewport.removeEventListener("resize", En, $t.passiveCapture), window.visualViewport.removeEventListener("scroll", En, $t.passiveCapture)) : window.removeEventListener("scroll", Xo, $t.passiveCapture)), t.classList.remove("q-body--prevent-scroll"), t.classList.remove("q-body--force-scrollbar-x"), t.classList.remove("q-body--force-scrollbar-y"), document.qScrollPrevented = !1, t.style.left = Ko, t.style.top = Go, window.location.href === Zo && window.scrollTo(Ma, Da), hn = void 0);
}
function Is(e) {
  let t = "add";
  if (e === !0) {
    if (mn++, $l !== null) {
      clearTimeout($l), $l = null;
      return;
    }
    if (mn > 1)
      return;
  } else {
    if (mn === 0 || (mn--, mn > 0))
      return;
    if (t = "remove", mt.is.ios === !0 && mt.is.nativeMobile === !0) {
      $l !== null && clearTimeout($l), $l = setTimeout(() => {
        Jo(t), $l = null;
      }, 100);
      return;
    }
  }
  Jo(t);
}
function $s() {
  let e;
  return {
    preventBodyScroll(t) {
      t !== e && (e !== void 0 || t === !0) && (e = t, Is(t));
    }
  };
}
const Ll = [];
let nn;
function Fs(e) {
  nn = e.keyCode === 27;
}
function As() {
  nn === !0 && (nn = !1);
}
function Os(e) {
  nn === !0 && (nn = !1, gl(e, 27) === !0 && Ll[Ll.length - 1](e));
}
function or(e) {
  window[e]("keydown", Fs), window[e]("blur", As), window[e]("keyup", Os), nn = !1;
}
function ir(e) {
  mt.is.desktop === !0 && (Ll.push(e), Ll.length === 1 && or("addEventListener"));
}
function Jn(e) {
  const t = Ll.indexOf(e);
  t > -1 && (Ll.splice(t, 1), Ll.length === 0 && or("removeEventListener"));
}
const El = [];
function rr(e) {
  El[El.length - 1](e);
}
function ur(e) {
  mt.is.desktop === !0 && (El.push(e), El.length === 1 && document.body.addEventListener("focusin", rr));
}
function Qa(e) {
  const t = El.indexOf(e);
  t > -1 && (El.splice(t, 1), El.length === 0 && document.body.removeEventListener("focusin", rr));
}
let Pn = 0;
const Bs = {
  standard: "fixed-full flex-center",
  top: "fixed-top justify-center",
  bottom: "fixed-bottom justify-center",
  right: "fixed-right items-center",
  left: "fixed-left items-center"
}, ei = {
  standard: ["scale", "scale"],
  top: ["slide-down", "slide-up"],
  bottom: ["slide-up", "slide-down"],
  right: ["slide-left", "slide-right"],
  left: ["slide-right", "slide-left"]
}, $n = De({
  name: "QDialog",
  inheritAttrs: !1,
  props: {
    ...ra,
    ...da,
    transitionShow: String,
    // override useTransitionProps
    transitionHide: String,
    // override useTransitionProps
    persistent: Boolean,
    autoClose: Boolean,
    allowFocusOutside: Boolean,
    noEscDismiss: Boolean,
    noBackdropDismiss: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    noShake: Boolean,
    seamless: Boolean,
    maximized: Boolean,
    fullWidth: Boolean,
    fullHeight: Boolean,
    square: Boolean,
    position: {
      type: String,
      default: "standard",
      validator: (e) => e === "standard" || ["top", "bottom", "left", "right"].includes(e)
    }
  },
  emits: [
    ...ua,
    "shake",
    "click",
    "escapeKey"
  ],
  setup(e, { slots: t, emit: l, attrs: n }) {
    const a = Ae(), i = G(null), r = G(!1), s = G(!1);
    let d = null, c = null, u, m;
    const p = b(
      () => e.persistent !== !0 && e.noRouteDismiss !== !0 && e.seamless !== !0
    ), { preventBodyScroll: f } = $s(), { registerTimeout: _ } = qn(), { registerTick: v, removeTick: y } = Jl(), { transitionProps: M, transitionStyle: w } = co(
      e,
      () => ei[e.position][0],
      () => ei[e.position][1]
    ), { showPortal: S, hidePortal: h, portalIsAccessible: C, renderPortal: T } = so(
      a,
      i,
      ie,
      "dialog"
    ), { hide: I } = sa({
      showing: r,
      hideOnRouteChange: p,
      handleShow: g,
      handleHide: x,
      processOnMount: !0
    }), { addToHistory: E, removeFromHistory: A } = Ts(r), O = b(
      () => `q-dialog__inner flex no-pointer-events q-dialog__inner--${e.maximized === !0 ? "maximized" : "minimized"} q-dialog__inner--${e.position} ${Bs[e.position]}` + (s.value === !0 ? " q-dialog__inner--animating" : "") + (e.fullWidth === !0 ? " q-dialog__inner--fullwidth" : "") + (e.fullHeight === !0 ? " q-dialog__inner--fullheight" : "") + (e.square === !0 ? " q-dialog__inner--square" : "")
    ), P = b(() => r.value === !0 && e.seamless !== !0), $ = b(() => e.autoClose === !0 ? { onClick: W } : {}), k = b(() => [
      `q-dialog fullscreen no-pointer-events q-dialog--${P.value === !0 ? "modal" : "seamless"}`,
      n.class
    ]);
    me(() => e.maximized, (te) => {
      r.value === !0 && Q(te);
    }), me(P, (te) => {
      f(te), te === !0 ? (ur(R), ir(Y)) : (Qa(R), Jn(Y));
    });
    function g(te) {
      E(), c = e.noRefocus === !1 && document.activeElement !== null ? document.activeElement : null, Q(e.maximized), S(), s.value = !0, e.noFocus !== !0 ? (document.activeElement !== null && document.activeElement.blur(), v(B)) : y(), _(() => {
        if (a.proxy.$q.platform.is.ios === !0) {
          if (e.seamless !== !0 && document.activeElement) {
            const { top: oe, bottom: fe } = document.activeElement.getBoundingClientRect(), { innerHeight: Z } = window, j = window.visualViewport !== void 0 ? window.visualViewport.height : Z;
            oe > 0 && fe > j / 2 && (document.scrollingElement.scrollTop = Math.min(
              document.scrollingElement.scrollHeight - j,
              fe >= Z ? 1 / 0 : Math.ceil(document.scrollingElement.scrollTop + fe - j / 2)
            )), document.activeElement.scrollIntoView();
          }
          m = !0, i.value.click(), m = !1;
        }
        S(!0), s.value = !1, l("show", te);
      }, e.transitionDuration);
    }
    function x(te) {
      y(), A(), K(!0), s.value = !0, h(), c !== null && (((te && te.type.indexOf("key") === 0 ? c.closest('[tabindex]:not([tabindex^="-"])') : void 0) || c).focus(), c = null), _(() => {
        h(!0), s.value = !1, l("hide", te);
      }, e.transitionDuration);
    }
    function B(te) {
      dn(() => {
        let oe = i.value;
        oe === null || oe.contains(document.activeElement) === !0 || (oe = (te !== "" ? oe.querySelector(te) : null) || oe.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || oe.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || oe.querySelector("[autofocus], [data-autofocus]") || oe, oe.focus({ preventScroll: !0 }));
      });
    }
    function q(te) {
      te && typeof te.focus == "function" ? te.focus({ preventScroll: !0 }) : B(), l("shake");
      const oe = i.value;
      oe !== null && (oe.classList.remove("q-animate--scale"), oe.classList.add("q-animate--scale"), d !== null && clearTimeout(d), d = setTimeout(() => {
        d = null, i.value !== null && (oe.classList.remove("q-animate--scale"), B());
      }, 170));
    }
    function Y() {
      e.seamless !== !0 && (e.persistent === !0 || e.noEscDismiss === !0 ? e.maximized !== !0 && e.noShake !== !0 && q() : (l("escapeKey"), I()));
    }
    function K(te) {
      d !== null && (clearTimeout(d), d = null), (te === !0 || r.value === !0) && (Q(!1), e.seamless !== !0 && (f(!1), Qa(R), Jn(Y))), te !== !0 && (c = null);
    }
    function Q(te) {
      te === !0 ? u !== !0 && (Pn < 1 && document.body.classList.add("q-body--dialog"), Pn++, u = !0) : u === !0 && (Pn < 2 && document.body.classList.remove("q-body--dialog"), Pn--, u = !1);
    }
    function W(te) {
      m !== !0 && (I(te), l("click", te));
    }
    function H(te) {
      e.persistent !== !0 && e.noBackdropDismiss !== !0 ? I(te) : e.noShake !== !0 && q();
    }
    function R(te) {
      e.allowFocusOutside !== !0 && C.value === !0 && Ki(i.value, te.target) !== !0 && B('[tabindex]:not([tabindex="-1"])');
    }
    Object.assign(a.proxy, {
      // expose public methods
      focus: B,
      shake: q,
      // private but needed by QSelect
      __updateRefocusTarget(te) {
        c = te || null;
      }
    }), _t(K);
    function ie() {
      return V("div", {
        role: "dialog",
        "aria-modal": P.value === !0 ? "true" : "false",
        ...n,
        class: k.value
      }, [
        V(Qt, {
          name: "q-transition--fade",
          appear: !0
        }, () => P.value === !0 ? V("div", {
          class: "q-dialog__backdrop fixed-full",
          style: w.value,
          "aria-hidden": "true",
          tabindex: -1,
          onClick: H
        }) : null),
        V(
          Qt,
          M.value,
          () => r.value === !0 ? V("div", {
            ref: i,
            class: O.value,
            style: w.value,
            tabindex: -1,
            ...$.value
          }, We(t.default)) : null
        )
      ]);
    }
    return T;
  }
}), Ls = /* @__PURE__ */ Ce({
  __name: "CoreDialog",
  props: {
    cancelColor: { default: "primary" },
    cancelText: { default: "" },
    confirmButtonHidden: { type: Boolean, default: !1 },
    confirmColor: { default: "primary" },
    confirmText: { default: "" },
    errorDialog: { type: Boolean, default: !1 },
    minWidth: {},
    modelValue: { type: Boolean },
    title: {}
  },
  emits: ["cancel", "update:model-value", "valid"],
  setup(e, { emit: t }) {
    const l = e, n = Me("_uct"), a = b(() => l.cancelText || n("core.buttons.cancel")), i = b(() => l.confirmText || n("core.buttons.valid"));
    return (r, s) => (z(), ae($n, {
      "model-value": r.modelValue,
      "onUpdate:modelValue": s[3] || (s[3] = (d) => t("update:model-value", d))
    }, {
      default: L(() => [
        D(fn, {
          style: yu({
            minWidth: r.minWidth
          }),
          class: "usf_dialog_card",
          flat: ""
        }, {
          default: L(() => [
            D(fa, {
              class: Ft({ "bg-warning": r.errorDialog })
            }, {
              default: L(() => [
                ve(J(r.title) + " ", 1),
                D(va),
                D(se, {
                  dense: "",
                  flat: "",
                  icon: "mdi-close",
                  onClick: s[0] || (s[0] = (d) => t("update:model-value", !1))
                })
              ]),
              _: 1
            }, 8, ["class"]),
            D(cn, null, {
              default: L(() => [
                Sn(r.$slots, "default", {}, void 0, !0)
              ]),
              _: 3
            }),
            D(mo, { align: "right" }, {
              default: L(() => [
                D(se, {
                  color: r.cancelColor,
                  label: a.value,
                  flat: "",
                  onClick: s[1] || (s[1] = (d) => t("cancel"))
                }, null, 8, ["color", "label"]),
                r.confirmButtonHidden ? ce("", !0) : (z(), ae(se, {
                  key: 0,
                  color: r.confirmColor,
                  label: i.value,
                  "text-color": r.confirmColor === "primary" ? "white" : "black",
                  unelevated: "",
                  onClick: s[2] || (s[2] = (d) => t("valid"))
                }, null, 8, ["color", "label", "text-color"]))
              ]),
              _: 1
            })
          ]),
          _: 3
        }, 8, ["style"])
      ]),
      _: 3
    }, 8, ["model-value"]));
  }
});
const ul = /* @__PURE__ */ Oe(Ls, [["__scopeId", "data-v-bdfa15f1"]]), Es = /* @__PURE__ */ Ce({
  __name: "PanelDraggableItem",
  props: {
    group: {},
    field: {}
  },
  setup(e) {
    const t = e, { field: l } = ct(t), n = Me("_uct"), a = Ee(), i = G([]), r = b(() => l.value.fields.length > 0), s = () => {
      if (l.value.fields.length) {
        i.value = [...l.value.fields.map((d) => d.id)];
        return;
      }
      i.value = [];
    };
    return wt(s), me(l, s, { deep: !0 }), (d, c) => (z(), ae(oo, {
      group: d.group,
      label: o(l).content,
      "expand-separator": ""
    }, {
      default: L(() => [
        D(ln),
        D(fn, null, {
          default: L(() => [
            D(cn, null, {
              default: L(() => [
                D(o(na), {
                  id: o(l).id,
                  group: { name: "formbuilder" },
                  list: i.value,
                  class: "dragColPanelContainer",
                  "item-key": "id",
                  onAdd: o(a).onMoveFieldPositionToSubItem
                }, vl({
                  item: L(({ index: u }) => [
                    r.value ? (z(), ae(ko, {
                      key: 0,
                      index: u,
                      "parent-id": o(l).id
                    }, null, 8, ["index", "parent-id"])) : ce("", !0)
                  ]),
                  _: 2
                }, [
                  r.value ? void 0 : {
                    name: "header",
                    fn: L(() => [
                      ee("p", null, J(o(n)("renderer.fields.UsfAccordion.noItem")), 1)
                    ]),
                    key: "0"
                  }
                ]), 1032, ["id", "list", "onAdd"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["group", "label"]));
  }
});
const Ps = /* @__PURE__ */ Oe(Es, [["__scopeId", "data-v-6b31582a"]]), Vn = /* @__PURE__ */ Ce({
  __name: "GenericComponent",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const { getFieldComponent: l } = fu();
    return (n, a) => (z(), ae(eo(o(l)(n.field.component)), {
      "child-exists": n.childExists,
      "editor-mode": n.editorMode,
      field: n.field,
      "parent-index": n.parentIndex,
      "onUpdate:childExists": a[0] || (a[0] = (i) => t("update:child-exists", i))
    }, null, 40, ["child-exists", "editor-mode", "field", "parent-index"]));
  }
}), Rs = (e) => {
  const t = st();
  return {
    getPanelLegend: b(() => t.translated(e.value.id, "content") || e.value.content || "")
  };
}, zs = /* @__PURE__ */ Ce({
  __name: "PanelItem",
  props: {
    editorMode: { type: Boolean, default: !1 },
    field: {},
    group: {},
    parentIndex: {}
  },
  setup(e) {
    const t = e, { field: l } = ct(t), { getPanelLegend: n } = Rs(l);
    return (a, i) => (z(), ae(oo, {
      group: a.group,
      label: o(n),
      "expand-separator": ""
    }, {
      default: L(() => [
        D(ln),
        D(fn, null, {
          default: L(() => [
            D(cn, null, {
              default: L(() => [
                (z(!0), re(Ve, null, dt(o(l).fields, (r) => (z(), ae(Vn, {
                  key: r.id,
                  "editor-mode": a.editorMode,
                  field: r,
                  "parent-index": a.parentIndex
                }, null, 8, ["editor-mode", "field", "parent-index"]))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["group", "label"]));
  }
}), Us = /* @__PURE__ */ Ce({
  __name: "AccordionItem",
  props: {
    editorMode: { type: Boolean, default: !1 },
    field: {}
  },
  setup(e) {
    const t = e, { field: l } = ct(t), n = b(() => {
      var a, i, r;
      if ((a = l.value) != null && a.accordionMode)
        return ((i = l.value) == null ? void 0 : i.name) || ((r = l.value) == null ? void 0 : r.id) || "accordionGroup";
    });
    return (a, i) => (z(), ae(Wn, { bordered: "" }, {
      default: L(() => [
        a.editorMode ? (z(!0), re(Ve, { key: 0 }, dt(o(l).fields, (r) => (z(), ae(Ps, {
          key: r.id,
          field: r,
          group: n.value
        }, null, 8, ["field", "group"]))), 128)) : (z(!0), re(Ve, { key: 1 }, dt(o(l).fields, (r) => (z(), ae(zs, {
          key: r.id,
          "editor-mode": a.editorMode,
          field: r,
          group: n.value
        }, null, 8, ["editor-mode", "field", "group"]))), 128))
      ]),
      _: 1
    }));
  }
}), Hs = "_q_", sr = "_q_fo_", dr = "_q_tabs_", $a = () => {
};
function Ys({ validate: e, resetValidation: t, requiresQForm: l }) {
  const n = Me(sr, !1);
  if (n !== !1) {
    const { props: a, proxy: i } = Ae();
    Object.assign(i, { validate: e, resetValidation: t }), me(() => a.disable, (r) => {
      r === !0 ? (typeof t == "function" && t(), n.unbindComponent(i)) : n.bindComponent(i);
    }), wt(() => {
      a.disable !== !0 && n.bindComponent(i);
    }), _t(() => {
      a.disable !== !0 && n.unbindComponent(i);
    });
  } else
    l === !0 && console.error("Parent QForm not found on useFormChild()!");
}
const ti = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/, li = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/, ni = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/, Rn = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/, zn = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/, Fa = {
  date: (e) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(e),
  time: (e) => /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(e),
  fulltime: (e) => /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(e),
  timeOrFulltime: (e) => /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(e),
  // -- RFC 5322 --
  // -- Added in v2.6.6 --
  // This is a basic helper validation.
  // For something more complex (like RFC 822) you should write and use your own rule.
  // We won't be accepting PRs to enhance the one below because of the reason above.
  // eslint-disable-next-line
  email: (e) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e),
  hexColor: (e) => ti.test(e),
  hexaColor: (e) => li.test(e),
  hexOrHexaColor: (e) => ni.test(e),
  rgbColor: (e) => Rn.test(e),
  rgbaColor: (e) => zn.test(e),
  rgbOrRgbaColor: (e) => Rn.test(e) || zn.test(e),
  hexOrRgbColor: (e) => ti.test(e) || Rn.test(e),
  hexaOrRgbaColor: (e) => li.test(e) || zn.test(e),
  anyColor: (e) => ni.test(e) || Rn.test(e) || zn.test(e)
};
function cr(e, t = 250, l) {
  let n = null;
  function a() {
    const i = arguments, r = () => {
      n = null, l !== !0 && e.apply(this, i);
    };
    n !== null ? clearTimeout(n) : l === !0 && e.apply(this, i), n = setTimeout(r, t);
  }
  return a.cancel = () => {
    n !== null && clearTimeout(n);
  }, a;
}
const js = [!0, !1, "ondemand"], Ns = {
  modelValue: {},
  error: {
    type: Boolean,
    default: null
  },
  errorMessage: String,
  noErrorIcon: Boolean,
  rules: Array,
  reactiveRules: Boolean,
  lazyRules: {
    type: [Boolean, String],
    validator: (e) => js.includes(e)
  }
};
function Ws(e, t) {
  const { props: l, proxy: n } = Ae(), a = G(!1), i = G(null), r = G(null);
  Ys({ validate: _, resetValidation: f });
  let s = 0, d;
  const c = b(
    () => l.rules !== void 0 && l.rules !== null && l.rules.length !== 0
  ), u = b(
    () => l.disable !== !0 && c.value === !0
  ), m = b(
    () => l.error === !0 || a.value === !0
  ), p = b(() => typeof l.errorMessage == "string" && l.errorMessage.length !== 0 ? l.errorMessage : i.value);
  me(() => l.modelValue, () => {
    v();
  }), me(() => l.reactiveRules, (M) => {
    M === !0 ? d === void 0 && (d = me(() => l.rules, () => {
      v(!0);
    })) : d !== void 0 && (d(), d = void 0);
  }, { immediate: !0 }), me(e, (M) => {
    M === !0 ? r.value === null && (r.value = !1) : r.value === !1 && (r.value = !0, u.value === !0 && l.lazyRules !== "ondemand" && t.value === !1 && y());
  });
  function f() {
    s++, t.value = !1, r.value = null, a.value = !1, i.value = null, y.cancel();
  }
  function _(M = l.modelValue) {
    if (u.value !== !0)
      return !0;
    const w = ++s, S = t.value !== !0 ? () => {
      r.value = !0;
    } : () => {
    }, h = (T, I) => {
      T === !0 && S(), a.value = T, i.value = I || null, t.value = !1;
    }, C = [];
    for (let T = 0; T < l.rules.length; T++) {
      const I = l.rules[T];
      let E;
      if (typeof I == "function" ? E = I(M, Fa) : typeof I == "string" && Fa[I] !== void 0 && (E = Fa[I](M)), E === !1 || typeof E == "string")
        return h(!0, E), !1;
      E !== !0 && E !== void 0 && C.push(E);
    }
    return C.length === 0 ? (h(!1), !0) : (t.value = !0, Promise.all(C).then(
      (T) => {
        if (T === void 0 || Array.isArray(T) === !1 || T.length === 0)
          return w === s && h(!1), !0;
        const I = T.find((E) => E === !1 || typeof E == "string");
        return w === s && h(I !== void 0, I), I === void 0;
      },
      (T) => (w === s && (console.error(T), h(!0)), !1)
    ));
  }
  function v(M) {
    u.value === !0 && l.lazyRules !== "ondemand" && (r.value === !0 || l.lazyRules !== !0 && M !== !0) && y();
  }
  const y = cr(_, 0);
  return _t(() => {
    d !== void 0 && d(), y.cancel();
  }), Object.assign(n, { resetValidation: f, validate: _ }), Kt(n, "hasError", () => m.value), {
    isDirtyModel: r,
    hasRules: c,
    hasError: m,
    errorMessage: p,
    validate: _,
    resetValidation: f
  };
}
const ai = /^on[A-Z]/;
function fr(e, t) {
  const l = {
    listeners: G({}),
    attributes: G({})
  };
  function n() {
    const a = {}, i = {};
    for (const r in e)
      r !== "class" && r !== "style" && ai.test(r) === !1 && (a[r] = e[r]);
    for (const r in t.props)
      ai.test(r) === !0 && (i[r] = t.props[r]);
    l.attributes.value = a, l.listeners.value = i;
  }
  return Fi(n), n(), l;
}
function Ka(e) {
  return e === void 0 ? `f_${wn()}` : e;
}
function Pl(e) {
  return e != null && ("" + e).length !== 0;
}
const Fn = {
  ...Tt,
  ...Ns,
  label: String,
  stackLabel: Boolean,
  hint: String,
  hideHint: Boolean,
  prefix: String,
  suffix: String,
  labelColor: String,
  color: String,
  bgColor: String,
  filled: Boolean,
  outlined: Boolean,
  borderless: Boolean,
  standout: [Boolean, String],
  square: Boolean,
  loading: Boolean,
  labelSlot: Boolean,
  bottomSlots: Boolean,
  hideBottomSpace: Boolean,
  rounded: Boolean,
  dense: Boolean,
  itemAligned: Boolean,
  counter: Boolean,
  clearable: Boolean,
  clearIcon: String,
  disable: Boolean,
  readonly: Boolean,
  autofocus: Boolean,
  for: String,
  maxlength: [Number, String]
}, ma = ["update:modelValue", "clear", "focus", "blur", "popupShow", "popupHide"];
function pa() {
  const { props: e, attrs: t, proxy: l, vnode: n } = Ae();
  return {
    isDark: Mt(e, l.$q),
    editable: b(
      () => e.disable !== !0 && e.readonly !== !0
    ),
    innerLoading: G(!1),
    focused: G(!1),
    hasPopupOpen: !1,
    splitAttrs: fr(t, n),
    targetUid: G(Ka(e.for)),
    rootRef: G(null),
    targetRef: G(null),
    controlRef: G(null)
    /**
         * user supplied additionals:
    
         * innerValue - computed
         * floatingLabel - computed
         * inputRef - computed
    
         * fieldClass - computed
         * hasShadow - computed
    
         * controlEvents - Object with fn(e)
    
         * getControl - fn
         * getInnerAppend - fn
         * getControlChild - fn
         * getShadowControl - fn
         * showPopup - fn
         */
  };
}
function ba(e) {
  const { props: t, emit: l, slots: n, attrs: a, proxy: i } = Ae(), { $q: r } = i;
  let s = null;
  e.hasValue === void 0 && (e.hasValue = b(() => Pl(t.modelValue))), e.emitValue === void 0 && (e.emitValue = (q) => {
    l("update:modelValue", q);
  }), e.controlEvents === void 0 && (e.controlEvents = {
    onFocusin: A,
    onFocusout: O
  }), Object.assign(e, {
    clearValue: P,
    onControlFocusin: A,
    onControlFocusout: O,
    focus: I
  }), e.computedCounter === void 0 && (e.computedCounter = b(() => {
    if (t.counter !== !1) {
      const q = typeof t.modelValue == "string" || typeof t.modelValue == "number" ? ("" + t.modelValue).length : Array.isArray(t.modelValue) === !0 ? t.modelValue.length : 0, Y = t.maxlength !== void 0 ? t.maxlength : t.maxValues;
      return q + (Y !== void 0 ? " / " + Y : "");
    }
  }));
  const {
    isDirtyModel: d,
    hasRules: c,
    hasError: u,
    errorMessage: m,
    resetValidation: p
  } = Ws(e.focused, e.innerLoading), f = e.floatingLabel !== void 0 ? b(() => t.stackLabel === !0 || e.focused.value === !0 || e.floatingLabel.value === !0) : b(() => t.stackLabel === !0 || e.focused.value === !0 || e.hasValue.value === !0), _ = b(
    () => t.bottomSlots === !0 || t.hint !== void 0 || c.value === !0 || t.counter === !0 || t.error !== null
  ), v = b(() => t.filled === !0 ? "filled" : t.outlined === !0 ? "outlined" : t.borderless === !0 ? "borderless" : t.standout ? "standout" : "standard"), y = b(
    () => `q-field row no-wrap items-start q-field--${v.value}` + (e.fieldClass !== void 0 ? ` ${e.fieldClass.value}` : "") + (t.rounded === !0 ? " q-field--rounded" : "") + (t.square === !0 ? " q-field--square" : "") + (f.value === !0 ? " q-field--float" : "") + (w.value === !0 ? " q-field--labeled" : "") + (t.dense === !0 ? " q-field--dense" : "") + (t.itemAligned === !0 ? " q-field--item-aligned q-item-type" : "") + (e.isDark.value === !0 ? " q-field--dark" : "") + (e.getControl === void 0 ? " q-field--auto-height" : "") + (e.focused.value === !0 ? " q-field--focused" : "") + (u.value === !0 ? " q-field--error" : "") + (u.value === !0 || e.focused.value === !0 ? " q-field--highlighted" : "") + (t.hideBottomSpace !== !0 && _.value === !0 ? " q-field--with-bottom" : "") + (t.disable === !0 ? " q-field--disabled" : t.readonly === !0 ? " q-field--readonly" : "")
  ), M = b(
    () => "q-field__control relative-position row no-wrap" + (t.bgColor !== void 0 ? ` bg-${t.bgColor}` : "") + (u.value === !0 ? " text-negative" : typeof t.standout == "string" && t.standout.length !== 0 && e.focused.value === !0 ? ` ${t.standout}` : t.color !== void 0 ? ` text-${t.color}` : "")
  ), w = b(
    () => t.labelSlot === !0 || t.label !== void 0
  ), S = b(
    () => "q-field__label no-pointer-events absolute ellipsis" + (t.labelColor !== void 0 && u.value !== !0 ? ` text-${t.labelColor}` : "")
  ), h = b(() => ({
    id: e.targetUid.value,
    editable: e.editable.value,
    focused: e.focused.value,
    floatingLabel: f.value,
    modelValue: t.modelValue,
    emitValue: e.emitValue
  })), C = b(() => {
    const q = {
      for: e.targetUid.value
    };
    return t.disable === !0 ? q["aria-disabled"] = "true" : t.readonly === !0 && (q["aria-readonly"] = "true"), q;
  });
  me(() => t.for, (q) => {
    e.targetUid.value = Ka(q);
  });
  function T() {
    const q = document.activeElement;
    let Y = e.targetRef !== void 0 && e.targetRef.value;
    Y && (q === null || q.id !== e.targetUid.value) && (Y.hasAttribute("tabindex") === !0 || (Y = Y.querySelector("[tabindex]")), Y && Y !== q && Y.focus({ preventScroll: !0 }));
  }
  function I() {
    dn(T);
  }
  function E() {
    Xu(T);
    const q = document.activeElement;
    q !== null && e.rootRef.value.contains(q) && q.blur();
  }
  function A(q) {
    s !== null && (clearTimeout(s), s = null), e.editable.value === !0 && e.focused.value === !1 && (e.focused.value = !0, l("focus", q));
  }
  function O(q, Y) {
    s !== null && clearTimeout(s), s = setTimeout(() => {
      s = null, !(document.hasFocus() === !0 && (e.hasPopupOpen === !0 || e.controlRef === void 0 || e.controlRef.value === null || e.controlRef.value.contains(document.activeElement) !== !1)) && (e.focused.value === !0 && (e.focused.value = !1, l("blur", q)), Y !== void 0 && Y());
    });
  }
  function P(q) {
    Ze(q), r.platform.is.mobile !== !0 ? (e.targetRef !== void 0 && e.targetRef.value || e.rootRef.value).focus() : e.rootRef.value.contains(document.activeElement) === !0 && document.activeElement.blur(), t.type === "file" && (e.inputRef.value.value = null), l("update:modelValue", null), l("clear", t.modelValue), lt(() => {
      p(), r.platform.is.mobile !== !0 && (d.value = !1);
    });
  }
  function $() {
    const q = [];
    return n.prepend !== void 0 && q.push(
      V("div", {
        class: "q-field__prepend q-field__marginal row no-wrap items-center",
        key: "prepend",
        onClick: Ot
      }, n.prepend())
    ), q.push(
      V("div", {
        class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
      }, k())
    ), u.value === !0 && t.noErrorIcon === !1 && q.push(
      x("error", [
        V(Qe, { name: r.iconSet.field.error, color: "negative" })
      ])
    ), t.loading === !0 || e.innerLoading.value === !0 ? q.push(
      x(
        "inner-loading-append",
        n.loading !== void 0 ? n.loading() : [V(Ji, { color: t.color })]
      )
    ) : t.clearable === !0 && e.hasValue.value === !0 && e.editable.value === !0 && q.push(
      x("inner-clearable-append", [
        V(Qe, {
          class: "q-field__focusable-action",
          tag: "button",
          name: t.clearIcon || r.iconSet.field.clear,
          tabindex: 0,
          type: "button",
          "aria-hidden": null,
          role: null,
          onClick: P
        })
      ])
    ), n.append !== void 0 && q.push(
      V("div", {
        class: "q-field__append q-field__marginal row no-wrap items-center",
        key: "append",
        onClick: Ot
      }, n.append())
    ), e.getInnerAppend !== void 0 && q.push(
      x("inner-append", e.getInnerAppend())
    ), e.getControlChild !== void 0 && q.push(
      e.getControlChild()
    ), q;
  }
  function k() {
    const q = [];
    return t.prefix !== void 0 && t.prefix !== null && q.push(
      V("div", {
        class: "q-field__prefix no-pointer-events row items-center"
      }, t.prefix)
    ), e.getShadowControl !== void 0 && e.hasShadow.value === !0 && q.push(
      e.getShadowControl()
    ), e.getControl !== void 0 ? q.push(e.getControl()) : n.rawControl !== void 0 ? q.push(n.rawControl()) : n.control !== void 0 && q.push(
      V("div", {
        ref: e.targetRef,
        class: "q-field__native row",
        tabindex: -1,
        ...e.splitAttrs.attributes.value,
        "data-autofocus": t.autofocus === !0 || void 0
      }, n.control(h.value))
    ), w.value === !0 && q.push(
      V("div", {
        class: S.value
      }, We(n.label, t.label))
    ), t.suffix !== void 0 && t.suffix !== null && q.push(
      V("div", {
        class: "q-field__suffix no-pointer-events row items-center"
      }, t.suffix)
    ), q.concat(We(n.default));
  }
  function g() {
    let q, Y;
    u.value === !0 ? m.value !== null ? (q = [V("div", { role: "alert" }, m.value)], Y = `q--slot-error-${m.value}`) : (q = We(n.error), Y = "q--slot-error") : (t.hideHint !== !0 || e.focused.value === !0) && (t.hint !== void 0 ? (q = [V("div", t.hint)], Y = `q--slot-hint-${t.hint}`) : (q = We(n.hint), Y = "q--slot-hint"));
    const K = t.counter === !0 || n.counter !== void 0;
    if (t.hideBottomSpace === !0 && K === !1 && q === void 0)
      return;
    const Q = V("div", {
      key: Y,
      class: "q-field__messages col"
    }, q);
    return V("div", {
      class: "q-field__bottom row items-start q-field__bottom--" + (t.hideBottomSpace !== !0 ? "animated" : "stale"),
      onClick: Ot
    }, [
      t.hideBottomSpace === !0 ? Q : V(Qt, { name: "q-transition--field-message" }, () => Q),
      K === !0 ? V("div", {
        class: "q-field__counter"
      }, n.counter !== void 0 ? n.counter() : e.computedCounter.value) : null
    ]);
  }
  function x(q, Y) {
    return Y === null ? null : V("div", {
      key: q,
      class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
    }, Y);
  }
  let B = !1;
  return zl(() => {
    B = !0;
  }), Mn(() => {
    B === !0 && t.autofocus === !0 && i.focus();
  }), wt(() => {
    xn.value === !0 && t.for === void 0 && (e.targetUid.value = Ka()), t.autofocus === !0 && i.focus();
  }), _t(() => {
    s !== null && clearTimeout(s);
  }), Object.assign(i, { focus: I, blur: E }), function() {
    const Y = e.getControl === void 0 && n.control === void 0 ? {
      ...e.splitAttrs.attributes.value,
      "data-autofocus": t.autofocus === !0 || void 0,
      ...C.value
    } : C.value;
    return V("label", {
      ref: e.rootRef,
      class: [
        y.value,
        a.class
      ],
      style: a.style,
      ...Y
    }, [
      n.before !== void 0 ? V("div", {
        class: "q-field__before q-field__marginal row no-wrap items-center",
        onClick: Ot
      }, n.before()) : null,
      V("div", {
        class: "q-field__inner relative-position col self-stretch"
      }, [
        V("div", {
          ref: e.controlRef,
          class: M.value,
          tabindex: -1,
          ...e.controlEvents
        }, $()),
        _.value === !0 ? g() : null
      ]),
      n.after !== void 0 ? V("div", {
        class: "q-field__after q-field__marginal row no-wrap items-center",
        onClick: Ot
      }, n.after()) : null
    ]);
  };
}
const ha = De({
  name: "QField",
  inheritAttrs: !1,
  props: Fn,
  emits: ma,
  setup() {
    return ba(pa());
  }
}), Qs = Rl({
  settingsTabs: () => {
  },
  componentsCustom: () => {
  }
}), ga = () => ({
  ...ct(Qs)
});
function vr(e, t) {
  const l = G(null), n = b(() => e.disable === !0 ? null : V("span", {
    ref: l,
    class: "no-outline",
    tabindex: -1
  }));
  function a(i) {
    const r = t.value;
    i !== void 0 && i.type.indexOf("key") === 0 ? r !== null && document.activeElement !== r && r.contains(document.activeElement) === !0 && r.focus() : l.value !== null && (i === void 0 || r !== null && r.contains(i.target) === !0) && l.value.focus();
  }
  return {
    refocusTargetEl: n,
    refocusTarget: a
  };
}
const Ml = {
  name: String
};
function mr(e) {
  return b(() => ({
    type: "hidden",
    name: e.name,
    value: e.modelValue
  }));
}
function An(e = {}) {
  return (t, l, n) => {
    t[l](
      V("input", {
        class: "hidden" + (n || ""),
        ...e.value
      })
    );
  };
}
function po(e) {
  return b(() => e.name || e.for);
}
const pr = {
  xs: 30,
  sm: 35,
  md: 40,
  lg: 50,
  xl: 60
}, br = {
  ...Tt,
  ...on,
  ...Ml,
  modelValue: {
    required: !0,
    default: null
  },
  val: {},
  trueValue: { default: !0 },
  falseValue: { default: !1 },
  indeterminateValue: { default: null },
  checkedIcon: String,
  uncheckedIcon: String,
  indeterminateIcon: String,
  toggleOrder: {
    type: String,
    validator: (e) => e === "tf" || e === "ft"
  },
  toggleIndeterminate: Boolean,
  label: String,
  leftLabel: Boolean,
  color: String,
  keepColor: Boolean,
  dense: Boolean,
  disable: Boolean,
  tabindex: [String, Number]
}, hr = ["update:modelValue"];
function gr(e, t) {
  const { props: l, slots: n, emit: a, proxy: i } = Ae(), { $q: r } = i, s = Mt(l, r), d = G(null), { refocusTargetEl: c, refocusTarget: u } = vr(l, d), m = rn(l, pr), p = b(
    () => l.val !== void 0 && Array.isArray(l.modelValue)
  ), f = b(() => {
    const $ = wl(l.val);
    return p.value === !0 ? l.modelValue.findIndex((k) => wl(k) === $) : -1;
  }), _ = b(() => p.value === !0 ? f.value > -1 : wl(l.modelValue) === wl(l.trueValue)), v = b(() => p.value === !0 ? f.value === -1 : wl(l.modelValue) === wl(l.falseValue)), y = b(
    () => _.value === !1 && v.value === !1
  ), M = b(() => l.disable === !0 ? -1 : l.tabindex || 0), w = b(
    () => `q-${e} cursor-pointer no-outline row inline no-wrap items-center` + (l.disable === !0 ? " disabled" : "") + (s.value === !0 ? ` q-${e}--dark` : "") + (l.dense === !0 ? ` q-${e}--dense` : "") + (l.leftLabel === !0 ? " reverse" : "")
  ), S = b(() => {
    const $ = _.value === !0 ? "truthy" : v.value === !0 ? "falsy" : "indet", k = l.color !== void 0 && (l.keepColor === !0 || (e === "toggle" ? _.value === !0 : v.value !== !0)) ? ` text-${l.color}` : "";
    return `q-${e}__inner relative-position non-selectable q-${e}__inner--${$}${k}`;
  }), h = b(() => {
    const $ = { type: "checkbox" };
    return l.name !== void 0 && Object.assign($, {
      // see https://vuejs.org/guide/extras/render-function.html#creating-vnodes (.prop)
      ".checked": _.value,
      "^checked": _.value === !0 ? "checked" : void 0,
      name: l.name,
      value: p.value === !0 ? l.val : l.trueValue
    }), $;
  }), C = An(h), T = b(() => {
    const $ = {
      tabindex: M.value,
      role: e === "toggle" ? "switch" : "checkbox",
      "aria-label": l.label,
      "aria-checked": y.value === !0 ? "mixed" : _.value === !0 ? "true" : "false"
    };
    return l.disable === !0 && ($["aria-disabled"] = "true"), $;
  });
  function I($) {
    $ !== void 0 && (Ze($), u($)), l.disable !== !0 && a("update:modelValue", E(), $);
  }
  function E() {
    if (p.value === !0) {
      if (_.value === !0) {
        const $ = l.modelValue.slice();
        return $.splice(f.value, 1), $;
      }
      return l.modelValue.concat([l.val]);
    }
    if (_.value === !0) {
      if (l.toggleOrder !== "ft" || l.toggleIndeterminate === !1)
        return l.falseValue;
    } else if (v.value === !0) {
      if (l.toggleOrder === "ft" || l.toggleIndeterminate === !1)
        return l.trueValue;
    } else
      return l.toggleOrder !== "ft" ? l.trueValue : l.falseValue;
    return l.indeterminateValue;
  }
  function A($) {
    ($.keyCode === 13 || $.keyCode === 32) && Ze($);
  }
  function O($) {
    ($.keyCode === 13 || $.keyCode === 32) && I($);
  }
  const P = t(_, y);
  return Object.assign(i, { toggle: I }), () => {
    const $ = P();
    l.disable !== !0 && C(
      $,
      "unshift",
      ` q-${e}__native absolute q-ma-none q-pa-none`
    );
    const k = [
      V("div", {
        class: S.value,
        style: m.value,
        "aria-hidden": "true"
      }, $)
    ];
    c.value !== null && k.push(c.value);
    const g = l.label !== void 0 ? al(n.default, [l.label]) : We(n.default);
    return g !== void 0 && k.push(
      V("div", {
        class: `q-${e}__label q-anchor--skip`
      }, g)
    ), V("div", {
      ref: d,
      class: w.value,
      ...T.value,
      onClick: I,
      onKeydown: A,
      onKeyup: O
    }, k);
  };
}
const at = De({
  name: "QToggle",
  props: {
    ...br,
    icon: String,
    iconColor: String
  },
  emits: hr,
  setup(e) {
    function t(l, n) {
      const a = b(
        () => (l.value === !0 ? e.checkedIcon : n.value === !0 ? e.indeterminateIcon : e.uncheckedIcon) || e.icon
      ), i = b(() => l.value === !0 ? e.iconColor : null);
      return () => [
        V("div", { class: "q-toggle__track" }),
        V(
          "div",
          {
            class: "q-toggle__thumb absolute flex flex-center no-wrap"
          },
          a.value !== void 0 ? [
            V(Qe, {
              name: a.value,
              color: i.value
            })
          ] : void 0
        )
      ];
    }
    return gr("toggle", t);
  }
}), oi = {
  date: "####/##/##",
  datetime: "####/##/## ##:##",
  time: "##:##",
  fulltime: "##:##:##",
  phone: "(###) ### - ####",
  card: "#### #### #### ####"
}, ea = {
  "#": { pattern: "[\\d]", negate: "[^\\d]" },
  S: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]" },
  N: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]" },
  A: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (e) => e.toLocaleUpperCase() },
  a: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (e) => e.toLocaleLowerCase() },
  X: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (e) => e.toLocaleUpperCase() },
  x: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (e) => e.toLocaleLowerCase() }
}, yr = Object.keys(ea);
yr.forEach((e) => {
  ea[e].regex = new RegExp(ea[e].pattern);
});
const Ks = new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + yr.join("") + "])|(.)", "g"), ii = /[.*+?^${}()|[\]\\]/g, It = String.fromCharCode(1), Gs = {
  mask: String,
  reverseFillMask: Boolean,
  fillMask: [Boolean, String],
  unmaskedValue: Boolean
};
function Zs(e, t, l, n) {
  let a, i, r, s, d, c;
  const u = G(null), m = G(f());
  function p() {
    return e.autogrow === !0 || ["textarea", "text", "search", "url", "tel", "password"].includes(e.type);
  }
  me(() => e.type + e.autogrow, v), me(() => e.mask, (A) => {
    if (A !== void 0)
      y(m.value, !0);
    else {
      const O = I(m.value);
      v(), e.modelValue !== O && t("update:modelValue", O);
    }
  }), me(() => e.fillMask + e.reverseFillMask, () => {
    u.value === !0 && y(m.value, !0);
  }), me(() => e.unmaskedValue, () => {
    u.value === !0 && y(m.value);
  });
  function f() {
    if (v(), u.value === !0) {
      const A = C(I(e.modelValue));
      return e.fillMask !== !1 ? E(A) : A;
    }
    return e.modelValue;
  }
  function _(A) {
    if (A < a.length)
      return a.slice(-A);
    let O = "", P = a;
    const $ = P.indexOf(It);
    if ($ > -1) {
      for (let k = A - P.length; k > 0; k--)
        O += It;
      P = P.slice(0, $) + O + P.slice($);
    }
    return P;
  }
  function v() {
    if (u.value = e.mask !== void 0 && e.mask.length !== 0 && p(), u.value === !1) {
      s = void 0, a = "", i = "";
      return;
    }
    const A = oi[e.mask] === void 0 ? e.mask : oi[e.mask], O = typeof e.fillMask == "string" && e.fillMask.length !== 0 ? e.fillMask.slice(0, 1) : "_", P = O.replace(ii, "\\$&"), $ = [], k = [], g = [];
    let x = e.reverseFillMask === !0, B = "", q = "";
    A.replace(Ks, (W, H, R, ie, te) => {
      if (ie !== void 0) {
        const oe = ea[ie];
        g.push(oe), q = oe.negate, x === !0 && (k.push("(?:" + q + "+)?(" + oe.pattern + "+)?(?:" + q + "+)?(" + oe.pattern + "+)?"), x = !1), k.push("(?:" + q + "+)?(" + oe.pattern + ")?");
      } else if (R !== void 0)
        B = "\\" + (R === "\\" ? "" : R), g.push(R), $.push("([^" + B + "]+)?" + B + "?");
      else {
        const oe = H !== void 0 ? H : te;
        B = oe === "\\" ? "\\\\\\\\" : oe.replace(ii, "\\\\$&"), g.push(oe), $.push("([^" + B + "]+)?" + B + "?");
      }
    });
    const Y = new RegExp(
      "^" + $.join("") + "(" + (B === "" ? "." : "[^" + B + "]") + "+)?" + (B === "" ? "" : "[" + B + "]*") + "$"
    ), K = k.length - 1, Q = k.map((W, H) => H === 0 && e.reverseFillMask === !0 ? new RegExp("^" + P + "*" + W) : H === K ? new RegExp(
      "^" + W + "(" + (q === "" ? "." : q) + "+)?" + (e.reverseFillMask === !0 ? "$" : P + "*")
    ) : new RegExp("^" + W));
    r = g, s = (W) => {
      const H = Y.exec(e.reverseFillMask === !0 ? W : W.slice(0, g.length + 1));
      H !== null && (W = H.slice(1).join(""));
      const R = [], ie = Q.length;
      for (let te = 0, oe = W; te < ie; te++) {
        const fe = Q[te].exec(oe);
        if (fe === null)
          break;
        oe = oe.slice(fe.shift().length), R.push(...fe);
      }
      return R.length !== 0 ? R.join("") : W;
    }, a = g.map((W) => typeof W == "string" ? W : It).join(""), i = a.split(It).join(O);
  }
  function y(A, O, P) {
    const $ = n.value, k = $.selectionEnd, g = $.value.length - k, x = I(A);
    O === !0 && v();
    const B = C(x), q = e.fillMask !== !1 ? E(B) : B, Y = m.value !== q;
    $.value !== q && ($.value = q), Y === !0 && (m.value = q), document.activeElement === $ && lt(() => {
      if (q === i) {
        const Q = e.reverseFillMask === !0 ? i.length : 0;
        $.setSelectionRange(Q, Q, "forward");
        return;
      }
      if (P === "insertFromPaste" && e.reverseFillMask !== !0) {
        const Q = $.selectionEnd;
        let W = k - 1;
        for (let H = d; H <= W && H < Q; H++)
          a[H] !== It && W++;
        w.right($, W);
        return;
      }
      if (["deleteContentBackward", "deleteContentForward"].indexOf(P) > -1) {
        const Q = e.reverseFillMask === !0 ? k === 0 ? q.length > B.length ? 1 : 0 : Math.max(0, q.length - (q === i ? 0 : Math.min(B.length, g) + 1)) + 1 : k;
        $.setSelectionRange(Q, Q, "forward");
        return;
      }
      if (e.reverseFillMask === !0)
        if (Y === !0) {
          const Q = Math.max(0, q.length - (q === i ? 0 : Math.min(B.length, g + 1)));
          Q === 1 && k === 1 ? $.setSelectionRange(Q, Q, "forward") : w.rightReverse($, Q);
        } else {
          const Q = q.length - g;
          $.setSelectionRange(Q, Q, "backward");
        }
      else if (Y === !0) {
        const Q = Math.max(0, a.indexOf(It), Math.min(B.length, k) - 1);
        w.right($, Q);
      } else {
        const Q = k - 1;
        w.right($, Q);
      }
    });
    const K = e.unmaskedValue === !0 ? I(q) : q;
    String(e.modelValue) !== K && l(K, !0);
  }
  function M(A, O, P) {
    const $ = C(I(A.value));
    O = Math.max(0, a.indexOf(It), Math.min($.length, O)), d = O, A.setSelectionRange(O, P, "forward");
  }
  const w = {
    left(A, O) {
      const P = a.slice(O - 1).indexOf(It) === -1;
      let $ = Math.max(0, O - 1);
      for (; $ >= 0; $--)
        if (a[$] === It) {
          O = $, P === !0 && O++;
          break;
        }
      if ($ < 0 && a[O] !== void 0 && a[O] !== It)
        return w.right(A, 0);
      O >= 0 && A.setSelectionRange(O, O, "backward");
    },
    right(A, O) {
      const P = A.value.length;
      let $ = Math.min(P, O + 1);
      for (; $ <= P; $++)
        if (a[$] === It) {
          O = $;
          break;
        } else
          a[$ - 1] === It && (O = $);
      if ($ > P && a[O - 1] !== void 0 && a[O - 1] !== It)
        return w.left(A, P);
      A.setSelectionRange(O, O, "forward");
    },
    leftReverse(A, O) {
      const P = _(A.value.length);
      let $ = Math.max(0, O - 1);
      for (; $ >= 0; $--)
        if (P[$ - 1] === It) {
          O = $;
          break;
        } else if (P[$] === It && (O = $, $ === 0))
          break;
      if ($ < 0 && P[O] !== void 0 && P[O] !== It)
        return w.rightReverse(A, 0);
      O >= 0 && A.setSelectionRange(O, O, "backward");
    },
    rightReverse(A, O) {
      const P = A.value.length, $ = _(P), k = $.slice(0, O + 1).indexOf(It) === -1;
      let g = Math.min(P, O + 1);
      for (; g <= P; g++)
        if ($[g - 1] === It) {
          O = g, O > 0 && k === !0 && O--;
          break;
        }
      if (g > P && $[O - 1] !== void 0 && $[O - 1] !== It)
        return w.leftReverse(A, P);
      A.setSelectionRange(O, O, "forward");
    }
  };
  function S(A) {
    t("click", A), c = void 0;
  }
  function h(A) {
    if (t("keydown", A), un(A) === !0)
      return;
    const O = n.value, P = O.selectionStart, $ = O.selectionEnd;
    if (A.shiftKey || (c = void 0), A.keyCode === 37 || A.keyCode === 39) {
      A.shiftKey && c === void 0 && (c = O.selectionDirection === "forward" ? P : $);
      const k = w[(A.keyCode === 39 ? "right" : "left") + (e.reverseFillMask === !0 ? "Reverse" : "")];
      if (A.preventDefault(), k(O, c === P ? $ : P), A.shiftKey) {
        const g = O.selectionStart;
        O.setSelectionRange(Math.min(c, g), Math.max(c, g), "forward");
      }
    } else
      A.keyCode === 8 && e.reverseFillMask !== !0 && P === $ ? (w.left(O, P), O.setSelectionRange(O.selectionStart, $, "backward")) : A.keyCode === 46 && e.reverseFillMask === !0 && P === $ && (w.rightReverse(O, $), O.setSelectionRange(P, O.selectionEnd, "forward"));
  }
  function C(A) {
    if (A == null || A === "")
      return "";
    if (e.reverseFillMask === !0)
      return T(A);
    const O = r;
    let P = 0, $ = "";
    for (let k = 0; k < O.length; k++) {
      const g = A[P], x = O[k];
      if (typeof x == "string")
        $ += x, g === x && P++;
      else if (g !== void 0 && x.regex.test(g))
        $ += x.transform !== void 0 ? x.transform(g) : g, P++;
      else
        return $;
    }
    return $;
  }
  function T(A) {
    const O = r, P = a.indexOf(It);
    let $ = A.length - 1, k = "";
    for (let g = O.length - 1; g >= 0 && $ > -1; g--) {
      const x = O[g];
      let B = A[$];
      if (typeof x == "string")
        k = x + k, B === x && $--;
      else if (B !== void 0 && x.regex.test(B))
        do
          k = (x.transform !== void 0 ? x.transform(B) : B) + k, $--, B = A[$];
        while (P === g && B !== void 0 && x.regex.test(B));
      else
        return k;
    }
    return k;
  }
  function I(A) {
    return typeof A != "string" || s === void 0 ? typeof A == "number" ? s("" + A) : A : s(A);
  }
  function E(A) {
    return i.length - A.length <= 0 ? A : e.reverseFillMask === !0 && A.length !== 0 ? i.slice(0, -A.length) + A : A + i.slice(A.length);
  }
  return {
    innerValue: m,
    hasMask: u,
    moveCursorForPaste: M,
    updateMaskValue: y,
    onMaskedKeydown: h,
    onMaskedClick: S
  };
}
function _r(e, t) {
  function l() {
    const n = e.modelValue;
    try {
      const a = "DataTransfer" in window ? new DataTransfer() : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
      return Object(n) === n && ("length" in n ? Array.from(n) : [n]).forEach((i) => {
        a.items.add(i);
      }), {
        files: a.files
      };
    } catch {
      return {
        files: void 0
      };
    }
  }
  return t === !0 ? b(() => {
    if (e.type === "file")
      return l();
  }) : b(l);
}
const Xs = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/, Js = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u, ed = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/, td = /[a-z0-9_ -]$/i;
function Sr(e) {
  return function(l) {
    if (l.type === "compositionend" || l.type === "change") {
      if (l.target.qComposing !== !0)
        return;
      l.target.qComposing = !1, e(l);
    } else
      l.type === "compositionupdate" && l.target.qComposing !== !0 && typeof l.data == "string" && (mt.is.firefox === !0 ? td.test(l.data) === !1 : Xs.test(l.data) === !0 || Js.test(l.data) === !0 || ed.test(l.data) === !0) === !0 && (l.target.qComposing = !0);
  };
}
const Ne = De({
  name: "QInput",
  inheritAttrs: !1,
  props: {
    ...Fn,
    ...Gs,
    ...Ml,
    modelValue: { required: !1 },
    shadowText: String,
    type: {
      type: String,
      default: "text"
    },
    debounce: [String, Number],
    autogrow: Boolean,
    // makes a textarea
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...ma,
    "paste",
    "change",
    "keydown",
    "click",
    "animationend"
  ],
  setup(e, { emit: t, attrs: l }) {
    const { proxy: n } = Ae(), { $q: a } = n, i = {};
    let r = NaN, s, d, c = null, u;
    const m = G(null), p = po(e), {
      innerValue: f,
      hasMask: _,
      moveCursorForPaste: v,
      updateMaskValue: y,
      onMaskedKeydown: M,
      onMaskedClick: w
    } = Zs(e, t, B, m), S = _r(
      e,
      /* type guard */
      !0
    ), h = b(() => Pl(f.value)), C = Sr(g), T = pa(), I = b(
      () => e.type === "textarea" || e.autogrow === !0
    ), E = b(
      () => I.value === !0 || ["text", "search", "url", "tel", "password"].includes(e.type)
    ), A = b(() => {
      const H = {
        ...T.splitAttrs.listeners.value,
        onInput: g,
        onPaste: k,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange: Y,
        onBlur: K,
        onFocus: Pt
      };
      return H.onCompositionstart = H.onCompositionupdate = H.onCompositionend = C, _.value === !0 && (H.onKeydown = M, H.onClick = w), e.autogrow === !0 && (H.onAnimationend = x), H;
    }), O = b(() => {
      const H = {
        tabindex: 0,
        "data-autofocus": e.autofocus === !0 || void 0,
        rows: e.type === "textarea" ? 6 : void 0,
        "aria-label": e.label,
        name: p.value,
        ...T.splitAttrs.attributes.value,
        id: T.targetUid.value,
        maxlength: e.maxlength,
        disabled: e.disable === !0,
        readonly: e.readonly === !0
      };
      return I.value === !1 && (H.type = e.type), e.autogrow === !0 && (H.rows = 1), H;
    });
    me(() => e.type, () => {
      m.value && (m.value.value = e.modelValue);
    }), me(() => e.modelValue, (H) => {
      if (_.value === !0) {
        if (d === !0 && (d = !1, String(H) === r))
          return;
        y(H);
      } else
        f.value !== H && (f.value = H, e.type === "number" && i.hasOwnProperty("value") === !0 && (s === !0 ? s = !1 : delete i.value));
      e.autogrow === !0 && lt(q);
    }), me(() => e.autogrow, (H) => {
      H === !0 ? lt(q) : m.value !== null && l.rows > 0 && (m.value.style.height = "auto");
    }), me(() => e.dense, () => {
      e.autogrow === !0 && lt(q);
    });
    function P() {
      dn(() => {
        const H = document.activeElement;
        m.value !== null && m.value !== H && (H === null || H.id !== T.targetUid.value) && m.value.focus({ preventScroll: !0 });
      });
    }
    function $() {
      m.value !== null && m.value.select();
    }
    function k(H) {
      if (_.value === !0 && e.reverseFillMask !== !0) {
        const R = H.target;
        v(R, R.selectionStart, R.selectionEnd);
      }
      t("paste", H);
    }
    function g(H) {
      if (!H || !H.target)
        return;
      if (e.type === "file") {
        t("update:modelValue", H.target.files);
        return;
      }
      const R = H.target.value;
      if (H.target.qComposing === !0) {
        i.value = R;
        return;
      }
      if (_.value === !0)
        y(R, !1, H.inputType);
      else if (B(R), E.value === !0 && H.target === document.activeElement) {
        const { selectionStart: ie, selectionEnd: te } = H.target;
        ie !== void 0 && te !== void 0 && lt(() => {
          H.target === document.activeElement && R.indexOf(H.target.value) === 0 && H.target.setSelectionRange(ie, te);
        });
      }
      e.autogrow === !0 && q();
    }
    function x(H) {
      t("animationend", H), q();
    }
    function B(H, R) {
      u = () => {
        c = null, e.type !== "number" && i.hasOwnProperty("value") === !0 && delete i.value, e.modelValue !== H && r !== H && (r = H, R === !0 && (d = !0), t("update:modelValue", H), lt(() => {
          r === H && (r = NaN);
        })), u = void 0;
      }, e.type === "number" && (s = !0, i.value = H), e.debounce !== void 0 ? (c !== null && clearTimeout(c), i.value = H, c = setTimeout(u, e.debounce)) : u();
    }
    function q() {
      requestAnimationFrame(() => {
        const H = m.value;
        if (H !== null) {
          const R = H.parentNode.style, { scrollTop: ie } = H, { overflowY: te, maxHeight: oe } = a.platform.is.firefox === !0 ? {} : window.getComputedStyle(H), fe = te !== void 0 && te !== "scroll";
          fe === !0 && (H.style.overflowY = "hidden"), R.marginBottom = H.scrollHeight - 1 + "px", H.style.height = "1px", H.style.height = H.scrollHeight + "px", fe === !0 && (H.style.overflowY = parseInt(oe, 10) < H.scrollHeight ? "auto" : "hidden"), R.marginBottom = "", H.scrollTop = ie;
        }
      });
    }
    function Y(H) {
      C(H), c !== null && (clearTimeout(c), c = null), u !== void 0 && u(), t("change", H.target.value);
    }
    function K(H) {
      H !== void 0 && Pt(H), c !== null && (clearTimeout(c), c = null), u !== void 0 && u(), s = !1, d = !1, delete i.value, e.type !== "file" && setTimeout(() => {
        m.value !== null && (m.value.value = f.value !== void 0 ? f.value : "");
      });
    }
    function Q() {
      return i.hasOwnProperty("value") === !0 ? i.value : f.value !== void 0 ? f.value : "";
    }
    _t(() => {
      K();
    }), wt(() => {
      e.autogrow === !0 && q();
    }), Object.assign(T, {
      innerValue: f,
      fieldClass: b(
        () => `q-${I.value === !0 ? "textarea" : "input"}` + (e.autogrow === !0 ? " q-textarea--autogrow" : "")
      ),
      hasShadow: b(
        () => e.type !== "file" && typeof e.shadowText == "string" && e.shadowText.length !== 0
      ),
      inputRef: m,
      emitValue: B,
      hasValue: h,
      floatingLabel: b(
        () => h.value === !0 && (e.type !== "number" || isNaN(f.value) === !1) || Pl(e.displayValue)
      ),
      getControl: () => V(I.value === !0 ? "textarea" : "input", {
        ref: m,
        class: [
          "q-field__native q-placeholder",
          e.inputClass
        ],
        style: e.inputStyle,
        ...O.value,
        ...A.value,
        ...e.type !== "file" ? { value: Q() } : S.value
      }),
      getShadowControl: () => V("div", {
        class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + (I.value === !0 ? "" : " text-no-wrap")
      }, [
        V("span", { class: "invisible" }, Q()),
        V("span", e.shadowText)
      ])
    });
    const W = ba(T);
    return Object.assign(n, {
      focus: P,
      select: $,
      getNativeElement: () => m.value
      // deprecated
    }), Kt(n, "nativeEl", () => m.value), W;
  }
}), ld = { key: 0 }, nd = /* @__PURE__ */ Ce({
  __name: "APITab",
  emits: ["close-dialog"],
  setup(e, { emit: t }) {
    const l = Me("_uct"), n = Lt(), a = Ee(), { field: i, itemId: r, isSelect: s, isRadioGroup: d, selectRadioSwitch: c } = Ke(), u = [
      (m) => {
        var p;
        return !a.getOtherFieldsName(((p = i.value) == null ? void 0 : p.id) ?? "").includes(m) || l("builder.tabs.api.nameLabel.error");
      }
    ];
    return (m, p) => {
      var f, _;
      return z(), re("section", null, [
        ee("section", null, [
          ee("h2", null, J(o(l)("builder.tabs.api.protected.title")), 1),
          o(n).isAdmin ? (z(), ae(at, {
            key: 0,
            label: o(l)("builder.tabs.api.protected.label"),
            "model-value": ((f = o(i)) == null ? void 0 : f.protected) || !1,
            color: "primary",
            "onUpdate:modelValue": p[0] || (p[0] = (v) => o(a).updateField(o(r), "protected", v))
          }, null, 8, ["label", "model-value"])) : ce("", !0)
        ]),
        ee("section", null, [
          ee("h2", null, J(o(l)("builder.tabs.api.nameLabel.title")), 1),
          D(Ne, {
            label: o(l)("builder.tabs.api.nameLabel.label"),
            "model-value": (_ = o(i)) == null ? void 0 : _.name,
            rules: u,
            dense: "",
            "onUpdate:modelValue": p[1] || (p[1] = (v) => o(a).updateField(o(r), "name", v))
          }, null, 8, ["label", "model-value"])
        ]),
        o(s) || o(d) ? (z(), re("section", ld, [
          ee("h2", null, J(o(l)("builder.tabs.api.switch.title")), 1),
          D(se, {
            label: o(l)(`builder.tabs.api.switch.to.${o(s) ? "radio" : "select"}`),
            color: "primary",
            "icon-right": "mdi-swap-horizontal",
            outline: "",
            onClick: p[2] || (p[2] = (v) => {
              o(c)(), t("close-dialog");
            })
          }, null, 8, ["label"])
        ])) : ce("", !0)
      ]);
    };
  }
});
const ad = /* @__PURE__ */ Oe(nd, [["__scopeId", "data-v-0e2e5afb"]]), od = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
}, ya = De({
  name: "QChip",
  props: {
    ...Tt,
    ...on,
    dense: Boolean,
    icon: String,
    iconRight: String,
    iconRemove: String,
    iconSelected: String,
    label: [String, Number],
    color: String,
    textColor: String,
    modelValue: {
      type: Boolean,
      default: !0
    },
    selected: {
      type: Boolean,
      default: null
    },
    square: Boolean,
    outline: Boolean,
    clickable: Boolean,
    removable: Boolean,
    removeAriaLabel: String,
    tabindex: [String, Number],
    disable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: !0
    }
  },
  emits: ["update:modelValue", "update:selected", "remove", "click"],
  setup(e, { slots: t, emit: l }) {
    const { proxy: { $q: n } } = Ae(), a = Mt(e, n), i = rn(e, od), r = b(() => e.selected === !0 || e.icon !== void 0), s = b(() => e.selected === !0 ? e.iconSelected || n.iconSet.chip.selected : e.icon), d = b(() => e.iconRemove || n.iconSet.chip.remove), c = b(
      () => e.disable === !1 && (e.clickable === !0 || e.selected !== null)
    ), u = b(() => {
      const y = e.outline === !0 && e.color || e.textColor;
      return "q-chip row inline no-wrap items-center" + (e.outline === !1 && e.color !== void 0 ? ` bg-${e.color}` : "") + (y ? ` text-${y} q-chip--colored` : "") + (e.disable === !0 ? " disabled" : "") + (e.dense === !0 ? " q-chip--dense" : "") + (e.outline === !0 ? " q-chip--outline" : "") + (e.selected === !0 ? " q-chip--selected" : "") + (c.value === !0 ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (e.square === !0 ? " q-chip--square" : "") + (a.value === !0 ? " q-chip--dark q-dark" : "");
    }), m = b(() => {
      const y = e.disable === !0 ? { tabindex: -1, "aria-disabled": "true" } : { tabindex: e.tabindex || 0 }, M = {
        ...y,
        role: "button",
        "aria-hidden": "false",
        "aria-label": e.removeAriaLabel || n.lang.label.remove
      };
      return { chip: y, remove: M };
    });
    function p(y) {
      y.keyCode === 13 && f(y);
    }
    function f(y) {
      e.disable || (l("update:selected", !e.selected), l("click", y));
    }
    function _(y) {
      (y.keyCode === void 0 || y.keyCode === 13) && (Ze(y), e.disable === !1 && (l("update:modelValue", !1), l("remove")));
    }
    function v() {
      const y = [];
      c.value === !0 && y.push(
        V("div", { class: "q-focus-helper" })
      ), r.value === !0 && y.push(
        V(Qe, {
          class: "q-chip__icon q-chip__icon--left",
          name: s.value
        })
      );
      const M = e.label !== void 0 ? [V("div", { class: "ellipsis" }, [e.label])] : void 0;
      return y.push(
        V("div", {
          class: "q-chip__content col row no-wrap items-center q-anchor--skip"
        }, ku(t.default, M))
      ), e.iconRight && y.push(
        V(Qe, {
          class: "q-chip__icon q-chip__icon--right",
          name: e.iconRight
        })
      ), e.removable === !0 && y.push(
        V(Qe, {
          class: "q-chip__icon q-chip__icon--remove cursor-pointer",
          name: d.value,
          ...m.value.remove,
          onClick: _,
          onKeyup: _
        })
      ), y;
    }
    return () => {
      if (e.modelValue === !1)
        return;
      const y = {
        class: u.value,
        style: i.value
      };
      return c.value === !0 && Object.assign(
        y,
        m.value.chip,
        { onClick: f, onKeyup: p }
      ), Ei(
        "div",
        y,
        v(),
        "ripple",
        e.ripple !== !1 && e.disable !== !0,
        () => [[ca, e.ripple]]
      );
    };
  }
}), id = /* @__PURE__ */ Ce({
  __name: "DraggableContainer",
  props: {
    items: {},
    readOnly: { type: Boolean }
  },
  emits: ["update:items"],
  setup(e, { emit: t }) {
    const l = e, { items: n, readOnly: a } = ct(l), i = (f) => f.type === "field" ? "orange-10" : f.type === "item" ? f.value === "&&" || f.value === "||" ? "blue-10" : "green-10" : "purple-10", r = Ee(), s = Me("_uct"), d = (f) => {
      var _;
      switch (f.type) {
        case "field":
        case "token":
          return `${((_ = r.fields[f.id || ""]) == null ? void 0 : _.name) || f.id}=${f.value}`;
        case "item":
          switch (f.value) {
            case "&&":
              return s("builder.tabs.conditional.operators.and");
            case "||":
              return s("builder.tabs.conditional.operators.or");
            default:
              return f.value || "";
          }
        default:
          return "";
      }
    }, c = (f) => {
      a.value || t("update:items", n.value.filter((_) => _.id !== f.id || _.value !== f.value));
    }, u = (f) => {
      if (a.value)
        return;
      const _ = f.target, v = _.parentNode, y = f.clientX, M = f.clientY;
      let w = document.elementFromPoint(y, M) ?? _;
      v === w.parentNode && (w = w !== _.nextSibling ? w : w.nextSibling, v == null || v.insertBefore(_, w));
    }, m = G(), p = () => {
      var f;
      a.value || !m.value || t("update:items", Array.from(((f = m.value) == null ? void 0 : f.children) ?? []).map((_) => ({
        id: _.dataset.id,
        type: _.dataset.type,
        value: _.dataset.value
      })));
    };
    return (f, _) => (z(), re("div", {
      ref_key: "dragContainer",
      ref: m,
      class: Ft({ draggableContainer: !o(a) })
    }, [
      (z(!0), re(Ve, null, dt(o(n), (v, y) => (z(), ae(ya, {
        key: `${v.id}_${y}-readonly`,
        class: Ft({ draggableItem: !o(a) }),
        color: i(v),
        "data-id": v.id,
        "data-type": v.type,
        "data-value": v.value,
        draggable: !o(a),
        removable: !o(a),
        outline: "",
        onDrag: u,
        onDragend: p,
        onRemove: (M) => c(v)
      }, {
        default: L(() => [
          ve(J(d(v)), 1)
        ]),
        _: 2
      }, 1032, ["class", "color", "data-id", "data-type", "data-value", "draggable", "removable", "onRemove"]))), 128))
    ], 2));
  }
});
const wr = /* @__PURE__ */ Oe(id, [["__scopeId", "data-v-490fe107"]]), rd = { class: "conditionDisplayingContainer" }, ud = /* @__PURE__ */ Ce({
  __name: "DisplayingContainer",
  props: {
    title: {},
    type: {}
  },
  emits: ["update:condition"],
  setup(e, { emit: t }) {
    const { field: l, itemId: n } = Ke(), a = Me("_uct"), { copyCondition: i, getConditions: r, deleteCondition: s } = On();
    return (d, c) => {
      var u, m;
      return z(), re("div", rd, [
        ee("header", null, [
          ee("h3", null, J(d.title), 1),
          ee("div", null, [
            D(se, {
              color: "primary",
              icon: "mdi-pencil",
              round: "",
              size: "sm",
              onClick: c[0] || (c[0] = (p) => t("update:condition", "exist"))
            }, {
              default: L(() => [
                D(nt, null, {
                  default: L(() => [
                    ve(J(o(a)("builder.tabs.conditional.actions.update")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            D(se, {
              color: "primary",
              icon: "mdi-content-copy",
              outline: "",
              round: "",
              size: "sm",
              onClick: c[1] || (c[1] = (p) => o(i)(d.type))
            }, {
              default: L(() => [
                D(nt, null, {
                  default: L(() => [
                    ve(J(o(a)("builder.tabs.conditional.actions.copy")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            D(se, {
              color: "primary",
              icon: "mdi-trash-can",
              outline: "",
              round: "",
              size: "sm",
              onClick: c[2] || (c[2] = (p) => o(s)(d.type))
            }, {
              default: L(() => [
                D(nt, null, {
                  default: L(() => [
                    ve(J(o(a)("builder.tabs.conditional.actions.delete")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        D(wr, {
          items: o(r)(((m = (u = o(l)) == null ? void 0 : u.conditional) == null ? void 0 : m.basic[d.type]) || []) ?? [],
          "read-only": !0
        }, null, 8, ["items"])
      ]);
    };
  }
});
const Aa = /* @__PURE__ */ Oe(ud, [["__scopeId", "data-v-cd1247d4"]]), _a = De({
  name: "QMenu",
  inheritAttrs: !1,
  props: {
    ...ro,
    ...ra,
    ...Tt,
    ...da,
    persistent: Boolean,
    autoClose: Boolean,
    separateClosePopup: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    fit: Boolean,
    cover: Boolean,
    square: Boolean,
    anchor: {
      type: String,
      validator: Zn
    },
    self: {
      type: String,
      validator: Zn
    },
    offset: {
      type: Array,
      validator: Zi
    },
    scrollTarget: {
      default: void 0
    },
    touchPosition: Boolean,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    }
  },
  emits: [
    ...ua,
    "click",
    "escapeKey"
  ],
  setup(e, { slots: t, emit: l, attrs: n }) {
    let a = null, i, r, s;
    const d = Ae(), { proxy: c } = d, { $q: u } = c, m = G(null), p = G(!1), f = b(
      () => e.persistent !== !0 && e.noRouteDismiss !== !0
    ), _ = Mt(e, u), { registerTick: v, removeTick: y } = Jl(), { registerTimeout: M } = qn(), { transitionProps: w, transitionStyle: S } = co(e), { localScrollTarget: h, changeScrollEvent: C, unconfigureScrollTarget: T } = Ni(e, R), { anchorEl: I, canShow: E } = uo({ showing: p }), { hide: A } = sa({
      showing: p,
      canShow: E,
      handleShow: Q,
      handleHide: W,
      hideOnRouteChange: f,
      processOnMount: !0
    }), { showPortal: O, hidePortal: P, renderPortal: $ } = so(d, m, Z, "menu"), k = {
      anchorEl: I,
      innerRef: m,
      onClickOutside(j) {
        if (e.persistent !== !0 && p.value === !0)
          return A(j), // always prevent touch event
          (j.type === "touchstart" || j.target.classList.contains("q-dialog__backdrop")) && Ze(j), !0;
      }
    }, g = b(
      () => Xn(
        e.anchor || (e.cover === !0 ? "center middle" : "bottom start"),
        u.lang.rtl
      )
    ), x = b(() => e.cover === !0 ? g.value : Xn(e.self || "top start", u.lang.rtl)), B = b(
      () => (e.square === !0 ? " q-menu--square" : "") + (_.value === !0 ? " q-menu--dark q-dark" : "")
    ), q = b(() => e.autoClose === !0 ? { onClick: ie } : {}), Y = b(
      () => p.value === !0 && e.persistent !== !0
    );
    me(Y, (j) => {
      j === !0 ? (ir(oe), Gi(k)) : (Jn(oe), Gn(k));
    });
    function K() {
      dn(() => {
        let j = m.value;
        j && j.contains(document.activeElement) !== !0 && (j = j.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || j.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || j.querySelector("[autofocus], [data-autofocus]") || j, j.focus({ preventScroll: !0 }));
      });
    }
    function Q(j) {
      if (a = e.noRefocus === !1 ? document.activeElement : null, ur(te), O(), R(), i = void 0, j !== void 0 && (e.touchPosition || e.contextMenu)) {
        const he = Cl(j);
        if (he.left !== void 0) {
          const { top: we, left: Ie } = I.value.getBoundingClientRect();
          i = { left: he.left - Ie, top: he.top - we };
        }
      }
      r === void 0 && (r = me(
        () => u.screen.width + "|" + u.screen.height + "|" + e.self + "|" + e.anchor + "|" + u.lang.rtl,
        fe
      )), e.noFocus !== !0 && document.activeElement.blur(), v(() => {
        fe(), e.noFocus !== !0 && K();
      }), M(() => {
        u.platform.is.ios === !0 && (s = e.autoClose, m.value.click()), fe(), O(!0), l("show", j);
      }, e.transitionDuration);
    }
    function W(j) {
      y(), P(), H(!0), a !== null && // menu was hidden from code or ESC plugin
      (j === void 0 || j.qClickOutside !== !0) && (((j && j.type.indexOf("key") === 0 ? a.closest('[tabindex]:not([tabindex^="-"])') : void 0) || a).focus(), a = null), M(() => {
        P(!0), l("hide", j);
      }, e.transitionDuration);
    }
    function H(j) {
      i = void 0, r !== void 0 && (r(), r = void 0), (j === !0 || p.value === !0) && (Qa(te), T(), Gn(k), Jn(oe)), j !== !0 && (a = null);
    }
    function R() {
      (I.value !== null || e.scrollTarget !== void 0) && (h.value = fo(I.value, e.scrollTarget), C(h.value, fe));
    }
    function ie(j) {
      s !== !0 ? (Qi(c, j), l("click", j)) : s = !1;
    }
    function te(j) {
      Y.value === !0 && e.noFocus !== !0 && Ki(m.value, j.target) !== !0 && K();
    }
    function oe(j) {
      l("escapeKey"), A(j);
    }
    function fe() {
      const j = m.value;
      j === null || I.value === null || Xi({
        el: j,
        offset: e.offset,
        anchorEl: I.value,
        anchorOrigin: g.value,
        selfOrigin: x.value,
        absoluteOffset: i,
        fit: e.fit,
        cover: e.cover,
        maxHeight: e.maxHeight,
        maxWidth: e.maxWidth
      });
    }
    function Z() {
      return V(
        Qt,
        w.value,
        () => p.value === !0 ? V("div", {
          role: "menu",
          ...n,
          ref: m,
          tabindex: -1,
          class: [
            "q-menu q-position-engine scroll" + B.value,
            n.class
          ],
          style: [
            n.style,
            S.value
          ],
          ...q.value
        }, We(t.default)) : null
      );
    }
    return _t(H), Object.assign(c, { focus: K, updatePosition: fe }), $;
  }
});
let Tn = !1;
{
  const e = document.createElement("div");
  e.setAttribute("dir", "rtl"), Object.assign(e.style, {
    width: "1px",
    height: "1px",
    overflow: "auto"
  });
  const t = document.createElement("div");
  Object.assign(t.style, {
    width: "1000px",
    height: "1px"
  }), document.body.appendChild(e), e.appendChild(t), e.scrollLeft = -1e3, Tn = e.scrollLeft >= 0, e.remove();
}
const rl = 1e3, sd = [
  "start",
  "center",
  "end",
  "start-force",
  "center-force",
  "end-force"
], xr = Array.prototype.filter, dd = window.getComputedStyle(document.body).overflowAnchor === void 0 ? In : function(e, t) {
  e !== null && (e._qOverflowAnimationFrame !== void 0 && cancelAnimationFrame(e._qOverflowAnimationFrame), e._qOverflowAnimationFrame = requestAnimationFrame(() => {
    if (e === null)
      return;
    e._qOverflowAnimationFrame = void 0;
    const l = e.children || [];
    xr.call(l, (a) => a.dataset && a.dataset.qVsAnchor !== void 0).forEach((a) => {
      delete a.dataset.qVsAnchor;
    });
    const n = l[t];
    n && n.dataset && (n.dataset.qVsAnchor = "");
  }));
};
function en(e, t) {
  return e + t;
}
function Oa(e, t, l, n, a, i, r, s) {
  const d = e === window ? document.scrollingElement || document.documentElement : e, c = a === !0 ? "offsetWidth" : "offsetHeight", u = {
    scrollStart: 0,
    scrollViewSize: -r - s,
    scrollMaxSize: 0,
    offsetStart: -r,
    offsetEnd: -s
  };
  if (a === !0 ? (e === window ? (u.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, u.scrollViewSize += document.documentElement.clientWidth) : (u.scrollStart = d.scrollLeft, u.scrollViewSize += d.clientWidth), u.scrollMaxSize = d.scrollWidth, i === !0 && (u.scrollStart = (Tn === !0 ? u.scrollMaxSize - u.scrollViewSize : 0) - u.scrollStart)) : (e === window ? (u.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0, u.scrollViewSize += document.documentElement.clientHeight) : (u.scrollStart = d.scrollTop, u.scrollViewSize += d.clientHeight), u.scrollMaxSize = d.scrollHeight), l !== null)
    for (let m = l.previousElementSibling; m !== null; m = m.previousElementSibling)
      m.classList.contains("q-virtual-scroll--skip") === !1 && (u.offsetStart += m[c]);
  if (n !== null)
    for (let m = n.nextElementSibling; m !== null; m = m.nextElementSibling)
      m.classList.contains("q-virtual-scroll--skip") === !1 && (u.offsetEnd += m[c]);
  if (t !== e) {
    const m = d.getBoundingClientRect(), p = t.getBoundingClientRect();
    a === !0 ? (u.offsetStart += p.left - m.left, u.offsetEnd -= p.width) : (u.offsetStart += p.top - m.top, u.offsetEnd -= p.height), e !== window && (u.offsetStart += u.scrollStart), u.offsetEnd += u.scrollMaxSize - u.offsetStart;
  }
  return u;
}
function ri(e, t, l, n) {
  t === "end" && (t = (e === window ? document.body : e)[l === !0 ? "scrollWidth" : "scrollHeight"]), e === window ? l === !0 ? (n === !0 && (t = (Tn === !0 ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - t), window.scrollTo(t, window.pageYOffset || window.scrollY || document.body.scrollTop || 0)) : window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, t) : l === !0 ? (n === !0 && (t = (Tn === !0 ? e.scrollWidth - e.offsetWidth : 0) - t), e.scrollLeft = t) : e.scrollTop = t;
}
function pn(e, t, l, n) {
  if (l >= n)
    return 0;
  const a = t.length, i = Math.floor(l / rl), r = Math.floor((n - 1) / rl) + 1;
  let s = e.slice(i, r).reduce(en, 0);
  return l % rl !== 0 && (s -= t.slice(i * rl, l).reduce(en, 0)), n % rl !== 0 && n !== a && (s -= t.slice(n, r * rl).reduce(en, 0)), s;
}
const kr = {
  virtualScrollSliceSize: {
    type: [Number, String],
    default: null
  },
  virtualScrollSliceRatioBefore: {
    type: [Number, String],
    default: 1
  },
  virtualScrollSliceRatioAfter: {
    type: [Number, String],
    default: 1
  },
  virtualScrollItemSize: {
    type: [Number, String],
    default: 24
  },
  virtualScrollStickySizeStart: {
    type: [Number, String],
    default: 0
  },
  virtualScrollStickySizeEnd: {
    type: [Number, String],
    default: 0
  },
  tableColspan: [Number, String]
}, Cr = Object.keys(kr), qr = {
  virtualScrollHorizontal: Boolean,
  onVirtualScroll: Function,
  ...kr
};
function Vr({
  virtualScrollLength: e,
  getVirtualScrollTarget: t,
  getVirtualScrollEl: l,
  virtualScrollItemSizeComputed: n
  // optional
}) {
  const a = Ae(), { props: i, emit: r, proxy: s } = a, { $q: d } = s;
  let c, u, m, p = [], f;
  const _ = G(0), v = G(0), y = G({}), M = G(null), w = G(null), S = G(null), h = G({ from: 0, to: 0 }), C = b(() => i.tableColspan !== void 0 ? i.tableColspan : 100);
  n === void 0 && (n = b(() => i.virtualScrollItemSize));
  const T = b(() => n.value + ";" + i.virtualScrollHorizontal), I = b(
    () => T.value + ";" + i.virtualScrollSliceRatioBefore + ";" + i.virtualScrollSliceRatioAfter
  );
  me(I, () => {
    B();
  }), me(T, E);
  function E() {
    x(u, !0);
  }
  function A(W) {
    x(W === void 0 ? u : W);
  }
  function O(W, H) {
    const R = t();
    if (R == null || R.nodeType === 8)
      return;
    const ie = Oa(
      R,
      l(),
      M.value,
      w.value,
      i.virtualScrollHorizontal,
      d.lang.rtl,
      i.virtualScrollStickySizeStart,
      i.virtualScrollStickySizeEnd
    );
    m !== ie.scrollViewSize && B(ie.scrollViewSize), $(
      R,
      ie,
      Math.min(e.value - 1, Math.max(0, parseInt(W, 10) || 0)),
      0,
      sd.indexOf(H) > -1 ? H : u > -1 && W > u ? "end" : "start"
    );
  }
  function P() {
    const W = t();
    if (W == null || W.nodeType === 8)
      return;
    const H = Oa(
      W,
      l(),
      M.value,
      w.value,
      i.virtualScrollHorizontal,
      d.lang.rtl,
      i.virtualScrollStickySizeStart,
      i.virtualScrollStickySizeEnd
    ), R = e.value - 1, ie = H.scrollMaxSize - H.offsetStart - H.offsetEnd - v.value;
    if (c === H.scrollStart)
      return;
    if (H.scrollMaxSize <= 0) {
      $(W, H, 0, 0);
      return;
    }
    m !== H.scrollViewSize && B(H.scrollViewSize), k(h.value.from);
    const te = Math.floor(H.scrollMaxSize - Math.max(H.scrollViewSize, H.offsetEnd) - Math.min(f[R], H.scrollViewSize / 2));
    if (te > 0 && Math.ceil(H.scrollStart) >= te) {
      $(
        W,
        H,
        R,
        H.scrollMaxSize - H.offsetEnd - p.reduce(en, 0)
      );
      return;
    }
    let oe = 0, fe = H.scrollStart - H.offsetStart, Z = fe;
    if (fe <= ie && fe + H.scrollViewSize >= _.value)
      fe -= _.value, oe = h.value.from, Z = fe;
    else
      for (let j = 0; fe >= p[j] && oe < R; j++)
        fe -= p[j], oe += rl;
    for (; fe > 0 && oe < R; )
      fe -= f[oe], fe > -H.scrollViewSize ? (oe++, Z = fe) : Z = f[oe] + fe;
    $(
      W,
      H,
      oe,
      Z
    );
  }
  function $(W, H, R, ie, te) {
    const oe = typeof te == "string" && te.indexOf("-force") > -1, fe = oe === !0 ? te.replace("-force", "") : te, Z = fe !== void 0 ? fe : "start";
    let j = Math.max(0, R - y.value[Z]), he = j + y.value.total;
    he > e.value && (he = e.value, j = Math.max(0, he - y.value.total)), c = H.scrollStart;
    const we = j !== h.value.from || he !== h.value.to;
    if (we === !1 && fe === void 0) {
      Y(R);
      return;
    }
    const { activeElement: Ie } = document, ot = S.value;
    we === !0 && ot !== null && ot !== Ie && ot.contains(Ie) === !0 && (ot.addEventListener("focusout", g), setTimeout(() => {
      ot !== null && ot.removeEventListener("focusout", g);
    })), dd(ot, R - j);
    const St = fe !== void 0 ? f.slice(j, R).reduce(en, 0) : 0;
    if (we === !0) {
      const xt = he >= h.value.from && j <= h.value.to ? h.value.to : he;
      h.value = { from: j, to: xt }, _.value = pn(p, f, 0, j), v.value = pn(p, f, he, e.value), requestAnimationFrame(() => {
        h.value.to !== he && c === H.scrollStart && (h.value = { from: h.value.from, to: he }, v.value = pn(p, f, he, e.value));
      });
    }
    requestAnimationFrame(() => {
      if (c !== H.scrollStart)
        return;
      we === !0 && k(j);
      const xt = f.slice(j, R).reduce(en, 0), qt = xt + H.offsetStart + _.value, pt = qt + f[R];
      let Wt = qt + ie;
      if (fe !== void 0) {
        const el = xt - St, ft = H.scrollStart + el;
        Wt = oe !== !0 && ft < qt && pt < ft + H.scrollViewSize ? ft : fe === "end" ? pt - H.scrollViewSize : qt - (fe === "start" ? 0 : Math.round((H.scrollViewSize - f[R]) / 2));
      }
      c = Wt, ri(
        W,
        Wt,
        i.virtualScrollHorizontal,
        d.lang.rtl
      ), Y(R);
    });
  }
  function k(W) {
    const H = S.value;
    if (H) {
      const R = xr.call(
        H.children,
        (j) => j.classList && j.classList.contains("q-virtual-scroll--skip") === !1
      ), ie = R.length, te = i.virtualScrollHorizontal === !0 ? (j) => j.getBoundingClientRect().width : (j) => j.offsetHeight;
      let oe = W, fe, Z;
      for (let j = 0; j < ie; ) {
        for (fe = te(R[j]), j++; j < ie && R[j].classList.contains("q-virtual-scroll--with-prev") === !0; )
          fe += te(R[j]), j++;
        Z = fe - f[oe], Z !== 0 && (f[oe] += Z, p[Math.floor(oe / rl)] += Z), oe++;
      }
    }
  }
  function g() {
    S.value !== null && S.value !== void 0 && S.value.focus();
  }
  function x(W, H) {
    const R = 1 * n.value;
    (H === !0 || Array.isArray(f) === !1) && (f = []);
    const ie = f.length;
    f.length = e.value;
    for (let oe = e.value - 1; oe >= ie; oe--)
      f[oe] = R;
    const te = Math.floor((e.value - 1) / rl);
    p = [];
    for (let oe = 0; oe <= te; oe++) {
      let fe = 0;
      const Z = Math.min((oe + 1) * rl, e.value);
      for (let j = oe * rl; j < Z; j++)
        fe += f[j];
      p.push(fe);
    }
    u = -1, c = void 0, _.value = pn(p, f, 0, h.value.from), v.value = pn(p, f, h.value.to, e.value), W >= 0 ? (k(h.value.from), lt(() => {
      O(W);
    })) : K();
  }
  function B(W) {
    if (W === void 0 && typeof window < "u") {
      const fe = t();
      fe != null && fe.nodeType !== 8 && (W = Oa(
        fe,
        l(),
        M.value,
        w.value,
        i.virtualScrollHorizontal,
        d.lang.rtl,
        i.virtualScrollStickySizeStart,
        i.virtualScrollStickySizeEnd
      ).scrollViewSize);
    }
    m = W;
    const H = parseFloat(i.virtualScrollSliceRatioBefore) || 0, R = parseFloat(i.virtualScrollSliceRatioAfter) || 0, ie = 1 + H + R, te = W === void 0 || W <= 0 ? 1 : Math.ceil(W / n.value), oe = Math.max(
      1,
      te,
      Math.ceil((i.virtualScrollSliceSize > 0 ? i.virtualScrollSliceSize : 10) / ie)
    );
    y.value = {
      total: Math.ceil(oe * ie),
      start: Math.ceil(oe * H),
      center: Math.ceil(oe * (0.5 + H)),
      end: Math.ceil(oe * (1 + H)),
      view: te
    };
  }
  function q(W, H) {
    const R = i.virtualScrollHorizontal === !0 ? "width" : "height", ie = {
      ["--q-virtual-scroll-item-" + R]: n.value + "px"
    };
    return [
      W === "tbody" ? V(W, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: M
      }, [
        V("tr", [
          V("td", {
            style: { [R]: `${_.value}px`, ...ie },
            colspan: C.value
          })
        ])
      ]) : V(W, {
        class: "q-virtual-scroll__padding",
        key: "before",
        ref: M,
        style: { [R]: `${_.value}px`, ...ie }
      }),
      V(W, {
        class: "q-virtual-scroll__content",
        key: "content",
        ref: S,
        tabindex: -1
      }, H.flat()),
      W === "tbody" ? V(W, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: w
      }, [
        V("tr", [
          V("td", {
            style: { [R]: `${v.value}px`, ...ie },
            colspan: C.value
          })
        ])
      ]) : V(W, {
        class: "q-virtual-scroll__padding",
        key: "after",
        ref: w,
        style: { [R]: `${v.value}px`, ...ie }
      })
    ];
  }
  function Y(W) {
    u !== W && (i.onVirtualScroll !== void 0 && r("virtualScroll", {
      index: W,
      from: h.value.from,
      to: h.value.to - 1,
      direction: W < u ? "decrease" : "increase",
      ref: s
    }), u = W);
  }
  B();
  const K = cr(
    P,
    d.platform.is.ios === !0 ? 120 : 35
  );
  to(() => {
    B();
  });
  let Q = !1;
  return zl(() => {
    Q = !0;
  }), Mn(() => {
    if (Q !== !0)
      return;
    const W = t();
    c !== void 0 && W !== void 0 && W !== null && W.nodeType !== 8 ? ri(
      W,
      c,
      i.virtualScrollHorizontal,
      d.lang.rtl
    ) : O(u);
  }), _t(() => {
    K.cancel();
  }), Object.assign(s, { scrollTo: O, reset: E, refresh: A }), {
    virtualScrollSliceRange: h,
    virtualScrollSliceSizeComputed: y,
    setVirtualScrollSize: B,
    onVirtualScrollEvt: K,
    localResetVirtualScroll: x,
    padVirtualScroll: q,
    scrollTo: O,
    reset: E,
    refresh: A
  };
}
function cl(e, t) {
  if (e === t)
    return !0;
  if (e !== null && t !== null && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    let l, n;
    if (e.constructor === Array) {
      if (l = e.length, l !== t.length)
        return !1;
      for (n = l; n-- !== 0; )
        if (cl(e[n], t[n]) !== !0)
          return !1;
      return !0;
    }
    if (e.constructor === Map) {
      if (e.size !== t.size)
        return !1;
      let i = e.entries();
      for (n = i.next(); n.done !== !0; ) {
        if (t.has(n.value[0]) !== !0)
          return !1;
        n = i.next();
      }
      for (i = e.entries(), n = i.next(); n.done !== !0; ) {
        if (cl(n.value[1], t.get(n.value[0])) !== !0)
          return !1;
        n = i.next();
      }
      return !0;
    }
    if (e.constructor === Set) {
      if (e.size !== t.size)
        return !1;
      const i = e.entries();
      for (n = i.next(); n.done !== !0; ) {
        if (t.has(n.value[0]) !== !0)
          return !1;
        n = i.next();
      }
      return !0;
    }
    if (e.buffer != null && e.buffer.constructor === ArrayBuffer) {
      if (l = e.length, l !== t.length)
        return !1;
      for (n = l; n-- !== 0; )
        if (e[n] !== t[n])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const a = Object.keys(e).filter((i) => e[i] !== void 0);
    if (l = a.length, l !== Object.keys(t).filter((i) => t[i] !== void 0).length)
      return !1;
    for (n = l; n-- !== 0; ) {
      const i = a[n];
      if (cl(e[i], t[i]) !== !0)
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Tr(e) {
  return e !== null && typeof e == "object" && Array.isArray(e) !== !0;
}
function ui(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function Ga(e) {
  return typeof e == "number" && isFinite(e);
}
const si = ["B", "KB", "MB", "GB", "TB", "PB"];
function cd(e) {
  let t = 0;
  for (; parseInt(e, 10) >= 1024 && t < si.length - 1; )
    e /= 1024, ++t;
  return `${e.toFixed(1)}${si[t]}`;
}
function di(e, t, l) {
  if (l <= t)
    return t;
  const n = l - t + 1;
  let a = t + (e - t) % n;
  return a < t && (a = n + a), a === 0 ? 0 : a;
}
function Xe(e, t = 2, l = "0") {
  if (e == null)
    return e;
  const n = "" + e;
  return n.length >= t ? n : new Array(t - n.length + 1).join(l) + n;
}
const ci = (e) => ["add", "add-unique", "toggle"].includes(e), fd = ".*+?^${}()|[]\\", vd = Object.keys(Fn), Rt = De({
  name: "QSelect",
  inheritAttrs: !1,
  props: {
    ...qr,
    ...Ml,
    ...Fn,
    modelValue: {
      required: !0
    },
    multiple: Boolean,
    displayValue: [String, Number],
    displayValueHtml: Boolean,
    dropdownIcon: String,
    options: {
      type: Array,
      default: () => []
    },
    optionValue: [Function, String],
    optionLabel: [Function, String],
    optionDisable: [Function, String],
    hideSelected: Boolean,
    hideDropdownIcon: Boolean,
    fillInput: Boolean,
    maxValues: [Number, String],
    optionsDense: Boolean,
    optionsDark: {
      type: Boolean,
      default: null
    },
    optionsSelectedClass: String,
    optionsHtml: Boolean,
    optionsCover: Boolean,
    menuShrink: Boolean,
    menuAnchor: String,
    menuSelf: String,
    menuOffset: Array,
    popupContentClass: String,
    popupContentStyle: [String, Array, Object],
    useInput: Boolean,
    useChips: Boolean,
    newValueMode: {
      type: String,
      validator: ci
    },
    mapOptions: Boolean,
    emitValue: Boolean,
    inputDebounce: {
      type: [Number, String],
      default: 500
    },
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    autocomplete: String,
    transitionShow: String,
    transitionHide: String,
    transitionDuration: [String, Number],
    behavior: {
      type: String,
      validator: (e) => ["default", "menu", "dialog"].includes(e),
      default: "default"
    },
    virtualScrollItemSize: {
      type: [Number, String],
      default: void 0
    },
    onNewValue: Function,
    onFilter: Function
  },
  emits: [
    ...ma,
    "add",
    "remove",
    "inputValue",
    "newValue",
    "keyup",
    "keypress",
    "keydown",
    "filterAbort"
  ],
  setup(e, { slots: t, emit: l }) {
    const { proxy: n } = Ae(), { $q: a } = n, i = G(!1), r = G(!1), s = G(-1), d = G(""), c = G(!1), u = G(!1);
    let m = null, p, f, _, v = null, y, M, w, S;
    const h = G(null), C = G(null), T = G(null), I = G(null), E = G(null), A = po(e), O = Sr(le), P = b(() => Array.isArray(e.options) ? e.options.length : 0), $ = b(() => e.virtualScrollItemSize === void 0 ? e.optionsDense === !0 ? 24 : 48 : e.virtualScrollItemSize), {
      virtualScrollSliceRange: k,
      virtualScrollSliceSizeComputed: g,
      localResetVirtualScroll: x,
      padVirtualScroll: B,
      onVirtualScrollEvt: q,
      scrollTo: Y,
      setVirtualScrollSize: K
    } = Vr({
      virtualScrollLength: P,
      getVirtualScrollTarget: Hl,
      getVirtualScrollEl: ol,
      virtualScrollItemSizeComputed: $
    }), Q = pa(), W = b(() => {
      const U = e.mapOptions === !0 && e.multiple !== !0, Se = e.modelValue !== void 0 && (e.modelValue !== null || U === !0) ? e.multiple === !0 && Array.isArray(e.modelValue) ? e.modelValue : [e.modelValue] : [];
      if (e.mapOptions === !0 && Array.isArray(e.options) === !0) {
        const ge = e.mapOptions === !0 && p !== void 0 ? p : [], ze = Se.map((vt) => ke(vt, ge));
        return e.modelValue === null && U === !0 ? ze.filter((vt) => vt !== null) : ze;
      }
      return Se;
    }), H = b(() => {
      const U = {};
      return vd.forEach((Se) => {
        const ge = e[Se];
        ge !== void 0 && (U[Se] = ge);
      }), U;
    }), R = b(() => e.optionsDark === null ? Q.isDark.value : e.optionsDark), ie = b(() => Pl(W.value)), te = b(() => {
      let U = "q-field__input q-placeholder col";
      return e.hideSelected === !0 || W.value.length === 0 ? [U, e.inputClass] : (U += " q-field__input--padding", e.inputClass === void 0 ? U : [U, e.inputClass]);
    }), oe = b(
      () => (e.virtualScrollHorizontal === !0 ? "q-virtual-scroll--horizontal" : "") + (e.popupContentClass ? " " + e.popupContentClass : "")
    ), fe = b(() => P.value === 0), Z = b(
      () => W.value.map((U) => ue.value(U)).join(", ")
    ), j = b(() => e.displayValue !== void 0 ? e.displayValue : Z.value), he = b(() => e.optionsHtml === !0 ? () => !0 : (U) => U != null && U.html === !0), we = b(() => e.displayValueHtml === !0 || e.displayValue === void 0 && (e.optionsHtml === !0 || W.value.some(he.value))), Ie = b(() => Q.focused.value === !0 ? e.tabindex : -1), ot = b(() => {
      const U = {
        tabindex: e.tabindex,
        role: "combobox",
        "aria-label": e.label,
        "aria-readonly": e.readonly === !0 ? "true" : "false",
        "aria-autocomplete": e.useInput === !0 ? "list" : "none",
        "aria-expanded": i.value === !0 ? "true" : "false",
        "aria-controls": `${Q.targetUid.value}_lb`
      };
      return s.value >= 0 && (U["aria-activedescendant"] = `${Q.targetUid.value}_${s.value}`), U;
    }), St = b(() => ({
      id: `${Q.targetUid.value}_lb`,
      role: "listbox",
      "aria-multiselectable": e.multiple === !0 ? "true" : "false"
    })), xt = b(() => W.value.map((U, Se) => ({
      index: Se,
      opt: U,
      html: he.value(U),
      selected: !0,
      removeAtIndex: Ue,
      toggleOption: ht,
      tabindex: Ie.value
    }))), qt = b(() => {
      if (P.value === 0)
        return [];
      const { from: U, to: Se } = k.value;
      return e.options.slice(U, Se).map((ge, ze) => {
        const vt = _e.value(ge) === !0, rt = U + ze, Vt = {
          clickable: !0,
          active: !1,
          activeClass: el.value,
          manualFocus: !0,
          focused: !1,
          disable: vt,
          tabindex: -1,
          dense: e.optionsDense,
          dark: R.value,
          role: "option",
          id: `${Q.targetUid.value}_${rt}`,
          onClick: () => {
            ht(ge);
          }
        };
        return vt !== !0 && (Ye(ge) === !0 && (Vt.active = !0), s.value === rt && (Vt.focused = !0), Vt["aria-selected"] = Vt.active === !0 ? "true" : "false", a.platform.is.desktop === !0 && (Vt.onMousemove = () => {
          i.value === !0 && ne(rt);
        })), {
          index: rt,
          opt: ge,
          html: he.value(ge),
          label: ue.value(ge),
          selected: Vt.active,
          focused: Vt.focused,
          toggleOption: ht,
          setOptionIndex: ne,
          itemProps: Vt
        };
      });
    }), pt = b(() => e.dropdownIcon !== void 0 ? e.dropdownIcon : a.iconSet.arrow.dropdown), Wt = b(
      () => e.optionsCover === !1 && e.outlined !== !0 && e.standout !== !0 && e.borderless !== !0 && e.rounded !== !0
    ), el = b(() => e.optionsSelectedClass !== void 0 ? e.optionsSelectedClass : e.color !== void 0 ? `text-${e.color}` : ""), ft = b(() => Pe(e.optionValue, "value")), ue = b(() => Pe(e.optionLabel, "label")), _e = b(() => Pe(e.optionDisable, "disable")), $e = b(() => W.value.map((U) => ft.value(U))), tt = b(() => {
      const U = {
        onInput: le,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange: O,
        onKeydown: tl,
        onKeyup: it,
        onKeypress: Dt,
        onFocus: At,
        onClick(Se) {
          f === !0 && Pt(Se);
        }
      };
      return U.onCompositionstart = U.onCompositionupdate = U.onCompositionend = O, U;
    });
    me(W, (U) => {
      p = U, e.useInput === !0 && e.fillInput === !0 && e.multiple !== !0 && Q.innerLoading.value !== !0 && (r.value !== !0 && i.value !== !0 || ie.value !== !0) && (_ !== !0 && Yl(), (r.value === !0 || i.value === !0) && Fe(""));
    }, { immediate: !0 }), me(() => e.fillInput, Yl), me(i, xa), me(P, bu);
    function Je(U) {
      return e.emitValue === !0 ? ft.value(U) : U;
    }
    function Re(U) {
      if (U > -1 && U < W.value.length)
        if (e.multiple === !0) {
          const Se = e.modelValue.slice();
          l("remove", { index: U, value: Se.splice(U, 1)[0] }), l("update:modelValue", Se);
        } else
          l("update:modelValue", null);
    }
    function Ue(U) {
      Re(U), Q.focus();
    }
    function bt(U, Se) {
      const ge = Je(U);
      if (e.multiple !== !0) {
        e.fillInput === !0 && Te(
          ue.value(U),
          !0,
          !0
        ), l("update:modelValue", ge);
        return;
      }
      if (W.value.length === 0) {
        l("add", { index: 0, value: ge }), l("update:modelValue", e.multiple === !0 ? [ge] : ge);
        return;
      }
      if (Se === !0 && Ye(U) === !0 || e.maxValues !== void 0 && e.modelValue.length >= e.maxValues)
        return;
      const ze = e.modelValue.slice();
      l("add", { index: ze.length, value: ge }), ze.push(ge), l("update:modelValue", ze);
    }
    function ht(U, Se) {
      if (Q.editable.value !== !0 || U === void 0 || _e.value(U) === !0)
        return;
      const ge = ft.value(U);
      if (e.multiple !== !0) {
        Se !== !0 && (Te(
          e.fillInput === !0 ? ue.value(U) : "",
          !0,
          !0
        ), Zt()), C.value !== null && C.value.focus(), (W.value.length === 0 || cl(ft.value(W.value[0]), ge) !== !0) && l("update:modelValue", e.emitValue === !0 ? ge : U);
        return;
      }
      if ((f !== !0 || c.value === !0) && Q.focus(), At(), W.value.length === 0) {
        const rt = e.emitValue === !0 ? ge : U;
        l("add", { index: 0, value: rt }), l("update:modelValue", e.multiple === !0 ? [rt] : rt);
        return;
      }
      const ze = e.modelValue.slice(), vt = $e.value.findIndex((rt) => cl(rt, ge));
      if (vt > -1)
        l("remove", { index: vt, value: ze.splice(vt, 1)[0] });
      else {
        if (e.maxValues !== void 0 && ze.length >= e.maxValues)
          return;
        const rt = e.emitValue === !0 ? ge : U;
        l("add", { index: ze.length, value: rt }), ze.push(rt);
      }
      l("update:modelValue", ze);
    }
    function ne(U) {
      if (a.platform.is.desktop !== !0)
        return;
      const Se = U > -1 && U < P.value ? U : -1;
      s.value !== Se && (s.value = Se);
    }
    function de(U = 1, Se) {
      if (i.value === !0) {
        let ge = s.value;
        do
          ge = di(
            ge + U,
            -1,
            P.value - 1
          );
        while (ge !== -1 && ge !== s.value && _e.value(e.options[ge]) === !0);
        s.value !== ge && (ne(ge), Y(ge), Se !== !0 && e.useInput === !0 && e.fillInput === !0 && ye(
          ge >= 0 ? ue.value(e.options[ge]) : y
        ));
      }
    }
    function ke(U, Se) {
      const ge = (ze) => cl(ft.value(ze), U);
      return e.options.find(ge) || Se.find(ge) || U;
    }
    function Pe(U, Se) {
      const ge = U !== void 0 ? U : Se;
      return typeof ge == "function" ? ge : (ze) => ze !== null && typeof ze == "object" && ge in ze ? ze[ge] : ze;
    }
    function Ye(U) {
      const Se = ft.value(U);
      return $e.value.find((ge) => cl(ge, Se)) !== void 0;
    }
    function At(U) {
      e.useInput === !0 && C.value !== null && (U === void 0 || C.value === U.target && U.target.value === Z.value) && C.value.select();
    }
    function He(U) {
      gl(U, 27) === !0 && i.value === !0 && (Pt(U), Zt(), Yl()), l("keyup", U);
    }
    function it(U) {
      const { value: Se } = U.target;
      if (U.keyCode !== void 0) {
        He(U);
        return;
      }
      if (U.target.value = "", m !== null && (clearTimeout(m), m = null), Yl(), typeof Se == "string" && Se.length !== 0) {
        const ge = Se.toLocaleLowerCase(), ze = (rt) => {
          const Vt = e.options.find((Ut) => rt.value(Ut).toLocaleLowerCase() === ge);
          return Vt === void 0 ? !1 : (W.value.indexOf(Vt) === -1 ? ht(Vt) : Zt(), !0);
        }, vt = (rt) => {
          ze(ft) !== !0 && (ze(ue) === !0 || rt === !0 || Fe(Se, !0, () => vt(!0)));
        };
        vt();
      } else
        Q.clearValue(U);
    }
    function Dt(U) {
      l("keypress", U);
    }
    function tl(U) {
      if (l("keydown", U), un(U) === !0)
        return;
      const Se = d.value.length !== 0 && (e.newValueMode !== void 0 || e.onNewValue !== void 0), ge = U.shiftKey !== !0 && e.multiple !== !0 && (s.value > -1 || Se === !0);
      if (U.keyCode === 27) {
        Ot(U);
        return;
      }
      if (U.keyCode === 9 && ge === !1) {
        Be();
        return;
      }
      if (U.target === void 0 || U.target.id !== Q.targetUid.value)
        return;
      if (U.keyCode === 40 && Q.innerLoading.value !== !0 && i.value === !1) {
        Ze(U), et();
        return;
      }
      if (U.keyCode === 8 && e.hideSelected !== !0 && d.value.length === 0) {
        e.multiple === !0 && Array.isArray(e.modelValue) === !0 ? Re(e.modelValue.length - 1) : e.multiple !== !0 && e.modelValue !== null && l("update:modelValue", null);
        return;
      }
      (U.keyCode === 35 || U.keyCode === 36) && (typeof d.value != "string" || d.value.length === 0) && (Ze(U), s.value = -1, de(U.keyCode === 36 ? 1 : -1, e.multiple)), (U.keyCode === 33 || U.keyCode === 34) && g.value !== void 0 && (Ze(U), s.value = Math.max(
        -1,
        Math.min(
          P.value,
          s.value + (U.keyCode === 33 ? -1 : 1) * g.value.view
        )
      ), de(U.keyCode === 33 ? 1 : -1, e.multiple)), (U.keyCode === 38 || U.keyCode === 40) && (Ze(U), de(U.keyCode === 38 ? -1 : 1, e.multiple));
      const ze = P.value;
      if ((w === void 0 || S < Date.now()) && (w = ""), ze > 0 && e.useInput !== !0 && U.key !== void 0 && U.key.length === 1 && U.altKey === !1 && U.ctrlKey === !1 && U.metaKey === !1 && (U.keyCode !== 32 || w.length !== 0)) {
        i.value !== !0 && et(U);
        const vt = U.key.toLocaleLowerCase(), rt = w.length === 1 && w[0] === vt;
        S = Date.now() + 1500, rt === !1 && (Ze(U), w += vt);
        const Vt = new RegExp("^" + w.split("").map((ka) => fd.indexOf(ka) > -1 ? "\\" + ka : ka).join(".*"), "i");
        let Ut = s.value;
        if (rt === !0 || Ut < 0 || Vt.test(ue.value(e.options[Ut])) !== !0)
          do
            Ut = di(Ut + 1, -1, ze - 1);
          while (Ut !== s.value && (_e.value(e.options[Ut]) === !0 || Vt.test(ue.value(e.options[Ut])) !== !0));
        s.value !== Ut && lt(() => {
          ne(Ut), Y(Ut), Ut >= 0 && e.useInput === !0 && e.fillInput === !0 && ye(ue.value(e.options[Ut]));
        });
        return;
      }
      if (!(U.keyCode !== 13 && (U.keyCode !== 32 || e.useInput === !0 || w !== "") && (U.keyCode !== 9 || ge === !1))) {
        if (U.keyCode !== 9 && Ze(U), s.value > -1 && s.value < ze) {
          ht(e.options[s.value]);
          return;
        }
        if (Se === !0) {
          const vt = (rt, Vt) => {
            if (Vt) {
              if (ci(Vt) !== !0)
                return;
            } else
              Vt = e.newValueMode;
            if (rt == null)
              return;
            Te("", e.multiple !== !0, !0), (Vt === "toggle" ? ht : bt)(rt, Vt === "add-unique"), e.multiple !== !0 && (C.value !== null && C.value.focus(), Zt());
          };
          if (e.onNewValue !== void 0 ? l("newValue", d.value, vt) : vt(d.value), e.multiple !== !0)
            return;
        }
        i.value === !0 ? Be() : Q.innerLoading.value !== !0 && et();
      }
    }
    function ol() {
      return f === !0 ? E.value : T.value !== null && T.value.contentEl !== null ? T.value.contentEl : void 0;
    }
    function Hl() {
      return ol();
    }
    function sl() {
      return e.hideSelected === !0 ? [] : t["selected-item"] !== void 0 ? xt.value.map((U) => t["selected-item"](U)).slice() : t.selected !== void 0 ? [].concat(t.selected()) : e.useChips === !0 ? xt.value.map((U, Se) => V(ya, {
        key: "option-" + Se,
        removable: Q.editable.value === !0 && _e.value(U.opt) !== !0,
        dense: !0,
        textColor: e.color,
        tabindex: Ie.value,
        onRemove() {
          U.removeAtIndex(Se);
        }
      }, () => V("span", {
        class: "ellipsis",
        [U.html === !0 ? "innerHTML" : "textContent"]: ue.value(U.opt)
      }))) : [
        V("span", {
          [we.value === !0 ? "innerHTML" : "textContent"]: j.value
        })
      ];
    }
    function _l() {
      if (fe.value === !0)
        return t["no-option"] !== void 0 ? t["no-option"]({ inputValue: d.value }) : void 0;
      const U = t.option !== void 0 ? t.option : (ge) => V(Tl, {
        key: ge.index,
        ...ge.itemProps
      }, () => V(
        jt,
        () => V(
          ql,
          () => V("span", {
            [ge.html === !0 ? "innerHTML" : "textContent"]: ge.label
          })
        )
      ));
      let Se = B("div", qt.value.map(U));
      return t["before-options"] !== void 0 && (Se = t["before-options"]().concat(Se)), al(t["after-options"], Se);
    }
    function Dl(U, Se) {
      const ge = Se === !0 ? { ...ot.value, ...Q.splitAttrs.attributes.value } : void 0, ze = {
        ref: Se === !0 ? C : void 0,
        key: "i_t",
        class: te.value,
        style: e.inputStyle,
        value: d.value !== void 0 ? d.value : "",
        // required for Android in order to show ENTER key when in form
        type: "search",
        ...ge,
        id: Se === !0 ? Q.targetUid.value : void 0,
        maxlength: e.maxlength,
        autocomplete: e.autocomplete,
        "data-autofocus": U === !0 || e.autofocus === !0 || void 0,
        disabled: e.disable === !0,
        readonly: e.readonly === !0,
        ...tt.value
      };
      return U !== !0 && f === !0 && (Array.isArray(ze.class) === !0 ? ze.class = [...ze.class, "no-pointer-events"] : ze.class += " no-pointer-events"), V("input", ze);
    }
    function le(U) {
      m !== null && (clearTimeout(m), m = null), !(U && U.target && U.target.qComposing === !0) && (ye(U.target.value || ""), _ = !0, y = d.value, Q.focused.value !== !0 && (f !== !0 || c.value === !0) && Q.focus(), e.onFilter !== void 0 && (m = setTimeout(() => {
        m = null, Fe(d.value);
      }, e.inputDebounce)));
    }
    function ye(U) {
      d.value !== U && (d.value = U, l("inputValue", U));
    }
    function Te(U, Se, ge) {
      _ = ge !== !0, e.useInput === !0 && (ye(U), (Se === !0 || ge !== !0) && (y = U), Se !== !0 && Fe(U));
    }
    function Fe(U, Se, ge) {
      if (e.onFilter === void 0 || Se !== !0 && Q.focused.value !== !0)
        return;
      Q.innerLoading.value === !0 ? l("filterAbort") : (Q.innerLoading.value = !0, u.value = !0), U !== "" && e.multiple !== !0 && W.value.length !== 0 && _ !== !0 && U === ue.value(W.value[0]) && (U = "");
      const ze = setTimeout(() => {
        i.value === !0 && (i.value = !1);
      }, 10);
      v !== null && clearTimeout(v), v = ze, l(
        "filter",
        U,
        (vt, rt) => {
          (Se === !0 || Q.focused.value === !0) && v === ze && (clearTimeout(v), typeof vt == "function" && vt(), u.value = !1, lt(() => {
            Q.innerLoading.value = !1, Q.editable.value === !0 && (Se === !0 ? i.value === !0 && Zt() : i.value === !0 ? xa(!0) : i.value = !0), typeof rt == "function" && lt(() => {
              rt(n);
            }), typeof ge == "function" && lt(() => {
              ge(n);
            });
          }));
        },
        () => {
          Q.focused.value === !0 && v === ze && (clearTimeout(v), Q.innerLoading.value = !1, u.value = !1), i.value === !0 && (i.value = !1);
        }
      );
    }
    function je() {
      return V(_a, {
        ref: T,
        class: oe.value,
        style: e.popupContentStyle,
        modelValue: i.value,
        fit: e.menuShrink !== !0,
        cover: e.optionsCover === !0 && fe.value !== !0 && e.useInput !== !0,
        anchor: e.menuAnchor,
        self: e.menuSelf,
        offset: e.menuOffset,
        dark: R.value,
        noParentEvent: !0,
        noRefocus: !0,
        noFocus: !0,
        square: Wt.value,
        transitionShow: e.transitionShow,
        transitionHide: e.transitionHide,
        transitionDuration: e.transitionDuration,
        separateClosePopup: !0,
        ...St.value,
        onScrollPassive: q,
        onBeforeShow: qo,
        onBeforeHide: gt,
        onShow: F
      }, _l);
    }
    function gt(U) {
      Vo(U), Be();
    }
    function F() {
      K();
    }
    function N(U) {
      Pt(U), C.value !== null && C.value.focus(), c.value = !0, window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
    }
    function X(U) {
      Pt(U), lt(() => {
        c.value = !1;
      });
    }
    function be() {
      const U = [
        V(ha, {
          class: `col-auto ${Q.fieldClass.value}`,
          ...H.value,
          for: Q.targetUid.value,
          dark: R.value,
          square: !0,
          loading: u.value,
          itemAligned: !1,
          filled: !0,
          stackLabel: d.value.length !== 0,
          ...Q.splitAttrs.listeners.value,
          onFocus: N,
          onBlur: X
        }, {
          ...t,
          rawControl: () => Q.getControl(!0),
          before: void 0,
          after: void 0
        })
      ];
      return i.value === !0 && U.push(
        V("div", {
          ref: E,
          class: oe.value + " scroll",
          style: e.popupContentStyle,
          ...St.value,
          onClick: Ot,
          onScrollPassive: q
        }, _l())
      ), V($n, {
        ref: I,
        modelValue: r.value,
        position: e.useInput === !0 ? "top" : void 0,
        transitionShow: M,
        transitionHide: e.transitionHide,
        transitionDuration: e.transitionDuration,
        onBeforeShow: qo,
        onBeforeHide: pe,
        onHide: Ge,
        onShow: xe
      }, () => V("div", {
        class: "q-select__dialog" + (R.value === !0 ? " q-select__dialog--dark q-dark" : "") + (c.value === !0 ? " q-select__dialog--focused" : "")
      }, U));
    }
    function pe(U) {
      Vo(U), I.value !== null && I.value.__updateRefocusTarget(
        Q.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child")
      ), Q.focused.value = !1;
    }
    function Ge(U) {
      Zt(), Q.focused.value === !1 && l("blur", U), Yl();
    }
    function xe() {
      const U = document.activeElement;
      (U === null || U.id !== Q.targetUid.value) && C.value !== null && C.value !== U && C.value.focus(), K();
    }
    function Be() {
      r.value !== !0 && (s.value = -1, i.value === !0 && (i.value = !1), Q.focused.value === !1 && (v !== null && (clearTimeout(v), v = null), Q.innerLoading.value === !0 && (l("filterAbort"), Q.innerLoading.value = !1, u.value = !1)));
    }
    function et(U) {
      Q.editable.value === !0 && (f === !0 ? (Q.onControlFocusin(U), r.value = !0, lt(() => {
        Q.focus();
      })) : Q.focus(), e.onFilter !== void 0 ? Fe(d.value) : (fe.value !== !0 || t["no-option"] !== void 0) && (i.value = !0));
    }
    function Zt() {
      r.value = !1, Be();
    }
    function Yl() {
      e.useInput === !0 && Te(
        e.multiple !== !0 && e.fillInput === !0 && W.value.length !== 0 && ue.value(W.value[0]) || "",
        !0,
        !0
      );
    }
    function xa(U) {
      let Se = -1;
      if (U === !0) {
        if (W.value.length !== 0) {
          const ge = ft.value(W.value[0]);
          Se = e.options.findIndex((ze) => cl(ft.value(ze), ge));
        }
        x(Se);
      }
      ne(Se);
    }
    function bu(U, Se) {
      i.value === !0 && Q.innerLoading.value === !1 && (x(-1, !0), lt(() => {
        i.value === !0 && Q.innerLoading.value === !1 && (U > Se ? x() : xa(!0));
      }));
    }
    function Co() {
      r.value === !1 && T.value !== null && T.value.updatePosition();
    }
    function qo(U) {
      U !== void 0 && Pt(U), l("popupShow", U), Q.hasPopupOpen = !0, Q.onControlFocusin(U);
    }
    function Vo(U) {
      U !== void 0 && Pt(U), l("popupHide", U), Q.hasPopupOpen = !1, Q.onControlFocusout(U);
    }
    function To() {
      f = a.platform.is.mobile !== !0 && e.behavior !== "dialog" ? !1 : e.behavior !== "menu" && (e.useInput === !0 ? t["no-option"] !== void 0 || e.onFilter !== void 0 || fe.value === !1 : !0), M = a.platform.is.ios === !0 && f === !0 && e.useInput === !0 ? "fade" : e.transitionShow;
    }
    return Fi(To), _u(Co), To(), _t(() => {
      m !== null && clearTimeout(m);
    }), Object.assign(n, {
      showPopup: et,
      hidePopup: Zt,
      removeAtIndex: Re,
      add: bt,
      toggleOption: ht,
      getOptionIndex: () => s.value,
      setOptionIndex: ne,
      moveOptionSelection: de,
      filter: Fe,
      updateMenuPosition: Co,
      updateInputValue: Te,
      isOptionSelected: Ye,
      getEmittingOptionValue: Je,
      isOptionDisabled: (...U) => _e.value.apply(null, U) === !0,
      getOptionValue: (...U) => ft.value.apply(null, U),
      getOptionLabel: (...U) => ue.value.apply(null, U)
    }), Object.assign(Q, {
      innerValue: W,
      fieldClass: b(
        () => `q-select q-field--auto-height q-select--with${e.useInput !== !0 ? "out" : ""}-input q-select--with${e.useChips !== !0 ? "out" : ""}-chips q-select--${e.multiple === !0 ? "multiple" : "single"}`
      ),
      inputRef: h,
      targetRef: C,
      hasValue: ie,
      showPopup: et,
      floatingLabel: b(
        () => e.hideSelected !== !0 && ie.value === !0 || typeof d.value == "number" || d.value.length !== 0 || Pl(e.displayValue)
      ),
      getControlChild: () => {
        if (Q.editable.value !== !1 && (r.value === !0 || fe.value !== !0 || t["no-option"] !== void 0))
          return f === !0 ? be() : je();
        Q.hasPopupOpen === !0 && (Q.hasPopupOpen = !1);
      },
      controlEvents: {
        onFocusin(U) {
          Q.onControlFocusin(U);
        },
        onFocusout(U) {
          Q.onControlFocusout(U, () => {
            Yl(), Be();
          });
        },
        onClick(U) {
          if (Ot(U), f !== !0 && i.value === !0) {
            Be(), C.value !== null && C.value.focus();
            return;
          }
          et(U);
        }
      },
      getControl: (U) => {
        const Se = sl(), ge = U === !0 || r.value !== !0 || f !== !0;
        if (e.useInput === !0)
          Se.push(Dl(U, ge));
        else if (Q.editable.value === !0) {
          const vt = ge === !0 ? ot.value : void 0;
          Se.push(
            V("input", {
              ref: ge === !0 ? C : void 0,
              key: "d_t",
              class: "q-select__focus-target",
              id: ge === !0 ? Q.targetUid.value : void 0,
              value: j.value,
              readonly: !0,
              "data-autofocus": U === !0 || e.autofocus === !0 || void 0,
              ...vt,
              onKeydown: tl,
              onKeyup: He,
              onKeypress: Dt
            })
          ), ge === !0 && typeof e.autocomplete == "string" && e.autocomplete.length !== 0 && Se.push(
            V("input", {
              class: "q-select__autocomplete-input",
              autocomplete: e.autocomplete,
              tabindex: -1,
              onKeyup: it
            })
          );
        }
        if (A.value !== void 0 && e.disable !== !0 && $e.value.length !== 0) {
          const vt = $e.value.map((rt) => V("option", { value: rt, selected: !0 }));
          Se.push(
            V("select", {
              class: "hidden",
              name: A.value,
              multiple: e.multiple
            }, vt)
          );
        }
        const ze = e.useInput === !0 || ge !== !0 ? void 0 : Q.splitAttrs.attributes.value;
        return V("div", {
          class: "q-field__native row items-center",
          ...ze,
          ...Q.splitAttrs.listeners.value
        }, Se);
      },
      getInnerAppend: () => e.loading !== !0 && u.value !== !0 && e.hideDropdownIcon !== !0 ? [
        V(Qe, {
          class: "q-select__dropdown-icon" + (i.value === !0 ? " rotate-180" : ""),
          name: pt.value
        })
      ] : null
    }), ba(Q);
  }
}), md = V("div", {
  key: "svg",
  class: "q-checkbox__bg absolute"
}, [
  V("svg", {
    class: "q-checkbox__svg fit absolute-full",
    viewBox: "0 0 24 24"
  }, [
    V("path", {
      class: "q-checkbox__truthy",
      fill: "none",
      d: "M1.73,12.91 8.1,19.28 22.79,4.59"
    }),
    V("path", {
      class: "q-checkbox__indet",
      d: "M4,14H20V10H4"
    })
  ])
]), Bt = De({
  name: "QCheckbox",
  props: br,
  emits: hr,
  setup(e) {
    function t(l, n) {
      const a = b(
        () => (l.value === !0 ? e.checkedIcon : n.value === !0 ? e.indeterminateIcon : e.uncheckedIcon) || null
      );
      return () => a.value !== null ? [
        V("div", {
          key: "icon",
          class: "q-checkbox__icon-container absolute-full flex flex-center no-wrap"
        }, [
          V(Qe, {
            class: "q-checkbox__icon",
            name: a.value
          })
        ])
      ] : [md];
    }
    return gr("checkbox", t);
  }
}), Ht = Rl({
  conditionModalDisplayed: !1,
  conditionTypeSelected: "exist",
  items: []
}), Sa = () => {
  const e = Ee(), t = Lt(), l = sn(), { translateCondition: n, deleteCondition: a } = On(), { field: i, itemId: r } = Ke(), s = Me("_uct"), d = () => {
    Ht.conditionModalDisplayed = !0;
  }, c = () => {
    Ht.conditionTypeSelected = "exist", Ht.conditionModalDisplayed = !1, Ht.items = [];
  }, u = G(!1), m = b(() => [
    // { value: 'visible', label: _uct('builder.tabs.conditional.types.labelDisplayed') },
    { value: "exist", label: s("builder.tabs.conditional.types.labelExist") },
    { value: "required", label: s("builder.tabs.conditional.types.labelRequired") }
  ]), p = (x, B = "item", q) => {
    const Y = {
      id: q || `${Yt()}`,
      value: x,
      type: B
    };
    Ht.items.push(Y);
  }, f = () => {
    if (Object.keys(Ht.items).length === 0) {
      a(Ht.conditionTypeSelected), c();
      return;
    }
    n(Ht.items, r.value, Ht.conditionTypeSelected), e.initDependenciesForAllFields(), c();
  }, _ = () => {
    var x, B;
    e.updateField(
      r.value,
      "conditional",
      {
        basic: {
          ...((B = (x = i.value) == null ? void 0 : x.conditional) == null ? void 0 : B.basic) || {},
          [Ht.conditionTypeSelected]: []
        }
      }
    ), Ht.items.splice(0, Ht.items.length);
  }, v = b(() => t.templatesNames.map((x) => ({
    optGroup: {
      label: s(`builder.tabs.conditional.fieldSelection.${x}`),
      options: t.templateAttributes(x)
    }
  }))), y = b(() => ({
    optGroup: {
      label: s("builder.tabs.conditional.fieldSelection.otherFields"),
      options: Object.values(e.fields).filter(
        (x) => {
          var B;
          return x.id !== ((B = i.value) == null ? void 0 : B.id) && l.controls[x.component].usfType === "input";
        }
      ).map(({ name: x, id: B }) => ({ name: x || B, id: B })).sort((x, B) => x.name ? B.name ? x.name < B.name ? -1 : x.name > B.name ? 1 : 0 : 1 : -1)
    }
  })), M = b(() => [
    ...v.value,
    y.value
  ]), w = G(null), S = G([]), h = G(null), C = [
    { label: s("builder.tabs.conditional.operators.and"), value: "&&" },
    { label: s("builder.tabs.conditional.operators.or"), value: "||" }
  ], T = G(""), I = b(() => s(`builder.tabs.conditional.types.${Ht.conditionTypeSelected === "exist" ? "labelExist" : Ht.conditionTypeSelected === "visible" ? "labelDisplayed" : "labelRequired"}`)), E = b(() => !!w.value && (!!T.value || !!S.value.length)), A = b(() => {
    var x;
    if (w.value && !k.value)
      return e.fields[(x = w.value) == null ? void 0 : x.id];
  }), O = b(() => A.value ? l.controls[A.value.component] : void 0), P = b(() => {
    var x, B;
    return !!((B = (x = O.value) == null ? void 0 : x.usfSubtypes) != null && B.includes("withOptions"));
  }), $ = b(() => {
    var B;
    return (((B = A.value) == null ? void 0 : B.options) || []).map((q) => e.getOptionByIdOrValue(q));
  }), k = b(() => {
    var x;
    return w.value ? (x = w.value) == null ? void 0 : x.id.startsWith("user.") : !1;
  }), g = () => {
    var x, B, q, Y;
    T.value.length > 0 ? p(
      T.value,
      (B = (x = w.value) == null ? void 0 : x.id) != null && B.startsWith("user.") ? "token" : "field",
      (q = w.value) == null ? void 0 : q.id
    ) : Array.isArray(S.value) && ((Y = S.value) == null || Y.forEach((K, Q) => {
      var W;
      p(
        K,
        "field",
        (W = w.value) == null ? void 0 : W.id
      ), Q !== S.value.length - 1 && p(
        h.value || "||",
        "item"
      );
    })), w.value = null, T.value = "", S.value = [], h.value = null;
  };
  return {
    ...ct(Ht),
    userTemplatesAttributes: v,
    closeDialog: c,
    openDialog: d,
    errorDisplayed: u,
    conditionTypeOptions: m,
    onAddItem: p,
    onEmptyConditions: _,
    conditionalBasicItems: M,
    onAddItemLinked: g,
    itemLinked: w,
    itemValue: T,
    itemLinkedOptionSelected: S,
    linkedInputOptions: $,
    itemLinkedOptionOperatorSelected: h,
    operatorsOptions: C,
    linkedInputHasOptions: P,
    selectSelectionLabel: I,
    fieldIsSelectWithValue: E,
    onValidCondition: f
  };
};
function fi(e) {
  if (e === !1)
    return 0;
  if (e === !0 || e === void 0)
    return 1;
  const t = parseInt(e, 10);
  return isNaN(t) ? 0 : t;
}
const Za = aa(
  {
    name: "close-popup",
    beforeMount(e, { value: t }) {
      const l = {
        depth: fi(t),
        handler(n) {
          l.depth !== 0 && setTimeout(() => {
            const a = ns(e);
            a !== void 0 && as(a, n, l.depth);
          });
        },
        handlerKey(n) {
          gl(n, 13) === !0 && l.handler(n);
        }
      };
      e.__qclosepopup = l, e.addEventListener("click", l.handler), e.addEventListener("keyup", l.handlerKey);
    },
    updated(e, { value: t, oldValue: l }) {
      t !== l && (e.__qclosepopup.depth = fi(t));
    },
    beforeUnmount(e) {
      const t = e.__qclosepopup;
      e.removeEventListener("click", t.handler), e.removeEventListener("keyup", t.handlerKey), delete e.__qclosepopup;
    }
  }
), Mr = /* @__PURE__ */ Ce({
  __name: "ConditionalSelect",
  props: {
    clearable: { type: Boolean, default: !1 },
    dense: { type: Boolean, default: !1 },
    emitValue: { type: Boolean, default: !1 },
    label: {},
    mapOptions: { type: Boolean, default: !1 },
    modelValue: {},
    optionLabel: { default: "label" },
    optionValue: { default: "value" },
    options: {}
  },
  emits: ["clear", "update:modelValue"],
  setup(e, { emit: t }) {
    const l = e, { emitValue: n, mapOptions: a, modelValue: i, options: r } = ct(l), s = (c) => {
      t(
        "update:modelValue",
        n.value && a.value ? c.id : c
      );
    }, d = b(() => {
      if (!i.value)
        return "";
      for (const c of r.value)
        for (const u of c.optGroup.options)
          if (u.id === (typeof i.value == "string" ? i.value : i.value.id))
            return u.name;
      return "";
    });
    return (c, u) => (z(), ae(Rt, {
      clearable: c.clearable,
      dense: c.dense,
      "emit-value": o(n),
      label: c.label,
      "map-options": o(a),
      "model-value": o(i),
      "option-label": c.optionLabel,
      "option-value": c.optionValue,
      options: o(r),
      onClear: u[0] || (u[0] = (m) => t("clear"))
    }, {
      selected: L(() => [
        ve(J(d.value), 1)
      ]),
      option: L((m) => [
        m.opt.optGroup.options.length ? (z(), re(Ve, { key: 0 }, [
          D(ql, { header: "" }, {
            default: L(() => [
              ve(J(m.opt.optGroup.label), 1)
            ]),
            _: 2
          }, 1024),
          (z(!0), re(Ve, null, dt(m.opt.optGroup.options, (p) => Ct((z(), ae(Tl, {
            key: p.id,
            clickable: "",
            dense: "",
            onClick: (f) => s(p)
          }, {
            default: L(() => [
              D(jt, null, {
                default: L(() => [
                  D(ql, null, {
                    default: L(() => [
                      ve(J(p.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [Za],
            [ca]
          ])), 128))
        ], 64)) : ce("", !0)
      ]),
      _: 1
    }, 8, ["clearable", "dense", "emit-value", "label", "map-options", "model-value", "option-label", "option-value", "options"]));
  }
}), pd = /* @__PURE__ */ Ce({
  __name: "BasicSelect",
  setup(e) {
    const {
      conditionalBasicItems: t,
      fieldIsSelectWithValue: l,
      itemLinked: n,
      itemLinkedOptionOperatorSelected: a,
      itemLinkedOptionSelected: i,
      itemValue: r,
      linkedInputHasOptions: s,
      linkedInputOptions: d,
      onAddItemLinked: c,
      operatorsOptions: u,
      selectSelectionLabel: m
    } = Sa(), p = Me("_uct");
    return (f, _) => (z(), re("section", {
      class: Ft({ linkedInputHasOptions: o(s) })
    }, [
      D(Mr, {
        modelValue: o(n),
        "onUpdate:modelValue": _[0] || (_[0] = (v) => Gt(n) ? n.value = v : null),
        label: o(m),
        options: o(t),
        clearable: "",
        dense: "",
        "option-value": "id",
        onClear: _[1] || (_[1] = (v) => n.value = null)
      }, null, 8, ["modelValue", "label", "options"]),
      o(s) ? (z(), re(Ve, { key: 0 }, [
        D(Rt, {
          modelValue: o(i),
          "onUpdate:modelValue": _[2] || (_[2] = (v) => Gt(i) ? i.value = v : null),
          label: o(p)("builder.tabs.conditional.valueLabels.in"),
          options: o(d),
          dense: "",
          "emit-value": "",
          "map-options": "",
          multiple: ""
        }, {
          option: L(({ itemProps: v, opt: y, selected: M, toggleOption: w }) => [
            D(Tl, lo(no(v)), {
              default: L(() => [
                D(jt, { side: "" }, {
                  default: L(() => [
                    D(Bt, {
                      "model-value": M,
                      "onUpdate:modelValue": (S) => w(y)
                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024),
                D(jt, null, {
                  default: L(() => [
                    D(ql, null, {
                      default: L(() => [
                        ve(J(y.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1040)
          ]),
          _: 1
        }, 8, ["modelValue", "label", "options"]),
        D(Rt, {
          modelValue: o(a),
          "onUpdate:modelValue": _[3] || (_[3] = (v) => Gt(a) ? a.value = v : null),
          label: o(p)("builder.tabs.conditional.valueLabels.operator"),
          options: o(u),
          dense: "",
          "emit-value": "",
          "map-options": ""
        }, null, 8, ["modelValue", "label", "options"])
      ], 64)) : (z(), ae(Ne, {
        key: 1,
        modelValue: o(r),
        "onUpdate:modelValue": _[4] || (_[4] = (v) => Gt(r) ? r.value = v : null),
        label: o(p)("builder.tabs.conditional.valueLabels.equal"),
        dense: "",
        onKeypress: dl(o(c), ["enter"])
      }, null, 8, ["modelValue", "label", "onKeypress"])),
      D(se, {
        disabled: !o(l),
        flat: "",
        icon: "mdi-plus-circle-outline",
        round: "",
        small: "",
        onClick: o(c)
      }, null, 8, ["disabled", "onClick"])
    ], 2));
  }
});
const bd = /* @__PURE__ */ Oe(pd, [["__scopeId", "data-v-281cd5ca"]]), hd = { class: "btnContainer" }, gd = /* @__PURE__ */ Ce({
  __name: "ConditionalDialog",
  setup(e) {
    const {
      closeDialog: t,
      conditionModalDisplayed: l,
      conditionTypeOptions: n,
      conditionTypeSelected: a,
      errorDisplayed: i,
      items: r,
      onAddItem: s,
      onEmptyConditions: d,
      onValidCondition: c
    } = Sa(), u = Me("_uct");
    return (m, p) => (z(), ae($n, {
      "model-value": o(l),
      maximized: "",
      persistent: ""
    }, {
      default: L(() => [
        D(fn, { class: "usf_dialog_card" }, {
          default: L(() => [
            D(fa, null, {
              default: L(() => [
                ve(J(o(u)("builder.tabs.conditional.actions.add")) + " ", 1),
                D(va),
                D(se, {
                  dense: "",
                  flat: "",
                  icon: "mdi-close",
                  onClick: o(t)
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            D(cn, null, {
              default: L(() => [
                ee("header", null, [
                  D(Rt, {
                    modelValue: o(a),
                    "onUpdate:modelValue": p[0] || (p[0] = (f) => Gt(a) ? a.value = f : null),
                    label: o(u)("builder.tabs.conditional.types.label"),
                    options: o(n),
                    "emit-value": "",
                    "map-options": ""
                  }, null, 8, ["modelValue", "label", "options"]),
                  ee("div", hd, [
                    D(se, {
                      color: "primary",
                      outline: "",
                      onClick: p[1] || (p[1] = (f) => o(s)("&&"))
                    }, {
                      default: L(() => [
                        ve(J(o(u)("builder.tabs.conditional.operators.and")), 1)
                      ]),
                      _: 1
                    }),
                    D(se, {
                      color: "primary",
                      outline: "",
                      onClick: p[2] || (p[2] = (f) => o(s)("||"))
                    }, {
                      default: L(() => [
                        ve(J(o(u)("builder.tabs.conditional.operators.or")), 1)
                      ]),
                      _: 1
                    }),
                    D(se, {
                      color: "primary",
                      outline: "",
                      onClick: p[3] || (p[3] = (f) => o(s)("("))
                    }, {
                      default: L(() => [
                        ve(" ( ")
                      ]),
                      _: 1
                    }),
                    D(se, {
                      color: "primary",
                      outline: "",
                      onClick: p[4] || (p[4] = (f) => o(s)(")"))
                    }, {
                      default: L(() => [
                        ve(" ) ")
                      ]),
                      _: 1
                    }),
                    D(se, {
                      color: "primary",
                      icon: "mdi-trash-can",
                      outline: "",
                      onClick: o(d)
                    }, {
                      default: L(() => [
                        D(nt, null, {
                          default: L(() => [
                            ve(J(o(u)("builder.tabs.conditional.emptyInformation")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  D(bd)
                ]),
                Ct(D(Vl, { class: "bg-negative" }, {
                  default: L(() => [
                    ve(J(o(u)("builder.tabs.conditional.error.format")), 1)
                  ]),
                  _: 1
                }, 512), [
                  [Nt, o(i)]
                ]),
                D(wr, {
                  items: o(r),
                  "onUpdate:items": p[5] || (p[5] = (f) => Gt(r) ? r.value = f : null),
                  "read-only": !1
                }, null, 8, ["items"])
              ]),
              _: 1
            }),
            D(mo, null, {
              default: L(() => [
                D(se, {
                  color: "primary",
                  outlined: "",
                  onClick: o(t)
                }, {
                  default: L(() => [
                    ve(J(o(u)("builder.tabs.conditional.actions.cancel")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                D(se, {
                  color: "primary",
                  onClick: o(c)
                }, {
                  default: L(() => [
                    ve(J(o(u)("builder.tabs.conditional.actions.valid")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"]));
  }
});
const yd = /* @__PURE__ */ Oe(gd, [["__scopeId", "data-v-588f5e46"]]);
function wa() {
  return Me(Hs);
}
const _d = {
  key: 0,
  class: "noValue"
}, Sd = /* @__PURE__ */ Ce({
  __name: "ConditionalTab",
  setup(e) {
    const t = Me("_uct"), { items: l, openDialog: n } = Sa(), { field: a } = Ke(), {
      fieldConditionsIsEmpty: i,
      fieldHasConditionExist: r,
      fieldHasConditionDisplayed: s,
      fieldHasConditionRequired: d,
      getConditions: c,
      pasteCondition: u
    } = On(), m = (_) => {
      var v, y;
      l.value = c(((y = (v = a.value) == null ? void 0 : v.conditional) == null ? void 0 : y.basic[_]) || []), n();
    }, { notify: p } = wa(), f = () => {
      u() || p({
        type: "negative",
        textColor: "black",
        message: t("builder.tabs.conditional.actions.cannotPaste")
      });
    };
    return (_, v) => (z(), re(Ve, null, [
      D(yd),
      ee("section", null, [
        ee("section", null, [
          ee("header", null, [
            ee("h2", null, J(o(t)("builder.tabs.conditional.title")), 1),
            D(se, {
              color: "primary",
              icon: "mdi-plus",
              round: "",
              size: "sm",
              onClick: o(n)
            }, {
              default: L(() => [
                D(nt, null, {
                  default: L(() => [
                    ve(J(o(t)("builder.tabs.conditional.actions.add")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]),
            D(se, {
              color: "primary",
              icon: "mdi-content-paste",
              outline: "",
              round: "",
              size: "sm",
              onClick: f
            }, {
              default: L(() => [
                D(nt, null, {
                  default: L(() => [
                    ve(J(o(t)("builder.tabs.conditional.actions.paste")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          o(i) ? (z(), re("p", _d, J(o(t)("builder.tabs.conditional.noValue")), 1)) : ce("", !0),
          !o(i) && o(r) ? (z(), ae(Aa, {
            key: 1,
            title: o(t)("builder.tabs.conditional.types.labelExist"),
            type: "exist",
            "onUpdate:condition": m
          }, null, 8, ["title"])) : ce("", !0),
          !o(i) && o(s) ? (z(), ae(Aa, {
            key: 2,
            title: o(t)("builder.tabs.conditional.types.labelDisplayed"),
            type: "visible",
            "onUpdate:condition": m
          }, null, 8, ["title"])) : ce("", !0),
          !o(i) && o(d) ? (z(), ae(Aa, {
            key: 3,
            title: o(t)("builder.tabs.conditional.types.labelRequired"),
            type: "required",
            "onUpdate:condition": m
          }, null, 8, ["title"])) : ce("", !0)
        ])
      ])
    ], 64));
  }
});
const wd = /* @__PURE__ */ Oe(Sd, [["__scopeId", "data-v-d8697214"]]);
function Dr(e, t) {
  if (t && e === t)
    return null;
  const l = e.nodeName.toLowerCase();
  if (["div", "li", "ul", "ol", "blockquote"].includes(l) === !0)
    return e;
  const n = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle, a = n.display;
  return a === "block" || a === "table" ? e : Dr(e.parentNode);
}
function Ba(e, t, l) {
  return !e || e === document.body ? !1 : l === !0 && e === t || (t === document ? document.body : t).contains(e.parentNode);
}
function Ir(e, t, l) {
  if (l || (l = document.createRange(), l.selectNode(e), l.setStart(e, 0)), t.count === 0)
    l.setEnd(e, t.count);
  else if (t.count > 0)
    if (e.nodeType === Node.TEXT_NODE)
      e.textContent.length < t.count ? t.count -= e.textContent.length : (l.setEnd(e, t.count), t.count = 0);
    else
      for (let n = 0; t.count !== 0 && n < e.childNodes.length; n++)
        l = Ir(e.childNodes[n], t, l);
  return l;
}
const xd = /^https?:\/\//;
class kd {
  constructor(t, l) {
    this.el = t, this.eVm = l, this._range = null;
  }
  get selection() {
    if (this.el) {
      const t = document.getSelection();
      if (Ba(t.anchorNode, this.el, !0) && Ba(t.focusNode, this.el, !0))
        return t;
    }
    return null;
  }
  get hasSelection() {
    return this.selection !== null ? this.selection.toString().length !== 0 : !1;
  }
  get range() {
    const t = this.selection;
    return t !== null && t.rangeCount ? t.getRangeAt(0) : this._range;
  }
  get parent() {
    const t = this.range;
    if (t !== null) {
      const l = t.startContainer;
      return l.nodeType === document.ELEMENT_NODE ? l : l.parentNode;
    }
    return null;
  }
  get blockParent() {
    const t = this.parent;
    return t !== null ? Dr(t, this.el) : null;
  }
  save(t = this.range) {
    t !== null && (this._range = t);
  }
  restore(t = this._range) {
    const l = document.createRange(), n = document.getSelection();
    t !== null ? (l.setStart(t.startContainer, t.startOffset), l.setEnd(t.endContainer, t.endOffset), n.removeAllRanges(), n.addRange(l)) : (n.selectAllChildren(this.el), n.collapseToEnd());
  }
  savePosition() {
    let t = -1, l;
    const n = document.getSelection(), a = this.el.parentNode;
    if (n.focusNode && Ba(n.focusNode, a))
      for (l = n.focusNode, t = n.focusOffset; l && l !== a; )
        l !== this.el && l.previousSibling ? (l = l.previousSibling, t += l.textContent.length) : l = l.parentNode;
    this.savedPos = t;
  }
  restorePosition(t = 0) {
    if (this.savedPos > 0 && this.savedPos < t) {
      const l = window.getSelection(), n = Ir(this.el, { count: this.savedPos });
      n && (n.collapse(!1), l.removeAllRanges(), l.addRange(n));
    }
  }
  hasParent(t, l) {
    const n = l ? this.parent : this.blockParent;
    return n !== null ? n.nodeName.toLowerCase() === t.toLowerCase() : !1;
  }
  hasParents(t, l, n = this.parent) {
    return n === null ? !1 : t.includes(n.nodeName.toLowerCase()) === !0 ? !0 : l === !0 ? this.hasParents(t, l, n.parentNode) : !1;
  }
  is(t, l) {
    if (this.selection === null)
      return !1;
    switch (t) {
      case "formatBlock":
        return l === "DIV" && this.parent === this.el || this.hasParent(l, l === "PRE");
      case "link":
        return this.hasParent("A", !0);
      case "fontSize":
        return document.queryCommandValue(t) === l;
      case "fontName":
        const n = document.queryCommandValue(t);
        return n === `"${l}"` || n === l;
      case "fullscreen":
        return this.eVm.inFullscreen.value;
      case "viewsource":
        return this.eVm.isViewingSource.value;
      case void 0:
        return !1;
      default:
        const a = document.queryCommandState(t);
        return l !== void 0 ? a === l : a;
    }
  }
  getParentAttribute(t) {
    return this.parent !== null ? this.parent.getAttribute(t) : null;
  }
  can(t) {
    if (t === "outdent")
      return this.hasParents(["blockquote", "li"], !0);
    if (t === "indent")
      return this.hasParents(["li"], !0);
    if (t === "link")
      return this.selection !== null || this.is("link");
  }
  apply(t, l, n = In) {
    if (t === "formatBlock")
      ["BLOCKQUOTE", "H1", "H2", "H3", "H4", "H5", "H6"].includes(l) && this.is(t, l) && (t = "outdent", l = null), l === "PRE" && this.is(t, "PRE") && (l = "P");
    else if (t === "print") {
      n();
      const a = window.open();
      a.document.write(`
        <!doctype html>
        <html>
          <head>
            <title>Print - ${document.title}</title>
          </head>
          <body>
            <div>${this.el.innerHTML}</div>
          </body>
        </html>
      `), a.print(), a.close();
      return;
    } else if (t === "link") {
      const a = this.getParentAttribute("href");
      if (a === null) {
        const i = this.selectWord(this.selection), r = i ? i.toString() : "";
        if (!r.length && (!this.range || !this.range.cloneContents().querySelector("img")))
          return;
        this.eVm.editLinkUrl.value = xd.test(r) ? r : "https://", document.execCommand("createLink", !1, this.eVm.editLinkUrl.value), this.save(i.getRangeAt(0));
      } else
        this.eVm.editLinkUrl.value = a, this.range.selectNodeContents(this.parent), this.save();
      return;
    } else if (t === "fullscreen") {
      this.eVm.toggleFullscreen(), n();
      return;
    } else if (t === "viewsource") {
      this.eVm.isViewingSource.value = this.eVm.isViewingSource.value === !1, this.eVm.setContent(this.eVm.props.modelValue), n();
      return;
    }
    document.execCommand(t, !1, l), n();
  }
  selectWord(t) {
    if (t === null || t.isCollapsed !== !0 || /* IE 11 */
    t.modify === void 0)
      return t;
    const l = document.createRange();
    l.setStart(t.anchorNode, t.anchorOffset), l.setEnd(t.focusNode, t.focusOffset);
    const n = l.collapsed ? ["backward", "forward"] : ["forward", "backward"];
    l.detach();
    const a = t.focusNode, i = t.focusOffset;
    return t.collapse(t.anchorNode, t.anchorOffset), t.modify("move", n[0], "character"), t.modify("move", n[1], "word"), t.extend(a, i), t.modify("extend", n[1], "character"), t.modify("extend", n[0], "word"), t;
  }
}
const $r = De({
  name: "QBtnGroup",
  props: {
    unelevated: Boolean,
    outline: Boolean,
    flat: Boolean,
    rounded: Boolean,
    square: Boolean,
    push: Boolean,
    stretch: Boolean,
    glossy: Boolean,
    spread: Boolean
  },
  setup(e, { slots: t }) {
    const l = b(() => {
      const n = ["unelevated", "outline", "flat", "rounded", "square", "push", "stretch", "glossy"].filter((a) => e[a] === !0).map((a) => `q-btn-group--${a}`).join(" ");
      return `q-btn-group row no-wrap${n.length !== 0 ? " " + n : ""}` + (e.spread === !0 ? " q-btn-group--spread" : " inline");
    });
    return () => V("div", { class: l.value }, We(t.default));
  }
}), Cd = Object.keys(vo), qd = (e) => Cd.reduce(
  (t, l) => {
    const n = e[l];
    return n !== void 0 && (t[l] = n), t;
  },
  {}
), Vd = De({
  name: "QBtnDropdown",
  props: {
    ...vo,
    ...da,
    modelValue: Boolean,
    split: Boolean,
    dropdownIcon: String,
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object],
    cover: Boolean,
    persistent: Boolean,
    noRouteDismiss: Boolean,
    autoClose: Boolean,
    menuAnchor: {
      type: String,
      default: "bottom end"
    },
    menuSelf: {
      type: String,
      default: "top end"
    },
    menuOffset: Array,
    disableMainBtn: Boolean,
    disableDropdown: Boolean,
    noIconAnimation: Boolean,
    toggleAriaLabel: String
  },
  emits: ["update:modelValue", "click", "beforeShow", "show", "beforeHide", "hide"],
  setup(e, { slots: t, emit: l }) {
    const { proxy: n } = Ae(), a = G(e.modelValue), i = G(null), r = wn(), s = b(() => {
      const h = {
        "aria-expanded": a.value === !0 ? "true" : "false",
        "aria-haspopup": "true",
        "aria-controls": r,
        "aria-label": e.toggleAriaLabel || n.$q.lang.label[a.value === !0 ? "collapse" : "expand"](e.label)
      };
      return (e.disable === !0 || e.split === !1 && e.disableMainBtn === !0 || e.disableDropdown === !0) && (h["aria-disabled"] = "true"), h;
    }), d = b(
      () => "q-btn-dropdown__arrow" + (a.value === !0 && e.noIconAnimation === !1 ? " rotate-180" : "") + (e.split === !1 ? " q-btn-dropdown__arrow-container" : "")
    ), c = b(() => ar(e)), u = b(() => qd(e));
    me(() => e.modelValue, (h) => {
      i.value !== null && i.value[h ? "show" : "hide"]();
    }), me(() => e.split, S);
    function m(h) {
      a.value = !0, l("beforeShow", h);
    }
    function p(h) {
      l("show", h), l("update:modelValue", !0);
    }
    function f(h) {
      a.value = !1, l("beforeHide", h);
    }
    function _(h) {
      l("hide", h), l("update:modelValue", !1);
    }
    function v(h) {
      l("click", h);
    }
    function y(h) {
      Pt(h), S(), l("click", h);
    }
    function M(h) {
      i.value !== null && i.value.toggle(h);
    }
    function w(h) {
      i.value !== null && i.value.show(h);
    }
    function S(h) {
      i.value !== null && i.value.hide(h);
    }
    return Object.assign(n, {
      show: w,
      hide: S,
      toggle: M
    }), wt(() => {
      e.modelValue === !0 && w();
    }), () => {
      const h = [
        V(Qe, {
          class: d.value,
          name: e.dropdownIcon || n.$q.iconSet.arrow.dropdown
        })
      ];
      return e.disableDropdown !== !0 && h.push(
        V(_a, {
          ref: i,
          id: r,
          class: e.contentClass,
          style: e.contentStyle,
          cover: e.cover,
          fit: !0,
          persistent: e.persistent,
          noRouteDismiss: e.noRouteDismiss,
          autoClose: e.autoClose,
          anchor: e.menuAnchor,
          self: e.menuSelf,
          offset: e.menuOffset,
          separateClosePopup: !0,
          transitionShow: e.transitionShow,
          transitionHide: e.transitionHide,
          transitionDuration: e.transitionDuration,
          onBeforeShow: m,
          onShow: p,
          onBeforeHide: f,
          onHide: _
        }, t.default)
      ), e.split === !1 ? V(se, {
        class: "q-btn-dropdown q-btn-dropdown--simple",
        ...u.value,
        ...s.value,
        disable: e.disable === !0 || e.disableMainBtn === !0,
        noWrap: !0,
        round: !1,
        onClick: v
      }, {
        default: () => We(t.label, []).concat(h),
        loading: t.loading
      }) : V($r, {
        class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
        rounded: e.rounded,
        square: e.square,
        ...c.value,
        glossy: e.glossy,
        stretch: e.stretch
      }, () => [
        V(se, {
          class: "q-btn-dropdown--current",
          ...u.value,
          disable: e.disable === !0 || e.disableMainBtn === !0,
          noWrap: !0,
          round: !1,
          onClick: y
        }, {
          default: t.label,
          loading: t.loading
        }),
        V(se, {
          class: "q-btn-dropdown__arrow-container q-anchor--skip",
          ...s.value,
          ...c.value,
          disable: e.disable === !0 || e.disableDropdown === !0,
          rounded: e.rounded,
          color: e.color,
          textColor: e.textColor,
          dense: e.dense,
          size: e.size,
          padding: e.padding,
          ripple: e.ripple
        }, () => h)
      ]);
    };
  }
});
function Fr(e, t, l) {
  t.handler ? t.handler(e, l, l.caret) : l.runCmd(t.cmd, t.param);
}
function bo(e) {
  return V("div", { class: "q-editor__toolbar-group" }, e);
}
function Ar(e, t, l, n = !1) {
  const a = n || (t.type === "toggle" ? t.toggled ? t.toggled(e) : t.cmd && e.caret.is(t.cmd, t.param) : !1), i = [];
  if (t.tip && e.$q.platform.is.desktop) {
    const r = t.key ? V("div", [
      V("small", `(CTRL + ${String.fromCharCode(t.key)})`)
    ]) : null;
    i.push(
      V(nt, { delay: 1e3 }, () => [
        V("div", { innerHTML: t.tip }),
        r
      ])
    );
  }
  return V(se, {
    ...e.buttonProps.value,
    icon: t.icon !== null ? t.icon : void 0,
    color: a ? t.toggleColor || e.props.toolbarToggleColor : t.color || e.props.toolbarColor,
    textColor: a && !e.props.toolbarPush ? null : t.textColor || e.props.toolbarTextColor,
    label: t.label,
    disable: t.disable ? typeof t.disable == "function" ? t.disable(e) : !0 : !1,
    size: "sm",
    onClick(r) {
      l && l(), Fr(r, t, e);
    }
  }, () => i);
}
function Td(e, t) {
  const l = t.list === "only-icons";
  let n = t.label, a = t.icon !== null ? t.icon : void 0, i, r;
  function s() {
    c.component.proxy.hide();
  }
  if (l)
    r = t.options.map((u) => {
      const m = u.type === void 0 ? e.caret.is(u.cmd, u.param) : !1;
      return m && (n = u.tip, a = u.icon !== null ? u.icon : void 0), Ar(e, u, s, m);
    }), i = e.toolbarBackgroundClass.value, r = [
      bo(r)
    ];
  else {
    const u = e.props.toolbarToggleColor !== void 0 ? `text-${e.props.toolbarToggleColor}` : null, m = e.props.toolbarTextColor !== void 0 ? `text-${e.props.toolbarTextColor}` : null, p = t.list === "no-icons";
    r = t.options.map((f) => {
      const _ = f.disable ? f.disable(e) : !1, v = f.type === void 0 ? e.caret.is(f.cmd, f.param) : !1;
      v && (n = f.tip, a = f.icon !== null ? f.icon : void 0);
      const y = f.htmlTip;
      return V(Tl, {
        active: v,
        activeClass: u,
        clickable: !0,
        disable: _,
        dense: !0,
        onClick(M) {
          s(), e.contentRef.value !== null && e.contentRef.value.focus(), e.caret.restore(), Fr(M, f, e);
        }
      }, () => [
        p === !0 ? null : V(
          jt,
          {
            class: v ? u : m,
            side: !0
          },
          () => V(Qe, { name: f.icon !== null ? f.icon : void 0 })
        ),
        V(
          jt,
          y ? () => V("div", { class: "text-no-wrap", innerHTML: f.htmlTip }) : f.tip ? () => V("div", { class: "text-no-wrap" }, f.tip) : void 0
        )
      ]);
    }), i = [e.toolbarBackgroundClass.value, m];
  }
  const d = t.highlight && n !== t.label, c = V(Vd, {
    ...e.buttonProps.value,
    noCaps: !0,
    noWrap: !0,
    color: d ? e.props.toolbarToggleColor : e.props.toolbarColor,
    textColor: d && !e.props.toolbarPush ? null : e.props.toolbarTextColor,
    label: t.fixedLabel ? t.label : n,
    icon: t.fixedIcon ? t.icon !== null ? t.icon : void 0 : a,
    contentClass: i,
    onShow: (u) => e.emit("dropdownShow", u),
    onHide: (u) => e.emit("dropdownHide", u),
    onBeforeShow: (u) => e.emit("dropdownBeforeShow", u),
    onBeforeHide: (u) => e.emit("dropdownBeforeHide", u)
  }, () => r);
  return c;
}
function Md(e) {
  if (e.caret)
    return e.buttons.value.filter((t) => !e.isViewingSource.value || t.find((l) => l.cmd === "viewsource")).map((t) => bo(
      t.map((l) => e.isViewingSource.value && l.cmd !== "viewsource" ? !1 : l.type === "slot" ? We(e.slots[l.slot]) : l.type === "dropdown" ? Td(e, l) : Ar(e, l))
    ));
}
function Dd(e, t, l, n = {}) {
  const a = Object.keys(n);
  if (a.length === 0)
    return {};
  const i = {
    default_font: {
      cmd: "fontName",
      param: e,
      icon: l,
      tip: t
    }
  };
  return a.forEach((r) => {
    const s = n[r];
    i[r] = {
      cmd: "fontName",
      param: s,
      icon: l,
      tip: s,
      htmlTip: `<font face="${s}">${s}</font>`
    };
  }), i;
}
function Id(e) {
  if (e.caret) {
    const t = e.props.toolbarColor || e.props.toolbarTextColor;
    let l = e.editLinkUrl.value;
    const n = () => {
      e.caret.restore(), l !== e.editLinkUrl.value && document.execCommand("createLink", !1, l === "" ? " " : l), e.editLinkUrl.value = null;
    };
    return [
      V("div", { class: `q-mx-xs text-${t}` }, `${e.$q.lang.editor.url}: `),
      V("input", {
        key: "qedt_btm_input",
        class: "col q-editor__link-input",
        value: l,
        onInput: (a) => {
          Pt(a), l = a.target.value;
        },
        onKeydown: (a) => {
          if (un(a) !== !0)
            switch (a.keyCode) {
              case 13:
                return Ot(a), n();
              case 27:
                Ot(a), e.caret.restore(), (!e.editLinkUrl.value || e.editLinkUrl.value === "https://") && document.execCommand("unlink"), e.editLinkUrl.value = null;
                break;
            }
        }
      }),
      bo([
        V(se, {
          key: "qedt_btm_rem",
          tabindex: -1,
          ...e.buttonProps.value,
          label: e.$q.lang.label.remove,
          noCaps: !0,
          onClick: () => {
            e.caret.restore(), document.execCommand("unlink"), e.editLinkUrl.value = null;
          }
        }),
        V(se, {
          key: "qedt_btm_upd",
          ...e.buttonProps.value,
          label: e.$q.lang.label.update,
          noCaps: !0,
          onClick: n
        })
      ])
    ];
  }
}
let bn = 0;
const Or = {
  fullscreen: Boolean,
  noRouteFullscreenExit: Boolean
}, Br = ["update:fullscreen", "fullscreen"];
function Lr() {
  const e = Ae(), { props: t, emit: l, proxy: n } = e;
  let a, i;
  const r = G(!1);
  ao(e) === !0 && me(() => n.$route.fullPath, () => {
    t.noRouteFullscreenExit !== !0 && c();
  }), me(() => t.fullscreen, (u) => {
    r.value !== u && s();
  }), me(r, (u) => {
    l("update:fullscreen", u), l("fullscreen", u);
  });
  function s() {
    r.value === !0 ? c() : d();
  }
  function d() {
    r.value !== !0 && (r.value = !0, i = n.$el.parentNode, i.replaceChild(a, n.$el), document.body.appendChild(n.$el), bn++, bn === 1 && document.body.classList.add("q-body--fullscreen-mixin"));
  }
  function c() {
    r.value === !0 && (i.replaceChild(n.$el, a), r.value = !1, bn = Math.max(0, bn - 1), bn === 0 && (document.body.classList.remove("q-body--fullscreen-mixin"), n.$el.scrollIntoView !== void 0 && setTimeout(() => {
      n.$el.scrollIntoView();
    })));
  }
  return to(() => {
    a = document.createElement("span");
  }), wt(() => {
    t.fullscreen === !0 && d();
  }), _t(c), Object.assign(n, {
    toggleFullscreen: s,
    setFullscreen: d,
    exitFullscreen: c
  }), {
    inFullscreen: r,
    toggleFullscreen: s
  };
}
const $d = Object.prototype.toString, La = Object.prototype.hasOwnProperty, Fd = new Set(
  ["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp"].map((e) => "[object " + e + "]")
);
function vi(e) {
  if (e !== Object(e) || Fd.has($d.call(e)) === !0 || e.constructor && La.call(e, "constructor") === !1 && La.call(e.constructor.prototype, "isPrototypeOf") === !1)
    return !1;
  let t;
  for (t in e)
    ;
  return t === void 0 || La.call(e, t);
}
function Er() {
  let e, t, l, n, a, i, r = arguments[0] || {}, s = 1, d = !1;
  const c = arguments.length;
  for (typeof r == "boolean" && (d = r, r = arguments[1] || {}, s = 2), Object(r) !== r && typeof r != "function" && (r = {}), c === s && (r = this, s--); s < c; s++)
    if ((e = arguments[s]) !== null)
      for (t in e)
        l = r[t], n = e[t], r !== n && (d === !0 && n && ((a = Array.isArray(n)) || vi(n) === !0) ? (a === !0 ? i = Array.isArray(l) === !0 ? l : [] : i = vi(l) === !0 ? l : {}, r[t] = Er(d, i, n)) : n !== void 0 && (r[t] = n));
  return r;
}
const Pr = De({
  name: "QEditor",
  props: {
    ...Tt,
    ...Or,
    modelValue: {
      type: String,
      required: !0
    },
    readonly: Boolean,
    disable: Boolean,
    minHeight: {
      type: String,
      default: "10rem"
    },
    maxHeight: String,
    height: String,
    definitions: Object,
    fonts: Object,
    placeholder: String,
    toolbar: {
      type: Array,
      validator: (e) => e.length === 0 || e.every((t) => t.length),
      default() {
        return [
          ["left", "center", "right", "justify"],
          ["bold", "italic", "underline", "strike"],
          ["undo", "redo"]
        ];
      }
    },
    toolbarColor: String,
    toolbarBg: String,
    toolbarTextColor: String,
    toolbarToggleColor: {
      type: String,
      default: "primary"
    },
    toolbarOutline: Boolean,
    toolbarPush: Boolean,
    toolbarRounded: Boolean,
    paragraphTag: {
      type: String,
      validator: (e) => ["div", "p"].includes(e),
      default: "div"
    },
    contentStyle: Object,
    contentClass: [Object, Array, String],
    square: Boolean,
    flat: Boolean,
    dense: Boolean
  },
  emits: [
    ...Br,
    "update:modelValue",
    "keydown",
    "click",
    "mouseup",
    "keyup",
    "touchend",
    "focus",
    "blur",
    "dropdownShow",
    "dropdownHide",
    "dropdownBeforeShow",
    "dropdownBeforeHide",
    "linkShow",
    "linkHide"
  ],
  setup(e, { slots: t, emit: l, attrs: n }) {
    const { proxy: a, vnode: i } = Ae(), { $q: r } = a, s = Mt(e, r), { inFullscreen: d, toggleFullscreen: c } = Lr(), u = fr(n, i), m = G(null), p = G(null), f = G(null), _ = G(!1), v = b(() => !e.readonly && !e.disable);
    let y, M, w = e.modelValue;
    document.execCommand("defaultParagraphSeparator", !1, e.paragraphTag), y = window.getComputedStyle(document.body).fontFamily;
    const S = b(() => e.toolbarBg ? ` bg-${e.toolbarBg}` : ""), h = b(() => ({
      type: "a",
      flat: e.toolbarOutline !== !0 && e.toolbarPush !== !0,
      noWrap: !0,
      outline: e.toolbarOutline,
      push: e.toolbarPush,
      rounded: e.toolbarRounded,
      dense: !0,
      color: e.toolbarColor,
      disable: !v.value,
      size: "sm"
    })), C = b(() => {
      const Z = r.lang.editor, j = r.iconSet.editor;
      return {
        bold: { cmd: "bold", icon: j.bold, tip: Z.bold, key: 66 },
        italic: { cmd: "italic", icon: j.italic, tip: Z.italic, key: 73 },
        strike: { cmd: "strikeThrough", icon: j.strikethrough, tip: Z.strikethrough, key: 83 },
        underline: { cmd: "underline", icon: j.underline, tip: Z.underline, key: 85 },
        unordered: { cmd: "insertUnorderedList", icon: j.unorderedList, tip: Z.unorderedList },
        ordered: { cmd: "insertOrderedList", icon: j.orderedList, tip: Z.orderedList },
        subscript: { cmd: "subscript", icon: j.subscript, tip: Z.subscript, htmlTip: "x<subscript>2</subscript>" },
        superscript: { cmd: "superscript", icon: j.superscript, tip: Z.superscript, htmlTip: "x<superscript>2</superscript>" },
        link: { cmd: "link", disable: (he) => he.caret && !he.caret.can("link"), icon: j.hyperlink, tip: Z.hyperlink, key: 76 },
        fullscreen: { cmd: "fullscreen", icon: j.toggleFullscreen, tip: Z.toggleFullscreen, key: 70 },
        viewsource: { cmd: "viewsource", icon: j.viewSource, tip: Z.viewSource },
        quote: { cmd: "formatBlock", param: "BLOCKQUOTE", icon: j.quote, tip: Z.quote, key: 81 },
        left: { cmd: "justifyLeft", icon: j.left, tip: Z.left },
        center: { cmd: "justifyCenter", icon: j.center, tip: Z.center },
        right: { cmd: "justifyRight", icon: j.right, tip: Z.right },
        justify: { cmd: "justifyFull", icon: j.justify, tip: Z.justify },
        print: { type: "no-state", cmd: "print", icon: j.print, tip: Z.print, key: 80 },
        outdent: { type: "no-state", disable: (he) => he.caret && !he.caret.can("outdent"), cmd: "outdent", icon: j.outdent, tip: Z.outdent },
        indent: { type: "no-state", disable: (he) => he.caret && !he.caret.can("indent"), cmd: "indent", icon: j.indent, tip: Z.indent },
        removeFormat: { type: "no-state", cmd: "removeFormat", icon: j.removeFormat, tip: Z.removeFormat },
        hr: { type: "no-state", cmd: "insertHorizontalRule", icon: j.hr, tip: Z.hr },
        undo: { type: "no-state", cmd: "undo", icon: j.undo, tip: Z.undo, key: 90 },
        redo: { type: "no-state", cmd: "redo", icon: j.redo, tip: Z.redo, key: 89 },
        h1: { cmd: "formatBlock", param: "H1", icon: j.heading1 || j.heading, tip: Z.heading1, htmlTip: `<h1 class="q-ma-none">${Z.heading1}</h1>` },
        h2: { cmd: "formatBlock", param: "H2", icon: j.heading2 || j.heading, tip: Z.heading2, htmlTip: `<h2 class="q-ma-none">${Z.heading2}</h2>` },
        h3: { cmd: "formatBlock", param: "H3", icon: j.heading3 || j.heading, tip: Z.heading3, htmlTip: `<h3 class="q-ma-none">${Z.heading3}</h3>` },
        h4: { cmd: "formatBlock", param: "H4", icon: j.heading4 || j.heading, tip: Z.heading4, htmlTip: `<h4 class="q-ma-none">${Z.heading4}</h4>` },
        h5: { cmd: "formatBlock", param: "H5", icon: j.heading5 || j.heading, tip: Z.heading5, htmlTip: `<h5 class="q-ma-none">${Z.heading5}</h5>` },
        h6: { cmd: "formatBlock", param: "H6", icon: j.heading6 || j.heading, tip: Z.heading6, htmlTip: `<h6 class="q-ma-none">${Z.heading6}</h6>` },
        p: { cmd: "formatBlock", param: e.paragraphTag, icon: j.heading, tip: Z.paragraph },
        code: { cmd: "formatBlock", param: "PRE", icon: j.code, htmlTip: `<code>${Z.code}</code>` },
        "size-1": { cmd: "fontSize", param: "1", icon: j.size1 || j.size, tip: Z.size1, htmlTip: `<font size="1">${Z.size1}</font>` },
        "size-2": { cmd: "fontSize", param: "2", icon: j.size2 || j.size, tip: Z.size2, htmlTip: `<font size="2">${Z.size2}</font>` },
        "size-3": { cmd: "fontSize", param: "3", icon: j.size3 || j.size, tip: Z.size3, htmlTip: `<font size="3">${Z.size3}</font>` },
        "size-4": { cmd: "fontSize", param: "4", icon: j.size4 || j.size, tip: Z.size4, htmlTip: `<font size="4">${Z.size4}</font>` },
        "size-5": { cmd: "fontSize", param: "5", icon: j.size5 || j.size, tip: Z.size5, htmlTip: `<font size="5">${Z.size5}</font>` },
        "size-6": { cmd: "fontSize", param: "6", icon: j.size6 || j.size, tip: Z.size6, htmlTip: `<font size="6">${Z.size6}</font>` },
        "size-7": { cmd: "fontSize", param: "7", icon: j.size7 || j.size, tip: Z.size7, htmlTip: `<font size="7">${Z.size7}</font>` }
      };
    }), T = b(() => {
      const Z = e.definitions || {}, j = e.definitions || e.fonts ? Er(
        !0,
        {},
        C.value,
        Z,
        Dd(
          y,
          r.lang.editor.defaultFont,
          r.iconSet.editor.font,
          e.fonts
        )
      ) : C.value;
      return e.toolbar.map(
        (he) => he.map((we) => {
          if (we.options)
            return {
              type: "dropdown",
              icon: we.icon,
              label: we.label,
              size: "sm",
              dense: !0,
              fixedLabel: we.fixedLabel,
              fixedIcon: we.fixedIcon,
              highlight: we.highlight,
              list: we.list,
              options: we.options.map((ot) => j[ot])
            };
          const Ie = j[we];
          return Ie ? Ie.type === "no-state" || Z[we] && (Ie.cmd === void 0 || C.value[Ie.cmd] && C.value[Ie.cmd].type === "no-state") ? Ie : Object.assign({ type: "toggle" }, Ie) : {
            type: "slot",
            slot: we
          };
        })
      );
    }), I = {
      $q: r,
      props: e,
      slots: t,
      emit: l,
      // caret (will get injected after mount)
      inFullscreen: d,
      toggleFullscreen: c,
      runCmd: ie,
      isViewingSource: _,
      editLinkUrl: f,
      toolbarBackgroundClass: S,
      buttonProps: h,
      contentRef: p,
      buttons: T,
      setContent: R
    };
    me(() => e.modelValue, (Z) => {
      w !== Z && (w = Z, R(Z, !0));
    }), me(f, (Z) => {
      l(`link-${Z ? "Show" : "Hide"}`);
    });
    const E = b(() => e.toolbar && e.toolbar.length !== 0), A = b(() => {
      const Z = {}, j = (he) => {
        he.key && (Z[he.key] = {
          cmd: he.cmd,
          param: he.param
        });
      };
      return T.value.forEach((he) => {
        he.forEach((we) => {
          we.options ? we.options.forEach(j) : j(we);
        });
      }), Z;
    }), O = b(() => d.value ? e.contentStyle : [
      {
        minHeight: e.minHeight,
        height: e.height,
        maxHeight: e.maxHeight
      },
      e.contentStyle
    ]), P = b(
      () => `q-editor q-editor--${_.value === !0 ? "source" : "default"}` + (e.disable === !0 ? " disabled" : "") + (d.value === !0 ? " fullscreen column" : "") + (e.square === !0 ? " q-editor--square no-border-radius" : "") + (e.flat === !0 ? " q-editor--flat" : "") + (e.dense === !0 ? " q-editor--dense" : "") + (s.value === !0 ? " q-editor--dark q-dark" : "")
    ), $ = b(() => [
      e.contentClass,
      "q-editor__content",
      { col: d.value, "overflow-auto": d.value || e.maxHeight }
    ]), k = b(() => e.disable === !0 ? { "aria-disabled": "true" } : e.readonly === !0 ? { "aria-readonly": "true" } : {});
    function g() {
      if (p.value !== null) {
        const Z = `inner${_.value === !0 ? "Text" : "HTML"}`, j = p.value[Z];
        j !== e.modelValue && (w = j, l("update:modelValue", j));
      }
    }
    function x(Z) {
      if (l("keydown", Z), Z.ctrlKey !== !0 || un(Z) === !0) {
        te();
        return;
      }
      const j = Z.keyCode, he = A.value[j];
      if (he !== void 0) {
        const { cmd: we, param: Ie } = he;
        Ze(Z), ie(we, Ie, !1);
      }
    }
    function B(Z) {
      te(), l("click", Z);
    }
    function q(Z) {
      if (p.value !== null) {
        const { scrollTop: j, scrollHeight: he } = p.value;
        M = he - j;
      }
      I.caret.save(), l("blur", Z);
    }
    function Y(Z) {
      lt(() => {
        p.value !== null && M !== void 0 && (p.value.scrollTop = p.value.scrollHeight - M);
      }), l("focus", Z);
    }
    function K(Z) {
      const j = m.value;
      if (j !== null && j.contains(Z.target) === !0 && (Z.relatedTarget === null || j.contains(Z.relatedTarget) !== !0)) {
        const he = `inner${_.value === !0 ? "Text" : "HTML"}`;
        I.caret.restorePosition(p.value[he].length), te();
      }
    }
    function Q(Z) {
      const j = m.value;
      j !== null && j.contains(Z.target) === !0 && (Z.relatedTarget === null || j.contains(Z.relatedTarget) !== !0) && (I.caret.savePosition(), te());
    }
    function W() {
      M = void 0;
    }
    function H(Z) {
      I.caret.save();
    }
    function R(Z, j) {
      if (p.value !== null) {
        j === !0 && I.caret.savePosition();
        const he = `inner${_.value === !0 ? "Text" : "HTML"}`;
        p.value[he] = Z, j === !0 && (I.caret.restorePosition(p.value[he].length), te());
      }
    }
    function ie(Z, j, he = !0) {
      oe(), I.caret.restore(), I.caret.apply(Z, j, () => {
        oe(), I.caret.save(), he && te();
      });
    }
    function te() {
      setTimeout(() => {
        f.value = null, a.$forceUpdate();
      }, 1);
    }
    function oe() {
      dn(() => {
        p.value !== null && p.value.focus({ preventScroll: !0 });
      });
    }
    function fe() {
      return p.value;
    }
    return wt(() => {
      I.caret = a.caret = new kd(p.value, I), R(e.modelValue), te(), document.addEventListener("selectionchange", H);
    }), _t(() => {
      document.removeEventListener("selectionchange", H);
    }), Object.assign(a, {
      runCmd: ie,
      refreshToolbar: te,
      focus: oe,
      getContentEl: fe
    }), () => {
      let Z;
      if (E.value) {
        const j = [
          V("div", {
            key: "qedt_top",
            class: "q-editor__toolbar row no-wrap scroll-x" + S.value
          }, Md(I))
        ];
        f.value !== null && j.push(
          V("div", {
            key: "qedt_btm",
            class: "q-editor__toolbar row no-wrap items-center scroll-x" + S.value
          }, Id(I))
        ), Z = V("div", {
          key: "toolbar_ctainer",
          class: "q-editor__toolbars-container"
        }, j);
      }
      return V("div", {
        ref: m,
        class: P.value,
        style: { height: d.value === !0 ? "100%" : null },
        ...k.value,
        onFocusin: K,
        onFocusout: Q
      }, [
        Z,
        V("div", {
          ref: p,
          style: O.value,
          class: $.value,
          contenteditable: v.value,
          placeholder: e.placeholder,
          ...u.listeners.value,
          onInput: g,
          onKeydown: x,
          onClick: B,
          onBlur: q,
          onFocus: Y,
          // clean saved scroll position
          onMousedown: W,
          onTouchstartPassive: W
        })
      ]);
    };
  }
}), Ad = () => {
  const { iconSet: e } = wa();
  return {
    toolbar: [
      ["left", "center", "right"],
      ["bold", "italic", "strike", "underline"],
      ["unordered", "ordered", "outdent", "indent"],
      ["hr"],
      [
        {
          icon: e.editor.formatting,
          list: "no-icons",
          options: [
            "p",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "code"
          ]
        },
        {
          icon: e.editor.fontSize,
          fixedLabel: !0,
          fixedIcon: !0,
          list: "no-icons",
          options: [
            "size-1",
            "size-2",
            "size-3",
            "size-4",
            "size-5",
            "size-6",
            "size-7"
          ]
        },
        "removeFormat"
      ],
      ["link", "image"],
      ["undo", "redo"]
    ]
  };
}, Od = /* @__PURE__ */ Ce({
  __name: "RichTextEditor",
  setup(e) {
    const t = Me("_uct"), l = G("fr"), { itemId: n } = Ke(), a = st(), { field: i } = Ke(), r = b(() => {
      var c, u, m;
      const d = (u = (c = a.messages.locales[l.value]) == null ? void 0 : c[n.value]) == null ? void 0 : u.content;
      return d || a.messages.defaultLocale === l.value && ((m = i.value) == null ? void 0 : m.content) || "";
    }), { toolbar: s } = Ad();
    return (d, c) => (z(), re("section", null, [
      D(Rt, {
        modelValue: l.value,
        "onUpdate:modelValue": c[0] || (c[0] = (u) => l.value = u),
        label: o(t)("builder.tabs.data.localeRichText.label"),
        options: o(a).listOfLocales
      }, null, 8, ["modelValue", "label", "options"]),
      D(Pr, {
        "model-value": r.value,
        toolbar: o(s),
        "onUpdate:modelValue": c[1] || (c[1] = (u) => o(a).updateTranslation(o(n), l.value, "content", u))
      }, null, 8, ["model-value", "toolbar"])
    ]));
  }
});
const Bd = /* @__PURE__ */ Oe(Od, [["__scopeId", "data-v-047482ed"]]), Ld = /* @__PURE__ */ Ce({
  __name: "OptionConditions",
  setup(e) {
    const t = Me("_uct"), { field: l, itemId: n } = Ke(), a = Ee(), { conditionalBasicItems: i } = Sa(), r = (s) => {
      var d;
      s === null ? a.removeDependency(((d = l.value) == null ? void 0 : d.dependsOn) ?? "", n.value, "dependsOn") : a.addDependency(s, n.value, "dependsOn"), a.updateField(n.value, "dependsOn", s || "");
    };
    return (s, d) => {
      var c;
      return z(), re("section", null, [
        ee("h2", null, J(o(t)("builder.tabs.data.options.conditional")), 1),
        D(Mr, {
          label: o(t)("builder.tabs.data.options.dependsOn"),
          "model-value": ((c = o(l)) == null ? void 0 : c.dependsOn) || null,
          options: o(i),
          clearable: "",
          dense: "",
          "emit-value": "",
          "map-options": "",
          "option-label": "name",
          "option-value": "id",
          onClear: d[0] || (d[0] = (u) => r(null)),
          "onUpdate:modelValue": r
        }, null, 8, ["label", "model-value", "options"])
      ]);
    };
  }
}), kt = De({
  name: "QTd",
  props: {
    props: Object,
    autoWidth: Boolean,
    noHover: Boolean
  },
  setup(e, { slots: t }) {
    const l = Ae(), n = b(
      () => "q-td" + (e.autoWidth === !0 ? " q-table--col-auto-width" : "") + (e.noHover === !0 ? " q-td--no-hover" : "") + " "
    );
    return () => {
      if (e.props === void 0)
        return V("td", { class: n.value }, We(t.default));
      const a = l.vnode.key, i = (e.props.colsMap !== void 0 ? e.props.colsMap[a] : null) || e.props.col;
      if (i === void 0)
        return;
      const { row: r } = e.props;
      return V("td", {
        class: n.value + i.__tdClass(r),
        style: i.__tdStyle(r)
      }, We(t.default));
    };
  }
});
function _n(e, t = /* @__PURE__ */ new WeakMap()) {
  if (Object(e) !== e)
    return e;
  if (t.has(e))
    return t.get(e);
  const l = e instanceof Date ? new Date(e) : e instanceof RegExp ? new RegExp(e.source, e.flags) : e instanceof Set ? /* @__PURE__ */ new Set() : e instanceof Map ? /* @__PURE__ */ new Map() : typeof e.constructor != "function" ? /* @__PURE__ */ Object.create(null) : e.prototype !== void 0 && typeof e.prototype.constructor == "function" ? e : new e.constructor();
  if (typeof e.constructor == "function" && typeof e.valueOf == "function") {
    const n = e.valueOf();
    if (Object(n) !== n) {
      const a = new e.constructor(n);
      return t.set(e, a), a;
    }
  }
  return t.set(e, l), e instanceof Set ? e.forEach((n) => {
    l.add(_n(n, t));
  }) : e instanceof Map && e.forEach((n, a) => {
    l.set(a, _n(n, t));
  }), Object.assign(
    l,
    ...Object.keys(e).map((n) => ({ [n]: _n(e[n], t) }))
  );
}
const tn = De({
  name: "QPopupEdit",
  props: {
    modelValue: {
      required: !0
    },
    title: String,
    buttons: Boolean,
    labelSet: String,
    labelCancel: String,
    color: {
      type: String,
      default: "primary"
    },
    validate: {
      type: Function,
      default: () => !0
    },
    autoSave: Boolean,
    /* menu props overrides */
    cover: {
      type: Boolean,
      default: !0
    },
    /* end of menu props */
    disable: Boolean
  },
  emits: [
    "update:modelValue",
    "save",
    "cancel",
    "beforeShow",
    "show",
    "beforeHide",
    "hide"
  ],
  setup(e, { slots: t, emit: l }) {
    const { proxy: n } = Ae(), { $q: a } = n, i = G(null), r = G(""), s = G("");
    let d = !1;
    const c = b(() => Kt({
      initialValue: r.value,
      validate: e.validate,
      set: u,
      cancel: m,
      updatePosition: p
    }, "value", () => s.value, (h) => {
      s.value = h;
    }));
    function u() {
      e.validate(s.value) !== !1 && (f() === !0 && (l("save", s.value, r.value), l("update:modelValue", s.value)), _());
    }
    function m() {
      f() === !0 && l("cancel", s.value, r.value), _();
    }
    function p() {
      lt(() => {
        i.value.updatePosition();
      });
    }
    function f() {
      return cl(s.value, r.value) === !1;
    }
    function _() {
      d = !0, i.value.hide();
    }
    function v() {
      d = !1, r.value = _n(e.modelValue), s.value = _n(e.modelValue), l("beforeShow");
    }
    function y() {
      l("show");
    }
    function M() {
      d === !1 && f() === !0 && (e.autoSave === !0 && e.validate(s.value) === !0 ? (l("save", s.value, r.value), l("update:modelValue", s.value)) : l("cancel", s.value, r.value)), l("beforeHide");
    }
    function w() {
      l("hide");
    }
    function S() {
      const h = t.default !== void 0 ? [].concat(t.default(c.value)) : [];
      return e.title && h.unshift(
        V("div", { class: "q-dialog__title q-mt-sm q-mb-sm" }, e.title)
      ), e.buttons === !0 && h.push(
        V("div", { class: "q-popup-edit__buttons row justify-center no-wrap" }, [
          V(se, {
            flat: !0,
            color: e.color,
            label: e.labelCancel || a.lang.label.cancel,
            onClick: m
          }),
          V(se, {
            flat: !0,
            color: e.color,
            label: e.labelSet || a.lang.label.set,
            onClick: u
          })
        ])
      ), h;
    }
    return Object.assign(n, {
      set: u,
      cancel: m,
      show(h) {
        i.value !== null && i.value.show(h);
      },
      hide(h) {
        i.value !== null && i.value.hide(h);
      },
      updatePosition: p
    }), () => {
      if (e.disable !== !0)
        return V(_a, {
          ref: i,
          class: "q-popup-edit",
          cover: e.cover,
          onBeforeShow: v,
          onShow: y,
          onBeforeHide: M,
          onHide: w,
          onEscapeKey: m
        }, S);
    };
  }
}), hl = De({
  name: "QTh",
  props: {
    props: Object,
    autoWidth: Boolean
  },
  emits: ["click"],
  setup(e, { slots: t, emit: l }) {
    const n = Ae(), { proxy: { $q: a } } = n, i = (r) => {
      l("click", r);
    };
    return () => {
      if (e.props === void 0)
        return V("th", {
          class: e.autoWidth === !0 ? "q-table--col-auto-width" : "",
          onClick: i
        }, We(t.default));
      let r, s;
      const d = n.vnode.key;
      if (d) {
        if (r = e.props.colsMap[d], r === void 0)
          return;
      } else
        r = e.props.col;
      if (r.sortable === !0) {
        const u = r.align === "right" ? "unshift" : "push";
        s = Li(t.default, []), s[u](
          V(Qe, {
            class: r.__iconClass,
            name: a.iconSet.table.arrowUp
          })
        );
      } else
        s = We(t.default);
      const c = {
        class: r.__thClass + (e.autoWidth === !0 ? " q-table--col-auto-width" : ""),
        style: r.headerStyle,
        onClick: (u) => {
          r.sortable === !0 && e.props.sort(r), i(u);
        }
      };
      return V("th", c, s);
    };
  }
}), Ed = ["horizontal", "vertical", "cell", "none"], Pd = De({
  name: "QMarkupTable",
  props: {
    ...Tt,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    wrapCells: Boolean,
    separator: {
      type: String,
      default: "horizontal",
      validator: (e) => Ed.includes(e)
    }
  },
  setup(e, { slots: t }) {
    const l = Ae(), n = Mt(e, l.proxy.$q), a = b(
      () => `q-markup-table q-table__container q-table__card q-table--${e.separator}-separator` + (n.value === !0 ? " q-table--dark q-table__card--dark q-dark" : "") + (e.dense === !0 ? " q-table--dense" : "") + (e.flat === !0 ? " q-table--flat" : "") + (e.bordered === !0 ? " q-table--bordered" : "") + (e.square === !0 ? " q-table--square" : "") + (e.wrapCells === !1 ? " q-table--no-wrap" : "")
    );
    return () => V("div", {
      class: a.value
    }, [
      V("table", { class: "q-table" }, We(t.default))
    ]);
  }
});
function Rr(e, t) {
  return V("div", e, [
    V("table", { class: "q-table" }, t)
  ]);
}
const Rd = {
  list: Wn,
  table: Pd
}, zd = ["list", "table", "__qtable"], Ud = De({
  name: "QVirtualScroll",
  props: {
    ...qr,
    type: {
      type: String,
      default: "list",
      validator: (e) => zd.includes(e)
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsFn: Function,
    itemsSize: Number,
    scrollTarget: {
      default: void 0
    }
  },
  setup(e, { slots: t, attrs: l }) {
    let n;
    const a = G(null), i = b(() => e.itemsSize >= 0 && e.itemsFn !== void 0 ? parseInt(e.itemsSize, 10) : Array.isArray(e.items) ? e.items.length : 0), {
      virtualScrollSliceRange: r,
      localResetVirtualScroll: s,
      padVirtualScroll: d,
      onVirtualScrollEvt: c
    } = Vr({
      virtualScrollLength: i,
      getVirtualScrollTarget: _,
      getVirtualScrollEl: f
    }), u = b(() => {
      if (i.value === 0)
        return [];
      const w = (S, h) => ({
        index: r.value.from + h,
        item: S
      });
      return e.itemsFn === void 0 ? e.items.slice(r.value.from, r.value.to).map(w) : e.itemsFn(r.value.from, r.value.to - r.value.from).map(w);
    }), m = b(
      () => "q-virtual-scroll q-virtual-scroll" + (e.virtualScrollHorizontal === !0 ? "--horizontal" : "--vertical") + (e.scrollTarget !== void 0 ? "" : " scroll")
    ), p = b(() => e.scrollTarget !== void 0 ? {} : { tabindex: 0 });
    me(i, () => {
      s();
    }), me(() => e.scrollTarget, () => {
      y(), v();
    });
    function f() {
      return a.value.$el || a.value;
    }
    function _() {
      return n;
    }
    function v() {
      n = fo(f(), e.scrollTarget), n.addEventListener("scroll", c, $t.passive);
    }
    function y() {
      n !== void 0 && (n.removeEventListener("scroll", c, $t.passive), n = void 0);
    }
    function M() {
      let w = d(
        e.type === "list" ? "div" : "tbody",
        u.value.map(t.default)
      );
      return t.before !== void 0 && (w = t.before().concat(w)), al(t.after, w);
    }
    return to(() => {
      s();
    }), wt(() => {
      v();
    }), Mn(() => {
      v();
    }), zl(() => {
      y();
    }), _t(() => {
      y();
    }), () => {
      if (t.default === void 0) {
        console.error("QVirtualScroll: default scoped slot is required for rendering");
        return;
      }
      return e.type === "__qtable" ? Rr(
        { ref: a, class: "q-table__middle " + m.value },
        M()
      ) : V(Rd[e.type], {
        ...l,
        ref: a,
        class: [l.class, m.value],
        ...p.value
      }, M);
    };
  }
}), Hd = {
  xs: 2,
  sm: 4,
  md: 6,
  lg: 10,
  xl: 14
};
function mi(e, t, l) {
  return {
    transform: t === !0 ? `translateX(${l.lang.rtl === !0 ? "-" : ""}100%) scale3d(${-e},1,1)` : `scale3d(${e},1,1)`
  };
}
const Yd = De({
  name: "QLinearProgress",
  props: {
    ...Tt,
    ...on,
    value: {
      type: Number,
      default: 0
    },
    buffer: Number,
    color: String,
    trackColor: String,
    reverse: Boolean,
    stripe: Boolean,
    indeterminate: Boolean,
    query: Boolean,
    rounded: Boolean,
    animationSpeed: {
      type: [String, Number],
      default: 2100
    },
    instantFeedback: Boolean
  },
  setup(e, { slots: t }) {
    const { proxy: l } = Ae(), n = Mt(e, l.$q), a = rn(e, Hd), i = b(() => e.indeterminate === !0 || e.query === !0), r = b(() => e.reverse !== e.query), s = b(() => ({
      ...a.value !== null ? a.value : {},
      "--q-linear-progress-speed": `${e.animationSpeed}ms`
    })), d = b(
      () => "q-linear-progress" + (e.color !== void 0 ? ` text-${e.color}` : "") + (e.reverse === !0 || e.query === !0 ? " q-linear-progress--reverse" : "") + (e.rounded === !0 ? " rounded-borders" : "")
    ), c = b(() => mi(e.buffer !== void 0 ? e.buffer : 1, r.value, l.$q)), u = b(() => `with${e.instantFeedback === !0 ? "out" : ""}-transition`), m = b(
      () => `q-linear-progress__track absolute-full q-linear-progress__track--${u.value} q-linear-progress__track--${n.value === !0 ? "dark" : "light"}` + (e.trackColor !== void 0 ? ` bg-${e.trackColor}` : "")
    ), p = b(() => mi(i.value === !0 ? 1 : e.value, r.value, l.$q)), f = b(
      () => `q-linear-progress__model absolute-full q-linear-progress__model--${u.value} q-linear-progress__model--${i.value === !0 ? "in" : ""}determinate`
    ), _ = b(() => ({ width: `${e.value * 100}%` })), v = b(
      () => `q-linear-progress__stripe absolute-${e.reverse === !0 ? "right" : "left"} q-linear-progress__stripe--${u.value}`
    );
    return () => {
      const y = [
        V("div", {
          class: m.value,
          style: c.value
        }),
        V("div", {
          class: f.value,
          style: p.value
        })
      ];
      return e.stripe === !0 && i.value === !1 && y.push(
        V("div", {
          class: v.value,
          style: _.value
        })
      ), V("div", {
        class: d.value,
        style: s.value,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 1,
        "aria-valuenow": e.indeterminate === !0 ? void 0 : e.value
      }, al(t.default, y));
    };
  }
});
function jd(e, t) {
  return new Date(e) - new Date(t);
}
const Nd = {
  sortMethod: Function,
  binaryStateSort: Boolean,
  columnSortOrder: {
    type: String,
    validator: (e) => e === "ad" || e === "da",
    default: "ad"
  }
};
function Wd(e, t, l, n) {
  const a = b(() => {
    const { sortBy: s } = t.value;
    return s && l.value.find((d) => d.name === s) || null;
  }), i = b(() => e.sortMethod !== void 0 ? e.sortMethod : (s, d, c) => {
    const u = l.value.find((f) => f.name === d);
    if (u === void 0 || u.field === void 0)
      return s;
    const m = c === !0 ? -1 : 1, p = typeof u.field == "function" ? (f) => u.field(f) : (f) => f[u.field];
    return s.sort((f, _) => {
      let v = p(f), y = p(_);
      return v == null ? -1 * m : y == null ? 1 * m : u.sort !== void 0 ? u.sort(v, y, f, _) * m : Ga(v) === !0 && Ga(y) === !0 ? (v - y) * m : ui(v) === !0 && ui(y) === !0 ? jd(v, y) * m : typeof v == "boolean" && typeof y == "boolean" ? (v - y) * m : ([v, y] = [v, y].map((M) => (M + "").toLocaleString().toLowerCase()), v < y ? -1 * m : v === y ? 0 : m);
    });
  });
  function r(s) {
    let d = e.columnSortOrder;
    if (Tr(s) === !0)
      s.sortOrder && (d = s.sortOrder), s = s.name;
    else {
      const m = l.value.find((p) => p.name === s);
      m !== void 0 && m.sortOrder && (d = m.sortOrder);
    }
    let { sortBy: c, descending: u } = t.value;
    c !== s ? (c = s, u = d === "da") : e.binaryStateSort === !0 ? u = !u : u === !0 ? d === "ad" ? c = null : u = !1 : d === "ad" ? u = !0 : c = null, n({ sortBy: c, descending: u, page: 1 });
  }
  return {
    columnToSort: a,
    computedSortMethod: i,
    sort: r
  };
}
const Qd = {
  filter: [String, Object],
  filterMethod: Function
};
function Kd(e, t) {
  const l = b(() => e.filterMethod !== void 0 ? e.filterMethod : (n, a, i, r) => {
    const s = a ? a.toLowerCase() : "";
    return n.filter(
      (d) => i.some((c) => {
        const u = r(c, d) + "";
        return (u === "undefined" || u === "null" ? "" : u.toLowerCase()).indexOf(s) !== -1;
      })
    );
  });
  return me(
    () => e.filter,
    () => {
      lt(() => {
        t({ page: 1 }, !0);
      });
    },
    { deep: !0 }
  ), { computedFilterMethod: l };
}
function Gd(e, t) {
  for (const l in t)
    if (t[l] !== e[l])
      return !1;
  return !0;
}
function pi(e) {
  return e.page < 1 && (e.page = 1), e.rowsPerPage !== void 0 && e.rowsPerPage < 1 && (e.rowsPerPage = 0), e;
}
const Zd = {
  pagination: Object,
  rowsPerPageOptions: {
    type: Array,
    default: () => [5, 7, 10, 15, 20, 25, 50, 0]
  },
  "onUpdate:pagination": [Function, Array]
};
function Xd(e, t) {
  const { props: l, emit: n } = e, a = G(
    Object.assign({
      sortBy: null,
      descending: !1,
      page: 1,
      rowsPerPage: l.rowsPerPageOptions.length !== 0 ? l.rowsPerPageOptions[0] : 5
    }, l.pagination)
  ), i = b(() => {
    const u = l["onUpdate:pagination"] !== void 0 ? { ...a.value, ...l.pagination } : a.value;
    return pi(u);
  }), r = b(() => i.value.rowsNumber !== void 0);
  function s(u) {
    d({
      pagination: u,
      filter: l.filter
    });
  }
  function d(u = {}) {
    lt(() => {
      n("request", {
        pagination: u.pagination || i.value,
        filter: u.filter || l.filter,
        getCellValue: t
      });
    });
  }
  function c(u, m) {
    const p = pi({
      ...i.value,
      ...u
    });
    if (Gd(i.value, p) === !0) {
      r.value === !0 && m === !0 && s(p);
      return;
    }
    if (r.value === !0) {
      s(p);
      return;
    }
    l.pagination !== void 0 && l["onUpdate:pagination"] !== void 0 ? n("update:pagination", p) : a.value = p;
  }
  return {
    innerPagination: a,
    computedPagination: i,
    isServerSide: r,
    requestServerInteraction: d,
    setPagination: c
  };
}
function Jd(e, t, l, n, a, i) {
  const { props: r, emit: s, proxy: { $q: d } } = e, c = b(() => n.value === !0 ? l.value.rowsNumber || 0 : i.value), u = b(() => {
    const { page: h, rowsPerPage: C } = l.value;
    return (h - 1) * C;
  }), m = b(() => {
    const { page: h, rowsPerPage: C } = l.value;
    return h * C;
  }), p = b(() => l.value.page === 1), f = b(() => l.value.rowsPerPage === 0 ? 1 : Math.max(
    1,
    Math.ceil(c.value / l.value.rowsPerPage)
  )), _ = b(() => m.value === 0 ? !0 : l.value.page >= f.value), v = b(() => (r.rowsPerPageOptions.includes(t.value.rowsPerPage) ? r.rowsPerPageOptions : [t.value.rowsPerPage].concat(r.rowsPerPageOptions)).map((C) => ({
    label: C === 0 ? d.lang.table.allRows : "" + C,
    value: C
  })));
  me(f, (h, C) => {
    if (h === C)
      return;
    const T = l.value.page;
    h && !T ? a({ page: 1 }) : h < T && a({ page: h });
  });
  function y() {
    a({ page: 1 });
  }
  function M() {
    const { page: h } = l.value;
    h > 1 && a({ page: h - 1 });
  }
  function w() {
    const { page: h, rowsPerPage: C } = l.value;
    m.value > 0 && h * C < c.value && a({ page: h + 1 });
  }
  function S() {
    a({ page: f.value });
  }
  return r["onUpdate:pagination"] !== void 0 && s("update:pagination", { ...l.value }), {
    firstRowIndex: u,
    lastRowIndex: m,
    isFirstPage: p,
    isLastPage: _,
    pagesNumber: f,
    computedRowsPerPageOptions: v,
    computedRowsNumber: c,
    firstPage: y,
    prevPage: M,
    nextPage: w,
    lastPage: S
  };
}
const ec = {
  selection: {
    type: String,
    default: "none",
    validator: (e) => ["single", "multiple", "none"].includes(e)
  },
  selected: {
    type: Array,
    default: () => []
  }
}, tc = ["update:selected", "selection"];
function lc(e, t, l, n) {
  const a = b(() => {
    const _ = {};
    return e.selected.map(n.value).forEach((v) => {
      _[v] = !0;
    }), _;
  }), i = b(() => e.selection !== "none"), r = b(() => e.selection === "single"), s = b(() => e.selection === "multiple"), d = b(
    () => l.value.length !== 0 && l.value.every(
      (_) => a.value[n.value(_)] === !0
    )
  ), c = b(
    () => d.value !== !0 && l.value.some((_) => a.value[n.value(_)] === !0)
  ), u = b(() => e.selected.length);
  function m(_) {
    return a.value[_] === !0;
  }
  function p() {
    t("update:selected", []);
  }
  function f(_, v, y, M) {
    t("selection", { rows: v, added: y, keys: _, evt: M });
    const w = r.value === !0 ? y === !0 ? v : [] : y === !0 ? e.selected.concat(v) : e.selected.filter(
      (S) => _.includes(n.value(S)) === !1
    );
    t("update:selected", w);
  }
  return {
    hasSelectionMode: i,
    singleSelection: r,
    multipleSelection: s,
    allRowsSelected: d,
    someRowsSelected: c,
    rowsSelectedNumber: u,
    isRowSelected: m,
    clearSelection: p,
    updateSelection: f
  };
}
function bi(e) {
  return Array.isArray(e) ? e.slice() : [];
}
const nc = {
  expanded: Array
  // v-model:expanded
}, ac = ["update:expanded"];
function oc(e, t) {
  const l = G(bi(e.expanded));
  me(() => e.expanded, (r) => {
    l.value = bi(r);
  });
  function n(r) {
    return l.value.includes(r);
  }
  function a(r) {
    e.expanded !== void 0 ? t("update:expanded", r) : l.value = r;
  }
  function i(r, s) {
    const d = l.value.slice(), c = d.indexOf(r);
    s === !0 ? c === -1 && (d.push(r), a(d)) : c !== -1 && (d.splice(c, 1), a(d));
  }
  return {
    isRowExpanded: n,
    setExpanded: a,
    updateExpanded: i
  };
}
const ic = {
  visibleColumns: Array
};
function rc(e, t, l) {
  const n = b(() => {
    if (e.columns !== void 0)
      return e.columns;
    const s = e.rows[0];
    return s !== void 0 ? Object.keys(s).map((d) => ({
      name: d,
      label: d.toUpperCase(),
      field: d,
      align: Ga(s[d]) ? "right" : "left",
      sortable: !0
    })) : [];
  }), a = b(() => {
    const { sortBy: s, descending: d } = t.value;
    return (e.visibleColumns !== void 0 ? n.value.filter((u) => u.required === !0 || e.visibleColumns.includes(u.name) === !0) : n.value).map((u) => {
      const m = u.align || "right", p = `text-${m}`;
      return {
        ...u,
        align: m,
        __iconClass: `q-table__sort-icon q-table__sort-icon--${m}`,
        __thClass: p + (u.headerClasses !== void 0 ? " " + u.headerClasses : "") + (u.sortable === !0 ? " sortable" : "") + (u.name === s ? ` sorted ${d === !0 ? "sort-desc" : ""}` : ""),
        __tdStyle: u.style !== void 0 ? typeof u.style != "function" ? () => u.style : u.style : () => null,
        __tdClass: u.classes !== void 0 ? typeof u.classes != "function" ? () => p + " " + u.classes : (f) => p + " " + u.classes(f) : () => p
      };
    });
  }), i = b(() => {
    const s = {};
    return a.value.forEach((d) => {
      s[d.name] = d;
    }), s;
  }), r = b(() => e.tableColspan !== void 0 ? e.tableColspan : a.value.length + (l.value === !0 ? 1 : 0));
  return {
    colList: n,
    computedCols: a,
    computedColsMap: i,
    computedColspan: r
  };
}
const Un = "q-table__bottom row items-center", zr = {};
Cr.forEach((e) => {
  zr[e] = {};
});
const an = De({
  name: "QTable",
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    rowKey: {
      type: [String, Function],
      default: "id"
    },
    columns: Array,
    loading: Boolean,
    iconFirstPage: String,
    iconPrevPage: String,
    iconNextPage: String,
    iconLastPage: String,
    title: String,
    hideHeader: Boolean,
    grid: Boolean,
    gridHeader: Boolean,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    separator: {
      type: String,
      default: "horizontal",
      validator: (e) => ["horizontal", "vertical", "cell", "none"].includes(e)
    },
    wrapCells: Boolean,
    virtualScroll: Boolean,
    virtualScrollTarget: {
      default: void 0
    },
    ...zr,
    noDataLabel: String,
    noResultsLabel: String,
    loadingLabel: String,
    selectedRowsLabel: Function,
    rowsPerPageLabel: String,
    paginationLabel: Function,
    color: {
      type: String,
      default: "grey-8"
    },
    titleClass: [String, Array, Object],
    tableStyle: [String, Array, Object],
    tableClass: [String, Array, Object],
    tableHeaderStyle: [String, Array, Object],
    tableHeaderClass: [String, Array, Object],
    cardContainerClass: [String, Array, Object],
    cardContainerStyle: [String, Array, Object],
    cardStyle: [String, Array, Object],
    cardClass: [String, Array, Object],
    hideBottom: Boolean,
    hideSelectedBanner: Boolean,
    hideNoData: Boolean,
    hidePagination: Boolean,
    onRowClick: Function,
    onRowDblclick: Function,
    onRowContextmenu: Function,
    ...Tt,
    ...Or,
    ...ic,
    ...Qd,
    ...Zd,
    ...nc,
    ...ec,
    ...Nd
  },
  emits: [
    "request",
    "virtualScroll",
    ...Br,
    ...ac,
    ...tc
  ],
  setup(e, { slots: t, emit: l }) {
    const n = Ae(), { proxy: { $q: a } } = n, i = Mt(e, a), { inFullscreen: r, toggleFullscreen: s } = Lr(), d = b(() => typeof e.rowKey == "function" ? e.rowKey : (le) => le[e.rowKey]), c = G(null), u = G(null), m = b(() => e.grid !== !0 && e.virtualScroll === !0), p = b(
      () => " q-table__card" + (i.value === !0 ? " q-table__card--dark q-dark" : "") + (e.square === !0 ? " q-table--square" : "") + (e.flat === !0 ? " q-table--flat" : "") + (e.bordered === !0 ? " q-table--bordered" : "")
    ), f = b(
      () => `q-table__container q-table--${e.separator}-separator column no-wrap` + (e.grid === !0 ? " q-table--grid" : p.value) + (i.value === !0 ? " q-table--dark" : "") + (e.dense === !0 ? " q-table--dense" : "") + (e.wrapCells === !1 ? " q-table--no-wrap" : "") + (r.value === !0 ? " fullscreen scroll" : "")
    ), _ = b(
      () => f.value + (e.loading === !0 ? " q-table--loading" : "")
    );
    me(
      () => e.tableStyle + e.tableClass + e.tableHeaderStyle + e.tableHeaderClass + f.value,
      () => {
        m.value === !0 && u.value !== null && u.value.reset();
      }
    );
    const {
      innerPagination: v,
      computedPagination: y,
      isServerSide: M,
      requestServerInteraction: w,
      setPagination: S
    } = Xd(n, de), { computedFilterMethod: h } = Kd(e, S), { isRowExpanded: C, setExpanded: T, updateExpanded: I } = oc(e, l), E = b(() => {
      let le = e.rows;
      if (M.value === !0 || le.length === 0)
        return le;
      const { sortBy: ye, descending: Te } = y.value;
      return e.filter && (le = h.value(le, e.filter, W.value, de)), ie.value !== null && (le = te.value(
        e.rows === le ? le.slice() : le,
        ye,
        Te
      )), le;
    }), A = b(() => E.value.length), O = b(() => {
      let le = E.value;
      if (M.value === !0)
        return le;
      const { rowsPerPage: ye } = y.value;
      return ye !== 0 && (fe.value === 0 && e.rows !== le ? le.length > Z.value && (le = le.slice(0, Z.value)) : le = le.slice(fe.value, Z.value)), le;
    }), {
      hasSelectionMode: P,
      singleSelection: $,
      multipleSelection: k,
      allRowsSelected: g,
      someRowsSelected: x,
      rowsSelectedNumber: B,
      isRowSelected: q,
      clearSelection: Y,
      updateSelection: K
    } = lc(e, l, O, d), { colList: Q, computedCols: W, computedColsMap: H, computedColspan: R } = rc(e, y, P), { columnToSort: ie, computedSortMethod: te, sort: oe } = Wd(e, y, Q, S), {
      firstRowIndex: fe,
      lastRowIndex: Z,
      isFirstPage: j,
      isLastPage: he,
      pagesNumber: we,
      computedRowsPerPageOptions: Ie,
      computedRowsNumber: ot,
      firstPage: St,
      prevPage: xt,
      nextPage: qt,
      lastPage: pt
    } = Jd(n, v, y, M, S, A), Wt = b(() => O.value.length === 0), el = b(() => {
      const le = {};
      return Cr.forEach((ye) => {
        le[ye] = e[ye];
      }), le.virtualScrollItemSize === void 0 && (le.virtualScrollItemSize = e.dense === !0 ? 28 : 48), le;
    });
    function ft() {
      m.value === !0 && u.value.reset();
    }
    function ue() {
      if (e.grid === !0)
        return Dl();
      const le = e.hideHeader !== !0 ? At : null;
      if (m.value === !0) {
        const Te = t["top-row"], Fe = t["bottom-row"], je = {
          default: (gt) => Je(gt.item, t.body, gt.index)
        };
        if (Te !== void 0) {
          const gt = V("tbody", Te({ cols: W.value }));
          je.before = le === null ? () => gt : () => [le()].concat(gt);
        } else
          le !== null && (je.before = le);
        return Fe !== void 0 && (je.after = () => V("tbody", Fe({ cols: W.value }))), V(Ud, {
          ref: u,
          class: e.tableClass,
          style: e.tableStyle,
          ...el.value,
          scrollTarget: e.virtualScrollTarget,
          items: O.value,
          type: "__qtable",
          tableColspan: R.value,
          onVirtualScroll: $e
        }, je);
      }
      const ye = [
        Re()
      ];
      return le !== null && ye.unshift(le()), Rr({
        class: ["q-table__middle scroll", e.tableClass],
        style: e.tableStyle
      }, ye);
    }
    function _e(le, ye) {
      if (u.value !== null) {
        u.value.scrollTo(le, ye);
        return;
      }
      le = parseInt(le, 10);
      const Te = c.value.querySelector(`tbody tr:nth-of-type(${le + 1})`);
      if (Te !== null) {
        const Fe = c.value.querySelector(".q-table__middle.scroll"), je = Te.offsetTop - e.virtualScrollStickySizeStart, gt = je < Fe.scrollTop ? "decrease" : "increase";
        Fe.scrollTop = je, l("virtualScroll", {
          index: le,
          from: 0,
          to: v.value.rowsPerPage - 1,
          direction: gt
        });
      }
    }
    function $e(le) {
      l("virtualScroll", le);
    }
    function tt() {
      return [
        V(Yd, {
          class: "q-table__linear-progress",
          color: e.color,
          dark: i.value,
          indeterminate: !0,
          trackColor: "transparent"
        })
      ];
    }
    function Je(le, ye, Te) {
      const Fe = d.value(le), je = q(Fe);
      if (ye !== void 0)
        return ye(
          Ue({
            key: Fe,
            row: le,
            pageIndex: Te,
            __trClass: je ? "selected" : ""
          })
        );
      const gt = t["body-cell"], F = W.value.map((X) => {
        const be = t[`body-cell-${X.name}`], pe = be !== void 0 ? be : gt;
        return pe !== void 0 ? pe(bt({ key: Fe, row: le, pageIndex: Te, col: X })) : V("td", {
          class: X.__tdClass(le),
          style: X.__tdStyle(le)
        }, de(X, le));
      });
      if (P.value === !0) {
        const X = t["body-selection"], be = X !== void 0 ? X(ht({ key: Fe, row: le, pageIndex: Te })) : [
          V(Bt, {
            modelValue: je,
            color: e.color,
            dark: i.value,
            dense: e.dense,
            "onUpdate:modelValue": (pe, Ge) => {
              K([Fe], [le], pe, Ge);
            }
          })
        ];
        F.unshift(
          V("td", { class: "q-table--col-auto-width" }, be)
        );
      }
      const N = { key: Fe, class: { selected: je } };
      return e.onRowClick !== void 0 && (N.class["cursor-pointer"] = !0, N.onClick = (X) => {
        l("RowClick", X, le, Te);
      }), e.onRowDblclick !== void 0 && (N.class["cursor-pointer"] = !0, N.onDblclick = (X) => {
        l("RowDblclick", X, le, Te);
      }), e.onRowContextmenu !== void 0 && (N.class["cursor-pointer"] = !0, N.onContextmenu = (X) => {
        l("RowContextmenu", X, le, Te);
      }), V("tr", N, F);
    }
    function Re() {
      const le = t.body, ye = t["top-row"], Te = t["bottom-row"];
      let Fe = O.value.map(
        (je, gt) => Je(je, le, gt)
      );
      return ye !== void 0 && (Fe = ye({ cols: W.value }).concat(Fe)), Te !== void 0 && (Fe = Fe.concat(Te({ cols: W.value }))), V("tbody", Fe);
    }
    function Ue(le) {
      return ne(le), le.cols = le.cols.map(
        (ye) => Kt({ ...ye }, "value", () => de(ye, le.row))
      ), le;
    }
    function bt(le) {
      return ne(le), Kt(le, "value", () => de(le.col, le.row)), le;
    }
    function ht(le) {
      return ne(le), le;
    }
    function ne(le) {
      Object.assign(le, {
        cols: W.value,
        colsMap: H.value,
        sort: oe,
        rowIndex: fe.value + le.pageIndex,
        color: e.color,
        dark: i.value,
        dense: e.dense
      }), P.value === !0 && Kt(
        le,
        "selected",
        () => q(le.key),
        (ye, Te) => {
          K([le.key], [le.row], ye, Te);
        }
      ), Kt(
        le,
        "expand",
        () => C(le.key),
        (ye) => {
          I(le.key, ye);
        }
      );
    }
    function de(le, ye) {
      const Te = typeof le.field == "function" ? le.field(ye) : ye[le.field];
      return le.format !== void 0 ? le.format(Te, ye) : Te;
    }
    const ke = b(() => ({
      pagination: y.value,
      pagesNumber: we.value,
      isFirstPage: j.value,
      isLastPage: he.value,
      firstPage: St,
      prevPage: xt,
      nextPage: qt,
      lastPage: pt,
      inFullscreen: r.value,
      toggleFullscreen: s
    }));
    function Pe() {
      const le = t.top, ye = t["top-left"], Te = t["top-right"], Fe = t["top-selection"], je = P.value === !0 && Fe !== void 0 && B.value > 0, gt = "q-table__top relative-position row items-center";
      if (le !== void 0)
        return V("div", { class: gt }, [le(ke.value)]);
      let F;
      if (je === !0 ? F = Fe(ke.value).slice() : (F = [], ye !== void 0 ? F.push(
        V("div", { class: "q-table__control" }, [
          ye(ke.value)
        ])
      ) : e.title && F.push(
        V("div", { class: "q-table__control" }, [
          V("div", {
            class: ["q-table__title", e.titleClass]
          }, e.title)
        ])
      )), Te !== void 0 && (F.push(
        V("div", { class: "q-table__separator col" })
      ), F.push(
        V("div", { class: "q-table__control" }, [
          Te(ke.value)
        ])
      )), F.length !== 0)
        return V("div", { class: gt }, F);
    }
    const Ye = b(() => x.value === !0 ? null : g.value);
    function At() {
      const le = He();
      return e.loading === !0 && t.loading === void 0 && le.push(
        V("tr", { class: "q-table__progress" }, [
          V("th", {
            class: "relative-position",
            colspan: R.value
          }, tt())
        ])
      ), V("thead", le);
    }
    function He() {
      const le = t.header, ye = t["header-cell"];
      if (le !== void 0)
        return le(
          it({ header: !0 })
        ).slice();
      const Te = W.value.map((Fe) => {
        const je = t[`header-cell-${Fe.name}`], gt = je !== void 0 ? je : ye, F = it({ col: Fe });
        return gt !== void 0 ? gt(F) : V(hl, {
          key: Fe.name,
          props: F
        }, () => Fe.label);
      });
      if ($.value === !0 && e.grid !== !0)
        Te.unshift(
          V("th", { class: "q-table--col-auto-width" }, " ")
        );
      else if (k.value === !0) {
        const Fe = t["header-selection"], je = Fe !== void 0 ? Fe(it({})) : [
          V(Bt, {
            color: e.color,
            modelValue: Ye.value,
            dark: i.value,
            dense: e.dense,
            "onUpdate:modelValue": Dt
          })
        ];
        Te.unshift(
          V("th", { class: "q-table--col-auto-width" }, je)
        );
      }
      return [
        V("tr", {
          class: e.tableHeaderClass,
          style: e.tableHeaderStyle
        }, Te)
      ];
    }
    function it(le) {
      return Object.assign(le, {
        cols: W.value,
        sort: oe,
        colsMap: H.value,
        color: e.color,
        dark: i.value,
        dense: e.dense
      }), k.value === !0 && Kt(
        le,
        "selected",
        () => Ye.value,
        Dt
      ), le;
    }
    function Dt(le) {
      x.value === !0 && (le = !1), K(
        O.value.map(d.value),
        O.value,
        le
      );
    }
    const tl = b(() => {
      const le = [
        e.iconFirstPage || a.iconSet.table.firstPage,
        e.iconPrevPage || a.iconSet.table.prevPage,
        e.iconNextPage || a.iconSet.table.nextPage,
        e.iconLastPage || a.iconSet.table.lastPage
      ];
      return a.lang.rtl === !0 ? le.reverse() : le;
    });
    function ol() {
      if (e.hideBottom === !0)
        return;
      if (Wt.value === !0) {
        if (e.hideNoData === !0)
          return;
        const Te = e.loading === !0 ? e.loadingLabel || a.lang.table.loading : e.filter ? e.noResultsLabel || a.lang.table.noResults : e.noDataLabel || a.lang.table.noData, Fe = t["no-data"], je = Fe !== void 0 ? [Fe({ message: Te, icon: a.iconSet.table.warning, filter: e.filter })] : [
          V(Qe, {
            class: "q-table__bottom-nodata-icon",
            name: a.iconSet.table.warning
          }),
          Te
        ];
        return V("div", { class: Un + " q-table__bottom--nodata" }, je);
      }
      const le = t.bottom;
      if (le !== void 0)
        return V("div", { class: Un }, [le(ke.value)]);
      const ye = e.hideSelectedBanner !== !0 && P.value === !0 && B.value > 0 ? [
        V("div", { class: "q-table__control" }, [
          V("div", [
            (e.selectedRowsLabel || a.lang.table.selectedRecords)(B.value)
          ])
        ])
      ] : [];
      if (e.hidePagination !== !0)
        return V("div", {
          class: Un + " justify-end"
        }, sl(ye));
      if (ye.length !== 0)
        return V("div", { class: Un }, ye);
    }
    function Hl(le) {
      S({
        page: 1,
        rowsPerPage: le.value
      });
    }
    function sl(le) {
      let ye;
      const { rowsPerPage: Te } = y.value, Fe = e.paginationLabel || a.lang.table.pagination, je = t.pagination, gt = e.rowsPerPageOptions.length > 1;
      if (le.push(
        V("div", { class: "q-table__separator col" })
      ), gt === !0 && le.push(
        V("div", { class: "q-table__control" }, [
          V("span", { class: "q-table__bottom-item" }, [
            e.rowsPerPageLabel || a.lang.table.recordsPerPage
          ]),
          V(Rt, {
            class: "q-table__select inline q-table__bottom-item",
            color: e.color,
            modelValue: Te,
            options: Ie.value,
            displayValue: Te === 0 ? a.lang.table.allRows : Te,
            dark: i.value,
            borderless: !0,
            dense: !0,
            optionsDense: !0,
            optionsCover: !0,
            "onUpdate:modelValue": Hl
          })
        ])
      ), je !== void 0)
        ye = je(ke.value);
      else if (ye = [
        V("span", Te !== 0 ? { class: "q-table__bottom-item" } : {}, [
          Te ? Fe(fe.value + 1, Math.min(Z.value, ot.value), ot.value) : Fe(1, A.value, ot.value)
        ])
      ], Te !== 0 && we.value > 1) {
        const F = {
          color: e.color,
          round: !0,
          dense: !0,
          flat: !0
        };
        e.dense === !0 && (F.size = "sm"), we.value > 2 && ye.push(
          V(se, {
            key: "pgFirst",
            ...F,
            icon: tl.value[0],
            disable: j.value,
            onClick: St
          })
        ), ye.push(
          V(se, {
            key: "pgPrev",
            ...F,
            icon: tl.value[1],
            disable: j.value,
            onClick: xt
          }),
          V(se, {
            key: "pgNext",
            ...F,
            icon: tl.value[2],
            disable: he.value,
            onClick: qt
          })
        ), we.value > 2 && ye.push(
          V(se, {
            key: "pgLast",
            ...F,
            icon: tl.value[3],
            disable: he.value,
            onClick: pt
          })
        );
      }
      return le.push(
        V("div", { class: "q-table__control" }, ye)
      ), le;
    }
    function _l() {
      const le = e.gridHeader === !0 ? [
        V("table", { class: "q-table" }, [
          At()
        ])
      ] : e.loading === !0 && t.loading === void 0 ? tt() : void 0;
      return V("div", { class: "q-table__middle" }, le);
    }
    function Dl() {
      const le = t.item !== void 0 ? t.item : (ye) => {
        const Te = ye.cols.map(
          (je) => V("div", { class: "q-table__grid-item-row" }, [
            V("div", { class: "q-table__grid-item-title" }, [je.label]),
            V("div", { class: "q-table__grid-item-value" }, [je.value])
          ])
        );
        if (P.value === !0) {
          const je = t["body-selection"], gt = je !== void 0 ? je(ye) : [
            V(Bt, {
              modelValue: ye.selected,
              color: e.color,
              dark: i.value,
              dense: e.dense,
              "onUpdate:modelValue": (F, N) => {
                K([ye.key], [ye.row], F, N);
              }
            })
          ];
          Te.unshift(
            V("div", { class: "q-table__grid-item-row" }, gt),
            V(ln, { dark: i.value })
          );
        }
        const Fe = {
          class: [
            "q-table__grid-item-card" + p.value,
            e.cardClass
          ],
          style: e.cardStyle
        };
        return (e.onRowClick !== void 0 || e.onRowDblclick !== void 0) && (Fe.class[0] += " cursor-pointer", e.onRowClick !== void 0 && (Fe.onClick = (je) => {
          l("RowClick", je, ye.row, ye.pageIndex);
        }), e.onRowDblclick !== void 0 && (Fe.onDblclick = (je) => {
          l("RowDblclick", je, ye.row, ye.pageIndex);
        })), V("div", {
          class: "q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3" + (ye.selected === !0 ? " q-table__grid-item--selected" : "")
        }, [
          V("div", Fe, Te)
        ]);
      };
      return V("div", {
        class: [
          "q-table__grid-content row",
          e.cardContainerClass
        ],
        style: e.cardContainerStyle
      }, O.value.map((ye, Te) => le(Ue({
        key: d.value(ye),
        row: ye,
        pageIndex: Te
      }))));
    }
    return Object.assign(n.proxy, {
      requestServerInteraction: w,
      setPagination: S,
      firstPage: St,
      prevPage: xt,
      nextPage: qt,
      lastPage: pt,
      isRowSelected: q,
      clearSelection: Y,
      isRowExpanded: C,
      setExpanded: T,
      sort: oe,
      resetVirtualScroll: ft,
      scrollTo: _e,
      getCellValue: de
    }), ju(n.proxy, {
      filteredSortedRows: () => E.value,
      computedRows: () => O.value,
      computedRowsNumber: () => ot.value
    }), () => {
      const le = [Pe()], ye = { ref: c, class: _.value };
      return e.grid === !0 ? le.push(_l()) : Object.assign(ye, {
        class: [ye.class, e.cardClass],
        style: e.cardStyle
      }), le.push(
        ue(),
        ol()
      ), e.loading === !0 && t.loading !== void 0 && le.push(
        t.loading()
      ), V("div", ye, le);
    };
  }
}), Ur = (e) => {
  const t = "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/-,:;", l = "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz______", n = new RegExp(t.split("").join("|"), "g");
  return e.toString().toLowerCase().replace(/\s+/g, "_").replace(n, (a) => l.charAt(t.indexOf(a))).replace(/[^\w-]+/g, "").replace(/__+/g, "_").replace(/^_+/, "").replace(/_+$/, "");
}, uc = /* @__PURE__ */ Ce({
  __name: "NewOptionDialog",
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const l = Me("_uct"), n = Ee(), { itemId: a } = Ke(), i = Lt(), r = G(!1), s = G(""), d = G(""), c = (m) => {
      s.value = m, r.value && (d.value = Ur(m));
    }, u = () => {
      n.addOption(
        a.value,
        {
          label: s.value,
          value: d.value
        }
      ), s.value = "", d.value = "", t("update:modelValue", !1);
    };
    return (m, p) => (z(), ae(ul, {
      "confirm-text": o(l)("builder.tabs.data.dialogNewOption.actions.save"),
      "model-value": m.modelValue,
      title: o(l)("builder.tabs.data.dialogNewOption.title"),
      onCancel: p[2] || (p[2] = (f) => t("update:modelValue", !1)),
      onValid: u,
      "onUpdate:modelValue": p[3] || (p[3] = (f) => t("update:modelValue", f))
    }, {
      default: L(() => [
        o(i).optionValueIsId ? ce("", !0) : (z(), ae(at, {
          key: 0,
          modelValue: r.value,
          "onUpdate:modelValue": p[0] || (p[0] = (f) => r.value = f),
          label: o(l)("builder.tabs.data.dialogNewOption.autocompleteLabel")
        }, null, 8, ["modelValue", "label"])),
        ee("div", null, [
          D(Ne, {
            label: o(l)("builder.tabs.data.dialogNewOption.label"),
            "model-value": s.value,
            "onUpdate:modelValue": c
          }, null, 8, ["label", "model-value"]),
          o(i).optionValueIsId ? ce("", !0) : (z(), ae(Ne, {
            key: 0,
            modelValue: d.value,
            "onUpdate:modelValue": p[1] || (p[1] = (f) => d.value = f),
            label: o(l)("builder.tabs.data.dialogNewOption.value")
          }, null, 8, ["modelValue", "label"]))
        ])
      ]),
      _: 1
    }, 8, ["confirm-text", "model-value", "title"]));
  }
}), sc = V("svg", {
  key: "svg",
  class: "q-radio__bg absolute non-selectable",
  viewBox: "0 0 24 24"
}, [
  V("path", {
    d: "M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12"
  }),
  V("path", {
    class: "q-radio__check",
    d: "M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
  })
]), gn = De({
  name: "QRadio",
  props: {
    ...Tt,
    ...on,
    ...Ml,
    modelValue: { required: !0 },
    val: { required: !0 },
    label: String,
    leftLabel: Boolean,
    checkedIcon: String,
    uncheckedIcon: String,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [String, Number]
  },
  emits: ["update:modelValue"],
  setup(e, { slots: t, emit: l }) {
    const { proxy: n } = Ae(), a = Mt(e, n.$q), i = rn(e, pr), r = G(null), { refocusTargetEl: s, refocusTarget: d } = vr(e, r), c = b(() => wl(e.modelValue) === wl(e.val)), u = b(
      () => "q-radio cursor-pointer no-outline row inline no-wrap items-center" + (e.disable === !0 ? " disabled" : "") + (a.value === !0 ? " q-radio--dark" : "") + (e.dense === !0 ? " q-radio--dense" : "") + (e.leftLabel === !0 ? " reverse" : "")
    ), m = b(() => {
      const S = e.color !== void 0 && (e.keepColor === !0 || c.value === !0) ? ` text-${e.color}` : "";
      return `q-radio__inner relative-position q-radio__inner--${c.value === !0 ? "truthy" : "falsy"}${S}`;
    }), p = b(
      () => (c.value === !0 ? e.checkedIcon : e.uncheckedIcon) || null
    ), f = b(() => e.disable === !0 ? -1 : e.tabindex || 0), _ = b(() => {
      const S = { type: "radio" };
      return e.name !== void 0 && Object.assign(S, {
        // see https://vuejs.org/guide/extras/render-function.html#creating-vnodes (.prop)
        ".checked": c.value === !0,
        "^checked": c.value === !0 ? "checked" : void 0,
        name: e.name,
        value: e.val
      }), S;
    }), v = An(_);
    function y(S) {
      S !== void 0 && (Ze(S), d(S)), e.disable !== !0 && c.value !== !0 && l("update:modelValue", e.val, S);
    }
    function M(S) {
      (S.keyCode === 13 || S.keyCode === 32) && Ze(S);
    }
    function w(S) {
      (S.keyCode === 13 || S.keyCode === 32) && y(S);
    }
    return Object.assign(n, { set: y }), () => {
      const S = p.value !== null ? [
        V("div", {
          key: "icon",
          class: "q-radio__icon-container absolute-full flex flex-center no-wrap"
        }, [
          V(Qe, {
            class: "q-radio__icon",
            name: p.value
          })
        ])
      ] : [sc];
      e.disable !== !0 && v(
        S,
        "unshift",
        " q-radio__native q-ma-none q-pa-none"
      );
      const h = [
        V("div", {
          class: m.value,
          style: i.value,
          "aria-hidden": "true"
        }, S)
      ];
      s.value !== null && h.push(s.value);
      const C = e.label !== void 0 ? al(t.default, [e.label]) : We(t.default);
      return C !== void 0 && h.push(
        V("div", {
          class: "q-radio__label q-anchor--skip"
        }, C)
      ), V("div", {
        ref: r,
        class: u.value,
        tabindex: f.value,
        role: "radio",
        "aria-label": e.label,
        "aria-checked": c.value === !0 ? "true" : "false",
        "aria-disabled": e.disable === !0 ? "true" : void 0,
        onClick: y,
        onKeydown: M,
        onKeyup: w
      }, h);
    };
  }
}), dc = { class: "radioContainer" }, cc = { class: "radioContainer" }, fc = /* @__PURE__ */ Ce({
  __name: "SortOptionDialog",
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const l = Me("_uct"), n = G("label"), a = G("asc"), i = Ee(), { itemId: r } = Ke(), s = () => {
      i.sortOptions(r.value, n.value, a.value), t("update:modelValue", !1);
    };
    return (d, c) => (z(), ae(ul, {
      "confirm-text": o(l)("builder.tabs.data.dialogSort.actions.sort"),
      "model-value": d.modelValue,
      title: o(l)("builder.tabs.data.dialogSort.title"),
      onCancel: c[4] || (c[4] = (u) => t("update:modelValue", !1)),
      onValid: s,
      "onUpdate:modelValue": c[5] || (c[5] = (u) => t("update:modelValue", u))
    }, {
      default: L(() => [
        ee("div", dc, [
          ee("p", null, J(o(l)("builder.tabs.data.dialogSort.form.label")) + " :", 1),
          D(gn, {
            modelValue: n.value,
            "onUpdate:modelValue": c[0] || (c[0] = (u) => n.value = u),
            label: o(l)("builder.tabs.data.dataTable.headers.label"),
            val: "label"
          }, null, 8, ["modelValue", "label"]),
          D(gn, {
            modelValue: n.value,
            "onUpdate:modelValue": c[1] || (c[1] = (u) => n.value = u),
            label: o(l)("builder.tabs.data.dataTable.headers.value"),
            val: "value"
          }, null, 8, ["modelValue", "label"])
        ]),
        ee("div", cc, [
          ee("p", null, J(o(l)("builder.tabs.data.dialogSort.form.direction.label")) + " :", 1),
          D(gn, {
            modelValue: a.value,
            "onUpdate:modelValue": c[2] || (c[2] = (u) => a.value = u),
            label: o(l)("builder.tabs.data.dialogSort.form.direction.options.asc"),
            val: "asc"
          }, null, 8, ["modelValue", "label"]),
          D(gn, {
            modelValue: a.value,
            "onUpdate:modelValue": c[3] || (c[3] = (u) => a.value = u),
            label: o(l)("builder.tabs.data.dialogSort.form.direction.options.desc"),
            val: "desc"
          }, null, 8, ["modelValue", "label"])
        ])
      ]),
      _: 1
    }, 8, ["confirm-text", "model-value", "title"]));
  }
});
function Ql(e, t, l, n) {
  const a = [];
  return e.forEach((i) => {
    n(i) === !0 ? a.push(i) : t.push({ failedPropValidation: l, file: i });
  }), a;
}
function Hn(e) {
  e && e.dataTransfer && (e.dataTransfer.dropEffect = "copy"), Ze(e);
}
const vc = {
  multiple: Boolean,
  accept: String,
  capture: String,
  maxFileSize: [Number, String],
  maxTotalSize: [Number, String],
  maxFiles: [Number, String],
  filter: Function
}, mc = ["rejected"];
function pc({
  editable: e,
  dnd: t,
  getFileInput: l,
  addFilesToQueue: n
}) {
  const { props: a, emit: i, proxy: r } = Ae(), s = G(null), d = b(() => a.accept !== void 0 ? a.accept.split(",").map((w) => (w = w.trim(), w === "*" ? "*/" : (w.endsWith("/*") && (w = w.slice(0, w.length - 1)), w.toUpperCase()))) : null), c = b(() => parseInt(a.maxFiles, 10)), u = b(() => parseInt(a.maxTotalSize, 10));
  function m(w) {
    if (e.value)
      if (w !== Object(w) && (w = { target: null }), w.target !== null && w.target.matches('input[type="file"]') === !0)
        w.clientX === 0 && w.clientY === 0 && Pt(w);
      else {
        const S = l();
        S && S !== w.target && S.click(w);
      }
  }
  function p(w) {
    e.value && w && n(null, w);
  }
  function f(w, S, h, C) {
    let T = Array.from(S || w.target.files);
    const I = [], E = () => {
      I.length !== 0 && i("rejected", I);
    };
    if (a.accept !== void 0 && d.value.indexOf("*/") === -1 && (T = Ql(T, I, "accept", (A) => d.value.some((O) => A.type.toUpperCase().startsWith(O) || A.name.toUpperCase().endsWith(O))), T.length === 0))
      return E();
    if (a.maxFileSize !== void 0) {
      const A = parseInt(a.maxFileSize, 10);
      if (T = Ql(T, I, "max-file-size", (O) => O.size <= A), T.length === 0)
        return E();
    }
    if (a.multiple !== !0 && T.length !== 0 && (T = [T[0]]), T.forEach((A) => {
      A.__key = A.webkitRelativePath + A.lastModified + A.name + A.size;
    }), C === !0) {
      const A = h.map((O) => O.__key);
      T = Ql(T, I, "duplicate", (O) => A.includes(O.__key) === !1);
    }
    if (T.length === 0)
      return E();
    if (a.maxTotalSize !== void 0) {
      let A = C === !0 ? h.reduce((O, P) => O + P.size, 0) : 0;
      if (T = Ql(T, I, "max-total-size", (O) => (A += O.size, A <= u.value)), T.length === 0)
        return E();
    }
    if (typeof a.filter == "function") {
      const A = a.filter(T);
      T = Ql(T, I, "filter", (O) => A.includes(O));
    }
    if (a.maxFiles !== void 0) {
      let A = C === !0 ? h.length : 0;
      if (T = Ql(T, I, "max-files", () => (A++, A <= c.value)), T.length === 0)
        return E();
    }
    if (E(), T.length !== 0)
      return T;
  }
  function _(w) {
    Hn(w), t.value !== !0 && (t.value = !0);
  }
  function v(w) {
    Ze(w), (w.relatedTarget !== null || mt.is.safari !== !0 ? w.relatedTarget !== s.value : document.elementsFromPoint(w.clientX, w.clientY).includes(s.value) === !1) === !0 && (t.value = !1);
  }
  function y(w) {
    Hn(w);
    const S = w.dataTransfer.files;
    S.length !== 0 && n(null, S), t.value = !1;
  }
  function M(w) {
    if (t.value === !0)
      return V("div", {
        ref: s,
        class: `q-${w}__dnd absolute-full`,
        onDragenter: Hn,
        onDragover: Hn,
        onDragleave: v,
        onDrop: y
      });
  }
  return Object.assign(r, { pickFiles: m, addFiles: p }), {
    pickFiles: m,
    addFiles: p,
    onDragover: _,
    onDragleave: v,
    processFiles: f,
    getDndNode: M,
    maxFilesNumber: c,
    maxTotalSizeNumber: u
  };
}
const Hr = De({
  name: "QFile",
  inheritAttrs: !1,
  props: {
    ...Fn,
    ...Ml,
    ...vc,
    /* SSR does not know about File & FileList */
    modelValue: [File, FileList, Array],
    append: Boolean,
    useChips: Boolean,
    displayValue: [String, Number],
    tabindex: {
      type: [String, Number],
      default: 0
    },
    counterLabel: Function,
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...ma,
    ...mc
  ],
  setup(e, { slots: t, emit: l, attrs: n }) {
    const { proxy: a } = Ae(), i = pa(), r = G(null), s = G(!1), d = po(e), {
      pickFiles: c,
      onDragover: u,
      onDragleave: m,
      processFiles: p,
      getDndNode: f
    } = pc({ editable: i.editable, dnd: s, getFileInput: $, addFilesToQueue: k }), _ = _r(e), v = b(() => Object(e.modelValue) === e.modelValue ? "length" in e.modelValue ? Array.from(e.modelValue) : [e.modelValue] : []), y = b(() => Pl(v.value)), M = b(
      () => v.value.map((q) => q.name).join(", ")
    ), w = b(
      () => cd(
        v.value.reduce((q, Y) => q + Y.size, 0)
      )
    ), S = b(() => ({
      totalSize: w.value,
      filesNumber: v.value.length,
      maxFiles: e.maxFiles
    })), h = b(() => ({
      tabindex: -1,
      type: "file",
      title: "",
      // try to remove default tooltip,
      accept: e.accept,
      capture: e.capture,
      name: d.value,
      ...n,
      id: i.targetUid.value,
      disabled: i.editable.value !== !0
    })), C = b(
      () => "q-file q-field--auto-height" + (s.value === !0 ? " q-file--dnd" : "")
    ), T = b(
      () => e.multiple === !0 && e.append === !0
    );
    function I(q) {
      const Y = v.value.slice();
      Y.splice(q, 1), A(Y);
    }
    function E(q) {
      const Y = v.value.indexOf(q);
      Y > -1 && I(Y);
    }
    function A(q) {
      l("update:modelValue", e.multiple === !0 ? q : q[0]);
    }
    function O(q) {
      q.keyCode === 13 && Ot(q);
    }
    function P(q) {
      (q.keyCode === 13 || q.keyCode === 32) && c(q);
    }
    function $() {
      return r.value;
    }
    function k(q, Y) {
      const K = p(q, Y, v.value, T.value), Q = $();
      Q != null && (Q.value = ""), K !== void 0 && ((e.multiple === !0 ? e.modelValue && K.every((W) => v.value.includes(W)) : e.modelValue === K[0]) || A(
        T.value === !0 ? v.value.concat(K) : K
      ));
    }
    function g() {
      return [
        V("input", {
          class: [e.inputClass, "q-file__filler"],
          style: e.inputStyle
        })
      ];
    }
    function x() {
      if (t.file !== void 0)
        return v.value.length === 0 ? g() : v.value.map(
          (Y, K) => t.file({ index: K, file: Y, ref: this })
        );
      if (t.selected !== void 0)
        return v.value.length === 0 ? g() : t.selected({ files: v.value, ref: this });
      if (e.useChips === !0)
        return v.value.length === 0 ? g() : v.value.map((Y, K) => V(ya, {
          key: "file-" + K,
          removable: i.editable.value,
          dense: !0,
          textColor: e.color,
          tabindex: e.tabindex,
          onRemove: () => {
            I(K);
          }
        }, () => V("span", {
          class: "ellipsis",
          textContent: Y.name
        })));
      const q = e.displayValue !== void 0 ? e.displayValue : M.value;
      return q.length !== 0 ? [
        V("div", {
          class: e.inputClass,
          style: e.inputStyle,
          textContent: q
        })
      ] : g();
    }
    function B() {
      const q = {
        ref: r,
        ...h.value,
        ..._.value,
        class: "q-field__input fit absolute-full cursor-pointer",
        onChange: k
      };
      return e.multiple === !0 && (q.multiple = !0), V("input", q);
    }
    return Object.assign(i, {
      fieldClass: C,
      emitValue: A,
      hasValue: y,
      inputRef: r,
      innerValue: v,
      floatingLabel: b(
        () => y.value === !0 || Pl(e.displayValue)
      ),
      computedCounter: b(() => {
        if (e.counterLabel !== void 0)
          return e.counterLabel(S.value);
        const q = e.maxFiles;
        return `${v.value.length}${q !== void 0 ? " / " + q : ""} (${w.value})`;
      }),
      getControlChild: () => f("file"),
      getControl: () => {
        const q = {
          ref: i.targetRef,
          class: "q-field__native row items-center cursor-pointer",
          tabindex: e.tabindex
        };
        return i.editable.value === !0 && Object.assign(q, { onDragover: u, onDragleave: m, onKeydown: O, onKeyup: P }), V("div", q, [B()].concat(x()));
      }
    }), Object.assign(a, {
      removeAtIndex: I,
      removeFile: E,
      getNativeElement: () => r.value
      // deprecated
    }), Kt(a, "nativeEl", () => r.value), ba(i);
  }
}), bc = /* @__PURE__ */ Ce({
  __name: "CSVNewOptionDialog",
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const l = Me("_uct"), n = G(null), a = G(!0), { itemId: i } = Ke(), r = Ee(), s = () => {
      if (n.value) {
        const d = new FileReader();
        d.onload = (c) => {
          var m;
          const u = (m = c.target) == null ? void 0 : m.result;
          if (u) {
            const p = u.split(`
`).filter((f) => f !== "").map((f) => f.split('";"').map((_, v, y) => v === 0 ? _.substring(1) : v === y.length - 1 ? _.split("\r")[0].slice(0, -1) : _));
            a.value && r.removeAllOptions(i.value), p.forEach((f) => {
              const _ = {
                label: f[0],
                value: f[1],
                owner: i.value
              };
              f[2] !== void 0 && (_.displayedBy = [], f[2].split(" ").forEach((v) => {
                var M;
                const y = r.getOptionByIdOrValue(v);
                y && ((M = _.displayedBy) == null || M.push(y.id));
              })), r.addOption(i.value, _);
            });
          }
          n.value = null, t("update:modelValue", !1);
        }, d.readAsText(n.value);
      } else
        t("update:modelValue", !1);
    };
    return (d, c) => (z(), ae(ul, {
      "confirm-text": o(l)("builder.tabs.data.fileSystem.import"),
      "model-value": d.modelValue,
      title: o(l)("builder.tabs.data.fileSystem.title"),
      onCancel: c[2] || (c[2] = (u) => t("update:modelValue", !1)),
      onValid: s,
      "onUpdate:modelValue": c[3] || (c[3] = (u) => t("update:modelValue", u))
    }, {
      default: L(() => [
        ee("header", null, [
          D(Vl, { class: "bg-info" }, {
            avatar: L(() => [
              D(Qe, { name: "mdi-alert-circle-outline" })
            ]),
            default: L(() => [
              ve(J(o(l)("builder.tabs.data.fileSystem.infoFormat")) + " ", 1)
            ]),
            _: 1
          }),
          a.value ? (z(), ae(Vl, {
            key: 0,
            class: "bg-warning"
          }, {
            avatar: L(() => [
              D(Qe, { name: "mdi-alert-outline" })
            ]),
            default: L(() => [
              ve(J(o(l)("builder.tabs.data.fileSystem.warning")) + " ", 1)
            ]),
            _: 1
          })) : ce("", !0)
        ]),
        D(at, {
          modelValue: a.value,
          "onUpdate:modelValue": c[0] || (c[0] = (u) => a.value = u),
          label: o(l)("builder.tabs.data.fileSystem.emptyBefore")
        }, null, 8, ["modelValue", "label"]),
        D(Hr, {
          modelValue: n.value,
          "onUpdate:modelValue": c[1] || (c[1] = (u) => n.value = u),
          label: o(l)("builder.tabs.data.fileSystem.myCSV"),
          clearable: ""
        }, {
          prepend: L(() => [
            D(Qe, { name: "mdi-file" })
          ]),
          _: 1
        }, 8, ["modelValue", "label"])
      ]),
      _: 1
    }, 8, ["confirm-text", "model-value", "title"]));
  }
});
const hc = /* @__PURE__ */ Oe(bc, [["__scopeId", "data-v-0dc93689"]]), gc = /* @__PURE__ */ Ce({
  __name: "EmptyOptionsDialog",
  props: {
    modelValue: { type: Boolean },
    isAPI: { type: Boolean }
  },
  emits: ["update:modelValue", "update:is-a-p-i"],
  setup(e, { emit: t }) {
    const l = e, { isAPI: n } = ct(l), a = Me("_uct"), i = Ee(), { itemId: r } = Ke(), s = () => {
      i.removeAllOptions(r.value), t("update:modelValue", !1);
    }, d = b(() => n.value ? a("builder.tabs.data.options.APIOptions.message") : a("builder.tabs.data.empty.information"));
    return (c, u) => (z(), ae(ul, {
      "confirm-text": o(a)("builder.tabs.data.empty.actions.allRemove"),
      "model-value": c.modelValue,
      title: o(a)("builder.tabs.data.empty.title"),
      "confirm-color": "negative",
      onCancel: u[0] || (u[0] = (m) => {
        t("update:modelValue", !1), t("update:is-a-p-i", !1);
      }),
      onValid: s,
      "onUpdate:modelValue": u[1] || (u[1] = (m) => t("update:modelValue", m))
    }, {
      default: L(() => [
        D(Vl, { class: "bg-warning" }, {
          avatar: L(() => [
            D(Qe, { name: "mdi-alert-outline" })
          ]),
          default: L(() => [
            ve(J(d.value) + " ", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["confirm-text", "model-value", "title"]));
  }
}), hi = De({
  name: "QBtnToggle",
  props: {
    ...Ml,
    modelValue: {
      required: !0
    },
    options: {
      type: Array,
      required: !0,
      validator: (e) => e.every(
        (t) => ("label" in t || "icon" in t || "slot" in t) && "value" in t
      )
    },
    // To avoid seeing the active raise shadow through
    // the transparent button, give it a color (even white)
    color: String,
    textColor: String,
    toggleColor: {
      type: String,
      default: "primary"
    },
    toggleTextColor: String,
    outline: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    rounded: Boolean,
    push: Boolean,
    glossy: Boolean,
    size: String,
    padding: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    readonly: Boolean,
    disable: Boolean,
    stack: Boolean,
    stretch: Boolean,
    spread: Boolean,
    clearable: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: !0
    }
  },
  emits: ["update:modelValue", "clear", "click"],
  setup(e, { slots: t, emit: l }) {
    const n = b(
      () => e.options.find((p) => p.value === e.modelValue) !== void 0
    ), a = b(() => ({
      type: "hidden",
      name: e.name,
      value: e.modelValue
    })), i = An(a), r = b(() => ar(e)), s = b(() => ({
      rounded: e.rounded,
      dense: e.dense,
      ...r.value
    })), d = b(() => e.options.map((p, f) => {
      const { attrs: _, value: v, slot: y, ...M } = p;
      return {
        slot: y,
        props: {
          key: f,
          "aria-pressed": v === e.modelValue ? "true" : "false",
          ..._,
          ...M,
          ...s.value,
          disable: e.disable === !0 || M.disable === !0,
          // Options that come from the button specific options first, then from general props
          color: v === e.modelValue ? u(M, "toggleColor") : u(M, "color"),
          textColor: v === e.modelValue ? u(M, "toggleTextColor") : u(M, "textColor"),
          noCaps: u(M, "noCaps") === !0,
          noWrap: u(M, "noWrap") === !0,
          size: u(M, "size"),
          padding: u(M, "padding"),
          ripple: u(M, "ripple"),
          stack: u(M, "stack") === !0,
          stretch: u(M, "stretch") === !0,
          onClick(w) {
            c(v, p, w);
          }
        }
      };
    }));
    function c(p, f, _) {
      e.readonly !== !0 && (e.modelValue === p ? e.clearable === !0 && (l("update:modelValue", null, null), l("clear")) : l("update:modelValue", p, f), l("click", _));
    }
    function u(p, f) {
      return p[f] === void 0 ? e[f] : p[f];
    }
    function m() {
      const p = d.value.map((f) => V(se, f.props, f.slot !== void 0 ? t[f.slot] : void 0));
      return e.name !== void 0 && e.disable !== !0 && n.value === !0 && i(p, "push"), al(t.default, p);
    }
    return () => V($r, {
      class: "q-btn-toggle",
      ...r.value,
      rounded: e.rounded,
      stretch: e.stretch,
      glossy: e.glossy,
      spread: e.spread
    }, m);
  }
}), ho = () => {
  const { iconSet: e, lang: t, loading: l, notify: n } = wa();
  return {
    iconSet: e,
    lang: t,
    loading: l,
    notify: n
  };
}, ml = Rl({
  APIData: [],
  labelOrValue: null
}), go = (e, t, l) => {
  const { notify: n } = ho(), a = Ee(), i = (v, y) => {
    if (y === "")
      return;
    const M = y.split(".");
    let w = v;
    for (let S = 0; S < M.length; S++) {
      const h = w[M[S]];
      if (h === void 0)
        return;
      if (Array.isArray(h) || typeof h == "string" || typeof h == "number")
        return h;
      typeof h == "object" && (w = h);
    }
  }, r = G({}), s = (v, y = !1) => {
    const M = {};
    for (const w in v) {
      if (typeof v[w] == "string" || typeof v[w] == "number" || typeof v[w] == "boolean" || v[w] === null) {
        M[w] = typeof v[w];
        continue;
      }
      if (Array.isArray(v[w])) {
        if (v[w].every((S) => Array.isArray(S)))
          continue;
        if (v[w].every((S) => typeof S == "string" || typeof S == "number" || typeof S == "boolean" || S === null)) {
          const S = v[w].reduce(
            (h, C) => (h.add(typeof C), h),
            /* @__PURE__ */ new Set()
          );
          M[w + "[]"] = [...S].join(" | ");
          continue;
        }
        if (v[w].every((S) => typeof S == "object")) {
          const S = v[w][0];
          M[w + "[]"] = s(S);
        }
      } else
        typeof v[w] == "object" && (M[w] = s(v[w]));
    }
    return y && (r.value = M), M;
  }, d = async (v) => {
    var M, w;
    if (!((M = t.value) != null && M.optionsApi)) {
      n({
        type: "negative",
        textColor: "black",
        message: e("builder.tabs.data.options.APIOptions.error.fieldEmpty"),
        timeout: 1e4,
        closeBtn: !0
      });
      return;
    }
    const y = (w = await xu.get(t.value.optionsApi)) == null ? void 0 : w.data;
    if (ml.APIData = t.value.optionsApiKey ? i(y, t.value.optionsApiKey) : y, !Array.isArray(ml.APIData)) {
      n({
        type: "negative",
        textColor: "black",
        message: e("builder.tabs.data.options.APIOptions.error.arrayFormat"),
        timeout: 1e4,
        closeBtn: !0
      });
      return;
    }
    v && s(ml.APIData[0], !0);
  }, c = b(() => Object.keys(r.value).length !== 0), u = G(), m = G({}), p = (v, y, M, w, S, h, C) => {
    const T = ml.APIData.every((E) => {
      const A = i(E, C);
      return !(A === void 0 || typeof A == "object" || Array.isArray(A));
    });
    for (let E = 0; E < y; E++)
      v.innerHTML += h[E] ? "         " : "│      ";
    v.innerHTML += `${M - 1 === w ? "└" : "├"}── `;
    const I = document.createElement("span");
    I.innerText = S, T ? (I.innerText += " : " + i(ml.APIData[0], C), I.addEventListener("click", () => {
      ml.labelOrValue ? (a.updateField(l.value, ml.labelOrValue, C), ml.labelOrValue = null) : n({
        type: "negative",
        textColor: "black",
        message: e("builder.tabs.data.options.APIOptions.tree.selectFirst")
      });
    })) : (I.classList.add("notInAllObjects"), I.title = e("builder.tabs.data.options.APIOptions.tree.error")), v.appendChild(I), u.value && u.value.appendChild(v);
  }, f = (v, y) => y === "" ? v : `${y}.${v}`, _ = (v, y, M, w) => {
    let S = 0;
    const h = Object.keys(v).length;
    for (const C in v) {
      const T = document.createElement("li");
      if (typeof v[C] == "string") {
        p(
          T,
          y,
          h,
          S,
          C,
          M,
          f(C, w)
        ), S++;
        continue;
      }
      p(
        T,
        y,
        h,
        S,
        C,
        M,
        f(C, w)
      ), m.value[y] = h - 1 === S, _(
        v[C],
        y + 1,
        m.value,
        f(C, w)
      ), S++;
    }
  };
  return {
    ...ct(ml),
    APIColumnsList: r,
    loadAPI: d,
    loadDeepValue: i,
    treeBuilt: c,
    treeContainer: u,
    deepTermination: m,
    readTree: _
  };
}, yc = { id: "treeContainer" }, _c = /* @__PURE__ */ Ce({
  __name: "APITree",
  props: {
    APITree: {}
  },
  setup(e) {
    const t = e, { APITree: l } = ct(t), n = Me("_uct"), { field: a, itemId: i } = Ke(), { treeContainer: r, readTree: s, deepTermination: d } = go(n, a, i);
    return me(l, () => {
      r.value && Object.keys(l.value).length > 0 && (r.value.innerText = "", s(l.value, 0, d.value, ""));
    }), (c, u) => (z(), re("div", yc, [
      ee("h3", null, J(o(n)("builder.tabs.data.options.APIOptions.tree.title")), 1),
      ee("ul", {
        ref_key: "treeContainer",
        ref: r
      }, null, 512)
    ]));
  }
});
const Sc = /* @__PURE__ */ Oe(_c, [["__scopeId", "data-v-465bc8cb"]]), wc = { id: "keysSelectionContainer" }, xc = /* @__PURE__ */ Ce({
  __name: "APISystem",
  props: {
    optionList: {},
    isAPIOptions: { type: Boolean }
  },
  emits: ["display-empty-dialog", "update:is-a-p-i-options"],
  setup(e, { emit: t }) {
    const l = e, { isAPIOptions: n, optionList: a } = ct(l), i = Me("_uct"), r = Ee(), { field: s, itemId: d } = Ke(), c = (_) => {
      t("update:is-a-p-i-options", _), _ && a.value.length !== 0 && t("display-empty-dialog");
    }, { APIColumnsList: u, labelOrValue: m, loadAPI: p, treeBuilt: f } = go(i, s, d);
    return (_, v) => {
      var y, M, w, S;
      return z(), re("div", null, [
        D(at, {
          label: o(i)("builder.tabs.data.options.APIOptions.toggle"),
          "model-value": o(n),
          "onUpdate:modelValue": c
        }, null, 8, ["label", "model-value"]),
        o(n) ? (z(), re(Ve, { key: 0 }, [
          D(Ne, {
            hint: o(i)("builder.tabs.data.options.APIOptions.keyInAPIHint"),
            label: o(i)("builder.tabs.data.options.APIOptions.keyInAPI"),
            "model-value": (y = o(s)) == null ? void 0 : y.optionsApiKey,
            "onUpdate:modelValue": v[0] || (v[0] = (h) => o(r).updateField(o(d), "optionsApiKey", h))
          }, null, 8, ["hint", "label", "model-value"]),
          D(Ne, {
            label: o(i)("builder.tabs.data.options.APIOptions.inputLabel"),
            "model-value": ((M = o(s)) == null ? void 0 : M.optionsApi) || "",
            "onUpdate:modelValue": v[2] || (v[2] = (h) => o(r).updateField(o(d), "optionsApi", h))
          }, {
            after: L(() => [
              D(se, {
                color: "primary",
                flat: "",
                icon: "mdi-refresh",
                round: "",
                onClick: v[1] || (v[1] = (h) => o(p)(!0))
              })
            ]),
            _: 1
          }, 8, ["label", "model-value"]),
          Ct(ee("div", wc, [
            D(Sc, { APITree: o(u) }, null, 8, ["APITree"]),
            ee("div", null, [
              ee("p", null, J(o(i)("builder.tabs.data.options.APIOptions.info")), 1),
              ee("div", null, [
                D(hi, {
                  modelValue: o(m),
                  "onUpdate:modelValue": v[3] || (v[3] = (h) => Gt(m) ? m.value = h : null),
                  options: [{
                    label: o(i)("builder.tabs.data.options.APIOptions.tree.label"),
                    value: "optionLabel"
                  }]
                }, null, 8, ["modelValue", "options"]),
                ve(" " + J(((w = o(s)) == null ? void 0 : w.optionLabel) || ""), 1)
              ]),
              ee("div", null, [
                D(hi, {
                  modelValue: o(m),
                  "onUpdate:modelValue": v[4] || (v[4] = (h) => Gt(m) ? m.value = h : null),
                  options: [{
                    label: o(i)("builder.tabs.data.options.APIOptions.tree.value"),
                    value: "optionValue"
                  }]
                }, null, 8, ["modelValue", "options"]),
                ve(" " + J(((S = o(s)) == null ? void 0 : S.optionValue) || ""), 1)
              ])
            ])
          ], 512), [
            [Nt, o(f)]
          ])
        ], 64)) : ce("", !0)
      ]);
    };
  }
});
const kc = /* @__PURE__ */ Oe(xc, [["__scopeId", "data-v-325b7ec2"]]), Cc = {
  key: 1,
  class: "noValue"
}, qc = /* @__PURE__ */ Ce({
  __name: "OptionTable",
  setup(e) {
    const t = Me("_uct"), l = Ee(), { isDefaultOption: n, field: a, itemId: i, dependsOnOptionList: r, filterDependsOnOptions: s } = Ke(), d = Lt(), c = G(""), u = (P, $) => P.filter((k) => {
      var g;
      return k.label.toLowerCase().includes($.toString().toLowerCase()) || k.value.toLowerCase().includes($.toString().toLowerCase()) ? !0 : (g = k.displayedBy) == null ? void 0 : g.some((x) => {
        const B = l.options[x];
        return (B == null ? void 0 : B.value.toLowerCase().includes($.toString().toLowerCase())) || (B == null ? void 0 : B.label.toLowerCase().includes($.toString().toLowerCase()));
      });
    }), m = G(!1), p = G(!1), f = G(!1), _ = G(!1), v = G(Yt()), y = G(!1), M = G([
      {
        field: "default",
        label: t("builder.tabs.data.dataTable.headers.defaultValue"),
        name: "default",
        align: "left",
        sortable: !1
      },
      {
        field: "label",
        label: t("builder.tabs.data.dataTable.headers.label"),
        name: "label",
        align: "left",
        sortable: !0
      },
      {
        field: () => "",
        label: t("builder.tabs.data.dataTable.headers.actions"),
        name: "actions",
        align: "left",
        sortable: !1
      }
    ]), w = () => {
      var $, k, g;
      if (!d.optionValueIsId) {
        ($ = M.value) == null || $.splice(
          2,
          0,
          {
            field: "value",
            label: t("builder.tabs.data.dataTable.headers.value"),
            name: "value",
            align: "left",
            sortable: !0
          }
        );
        return;
      }
      const P = (k = M.value) == null ? void 0 : k.findIndex((x) => x.name === "value");
      P && P !== -1 && ((g = M.value) == null || g.splice(P, 1));
    }, S = () => {
      var $, k, g, x, B;
      if (($ = a.value) != null && $.dependsOn) {
        (g = M.value) == null || g.splice(
          ((k = M.value) == null ? void 0 : k.length) === 4 ? 3 : 4,
          0,
          {
            field: "dependsOn",
            label: t("builder.tabs.data.dataTable.headers.displayBy"),
            name: "dependsOn",
            align: "left",
            sortable: !0
          }
        );
        return;
      }
      const P = (x = M.value) == null ? void 0 : x.findIndex((q) => q.name === "dependsOn");
      P && P !== -1 && ((B = M.value) == null || B.splice(P, 1));
    }, h = () => {
      var $, k, g, x;
      if (($ = a.value) != null && $.optionsHasTooltip) {
        (k = M.value) == null || k.splice(
          3,
          0,
          {
            field: "tooltip",
            label: t("builder.tabs.data.options.tooltip.tableHeader"),
            name: "tooltip",
            align: "left",
            sortable: !0
          }
        );
        return;
      }
      const P = (g = M.value) == null ? void 0 : g.findIndex((B) => B.name === "tooltip");
      P && P !== -1 && ((x = M.value) == null || x.splice(P, 1), l.resetOptionsTooltip(i.value));
    };
    wt(() => {
      var P;
      y.value = !!((P = a.value) != null && P.optionsApi), w(), S(), h();
    }), me(() => d.optionValueIsId, w), me(() => {
      var P;
      return (P = a.value) == null ? void 0 : P.dependsOn;
    }, S), me(() => {
      var P;
      return (P = a.value) == null ? void 0 : P.optionsHasTooltip;
    }, h);
    const C = b(() => {
      var P, $;
      return (($ = (P = a.value) == null ? void 0 : P.options) == null ? void 0 : $.map((k) => l.options[k])) || [];
    }), T = (P) => {
      var $, k;
      return typeof P == "string" ? ($ = l.options[P]) == null ? void 0 : $.label : "label" in P ? P.label : "id" in P ? (k = l.options[P.id]) == null ? void 0 : k.label : "";
    }, I = (P, $) => {
      const k = l.options[$], g = typeof P == "string" ? P : P.id;
      k != null && k.displayedBy && l.updateOption(
        $,
        "displayedBy",
        k.displayedBy.filter((x) => g !== x)
      );
    }, E = G(""), { updateConditionValue: A } = On(), O = (P, $) => {
      A(P, E.value, $), l.updateOption(P, "value", $);
    };
    return (P, $) => {
      var k;
      return z(), re("section", null, [
        D(uc, {
          modelValue: m.value,
          "onUpdate:modelValue": $[0] || ($[0] = (g) => m.value = g)
        }, null, 8, ["modelValue"]),
        D(fc, {
          modelValue: p.value,
          "onUpdate:modelValue": $[1] || ($[1] = (g) => p.value = g)
        }, null, 8, ["modelValue"]),
        D(hc, {
          modelValue: f.value,
          "onUpdate:modelValue": $[2] || ($[2] = (g) => f.value = g)
        }, null, 8, ["modelValue"]),
        D(gc, {
          modelValue: _.value,
          "onUpdate:modelValue": $[3] || ($[3] = (g) => _.value = g),
          "is-a-p-i": y.value,
          "onUpdate:isAPI": $[4] || ($[4] = (g) => y.value = g)
        }, null, 8, ["modelValue", "is-a-p-i"]),
        ee("h2", null, J(o(t)("builder.tabs.data.options.title")), 1),
        D(kc, {
          "is-a-p-i-options": y.value,
          "onUpdate:isAPIOptions": $[5] || ($[5] = (g) => y.value = g),
          "option-list": C.value,
          onDisplayEmptyDialog: $[6] || ($[6] = (g) => _.value = !0)
        }, null, 8, ["is-a-p-i-options", "option-list"]),
        D(at, {
          label: o(t)("builder.tabs.data.options.tooltip.toggle"),
          "model-value": ((k = o(a)) == null ? void 0 : k.optionsHasTooltip) || !1,
          "onUpdate:modelValue": $[7] || ($[7] = (g) => o(l).updateField(o(i), "optionsHasTooltip", g))
        }, null, 8, ["label", "model-value"]),
        y.value ? ce("", !0) : (z(), ae(an, {
          key: v.value,
          columns: M.value,
          filter: c.value,
          "filter-method": u,
          rows: C.value,
          flat: "",
          "hide-selected-banner": "",
          "row-key": "id"
        }, {
          top: L(() => [
            D(Ne, {
              modelValue: c.value,
              "onUpdate:modelValue": $[8] || ($[8] = (g) => c.value = g),
              label: o(t)("builder.tabs.data.options.search"),
              dense: "",
              type: "search"
            }, {
              append: L(() => [
                D(Qe, { name: "mdi-magnify" })
              ]),
              _: 1
            }, 8, ["modelValue", "label"]),
            D(va),
            ee("div", null, [
              D(se, {
                color: "primary",
                dense: "",
                icon: "mdi-plus",
                round: "",
                onClick: $[9] || ($[9] = (g) => m.value = !0)
              }, {
                default: L(() => [
                  D(nt, null, {
                    default: L(() => [
                      ve(J(o(t)("builder.tabs.data.dialogNewOption.title")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              D(se, {
                color: "primary",
                dense: "",
                icon: "mdi-sort-alphabetical-descending",
                round: "",
                onClick: $[10] || ($[10] = (g) => p.value = !0)
              }, {
                default: L(() => [
                  D(nt, null, {
                    default: L(() => [
                      ve(J(o(t)("builder.tabs.data.dialogSort.title")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              D(se, {
                color: "primary",
                dense: "",
                icon: "mdi-file-plus",
                round: "",
                onClick: $[11] || ($[11] = (g) => f.value = !0)
              }, {
                default: L(() => [
                  D(nt, null, {
                    default: L(() => [
                      ve(J(o(t)("builder.tabs.data.fileSystem.title")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              D(se, {
                color: "primary",
                dense: "",
                icon: "mdi-playlist-remove",
                round: "",
                onClick: $[12] || ($[12] = (g) => _.value = !0)
              }, {
                default: L(() => [
                  D(nt, null, {
                    default: L(() => [
                      ve(J(o(t)("builder.tabs.data.empty.title")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          "body-cell-default": L((g) => [
            D(kt, { props: g }, {
              default: L(() => [
                D(at, {
                  "model-value": o(n)(g.row),
                  "onUpdate:modelValue": (x) => {
                    var B;
                    return o(l).updateField(
                      ((B = o(a)) == null ? void 0 : B.id) || "",
                      "defaultOption",
                      x ? g.row.id : ""
                    );
                  }
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-tooltip": L((g) => [
            D(kt, { props: g }, {
              default: L(() => [
                g.row.tooltip ? (z(), re(Ve, { key: 0 }, [
                  ve(J(g.row.tooltip), 1)
                ], 64)) : (z(), re("span", Cc, J(o(t)("builder.tabs.data.options.tooltip.noValue")), 1)),
                D(tn, {
                  "model-value": g.row.tooltip,
                  "onUpdate:modelValue": (x) => o(l).updateOption(g.row.id, "tooltip", x)
                }, {
                  default: L((x) => [
                    D(Ne, {
                      modelValue: x.value,
                      "onUpdate:modelValue": (B) => x.value = B,
                      autofocus: "",
                      dense: "",
                      onKeyup: [
                        dl(nl(x.set, ["stop"]), ["enter"]),
                        dl(nl(x.cancel, ["stop"]), ["esc"])
                      ]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                  ]),
                  _: 2
                }, 1032, ["model-value", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-label": L((g) => [
            D(kt, {
              key: "label",
              props: g
            }, {
              default: L(() => [
                ve(J(g.row.label) + " ", 1),
                D(tn, {
                  "model-value": g.row.label,
                  "onUpdate:modelValue": (x) => o(l).updateOption(g.row.id, "label", x)
                }, {
                  default: L((x) => [
                    D(Ne, {
                      modelValue: x.value,
                      "onUpdate:modelValue": (B) => x.value = B,
                      autofocus: "",
                      dense: "",
                      onKeyup: [
                        dl(nl(x.set, ["stop"]), ["enter"]),
                        dl(nl(x.cancel, ["stop"]), ["esc"])
                      ]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                  ]),
                  _: 2
                }, 1032, ["model-value", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-value": L((g) => [
            D(kt, {
              key: "value",
              props: g
            }, {
              default: L(() => [
                ve(J(g.row.value) + " ", 1),
                D(tn, {
                  modelValue: g.row.value,
                  "onUpdate:modelValue": [(x) => g.row.value = x, (x) => O(g.row.id, x)],
                  onHide: $[13] || ($[13] = (x) => E.value = ""),
                  onShow: (x) => E.value = g.row.value
                }, {
                  default: L((x) => [
                    D(Ne, {
                      modelValue: x.value,
                      "onUpdate:modelValue": (B) => x.value = B,
                      autofocus: "",
                      dense: "",
                      onKeyup: [
                        dl(nl(x.set, ["stop"]), ["enter"]),
                        dl(nl(x.cancel, ["stop"]), ["esc"])
                      ]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onShow"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-dependsOn": L((g) => [
            D(kt, { props: g }, {
              default: L(() => [
                D(Rt, {
                  "model-value": g.row.displayedBy,
                  options: o(r),
                  dense: "",
                  "emit-value": "",
                  "map-options": "",
                  multiple: "",
                  "new-value-mode": "add-unique",
                  "option-value": "id",
                  "use-chips": "",
                  "use-input": "",
                  onFilter: o(s),
                  "onUpdate:modelValue": (x) => o(l).updateOption(g.row.id, "displayedBy", x)
                }, {
                  option: L(({ itemProps: x, opt: B, selected: q, toggleOption: Y }) => [
                    D(Tl, lo(no(x)), {
                      default: L(() => [
                        D(jt, { side: "" }, {
                          default: L(() => [
                            D(Bt, {
                              "model-value": q,
                              "onUpdate:modelValue": (K) => Y(B)
                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        D(jt, null, {
                          default: L(() => [
                            D(ql, null, {
                              default: L(() => [
                                ve(J(B.label), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  "selected-item": L(({ opt: x }) => [
                    D(ya, {
                      label: T(x),
                      removable: "",
                      onRemove: (B) => I(x, g.row.id)
                    }, null, 8, ["label", "onRemove"])
                  ]),
                  _: 2
                }, 1032, ["model-value", "options", "onFilter", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-actions": L((g) => [
            D(kt, {
              key: "actions",
              props: g
            }, {
              default: L(() => [
                D(se, {
                  color: "primary",
                  dense: "",
                  flat: "",
                  icon: "mdi-trash-can",
                  round: "",
                  onClick: (x) => o(l).removeOption(g.row.id, o(i))
                }, null, 8, ["onClick"]),
                g.rowIndex > 0 ? (z(), ae(se, {
                  key: 0,
                  color: "primary",
                  dense: "",
                  flat: "",
                  icon: "mdi-arrow-up",
                  round: "",
                  onClick: (x) => o(l).moveOption(o(i), g.rowIndex, "up")
                }, null, 8, ["onClick"])) : ce("", !0),
                g.rowIndex < C.value.length - 1 ? (z(), ae(se, {
                  key: 1,
                  color: "primary",
                  dense: "",
                  flat: "",
                  icon: "mdi-arrow-down",
                  round: "",
                  onClick: (x) => o(l).moveOption(o(i), g.rowIndex, "down")
                }, null, 8, ["onClick"])) : ce("", !0)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["columns", "filter", "rows"]))
      ]);
    };
  }
});
const Vc = /* @__PURE__ */ Oe(qc, [["__scopeId", "data-v-16e32f05"]]), Tc = { key: 0 }, Mc = /* @__PURE__ */ Ce({
  __name: "SelectRadio",
  setup(e) {
    const t = Me("_uct"), { field: l, isSelectable: n, itemId: a } = Ke(), i = Ee();
    return (r, s) => {
      var d;
      return z(), re("section", null, [
        o(n) ? (z(), re("section", Tc, [
          ee("h2", null, J(o(t)("builder.tabs.data.multipleTitle")), 1),
          D(at, {
            label: o(t)("builder.tabs.data.multiple"),
            "model-value": ((d = o(l)) == null ? void 0 : d.multiple) || !1,
            "onUpdate:modelValue": s[0] || (s[0] = (c) => o(i).updateField(o(a), "multiple", c))
          }, null, 8, ["label", "model-value"])
        ])) : ce("", !0),
        D(Ld),
        D(Vc)
      ]);
    };
  }
});
const Dc = /* @__PURE__ */ Oe(Mc, [["__scopeId", "data-v-9154c953"]]), Ic = /* @__PURE__ */ Ce({
  __name: "DataTab",
  setup(e) {
    const { control: t } = Ke(), l = b(() => {
      var n;
      return ((n = t.value) == null ? void 0 : n.usfType) === "layout";
    });
    return (n, a) => (z(), re("section", null, [
      l.value ? (z(), ae(Bd, { key: 0 })) : (z(), ae(Dc, { key: 1 }))
    ]));
  }
}), Yr = /* @__PURE__ */ Ce({
  __name: "InputVisibility",
  setup(e) {
    const t = Me("_uct"), l = Ee(), { field: n, itemId: a } = Ke();
    return (i, r) => {
      var s, d;
      return z(), re("section", null, [
        ee("h2", null, J(o(t)("builder.tabs.display.visibility.title")), 1),
        ee("div", null, [
          D(at, {
            label: o(t)("builder.tabs.display.visibility.exist"),
            "model-value": ((s = o(n)) == null ? void 0 : s.exist) || !1,
            colot: "primary",
            "onUpdate:modelValue": r[0] || (r[0] = (c) => o(l).updateField(o(a), "exist", c))
          }, null, 8, ["label", "model-value"]),
          D(at, {
            label: o(t)("builder.tabs.display.visibility.visible"),
            "model-value": ((d = o(n)) == null ? void 0 : d.visible) || !1,
            colot: "primary",
            "onUpdate:modelValue": r[1] || (r[1] = (c) => o(l).updateField(o(a), "visible", c))
          }, null, 8, ["label", "model-value"])
        ])
      ]);
    };
  }
}), $c = { class: "tabSettingsContainer" }, Fc = { key: 0 }, Ac = { key: 0 }, Oc = /* @__PURE__ */ Ce({
  __name: "InputRepeat",
  props: {
    isDisabled: { type: Boolean, default: !1 },
    inRow: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { inRow: l } = ct(t), n = Me("_uct"), a = Ee(), { field: i, itemId: r, isSelectElement: s } = Ke(), d = (f, _) => {
      var v, y;
      if (f ? (a.updateField(_ ?? r.value, "repeatable", !0), a.updateField(_ ?? r.value, "maxRepeat", 2), a.updateField(_ ?? r.value, "defaultRepeat", 1), s.value && a.updateField(_ ?? r.value, "interdependentFields", !1)) : (a.removeAttribute(_ ?? r.value, "repeatable"), a.removeAttribute(_ ?? r.value, "maxRepeat"), a.removeAttribute(_ ?? r.value, "defaultRepeat"), s.value && a.removeAttribute(_ ?? r.value, "interdependentFields")), l.value && f && !_)
        for (const M of ((v = i.value) == null ? void 0 : v.fields) ?? [])
          for (const w of ((y = a.fields[M]) == null ? void 0 : y.fields) ?? [])
            d(!1, w);
    }, c = b(() => {
      var f;
      return ((f = i.value) == null ? void 0 : f.maxRepeat) === 2;
    }), u = b(() => {
      var f;
      return ((f = i.value) == null ? void 0 : f.defaultRepeat) === 1;
    }), m = b(() => {
      var f, _;
      return ((f = i.value) == null ? void 0 : f.defaultRepeat) === ((_ = i.value) == null ? void 0 : _.maxRepeat);
    }), p = (f) => {
      var _, v, y, M;
      a.updateField(r.value, "maxRepeatIsOptionNumber", f), f ? a.updateField(
        r.value,
        "maxRepeat",
        ((v = (_ = i.value) == null ? void 0 : _.options) == null ? void 0 : v.length) ?? (((y = i.value) == null ? void 0 : y.defaultRepeat) ?? 1) + 1
      ) : a.updateField(r.value, "maxRepeat", (((M = i.value) == null ? void 0 : M.defaultRepeat) ?? 1) + 1);
    };
    return (f, _) => {
      var v, y, M, w, S;
      return z(), re("section", {
        class: Ft({ isDisabled: f.isDisabled })
      }, [
        ee("h2", null, J(o(n)("builder.tabs.display.repeatable.title")), 1),
        ee("div", $c, [
          D(at, {
            disable: f.isDisabled,
            label: o(n)("builder.tabs.display.repeatable.repeatable"),
            "model-value": ((v = o(i)) == null ? void 0 : v.repeatable) || !1,
            color: "primary",
            "onUpdate:modelValue": _[0] || (_[0] = (h) => d(h))
          }, null, 8, ["disable", "label", "model-value"]),
          (y = o(i)) != null && y.repeatable ? (z(), re("div", Fc, [
            ee("div", null, [
              D(Ne, {
                label: o(n)("builder.tabs.display.repeatable.max"),
                "model-value": (M = o(i)) == null ? void 0 : M.maxRepeat,
                readonly: o(s) && ((w = o(i)) == null ? void 0 : w.maxRepeatIsOptionNumber),
                "onUpdate:modelValue": _[3] || (_[3] = (h) => o(a).updateField(o(r), "maxRepeat", h))
              }, {
                prepend: L(() => {
                  var h;
                  return [
                    ee("div", null, [
                      D(se, {
                        disable: c.value || o(s) && ((h = o(i)) == null ? void 0 : h.maxRepeatIsOptionNumber),
                        dense: "",
                        flat: "",
                        icon: "mdi-minus",
                        round: "",
                        onClick: _[1] || (_[1] = (C) => {
                          var T;
                          return o(a).updateField(o(r), "maxRepeat", ((T = o(i)) == null ? void 0 : T.maxRepeat) - 1);
                        })
                      }, null, 8, ["disable"]),
                      c.value ? (z(), ae(nt, { key: 0 }, {
                        default: L(() => [
                          ve(J(o(n)("builder.tabs.display.repeatable.tooltips.repeatMin")), 1)
                        ]),
                        _: 1
                      })) : ce("", !0)
                    ])
                  ];
                }),
                append: L(() => {
                  var h;
                  return [
                    D(se, {
                      disable: o(s) && ((h = o(i)) == null ? void 0 : h.maxRepeatIsOptionNumber),
                      dense: "",
                      flat: "",
                      icon: "mdi-plus",
                      round: "",
                      onClick: _[2] || (_[2] = (C) => {
                        var T;
                        return o(a).updateField(o(r), "maxRepeat", ((T = o(i)) == null ? void 0 : T.maxRepeat) + 1);
                      })
                    }, null, 8, ["disable"])
                  ];
                }),
                _: 1
              }, 8, ["label", "model-value", "readonly"]),
              D(Ne, {
                label: o(n)("builder.tabs.display.repeatable.initial"),
                "model-value": (S = o(i)) == null ? void 0 : S.defaultRepeat,
                "onUpdate:modelValue": _[6] || (_[6] = (h) => o(a).updateField(o(r), "defaultRepeat", h))
              }, {
                prepend: L(() => [
                  ee("div", null, [
                    D(se, {
                      disable: u.value,
                      dense: "",
                      flat: "",
                      icon: "mdi-minus",
                      round: "",
                      onClick: _[4] || (_[4] = (h) => {
                        var C;
                        return o(a).updateField(o(r), "defaultRepeat", ((C = o(i)) == null ? void 0 : C.defaultRepeat) - 1);
                      })
                    }, null, 8, ["disable"]),
                    u.value ? (z(), ae(nt, { key: 0 }, {
                      default: L(() => [
                        ve(J(o(n)("builder.tabs.display.repeatable.tooltips.defaultRepeatMin")), 1)
                      ]),
                      _: 1
                    })) : ce("", !0)
                  ])
                ]),
                append: L(() => [
                  ee("div", null, [
                    D(se, {
                      disable: m.value,
                      dense: "",
                      flat: "",
                      icon: "mdi-plus",
                      round: "",
                      onClick: _[5] || (_[5] = (h) => {
                        var C;
                        return o(a).updateField(o(r), "defaultRepeat", ((C = o(i)) == null ? void 0 : C.defaultRepeat) + 1);
                      })
                    }, null, 8, ["disable"]),
                    m.value ? (z(), ae(nt, { key: 0 }, {
                      default: L(() => [
                        ve(J(o(n)("builder.tabs.display.repeatable.tooltips.defaultRepeatMax")), 1)
                      ]),
                      _: 1
                    })) : ce("", !0)
                  ])
                ]),
                _: 1
              }, 8, ["label", "model-value"])
            ]),
            o(s) ? (z(), re("div", Ac, [
              D(Bt, {
                label: o(n)("builder.tabs.display.repeatable.interdependentFields"),
                "model-value": o(i).interdependentFields || !1,
                "onUpdate:modelValue": _[7] || (_[7] = (h) => o(a).updateField(o(r), "interdependentFields", h))
              }, null, 8, ["label", "model-value"]),
              D(Bt, {
                label: o(n)("builder.tabs.display.repeatable.maxRepeatIsOptionNumber"),
                "model-value": o(i).maxRepeatIsOptionNumber || !1,
                "onUpdate:modelValue": p
              }, null, 8, ["label", "model-value"])
            ])) : ce("", !0)
          ])) : ce("", !0)
        ]),
        D(nt, null, {
          default: L(() => [
            ve(J(o(n)("builder.tabs.display.repeatable.disabled")), 1)
          ]),
          _: 1
        })
      ], 2);
    };
  }
});
const jr = /* @__PURE__ */ Oe(Oc, [["__scopeId", "data-v-6fc642c9"]]), Bc = { class: "inlineBox" }, Lc = /* @__PURE__ */ Ce({
  __name: "InputContent",
  setup(e) {
    const t = Me("_uct"), l = Ee(), { field: n, itemId: a, isBoxInput: i, onUpdateNameWithLabel: r } = Ke();
    return (s, d) => {
      var c, u, m, p, f, _;
      return z(), re("section", null, [
        ee("header", null, [
          ee("h2", null, J(o(t)("builder.tabs.display.content.title")), 1),
          D(Qe, { name: "mdi-help-circle-outline" }, {
            default: L(() => [
              D(nt, null, {
                default: L(() => [
                  ve(J(o(t)("builder.tabs.display.content.tooltipTitle")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        ee("form", null, [
          D(Ne, {
            label: o(t)("builder.tabs.display.content.label"),
            "model-value": (c = o(n)) == null ? void 0 : c.label,
            dense: "",
            onBlur: o(r),
            "onUpdate:modelValue": d[0] || (d[0] = (v) => o(l).updateField(o(a), "label", v))
          }, null, 8, ["label", "model-value", "onBlur"]),
          o(i) ? (z(), ae(Ne, {
            key: 0,
            label: o(t)("builder.tabs.display.content.placeholder"),
            "model-value": (u = o(n)) == null ? void 0 : u.placeholder,
            dense: "",
            "onUpdate:modelValue": d[1] || (d[1] = (v) => o(l).updateField(o(a), "placeholder", v))
          }, null, 8, ["label", "model-value"])) : ce("", !0),
          ee("div", Bc, [
            D(Ne, {
              label: o(t)("builder.tabs.display.content.hint"),
              "model-value": (m = o(n)) == null ? void 0 : m.hint,
              dense: "",
              "onUpdate:modelValue": d[2] || (d[2] = (v) => o(l).updateField(o(a), "hint", v))
            }, null, 8, ["label", "model-value"]),
            D(Bt, {
              "model-value": ((p = o(n)) == null ? void 0 : p.persistentHint) || !1,
              dense: "",
              "onUpdate:modelValue": d[3] || (d[3] = (v) => o(l).updateField(o(a), "persistentHint", v))
            }, {
              default: L(() => [
                D(nt, null, {
                  default: L(() => [
                    ve(J(o(t)("builder.tabs.display.content.hintPersistent")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model-value"])
          ]),
          o(i) ? (z(), re(Ve, { key: 1 }, [
            D(Ne, {
              label: o(t)("builder.tabs.display.content.prefix"),
              "model-value": (f = o(n)) == null ? void 0 : f.prefix,
              dense: "",
              "onUpdate:modelValue": d[4] || (d[4] = (v) => o(l).updateField(o(a), "prefix", v))
            }, null, 8, ["label", "model-value"]),
            D(Ne, {
              label: o(t)("builder.tabs.display.content.suffix"),
              "model-value": (_ = o(n)) == null ? void 0 : _.suffix,
              dense: "",
              "onUpdate:modelValue": d[5] || (d[5] = (v) => o(l).updateField(o(a), "suffix", v))
            }, null, 8, ["label", "model-value"])
          ], 64)) : ce("", !0)
        ])
      ]);
    };
  }
});
const Ec = /* @__PURE__ */ Oe(Lc, [["__scopeId", "data-v-4d04dd91"]]), Nr = {
  radio: gn,
  checkbox: Bt,
  toggle: at
}, Pc = Object.keys(Nr), Wr = De({
  name: "QOptionGroup",
  props: {
    ...Tt,
    modelValue: {
      required: !0
    },
    options: {
      type: Array,
      validator: (e) => e.every((t) => "value" in t && "label" in t)
    },
    name: String,
    type: {
      default: "radio",
      validator: (e) => Pc.includes(e)
    },
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    size: String,
    leftLabel: Boolean,
    inline: Boolean,
    disable: Boolean
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t, slots: l }) {
    const { proxy: { $q: n } } = Ae(), a = Array.isArray(e.modelValue);
    e.type === "radio" ? a === !0 && console.error("q-option-group: model should not be array") : a === !1 && console.error("q-option-group: model should be array in your case");
    const i = Mt(e, n), r = b(() => Nr[e.type]), s = b(
      () => "q-option-group q-gutter-x-sm" + (e.inline === !0 ? " q-option-group--inline" : "")
    ), d = b(() => {
      const u = { role: "group" };
      return e.type === "radio" && (u.role = "radiogroup", e.disable === !0 && (u["aria-disabled"] = "true")), u;
    });
    function c(u) {
      t("update:modelValue", u);
    }
    return () => V("div", {
      class: s.value,
      ...d.value
    }, e.options.map((u, m) => {
      const p = l["label-" + m] !== void 0 ? () => l["label-" + m](u) : l.label !== void 0 ? () => l.label(u) : void 0;
      return V("div", [
        V(r.value, {
          modelValue: e.modelValue,
          val: u.value,
          name: u.name === void 0 ? e.name : u.name,
          disable: e.disable || u.disable,
          label: p === void 0 ? u.label : null,
          leftLabel: u.leftLabel === void 0 ? e.leftLabel : u.leftLabel,
          color: u.color === void 0 ? e.color : u.color,
          checkedIcon: u.checkedIcon,
          uncheckedIcon: u.uncheckedIcon,
          dark: u.dark || i.value,
          size: u.size === void 0 ? e.size : u.size,
          dense: e.dense,
          keepColor: u.keepColor === void 0 ? e.keepColor : u.keepColor,
          "onUpdate:modelValue": c
        }, p)
      ]);
    }));
  }
}), yo = (e) => {
  const t = b(() => {
    var r;
    return ((r = e.value) == null ? void 0 : r.type) === "wysiwyg";
  }), l = [
    { icon: "format-align-left", value: "left" },
    { icon: "format-align-center", value: "center" },
    { icon: "format-align-right", value: "right" },
    { icon: "format-align-justify", value: "justify" },
    { icon: "format-bold", value: "bold" },
    { icon: "format-italic", value: "italic" },
    { icon: "format-strikethrough-variant", value: "strike" },
    { icon: "format-subscript", value: "subscript" },
    { icon: "format-superscript", value: "superscript" },
    { icon: "minus", value: "hr" },
    { icon: "link", value: "link" },
    { icon: "unfold-more-vertical", value: "formatting" },
    { icon: "format-size", value: "fontSize" },
    { icon: "format-clear", value: "removeFormat" },
    { icon: "format-quote-close", value: "quote" },
    { icon: "format-list-numbered", value: "ordered" },
    { icon: "format-list-bulleted", value: "unordered" },
    { icon: "format-indent-decrease", value: "outdent" },
    { icon: "format-indent-increase", value: "indent" },
    { icon: "redo", value: "redo" },
    { icon: "undo", value: "undo" }
  ], { iconSet: n, lang: a } = ho(), i = b(() => {
    var f, _, v;
    if (((f = e.value) == null ? void 0 : f.type) === "textarea" || !((v = (_ = e.value) == null ? void 0 : _.WYSIWYGSettings) != null && v.length))
      return [];
    const r = [], s = [], d = [], c = [], u = [], m = [], p = [];
    return e.value.WYSIWYGSettings.includes("left") && s.push("left"), e.value.WYSIWYGSettings.includes("center") && s.push("center"), e.value.WYSIWYGSettings.includes("right") && s.push("right"), e.value.WYSIWYGSettings.includes("justify") && s.push("justify"), s.length && r.push(s), e.value.WYSIWYGSettings.includes("bold") && d.push("bold"), e.value.WYSIWYGSettings.includes("italic") && d.push("italic"), e.value.WYSIWYGSettings.includes("strike") && d.push("strike"), e.value.WYSIWYGSettings.includes("subscript") && d.push("subscript"), e.value.WYSIWYGSettings.includes("superscript") && d.push("superscript"), d.length && r.push(d), e.value.WYSIWYGSettings.includes("hr") && c.push("hr"), e.value.WYSIWYGSettings.includes("link") && c.push("link"), c.length && r.push(c), e.value.WYSIWYGSettings.includes("formatting") && u.push({
      label: a.editor.formatting,
      icon: n.editor.formatting,
      list: "no-icons",
      options: [
        "p",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "code"
      ]
    }), e.value.WYSIWYGSettings.includes("fontSize") && u.push({
      label: a.editor.fontSize,
      icon: n.editor.fontSize,
      fixedLabel: !0,
      fixedIcon: !0,
      list: "no-icons",
      options: [
        "size-1",
        "size-2",
        "size-3",
        "size-4",
        "size-5",
        "size-6",
        "size-7"
      ]
    }), e.value.WYSIWYGSettings.includes("removeFormat") && u.push("removeFormat"), u.length && r.push(u), e.value.WYSIWYGSettings.includes("quote") && m.push("quote"), e.value.WYSIWYGSettings.includes("ordered") && m.push("ordered"), e.value.WYSIWYGSettings.includes("unordered") && m.push("unordered"), e.value.WYSIWYGSettings.includes("outdent") && m.push("outdent"), e.value.WYSIWYGSettings.includes("indent") && m.push("indent"), m.length && r.push(m), e.value.WYSIWYGSettings.includes("undo") && p.push("undo"), e.value.WYSIWYGSettings.includes("redo") && p.push("redo"), p.length && r.push(p), r;
  });
  return {
    isWYSIWYG: t,
    optionGroupList: l,
    toolbar: i
  };
}, Rc = {
  key: 4,
  class: "toggleContainer"
}, zc = /* @__PURE__ */ Ce({
  __name: "InputStyle",
  setup(e) {
    const t = Me("_uct"), l = Ee(), {
      control: n,
      field: a,
      hasAStyleOption: i,
      hasATypeOption: r,
      isBoxInput: s,
      isRadioGroup: d,
      isSelect: c,
      isSelectable: u,
      isTextArea: m,
      isWYSIWYG: p,
      itemId: f,
      typeIsDate: _
    } = Ke(), v = b(() => {
      var M, w;
      return ((w = (M = n.value) == null ? void 0 : M.types) == null ? void 0 : w.map((S) => {
        var h;
        return {
          label: t(`builder.tabs.display.type.${((h = S.label) == null ? void 0 : h.toLowerCase()) || ""}`),
          value: S.value
        };
      })) || [];
    });
    me(() => {
      var M;
      return (M = a.value) == null ? void 0 : M.type;
    }, () => {
      m.value && (p.value ? (l.updateField(f.value, "filled", null), l.updateField(f.value, "outlined", null), l.updateField(f.value, "rounded", null), l.updateField(f.value, "clearable", null), l.updateField(f.value, "autoGrow", null), l.updateField(f.value, "rows", null)) : l.updateField(
        f.value,
        "WYSIWYGSettings",
        ["left", "center", "right", "justify", "bold", "italic", "strike", "undo", "redo"]
      ));
    });
    const { optionGroupList: y } = yo(a);
    return (M, w) => {
      var S, h, C, T, I, E, A, O, P, $, k, g, x, B;
      return z(), re("section", null, [
        ee("header", null, [
          ee("h2", null, J(o(t)("builder.tabs.display.style.title")), 1)
        ]),
        ee("form", null, [
          o(r) ? (z(), ae(Rt, {
            key: 0,
            label: o(t)("builder.tabs.display.style.type"),
            "model-value": (S = o(a)) == null ? void 0 : S.type,
            options: v.value,
            dense: "",
            "emit-value": "",
            "map-options": "",
            "option-label": "label",
            "option-value": "value",
            "onUpdate:modelValue": w[0] || (w[0] = (q) => o(l).updateField(o(f), "type", q))
          }, null, 8, ["label", "model-value", "options"])) : ce("", !0),
          o(i) && o(_) ? (z(), ae(Rt, {
            key: 1,
            label: o(t)("builder.tabs.display.style.style"),
            "model-value": (h = o(a)) == null ? void 0 : h.style,
            options: (C = o(n)) == null ? void 0 : C.styles,
            dense: "",
            "emit-value": "",
            "map-options": "",
            "option-label": "label",
            "option-value": "value",
            "onUpdate:modelValue": w[1] || (w[1] = (q) => o(l).updateField(o(f), "style", q))
          }, null, 8, ["label", "model-value", "options"])) : ce("", !0),
          o(d) ? (z(), ae(at, {
            key: 2,
            label: o(t)("builder.tabs.display.style.horizontal"),
            "model-value": ((T = o(a)) == null ? void 0 : T.horizontal) || !1,
            color: "primary",
            dense: "",
            "onUpdate:modelValue": w[2] || (w[2] = (q) => o(l).updateField(o(f), "horizontal", q))
          }, null, 8, ["label", "model-value"])) : ce("", !0),
          o(p) ? (z(), ae(Wr, {
            key: 3,
            "model-value": ((I = o(a)) == null ? void 0 : I.WYSIWYGSettings) ?? [],
            options: o(y),
            inline: "",
            type: "checkbox",
            "onUpdate:modelValue": w[3] || (w[3] = (q) => o(l).updateField(o(f), "WYSIWYGSettings", q))
          }, {
            label: L((q) => [
              D(Qe, {
                name: `mdi-${q.icon}`
              }, null, 8, ["name"]),
              ve(" " + J(o(t)(`builder.tabs.display.style.wysiwyg.${q.value}`)), 1)
            ]),
            _: 1
          }, 8, ["model-value", "options"])) : ce("", !0),
          o(s) && !o(p) ? (z(), re("div", Rc, [
            D(at, {
              label: o(t)("builder.tabs.display.style.options.filled"),
              "model-value": ((E = o(a)) == null ? void 0 : E.filled) || !1,
              color: "primary",
              dense: "",
              "onUpdate:modelValue": w[4] || (w[4] = (q) => o(l).updateField(o(f), "filled", q))
            }, null, 8, ["label", "model-value"]),
            D(at, {
              label: o(t)("builder.tabs.display.style.options.outlined"),
              "model-value": ((A = o(a)) == null ? void 0 : A.outlined) || !1,
              color: "primary",
              dense: "",
              "onUpdate:modelValue": w[5] || (w[5] = (q) => o(l).updateField(o(f), "outlined", q))
            }, null, 8, ["label", "model-value"]),
            D(at, {
              label: o(t)("builder.tabs.display.style.options.rounded"),
              "model-value": ((O = o(a)) == null ? void 0 : O.rounded) || !1,
              color: "primary",
              dense: "",
              "onUpdate:modelValue": w[6] || (w[6] = (q) => o(l).updateField(o(f), "rounded", q))
            }, null, 8, ["label", "model-value"]),
            o(_) ? ce("", !0) : (z(), ae(at, {
              key: 0,
              label: o(t)("builder.tabs.display.style.options.clearable"),
              "model-value": ((P = o(a)) == null ? void 0 : P.clearable) || !1,
              color: "primary",
              dense: "",
              "onUpdate:modelValue": w[7] || (w[7] = (q) => o(l).updateField(o(f), "clearable", q))
            }, null, 8, ["label", "model-value"])),
            o(m) ? (z(), ae(at, {
              key: 1,
              label: o(t)("builder.tabs.display.style.options.autoGrow"),
              "model-value": (($ = o(a)) == null ? void 0 : $.autoGrow) || !1,
              color: "primary",
              dense: "",
              "onUpdate:modelValue": w[8] || (w[8] = (q) => o(l).updateField(o(f), "autoGrow", q))
            }, null, 8, ["label", "model-value"])) : ce("", !0),
            o(u) ? (z(), ae(at, {
              key: 2,
              label: o(t)("builder.tabs.display.style.options.chips"),
              "model-value": ((k = o(a)) == null ? void 0 : k.chips) || !1,
              color: "primary",
              dense: "",
              "onUpdate:modelValue": w[9] || (w[9] = (q) => o(l).updateField(o(f), "chips", q))
            }, null, 8, ["label", "model-value"])) : ce("", !0),
            o(c) ? (z(), ae(at, {
              key: 3,
              label: o(t)("builder.tabs.display.style.options.filterable"),
              "model-value": ((g = o(a)) == null ? void 0 : g.filterable) || !1,
              color: "primary",
              dense: "",
              "onUpdate:modelValue": w[10] || (w[10] = (q) => o(l).updateField(o(f), "filterable", q))
            }, null, 8, ["label", "model-value"])) : ce("", !0)
          ])) : ce("", !0),
          o(m) && !((x = o(a)) != null && x.autoGrow) && !o(p) ? (z(), ae(Ne, {
            key: 5,
            label: o(t)("builder.tabs.display.style.options.rows"),
            "model-value": (B = o(a)) == null ? void 0 : B.rows,
            dense: "",
            type: "number",
            "onUpdate:modelValue": w[11] || (w[11] = (q) => o(l).updateField(o(f), "rows", q))
          }, null, 8, ["label", "model-value"])) : ce("", !0)
        ])
      ]);
    };
  }
});
const Uc = /* @__PURE__ */ Oe(zc, [["__scopeId", "data-v-4154402c"]]), Hc = { id: "DisplayInputIcon" }, Yc = {
  href: "https://materialdesignicons.com/",
  target: "_blank"
}, jc = ["href"], Nc = /* @__PURE__ */ Ce({
  __name: "InputIcon",
  setup(e) {
    const t = Me("_uct"), { field: l, itemId: n } = Ke(), a = Ee(), i = Lt();
    return (r, s) => {
      var d, c;
      return z(), re("section", Hc, [
        ee("header", null, [
          ee("h2", null, J(o(t)("builder.tabs.display.icon.title")), 1),
          D(Vl, { class: "bg-info" }, {
            avatar: L(() => [
              D(Qe, { name: "mdi-alert-circle-outline" })
            ]),
            default: L(() => [
              ve(J(o(t)("builder.tabs.display.icon.information.text")) + " ", 1),
              ee("ul", null, [
                ee("li", null, [
                  ee("a", Yc, J(o(t)("builder.tabs.display.icon.information.material")), 1)
                ]),
                (z(!0), re(Ve, null, dt(o(i).iconLibraryList, (u) => (z(), re("li", {
                  key: u.name
                }, [
                  ee("a", {
                    href: u.url,
                    target: "_blank"
                  }, J(u.name), 9, jc)
                ]))), 128))
              ])
            ]),
            _: 1
          })
        ]),
        ee("form", null, [
          D(Ne, {
            label: o(t)("builder.tabs.display.icon.labels.prepend"),
            "model-value": (d = o(l)) == null ? void 0 : d.prependIcon,
            dense: "",
            "onUpdate:modelValue": s[0] || (s[0] = (u) => o(a).updateField(o(n), "prependIcon", u))
          }, null, 8, ["label", "model-value"]),
          D(Ne, {
            label: o(t)("builder.tabs.display.icon.labels.append"),
            "model-value": (c = o(l)) == null ? void 0 : c.appendIcon,
            dense: "",
            "onUpdate:modelValue": s[1] || (s[1] = (u) => o(a).updateField(o(n), "appendIcon", u))
          }, null, 8, ["label", "model-value"])
        ])
      ]);
    };
  }
});
const Wc = /* @__PURE__ */ Oe(Nc, [["__scopeId", "data-v-d4e64f0f"]]), Qc = /* @__PURE__ */ Ce({
  __name: "DisplayInputTab",
  setup(e) {
    const { fieldIsRepeatable: t, parentIsRepeatable: l } = Ke();
    return (n, a) => (z(), re("section", null, [
      D(Yr),
      o(t) ? (z(), ae(jr, {
        key: 0,
        "is-disabled": o(l)
      }, null, 8, ["is-disabled"])) : ce("", !0),
      D(Ec),
      D(Wc),
      D(Uc)
    ]));
  }
});
const Kc = /* @__PURE__ */ Oe(Qc, [["__scopeId", "data-v-675b1121"]]), xl = De({
  name: "QTr",
  props: {
    props: Object,
    noHover: Boolean
  },
  setup(e, { slots: t }) {
    const l = b(
      () => "q-tr" + (e.props === void 0 || e.props.header === !0 ? "" : " " + e.props.__trClass) + (e.noHover === !0 ? " q-tr--no-hover" : "")
    );
    return () => V("tr", { class: l.value }, We(t.default));
  }
}), Qr = (e) => {
  const { field: t, itemId: l, columnSizeSum: n, children: a } = Ke(), i = Ee(), { notify: r } = ho(), s = b(() => {
    var T;
    return ((T = t.value) == null ? void 0 : T.component) === "UsfRow";
  }), d = b(() => {
    var T;
    return ((T = t.value) == null ? void 0 : T.component) === "UsfAccordion";
  }), c = [
    {
      label: e("builder.tabs.display.layout.type.types.row"),
      value: "row"
    },
    {
      label: e("builder.tabs.display.layout.type.types.container"),
      value: "container"
    }
  ], u = b(() => {
    var I, E;
    const T = [
      {
        align: "center",
        field: "id",
        label: "ID",
        name: "id",
        sortable: !1
      }
    ];
    return s.value && (T.push(
      {
        field: () => "",
        label: e(
          ((I = t.value) == null ? void 0 : I.type) === "row" ? "builder.tabs.display.layout.content.name.columns" : "builder.tabs.display.layout.content.name.rows"
        ),
        name: "content",
        sortable: !1
      }
    ), ((E = t.value) == null ? void 0 : E.type) === "row" && T.push({
      align: "center",
      field: "width",
      label: e("builder.tabs.display.layout.width"),
      name: "width",
      sortable: !1
    })), d.value && T.push({
      align: "center",
      field: "title",
      label: e("builder.tabs.display.accordion.dialog.label"),
      name: "title",
      sortable: !1
    }), T;
  }), m = G(!1), p = G("1"), f = G(""), _ = b(() => {
    const T = {
      component: s.value ? "UsfCol" : "UsfPanel",
      fields: [],
      parentId: l.value,
      exist: !0,
      visible: !0
    };
    return s.value && (T.width = p.value), d.value && (T.content = f.value), T;
  }), v = () => {
    var T, I;
    if (s.value) {
      if (((T = t.value) == null ? void 0 : T.type) === "row") {
        n.value < 12 ? (p.value = `${12 - n.value}`, m.value = !0) : r({
          type: "negative",
          textColor: "black",
          message: e("builder.tabs.display.layout.maxSize.cannotOpenAdd")
        });
        return;
      }
      p.value = "12", i.addField(
        l.value,
        ((I = a.value) == null ? void 0 : I.length) || 1,
        _.value,
        !0
      ), p.value = "1";
      return;
    }
    if (d.value) {
      m.value = !0;
      return;
    }
  }, y = () => {
    var T, I;
    s.value && (parseInt(p.value) + n.value <= 12 ? (i.addField(
      l.value,
      ((T = a.value) == null ? void 0 : T.length) || 1,
      _.value,
      !0
    ), m.value = !1, p.value = "1") : r({
      type: "negative",
      textColor: "black",
      message: e("builder.tabs.display.layout.maxSize.cannotAdd")
    })), d.value && (i.addField(
      l.value,
      ((I = a.value) == null ? void 0 : I.length) || 0,
      _.value,
      !0
    ), m.value = !1, f.value = "");
  }, M = (T, I) => {
    var E;
    (E = a.value) != null && E[I] && (parseInt(T) + n.value - parseInt(a.value[I].width || "0") <= 12 ? i.updateField(a.value[I].id, "width", T) : r({
      type: "negative",
      textColor: "black",
      message: e("builder.tabs.display.layout.maxSize.cannotUpdate")
    }));
  }, w = (T, I) => {
    var E;
    (E = a.value) != null && E[I] && i.updateField(a.value[I].id, "content", T);
  }, S = b(() => {
    var T;
    return d.value ? e("builder.tabs.display.accordion.title") : ((T = t.value) == null ? void 0 : T.type) === "row" ? e("builder.tabs.display.layout.content.title.columns") : e("builder.tabs.display.layout.content.title.rows");
  }), h = b(() => {
    var T;
    return d.value ? e("builder.tabs.display.accordion.empty") : ((T = t.value) == null ? void 0 : T.type) === "row" ? e("builder.tabs.display.layout.empty.columns") : e("builder.tabs.display.layout.empty.rows");
  }), C = b(() => {
    var T;
    return d.value ? e("builder.tabs.display.accordion.add") : ((T = t.value) == null ? void 0 : T.type) === "row" ? e("builder.tabs.display.layout.add.column") : e("builder.tabs.display.layout.add.row");
  });
  return {
    childrenListDataTableColumns: u,
    rowTypeSelectOptions: c,
    newColumnDialogDisplayed: m,
    columnNumber: p,
    newPanelTitle: f,
    openNewChildDialog: v,
    addChild: y,
    updateSize: M,
    updatePanelTitle: w,
    title: S,
    empty: h,
    tooltip: C
  };
}, Gc = /* @__PURE__ */ Ce({
  __name: "DisplayAccordionTab",
  setup(e) {
    const t = Me("_uct"), { itemId: l, field: n, children: a } = Ke(), i = Ee();
    wa();
    const {
      addChild: r,
      childrenListDataTableColumns: s,
      newColumnDialogDisplayed: d,
      newPanelTitle: c,
      openNewChildDialog: u,
      title: m,
      tooltip: p,
      updatePanelTitle: f
    } = Qr(t);
    return (_, v) => {
      var y;
      return z(), re(Ve, null, [
        D(ul, {
          modelValue: o(d),
          "onUpdate:modelValue": v[1] || (v[1] = (M) => Gt(d) ? d.value = M : null),
          "cancel-text": o(t)("builder.tabs.display.layout.dialog.actions.cancel"),
          "confirm-text": o(t)("builder.tabs.display.layout.dialog.actions.add"),
          title: o(t)("builder.tabs.display.accordion.dialog.title"),
          onValid: o(r)
        }, {
          default: L(() => [
            D(Ne, {
              modelValue: o(c),
              "onUpdate:modelValue": v[0] || (v[0] = (M) => Gt(c) ? c.value = M : null),
              label: o(t)("builder.tabs.display.accordion.dialog.label")
            }, null, 8, ["modelValue", "label"])
          ]),
          _: 1
        }, 8, ["modelValue", "cancel-text", "confirm-text", "title", "onValid"]),
        ee("section", null, [
          D(Yr, {
            field: o(n),
            "item-id": o(l)
          }, null, 8, ["field", "item-id"]),
          ee("section", null, [
            ee("header", null, [
              ee("h2", null, J(o(m)), 1),
              D(se, {
                color: "primary",
                icon: "mdi-plus",
                round: "",
                size: "sm",
                onClick: o(u)
              }, {
                default: L(() => [
                  D(nt, null, {
                    default: L(() => [
                      ve(J(o(p)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            D(an, {
              columns: o(s),
              rows: o(a),
              "rows-per-page-options": [10, 20, 40],
              flat: ""
            }, {
              header: L((M) => [
                D(xl, { props: M }, {
                  default: L(() => [
                    D(hl, { "auto-width": "" }),
                    (z(!0), re(Ve, null, dt(M.cols, (w) => (z(), ae(hl, {
                      key: w.name,
                      props: M
                    }, {
                      default: L(() => [
                        ve(J(w.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]))), 128)),
                    D(hl, { "auto-width": "" })
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              body: L((M) => [
                D(xl, { props: M }, {
                  default: L(() => [
                    D(kt, { "auto-width": "" }, {
                      default: L(() => {
                        var w;
                        return [
                          D(se, {
                            disable: M.rowIndex === 0,
                            color: "primary",
                            dense: "",
                            flat: "",
                            icon: "mdi-chevron-up",
                            round: "",
                            onClick: (S) => o(i).moveField(o(l), M.rowIndex, "up")
                          }, null, 8, ["disable", "onClick"]),
                          D(se, {
                            disable: M.rowIndex === ((w = o(a)) == null ? void 0 : w.length) - 1,
                            color: "primary",
                            dense: "",
                            flat: "",
                            icon: "mdi-chevron-down",
                            round: "",
                            onClick: (S) => o(i).moveField(o(l), M.rowIndex, "down")
                          }, null, 8, ["disable", "onClick"])
                        ];
                      }),
                      _: 2
                    }, 1024),
                    D(kt, {
                      key: "id",
                      props: M
                    }, {
                      default: L(() => [
                        ve(J(M.row.id), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]),
                    D(kt, {
                      key: "title",
                      props: M
                    }, {
                      default: L(() => [
                        ve(J(M.row.content) + " ", 1),
                        D(tn, {
                          "label-cancel": o(t)("core.buttons.cancel"),
                          "label-set": o(t)("core.buttons.valid"),
                          "model-value": M.row.content,
                          buttons: "",
                          persistent: "",
                          "onUpdate:modelValue": (w) => o(f)(w, M.rowIndex)
                        }, {
                          default: L((w) => [
                            D(Ne, {
                              modelValue: w.value,
                              "onUpdate:modelValue": (S) => w.value = S,
                              autofocus: "",
                              dense: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["label-cancel", "label-set", "model-value", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["props"]),
                    D(kt, { "auto-width": "" }, {
                      default: L(() => [
                        D(se, {
                          color: "primary",
                          dense: "",
                          flat: "",
                          icon: "mdi-trash-can",
                          round: "",
                          onClick: (w) => o(i).removeField(M.row.id, o(l), M.rowIndex)
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ]),
          ee("section", null, [
            ee("header", null, [
              ee("h2", null, J(o(t)("builder.tabs.display.style.title")), 1)
            ]),
            D(at, {
              label: o(t)("builder.tabs.display.accordion.style"),
              "model-value": ((y = o(n)) == null ? void 0 : y.accordionMode) || !1,
              "onUpdate:modelValue": v[2] || (v[2] = (M) => o(i).updateField(o(l), "accordionMode", M))
            }, null, 8, ["label", "model-value"])
          ])
        ])
      ], 64);
    };
  }
});
const Zc = /* @__PURE__ */ Oe(Gc, [["__scopeId", "data-v-372c95ca"]]), Xc = {
  key: 0,
  class: "containerEmpty"
}, Jc = /* @__PURE__ */ Ce({
  __name: "DisplayRowTab",
  setup(e) {
    const t = Me("_uct"), l = Ee(), { control: n, field: a, itemId: i, children: r, columnSizeSum: s, fieldIsRepeatable: d } = Ke(), {
      addChild: c,
      childrenListDataTableColumns: u,
      columnNumber: m,
      empty: p,
      newColumnDialogDisplayed: f,
      openNewChildDialog: _,
      rowTypeSelectOptions: v,
      title: y,
      tooltip: M,
      updateSize: w
    } = Qr(t);
    me(() => {
      var h;
      return (h = a.value) == null ? void 0 : h.type;
    }, () => {
      var C, T, I;
      const h = Math.floor(12 / (((C = r.value) == null ? void 0 : C.length) || 1));
      (I = (T = a.value) == null ? void 0 : T.fields) == null || I.forEach((E) => {
        var A;
        if (((A = a.value) == null ? void 0 : A.type) === "container") {
          l.updateField(E, "width", "12");
          return;
        }
        l.updateField(E, "width", `${h}`);
      });
    });
    const S = (h) => {
      l.updateField(i.value, "hasFieldset", h), h ? l.updateField(i.value, "fieldset", "") : l.removeAttribute(i.value, "fieldset");
    };
    return (h, C) => {
      var T, I, E, A;
      return z(), re(Ve, null, [
        D(ul, {
          modelValue: o(f),
          "onUpdate:modelValue": C[1] || (C[1] = (O) => Gt(f) ? f.value = O : null),
          "cancel-text": o(t)("builder.tabs.display.layout.dialog.actions.cancel"),
          "confirm-text": o(t)("builder.tabs.display.layout.dialog.actions.add"),
          title: o(t)("builder.tabs.display.layout.dialog.title"),
          onValid: o(c)
        }, {
          default: L(() => [
            D(Ne, {
              modelValue: o(m),
              "onUpdate:modelValue": C[0] || (C[0] = (O) => Gt(m) ? m.value = O : null),
              label: o(t)("builder.tabs.display.layout.width"),
              max: 12 - o(s),
              min: "1",
              type: "number"
            }, null, 8, ["modelValue", "label", "max"])
          ]),
          _: 1
        }, 8, ["modelValue", "cancel-text", "confirm-text", "title", "onValid"]),
        ee("section", null, [
          ee("section", null, [
            ee("h2", null, J(o(t)("builder.tabs.display.layout.type.title")), 1),
            D(Rt, {
              label: o(t)("builder.tabs.display.layout.type.selectLabel"),
              "model-value": (T = o(a)) == null ? void 0 : T.type,
              options: o(v),
              colot: "primary",
              "emit-value": "",
              "map-options": "",
              "onUpdate:modelValue": C[2] || (C[2] = (O) => o(l).updateField(o(i), "type", O))
            }, null, 8, ["label", "model-value", "options"])
          ]),
          o(d) ? (z(), ae(jr, {
            key: 0,
            "in-row": ""
          })) : ce("", !0),
          ee("section", null, [
            ee("header", null, [
              ee("h2", null, J(o(t)("builder.tabs.display.layout.fieldset.title")), 1)
            ]),
            D(at, {
              label: o(t)("builder.tabs.display.layout.fieldset.buttonLabel"),
              "model-value": !!((I = o(a)) != null && I.hasFieldset),
              color: "primary",
              "onUpdate:modelValue": S
            }, null, 8, ["label", "model-value"]),
            (E = o(a)) != null && E.hasFieldset ? (z(), ae(Ne, {
              key: 0,
              label: o(t)("builder.tabs.display.layout.fieldset.fieldsetText"),
              "model-value": (A = o(a)) == null ? void 0 : A.fieldset,
              color: "primary",
              "onUpdate:modelValue": C[3] || (C[3] = (O) => o(l).updateField(o(i), "fieldset", O))
            }, null, 8, ["label", "model-value"])) : ce("", !0)
          ]),
          ee("section", null, [
            ee("header", null, [
              ee("h2", null, J(o(y)), 1),
              D(se, {
                color: "primary",
                icon: "mdi-plus",
                round: "",
                size: "sm",
                onClick: o(_)
              }, {
                default: L(() => [
                  D(nt, null, {
                    default: L(() => [
                      ve(J(o(M)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            D(an, {
              columns: o(u),
              rows: o(r),
              "rows-per-page-options": [10, 20, 40],
              flat: ""
            }, {
              header: L((O) => [
                D(xl, { props: O }, {
                  default: L(() => [
                    D(hl, { "auto-width": "" }),
                    (z(!0), re(Ve, null, dt(O.cols, (P) => (z(), ae(hl, {
                      key: P.name,
                      props: O
                    }, {
                      default: L(() => [
                        ve(J(P.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]))), 128)),
                    D(hl, { "auto-width": "" })
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              body: L((O) => [
                D(xl, { props: O }, {
                  default: L(() => [
                    D(kt, { "auto-width": "" }, {
                      default: L(() => {
                        var P;
                        return [
                          D(se, {
                            disable: O.rowIndex === 0,
                            color: "primary",
                            dense: "",
                            flat: "",
                            icon: "mdi-chevron-up",
                            round: "",
                            onClick: ($) => o(l).moveField(o(i), O.rowIndex, "up")
                          }, null, 8, ["disable", "onClick"]),
                          D(se, {
                            disable: O.rowIndex === ((P = o(r)) == null ? void 0 : P.length) - 1,
                            color: "primary",
                            dense: "",
                            flat: "",
                            icon: "mdi-chevron-down",
                            round: "",
                            onClick: ($) => o(l).moveField(o(i), O.rowIndex, "down")
                          }, null, 8, ["disable", "onClick"])
                        ];
                      }),
                      _: 2
                    }, 1024),
                    D(kt, {
                      key: "id",
                      props: O
                    }, {
                      default: L(() => [
                        ve(J(O.row.id), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]),
                    D(kt, {
                      key: "content",
                      props: O
                    }, {
                      default: L(() => {
                        var P, $, k, g;
                        return [
                          (($ = (P = O.row) == null ? void 0 : P.fields) == null ? void 0 : $.length) === 0 ? (z(), re("span", Xc, J(o(p)), 1)) : (z(), re(Ve, { key: 1 }, [
                            ve(J(o(l).getFieldDescription(
                              O.row.fields[0],
                              (k = o(n)) != null && k.localeName ? o(t)(`builder.controls.fields.${(g = o(n)) == null ? void 0 : g.localeName}`) : ""
                            )), 1)
                          ], 64))
                        ];
                      }),
                      _: 2
                    }, 1032, ["props"]),
                    D(kt, {
                      key: "width",
                      props: O
                    }, {
                      default: L(() => [
                        ve(J(O.row.width) + " ", 1),
                        D(tn, {
                          "label-cancel": o(t)("core.buttons.cancel"),
                          "label-set": o(t)("core.buttons.valid"),
                          "model-value": O.row.width,
                          buttons: "",
                          persistent: "",
                          "onUpdate:modelValue": (P) => o(w)(P, O.rowIndex)
                        }, {
                          default: L((P) => [
                            D(Ne, {
                              modelValue: P.value,
                              "onUpdate:modelValue": ($) => P.value = $,
                              autofocus: "",
                              dense: "",
                              type: "number"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["label-cancel", "label-set", "model-value", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["props"]),
                    D(kt, { "auto-width": "" }, {
                      default: L(() => [
                        D(se, {
                          color: "primary",
                          dense: "",
                          flat: "",
                          icon: "mdi-trash-can",
                          round: "",
                          onClick: (P) => o(l).removeField(O.row.id, o(i), O.rowIndex)
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["props"])
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ])
        ])
      ], 64);
    };
  }
});
const ef = /* @__PURE__ */ Oe(Jc, [["__scopeId", "data-v-4d677804"]]), tf = {
  key: 0,
  class: "comment"
}, lf = {
  key: 1,
  class: "noValue"
}, nf = /* @__PURE__ */ Ce({
  __name: "I18nInput",
  setup(e) {
    const t = Me("_uct"), l = [
      {
        align: "left",
        field: "locale",
        label: t("builder.tabs.internationalization.dataTable.headers.locale"),
        name: "locale",
        sortable: !0
      }
    ], n = [
      {
        align: "left",
        field: "attribute",
        label: t("builder.tabs.internationalization.dataTable.headers.attribute"),
        name: "attribute",
        sortable: !1
      },
      {
        align: "left",
        field: "translation",
        label: t("builder.tabs.internationalization.dataTable.headers.translation"),
        name: "translation",
        sortable: !1
      }
    ], a = ["label", "hint"], i = ["placeholder", "prefix", "suffix"], { isBoxInput: r, itemId: s, field: d, withOptions: c } = Ke(), u = Lt(), m = st(), p = Ee(), f = b(() => {
      var y, M, w;
      let v;
      return ((y = d.value) == null ? void 0 : y.component) === "UsfRow" ? v = (M = d.value) != null && M.hasFieldset ? ["fieldset"] : [] : ((w = d.value) == null ? void 0 : w.component) === "UsfPanel" ? v = [] : v = r.value ? [...a, ...i] : [...a], m.listOfLocales.map((S) => {
        var C, T;
        let h = v.map((I) => ({
          id: Yt(),
          locale: S,
          attribute: I,
          type: "prop",
          translation: m.translation(s.value, S, I)
        }));
        if (c) {
          const I = d.value.options;
          I && I.forEach((E) => {
            var A;
            h.push({
              id: Yt(),
              optionId: E,
              locale: S,
              attribute: "label",
              type: "option",
              translation: m.translation(E, S, "label") ?? ""
            }), (A = d.value) != null && A.optionsHasTooltip && h.push({
              id: Yt(),
              optionId: E,
              locale: S,
              attribute: "tooltip",
              type: "option",
              translation: m.translation(E, S, "tooltip") ?? ""
            });
          });
        }
        return ((C = d.value) == null ? void 0 : C.component) === "UsfAccordion" && (h = (((T = d.value) == null ? void 0 : T.fields) ?? []).map((I) => ({
          id: I,
          locale: S,
          attribute: "content",
          type: "prop",
          translation: (() => {
            var E;
            return m.messages.defaultLocale === S ? m.translation(I, S, "content") || ((E = p.fields[I]) == null ? void 0 : E.content) || "" : m.translation(I, S, "content") || "";
          })()
        }))), {
          locale: S,
          subData: h
        };
      });
    }), _ = (v, y) => {
      if (v.attribute === "content") {
        m.updateTranslation(v.id, v.locale, "content", y);
        return;
      }
      if (v.type === "prop") {
        m.updateTranslation(s.value, v.locale, v.attribute, y);
        return;
      }
      v.type === "option" && v.optionId && m.updateTranslation(
        v.optionId,
        v.locale,
        v.attribute,
        y,
        !0
      );
    };
    return (v, y) => (z(), ae(an, {
      columns: l,
      rows: f.value,
      dense: "",
      "hide-bottom": "",
      "hide-pagination": "",
      "row-key": "locale"
    }, {
      header: L((M) => [
        D(xl, { props: M }, {
          default: L(() => [
            D(hl, { "auto-width": "" }),
            (z(!0), re(Ve, null, dt(M.cols, (w) => (z(), ae(hl, {
              key: w.name,
              props: M
            }, {
              default: L(() => [
                ve(J(w.label), 1)
              ]),
              _: 2
            }, 1032, ["props"]))), 128))
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      body: L((M) => [
        D(xl, { props: M }, {
          default: L(() => [
            D(kt, { "auto-width": "" }, {
              default: L(() => [
                D(se, {
                  icon: M.expand ? "mdi-chevron-up" : "mdi-chevron-down",
                  color: "primary",
                  dense: "",
                  flat: "",
                  round: "",
                  size: "sm",
                  onClick: (w) => M.expand = !M.expand
                }, null, 8, ["icon", "onClick"])
              ]),
              _: 2
            }, 1024),
            (z(!0), re(Ve, null, dt(M.cols, (w) => (z(), ae(kt, {
              key: w.name,
              props: M
            }, {
              default: L(() => [
                ve(J(w.value), 1)
              ]),
              _: 2
            }, 1032, ["props"]))), 128))
          ]),
          _: 2
        }, 1032, ["props"]),
        Ct(D(xl, { props: M }, {
          default: L(() => [
            D(kt, { colspan: "100%" }, {
              default: L(() => [
                D(an, {
                  columns: n,
                  pagination: { rowsPerPage: 0 },
                  rows: M.row.subData,
                  dense: "",
                  flat: "",
                  "hide-bottom": "",
                  "hide-pagination": "",
                  "row-key": "id"
                }, {
                  body: L((w) => [
                    D(xl, { props: w }, {
                      default: L(() => [
                        D(kt, {
                          key: "attribute",
                          props: w
                        }, {
                          default: L(() => {
                            var S;
                            return [
                              w.row.optionId ? (z(), re(Ve, { key: 0 }, [
                                o(u).optionValueIsId ? (z(), re("span", tf, " Option - ")) : (z(), re(Ve, { key: 1 }, [
                                  ve(J((S = o(p).options[w.row.optionId]) == null ? void 0 : S.value) + " - ", 1)
                                ], 64))
                              ], 64)) : ce("", !0),
                              w.row.attribute === "content" ? (z(), re(Ve, { key: 1 }, [
                                ve(J(w.row.id) + " - ", 1)
                              ], 64)) : ce("", !0),
                              ve(" " + J(o(t)(`builder.tabs.display.content.${w.row.attribute}`)), 1)
                            ];
                          }),
                          _: 2
                        }, 1032, ["props"]),
                        D(kt, {
                          key: "translation",
                          props: w
                        }, {
                          default: L(() => [
                            w.row.translation ? (z(), re(Ve, { key: 0 }, [
                              ve(J(w.row.translation), 1)
                            ], 64)) : (z(), re("span", lf, J(o(t)("builder.tabs.internationalization.noValue")), 1)),
                            D(tn, {
                              "model-value": w.row.translation,
                              "onUpdate:modelValue": (S) => _(w.row, S)
                            }, {
                              default: L((S) => [
                                D(Ne, {
                                  modelValue: S.value,
                                  "onUpdate:modelValue": (h) => S.value = h,
                                  autofocus: "",
                                  dense: "",
                                  onKeyup: [
                                    dl(nl(S.set, ["stop"]), ["enter"]),
                                    dl(nl(S.cancel, ["stop"]), ["esc"])
                                  ]
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
                              ]),
                              _: 2
                            }, 1032, ["model-value", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 2
                }, 1032, ["rows"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["props"]), [
          [Nt, M.expand]
        ])
      ]),
      _: 1
    }, 8, ["rows"]));
  }
});
const af = /* @__PURE__ */ Oe(nf, [["__scopeId", "data-v-c207ea76"]]);
function Kr() {
  const e = /* @__PURE__ */ new Map();
  return {
    getCache: function(t, l) {
      return e[t] === void 0 ? e[t] = l : e[t];
    },
    getCacheWithFn: function(t, l) {
      return e[t] === void 0 ? e[t] = l() : e[t];
    }
  };
}
const kl = [
  -61,
  9,
  38,
  199,
  426,
  686,
  756,
  818,
  1111,
  1181,
  1210,
  1635,
  2060,
  2097,
  2192,
  2262,
  2324,
  2394,
  2456,
  3178
];
function of(e, t, l) {
  return Object.prototype.toString.call(e) === "[object Date]" && (l = e.getDate(), t = e.getMonth() + 1, e = e.getFullYear()), df(_o(e, t, l));
}
function gi(e, t, l) {
  return Zr(sf(e, t, l));
}
function rf(e) {
  return uf(e) === 0;
}
function Nn(e, t) {
  return t <= 6 ? 31 : t <= 11 || rf(e) ? 30 : 29;
}
function uf(e) {
  const t = kl.length;
  let l = kl[0], n, a, i, r, s;
  if (e < l || e >= kl[t - 1])
    throw new Error("Invalid Jalaali year " + e);
  for (s = 1; s < t && (n = kl[s], a = n - l, !(e < n)); s += 1)
    l = n;
  return r = e - l, a - r < 6 && (r = r - a + yt(a + 4, 33) * 33), i = Xt(Xt(r + 1, 33) - 1, 4), i === -1 && (i = 4), i;
}
function Gr(e, t) {
  const l = kl.length, n = e + 621;
  let a = -14, i = kl[0], r, s, d, c, u;
  if (e < i || e >= kl[l - 1])
    throw new Error("Invalid Jalaali year " + e);
  for (u = 1; u < l && (r = kl[u], s = r - i, !(e < r)); u += 1)
    a = a + yt(s, 33) * 8 + yt(Xt(s, 33), 4), i = r;
  c = e - i, a = a + yt(c, 33) * 8 + yt(Xt(c, 33) + 3, 4), Xt(s, 33) === 4 && s - c === 4 && (a += 1);
  const m = yt(n, 4) - yt((yt(n, 100) + 1) * 3, 4) - 150, p = 20 + a - m;
  return t || (s - c < 6 && (c = c - s + yt(s + 4, 33) * 33), d = Xt(Xt(c + 1, 33) - 1, 4), d === -1 && (d = 4)), {
    leap: d,
    gy: n,
    march: p
  };
}
function sf(e, t, l) {
  const n = Gr(e, !0);
  return _o(n.gy, 3, n.march) + (t - 1) * 31 - yt(t, 7) * (t - 7) + l - 1;
}
function df(e) {
  const t = Zr(e).gy;
  let l = t - 621, n, a, i;
  const r = Gr(l, !1), s = _o(t, 3, r.march);
  if (i = e - s, i >= 0) {
    if (i <= 185)
      return a = 1 + yt(i, 31), n = Xt(i, 31) + 1, {
        jy: l,
        jm: a,
        jd: n
      };
    i -= 186;
  } else
    l -= 1, i += 179, r.leap === 1 && (i += 1);
  return a = 7 + yt(i, 30), n = Xt(i, 30) + 1, {
    jy: l,
    jm: a,
    jd: n
  };
}
function _o(e, t, l) {
  let n = yt((e + yt(t - 8, 6) + 100100) * 1461, 4) + yt(153 * Xt(t + 9, 12) + 2, 5) + l - 34840408;
  return n = n - yt(yt(e + 100100 + yt(t - 8, 6), 100) * 3, 4) + 752, n;
}
function Zr(e) {
  let t = 4 * e + 139361631;
  t = t + yt(yt(4 * e + 183187720, 146097) * 3, 4) * 4 - 3908;
  const l = yt(Xt(t, 1461), 4) * 5 + 308, n = yt(Xt(l, 153), 5) + 1, a = Xt(yt(l, 153), 12) + 1;
  return {
    gy: yt(t, 1461) - 100100 + yt(8 - a, 6),
    gm: a,
    gd: n
  };
}
function yt(e, t) {
  return ~~(e / t);
}
function Xt(e, t) {
  return e - ~~(e / t) * t;
}
const cf = ["gregorian", "persian"], Xr = {
  modelValue: {
    required: !0
  },
  mask: {
    type: String
  },
  locale: Object,
  calendar: {
    type: String,
    validator: (e) => cf.includes(e),
    default: "gregorian"
  },
  landscape: Boolean,
  color: String,
  textColor: String,
  square: Boolean,
  flat: Boolean,
  bordered: Boolean,
  readonly: Boolean,
  disable: Boolean
}, Jr = ["update:modelValue"];
function pl(e) {
  return e.year + "/" + Xe(e.month) + "/" + Xe(e.day);
}
function eu(e, t) {
  const l = b(() => e.disable !== !0 && e.readonly !== !0), n = b(() => l.value === !0 ? 0 : -1), a = b(() => {
    const s = [];
    return e.color !== void 0 && s.push(`bg-${e.color}`), e.textColor !== void 0 && s.push(`text-${e.textColor}`), s.join(" ");
  });
  function i() {
    return e.locale !== void 0 ? { ...t.lang.date, ...e.locale } : t.lang.date;
  }
  function r(s) {
    const d = /* @__PURE__ */ new Date(), c = s === !0 ? null : 0;
    if (e.calendar === "persian") {
      const u = of(d);
      return {
        year: u.jy,
        month: u.jm,
        day: u.jd
      };
    }
    return {
      year: d.getFullYear(),
      month: d.getMonth() + 1,
      day: d.getDate(),
      hour: c,
      minute: c,
      second: c,
      millisecond: c
    };
  }
  return {
    editable: l,
    tabindex: n,
    headerClass: a,
    getLocale: i,
    getCurrentDate: r
  };
}
const ff = (e, t) => {
  const l = Rl(e);
  for (const n in e)
    Kt(
      t,
      n,
      () => l[n],
      (a) => {
        l[n] = a;
      }
    );
  return t;
}, Xa = {
  isoName: "en-US",
  nativeName: "English (US)",
  label: {
    clear: "Clear",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    set: "Set",
    select: "Select",
    reset: "Reset",
    remove: "Remove",
    update: "Update",
    create: "Create",
    search: "Search",
    filter: "Filter",
    refresh: "Refresh",
    expand: (e) => e ? `Expand "${e}"` : "Expand",
    collapse: (e) => e ? `Collapse "${e}"` : "Collapse"
  },
  date: {
    days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    firstDayOfWeek: 0,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: !1,
    pluralDay: "days"
  },
  table: {
    noData: "No data available",
    noResults: "No matching records found",
    loading: "Loading...",
    selectedRecords: (e) => e === 1 ? "1 record selected." : (e === 0 ? "No" : e) + " records selected.",
    recordsPerPage: "Records per page:",
    allRows: "All",
    pagination: (e, t, l) => e + "-" + t + " of " + l,
    columns: "Columns"
  },
  editor: {
    url: "URL",
    bold: "Bold",
    italic: "Italic",
    strikethrough: "Strikethrough",
    underline: "Underline",
    unorderedList: "Unordered List",
    orderedList: "Ordered List",
    subscript: "Subscript",
    superscript: "Superscript",
    hyperlink: "Hyperlink",
    toggleFullscreen: "Toggle Fullscreen",
    quote: "Quote",
    left: "Left align",
    center: "Center align",
    right: "Right align",
    justify: "Justify align",
    print: "Print",
    outdent: "Decrease indentation",
    indent: "Increase indentation",
    removeFormat: "Remove formatting",
    formatting: "Formatting",
    fontSize: "Font Size",
    align: "Align",
    hr: "Insert Horizontal Rule",
    undo: "Undo",
    redo: "Redo",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3",
    heading4: "Heading 4",
    heading5: "Heading 5",
    heading6: "Heading 6",
    paragraph: "Paragraph",
    code: "Code",
    size1: "Very small",
    size2: "A bit small",
    size3: "Normal",
    size4: "Medium-large",
    size5: "Big",
    size6: "Very big",
    size7: "Maximum",
    defaultFont: "Default Font",
    viewSource: "View Source"
  },
  tree: {
    noNodes: "No nodes available",
    noResults: "No matching nodes found"
  }
};
function yi() {
  const e = Array.isArray(navigator.languages) === !0 && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
  if (typeof e == "string")
    return e.split(/[-_]/).map((t, l) => l === 0 ? t.toLowerCase() : l > 1 || t.length < 4 ? t.toUpperCase() : t[0].toUpperCase() + t.slice(1).toLowerCase()).join("-");
}
const il = ff({
  __langPack: {}
}, {
  getLocale: yi,
  set(e = Xa, t) {
    const l = {
      ...e,
      rtl: e.rtl === !0,
      getLocale: yi
    };
    {
      if (l.set = il.set, il.__langConfig === void 0 || il.__langConfig.noHtmlAttrs !== !0) {
        const n = document.documentElement;
        n.setAttribute("dir", l.rtl === !0 ? "rtl" : "ltr"), n.setAttribute("lang", l.isoName);
      }
      Object.assign(il.__langPack, l), il.props = l, il.isoName = l.isoName, il.nativeName = l.nativeName;
    }
  },
  install({ $q: e, lang: t, ssrContext: l }) {
    e.lang = il.__langPack, il.__langConfig = e.config.lang, this.__installed === !0 ? t !== void 0 && this.set(t) : this.set(t || Xa);
  }
}), tu = 864e5, vf = 36e5, Ja = 6e4, lu = "YYYY-MM-DDTHH:mm:ss.SSSZ", mf = /\[((?:[^\]\\]|\\]|\\)*)\]|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g, pf = /(\[[^\]]*\])|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g, Ea = {};
function bf(e, t) {
  const l = "(" + t.days.join("|") + ")", n = e + l;
  if (Ea[n] !== void 0)
    return Ea[n];
  const a = "(" + t.daysShort.join("|") + ")", i = "(" + t.months.join("|") + ")", r = "(" + t.monthsShort.join("|") + ")", s = {};
  let d = 0;
  const c = e.replace(pf, (m) => {
    switch (d++, m) {
      case "YY":
        return s.YY = d, "(-?\\d{1,2})";
      case "YYYY":
        return s.YYYY = d, "(-?\\d{1,4})";
      case "M":
        return s.M = d, "(\\d{1,2})";
      case "MM":
        return s.M = d, "(\\d{2})";
      case "MMM":
        return s.MMM = d, r;
      case "MMMM":
        return s.MMMM = d, i;
      case "D":
        return s.D = d, "(\\d{1,2})";
      case "Do":
        return s.D = d++, "(\\d{1,2}(st|nd|rd|th))";
      case "DD":
        return s.D = d, "(\\d{2})";
      case "H":
        return s.H = d, "(\\d{1,2})";
      case "HH":
        return s.H = d, "(\\d{2})";
      case "h":
        return s.h = d, "(\\d{1,2})";
      case "hh":
        return s.h = d, "(\\d{2})";
      case "m":
        return s.m = d, "(\\d{1,2})";
      case "mm":
        return s.m = d, "(\\d{2})";
      case "s":
        return s.s = d, "(\\d{1,2})";
      case "ss":
        return s.s = d, "(\\d{2})";
      case "S":
        return s.S = d, "(\\d{1})";
      case "SS":
        return s.S = d, "(\\d{2})";
      case "SSS":
        return s.S = d, "(\\d{3})";
      case "A":
        return s.A = d, "(AM|PM)";
      case "a":
        return s.a = d, "(am|pm)";
      case "aa":
        return s.aa = d, "(a\\.m\\.|p\\.m\\.)";
      case "ddd":
        return a;
      case "dddd":
        return l;
      case "Q":
      case "d":
      case "E":
        return "(\\d{1})";
      case "Qo":
        return "(1st|2nd|3rd|4th)";
      case "DDD":
      case "DDDD":
        return "(\\d{1,3})";
      case "w":
        return "(\\d{1,2})";
      case "ww":
        return "(\\d{2})";
      case "Z":
        return s.Z = d, "(Z|[+-]\\d{2}:\\d{2})";
      case "ZZ":
        return s.ZZ = d, "(Z|[+-]\\d{2}\\d{2})";
      case "X":
        return s.X = d, "(-?\\d+)";
      case "x":
        return s.x = d, "(-?\\d{4,})";
      default:
        return d--, m[0] === "[" && (m = m.substring(1, m.length - 1)), m.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
  }), u = { map: s, regex: new RegExp("^" + c) };
  return Ea[n] = u, u;
}
function nu(e, t) {
  return e !== void 0 ? e : t !== void 0 ? t.date : Xa.date;
}
function _i(e, t = "") {
  const l = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.floor(n / 60), i = n % 60;
  return l + Xe(a) + t + Xe(i);
}
function yn(e, t, l, n, a) {
  const i = {
    year: null,
    month: null,
    day: null,
    hour: null,
    minute: null,
    second: null,
    millisecond: null,
    timezoneOffset: null,
    dateHash: null,
    timeHash: null
  };
  if (a !== void 0 && Object.assign(i, a), e == null || e === "" || typeof e != "string")
    return i;
  t === void 0 && (t = lu);
  const r = nu(l, il.props), s = r.months, d = r.monthsShort, { regex: c, map: u } = bf(t, r), m = e.match(c);
  if (m === null)
    return i;
  let p = "";
  if (u.X !== void 0 || u.x !== void 0) {
    const f = parseInt(m[u.X !== void 0 ? u.X : u.x], 10);
    if (isNaN(f) === !0 || f < 0)
      return i;
    const _ = new Date(f * (u.X !== void 0 ? 1e3 : 1));
    i.year = _.getFullYear(), i.month = _.getMonth() + 1, i.day = _.getDate(), i.hour = _.getHours(), i.minute = _.getMinutes(), i.second = _.getSeconds(), i.millisecond = _.getMilliseconds();
  } else {
    if (u.YYYY !== void 0)
      i.year = parseInt(m[u.YYYY], 10);
    else if (u.YY !== void 0) {
      const f = parseInt(m[u.YY], 10);
      i.year = f < 0 ? f : 2e3 + f;
    }
    if (u.M !== void 0) {
      if (i.month = parseInt(m[u.M], 10), i.month < 1 || i.month > 12)
        return i;
    } else
      u.MMM !== void 0 ? i.month = d.indexOf(m[u.MMM]) + 1 : u.MMMM !== void 0 && (i.month = s.indexOf(m[u.MMMM]) + 1);
    if (u.D !== void 0) {
      if (i.day = parseInt(m[u.D], 10), i.year === null || i.month === null || i.day < 1)
        return i;
      const f = n !== "persian" ? new Date(i.year, i.month, 0).getDate() : Nn(i.year, i.month);
      if (i.day > f)
        return i;
    }
    u.H !== void 0 ? i.hour = parseInt(m[u.H], 10) % 24 : u.h !== void 0 && (i.hour = parseInt(m[u.h], 10) % 12, (u.A && m[u.A] === "PM" || u.a && m[u.a] === "pm" || u.aa && m[u.aa] === "p.m.") && (i.hour += 12), i.hour = i.hour % 24), u.m !== void 0 && (i.minute = parseInt(m[u.m], 10) % 60), u.s !== void 0 && (i.second = parseInt(m[u.s], 10) % 60), u.S !== void 0 && (i.millisecond = parseInt(m[u.S], 10) * 10 ** (3 - m[u.S].length)), (u.Z !== void 0 || u.ZZ !== void 0) && (p = u.Z !== void 0 ? m[u.Z].replace(":", "") : m[u.ZZ], i.timezoneOffset = (p[0] === "+" ? -1 : 1) * (60 * p.slice(1, 3) + 1 * p.slice(3, 5)));
  }
  return i.dateHash = Xe(i.year, 6) + "/" + Xe(i.month) + "/" + Xe(i.day), i.timeHash = Xe(i.hour) + ":" + Xe(i.minute) + ":" + Xe(i.second) + p, i;
}
function Si(e) {
  const t = new Date(e.getFullYear(), e.getMonth(), e.getDate());
  t.setDate(t.getDate() - (t.getDay() + 6) % 7 + 3);
  const l = new Date(t.getFullYear(), 0, 4);
  l.setDate(l.getDate() - (l.getDay() + 6) % 7 + 3);
  const n = t.getTimezoneOffset() - l.getTimezoneOffset();
  t.setHours(t.getHours() - n);
  const a = (t - l) / (tu * 7);
  return 1 + Math.floor(a);
}
function bl(e, t, l) {
  const n = new Date(e), a = `set${l === !0 ? "UTC" : ""}`;
  switch (t) {
    case "year":
    case "years":
      n[`${a}Month`](0);
    case "month":
    case "months":
      n[`${a}Date`](1);
    case "day":
    case "days":
    case "date":
      n[`${a}Hours`](0);
    case "hour":
    case "hours":
      n[`${a}Minutes`](0);
    case "minute":
    case "minutes":
      n[`${a}Seconds`](0);
    case "second":
    case "seconds":
      n[`${a}Milliseconds`](0);
  }
  return n;
}
function Yn(e, t, l) {
  return (e.getTime() - e.getTimezoneOffset() * Ja - (t.getTime() - t.getTimezoneOffset() * Ja)) / l;
}
function au(e, t, l = "days") {
  const n = new Date(e), a = new Date(t);
  switch (l) {
    case "years":
    case "year":
      return n.getFullYear() - a.getFullYear();
    case "months":
    case "month":
      return (n.getFullYear() - a.getFullYear()) * 12 + n.getMonth() - a.getMonth();
    case "days":
    case "day":
    case "date":
      return Yn(bl(n, "day"), bl(a, "day"), tu);
    case "hours":
    case "hour":
      return Yn(bl(n, "hour"), bl(a, "hour"), vf);
    case "minutes":
    case "minute":
      return Yn(bl(n, "minute"), bl(a, "minute"), Ja);
    case "seconds":
    case "second":
      return Yn(bl(n, "second"), bl(a, "second"), 1e3);
  }
}
function wi(e) {
  return au(e, bl(e, "year"), "days") + 1;
}
function xi(e) {
  if (e >= 11 && e <= 13)
    return `${e}th`;
  switch (e % 10) {
    case 1:
      return `${e}st`;
    case 2:
      return `${e}nd`;
    case 3:
      return `${e}rd`;
  }
  return `${e}th`;
}
const ki = {
  // Year: 00, 01, ..., 99
  YY(e, t, l) {
    const n = this.YYYY(e, t, l) % 100;
    return n >= 0 ? Xe(n) : "-" + Xe(Math.abs(n));
  },
  // Year: 1900, 1901, ..., 2099
  YYYY(e, t, l) {
    return l ?? e.getFullYear();
  },
  // Month: 1, 2, ..., 12
  M(e) {
    return e.getMonth() + 1;
  },
  // Month: 01, 02, ..., 12
  MM(e) {
    return Xe(e.getMonth() + 1);
  },
  // Month Short Name: Jan, Feb, ...
  MMM(e, t) {
    return t.monthsShort[e.getMonth()];
  },
  // Month Name: January, February, ...
  MMMM(e, t) {
    return t.months[e.getMonth()];
  },
  // Quarter: 1, 2, 3, 4
  Q(e) {
    return Math.ceil((e.getMonth() + 1) / 3);
  },
  // Quarter: 1st, 2nd, 3rd, 4th
  Qo(e) {
    return xi(this.Q(e));
  },
  // Day of month: 1, 2, ..., 31
  D(e) {
    return e.getDate();
  },
  // Day of month: 1st, 2nd, ..., 31st
  Do(e) {
    return xi(e.getDate());
  },
  // Day of month: 01, 02, ..., 31
  DD(e) {
    return Xe(e.getDate());
  },
  // Day of year: 1, 2, ..., 366
  DDD(e) {
    return wi(e);
  },
  // Day of year: 001, 002, ..., 366
  DDDD(e) {
    return Xe(wi(e), 3);
  },
  // Day of week: 0, 1, ..., 6
  d(e) {
    return e.getDay();
  },
  // Day of week: Su, Mo, ...
  dd(e, t) {
    return this.dddd(e, t).slice(0, 2);
  },
  // Day of week: Sun, Mon, ...
  ddd(e, t) {
    return t.daysShort[e.getDay()];
  },
  // Day of week: Sunday, Monday, ...
  dddd(e, t) {
    return t.days[e.getDay()];
  },
  // Day of ISO week: 1, 2, ..., 7
  E(e) {
    return e.getDay() || 7;
  },
  // Week of Year: 1 2 ... 52 53
  w(e) {
    return Si(e);
  },
  // Week of Year: 01 02 ... 52 53
  ww(e) {
    return Xe(Si(e));
  },
  // Hour: 0, 1, ... 23
  H(e) {
    return e.getHours();
  },
  // Hour: 00, 01, ..., 23
  HH(e) {
    return Xe(e.getHours());
  },
  // Hour: 1, 2, ..., 12
  h(e) {
    const t = e.getHours();
    return t === 0 ? 12 : t > 12 ? t % 12 : t;
  },
  // Hour: 01, 02, ..., 12
  hh(e) {
    return Xe(this.h(e));
  },
  // Minute: 0, 1, ..., 59
  m(e) {
    return e.getMinutes();
  },
  // Minute: 00, 01, ..., 59
  mm(e) {
    return Xe(e.getMinutes());
  },
  // Second: 0, 1, ..., 59
  s(e) {
    return e.getSeconds();
  },
  // Second: 00, 01, ..., 59
  ss(e) {
    return Xe(e.getSeconds());
  },
  // 1/10 of second: 0, 1, ..., 9
  S(e) {
    return Math.floor(e.getMilliseconds() / 100);
  },
  // 1/100 of second: 00, 01, ..., 99
  SS(e) {
    return Xe(Math.floor(e.getMilliseconds() / 10));
  },
  // Millisecond: 000, 001, ..., 999
  SSS(e) {
    return Xe(e.getMilliseconds(), 3);
  },
  // Meridiem: AM, PM
  A(e) {
    return this.H(e) < 12 ? "AM" : "PM";
  },
  // Meridiem: am, pm
  a(e) {
    return this.H(e) < 12 ? "am" : "pm";
  },
  // Meridiem: a.m., p.m.
  aa(e) {
    return this.H(e) < 12 ? "a.m." : "p.m.";
  },
  // Timezone: -01:00, +00:00, ... +12:00
  Z(e, t, l, n) {
    const a = n ?? e.getTimezoneOffset();
    return _i(a, ":");
  },
  // Timezone: -0100, +0000, ... +1200
  ZZ(e, t, l, n) {
    const a = n ?? e.getTimezoneOffset();
    return _i(a);
  },
  // Seconds timestamp: 512969520
  X(e) {
    return Math.floor(e.getTime() / 1e3);
  },
  // Milliseconds timestamp: 512969520900
  x(e) {
    return e.getTime();
  }
};
function ou(e, t, l, n, a) {
  if (e !== 0 && !e || e === 1 / 0 || e === -1 / 0)
    return;
  const i = new Date(e);
  if (isNaN(i))
    return;
  t === void 0 && (t = lu);
  const r = nu(l, il.props);
  return t.replace(
    mf,
    (s, d) => s in ki ? ki[s](i, r, n, a) : d === void 0 ? s : d.split("\\]").join("]")
  );
}
const Fl = 20, hf = ["Calendar", "Years", "Months"], Ci = (e) => hf.includes(e), Pa = (e) => /^-?[\d]+\/[0-1]\d$/.test(e), Kl = " — ";
function Sl(e) {
  return e.year + "/" + Xe(e.month);
}
const iu = De({
  name: "QDate",
  props: {
    ...Xr,
    ...Ml,
    ...Tt,
    multiple: Boolean,
    range: Boolean,
    title: String,
    subtitle: String,
    mask: {
      // this mask is forced
      // when using persian calendar
      default: "YYYY/MM/DD"
    },
    defaultYearMonth: {
      type: String,
      validator: Pa
    },
    yearsInMonthView: Boolean,
    events: [Array, Function],
    eventColor: [String, Function],
    emitImmediately: Boolean,
    options: [Array, Function],
    navigationMinYearMonth: {
      type: String,
      validator: Pa
    },
    navigationMaxYearMonth: {
      type: String,
      validator: Pa
    },
    noUnset: Boolean,
    firstDayOfWeek: [String, Number],
    todayBtn: Boolean,
    minimal: Boolean,
    defaultView: {
      type: String,
      default: "Calendar",
      validator: Ci
    }
  },
  emits: [
    ...Jr,
    "rangeStart",
    "rangeEnd",
    "navigation"
  ],
  setup(e, { slots: t, emit: l }) {
    const { proxy: n } = Ae(), { $q: a } = n, i = Mt(e, a), { getCache: r } = Kr(), { tabindex: s, headerClass: d, getLocale: c, getCurrentDate: u } = eu(e, a);
    let m;
    const p = mr(e), f = An(p), _ = G(null), v = G(bt()), y = G(c()), M = b(() => bt()), w = b(() => c()), S = b(() => u()), h = G(ne(v.value, y.value)), C = G(e.defaultView), T = a.lang.rtl === !0 ? "right" : "left", I = G(T.value), E = G(T.value), A = h.value.year, O = G(A - A % Fl - (A < 0 ? Fl : 0)), P = G(null), $ = b(() => {
      const F = e.landscape === !0 ? "landscape" : "portrait";
      return `q-date q-date--${F} q-date--${F}-${e.minimal === !0 ? "minimal" : "standard"}` + (i.value === !0 ? " q-date--dark q-dark" : "") + (e.bordered === !0 ? " q-date--bordered" : "") + (e.square === !0 ? " q-date--square no-border-radius" : "") + (e.flat === !0 ? " q-date--flat no-shadow" : "") + (e.disable === !0 ? " disabled" : e.readonly === !0 ? " q-date--readonly" : "");
    }), k = b(() => e.color || "primary"), g = b(() => e.textColor || "white"), x = b(
      () => e.emitImmediately === !0 && e.multiple !== !0 && e.range !== !0
    ), B = b(() => Array.isArray(e.modelValue) === !0 ? e.modelValue : e.modelValue !== null && e.modelValue !== void 0 ? [e.modelValue] : []), q = b(
      () => B.value.filter((F) => typeof F == "string").map((F) => ht(F, v.value, y.value)).filter(
        (F) => F.dateHash !== null && F.day !== null && F.month !== null && F.year !== null
      )
    ), Y = b(() => {
      const F = (N) => ht(N, v.value, y.value);
      return B.value.filter((N) => Tr(N) === !0 && N.from !== void 0 && N.to !== void 0).map((N) => ({ from: F(N.from), to: F(N.to) })).filter((N) => N.from.dateHash !== null && N.to.dateHash !== null && N.from.dateHash < N.to.dateHash);
    }), K = b(() => e.calendar !== "persian" ? (F) => new Date(F.year, F.month - 1, F.day) : (F) => {
      const N = gi(F.year, F.month, F.day);
      return new Date(N.gy, N.gm - 1, N.gd);
    }), Q = b(() => e.calendar === "persian" ? pl : (F, N, X) => ou(
      new Date(
        F.year,
        F.month - 1,
        F.day,
        F.hour,
        F.minute,
        F.second,
        F.millisecond
      ),
      N === void 0 ? v.value : N,
      X === void 0 ? y.value : X,
      F.year,
      F.timezoneOffset
    )), W = b(
      () => q.value.length + Y.value.reduce(
        (F, N) => F + 1 + au(
          K.value(N.to),
          K.value(N.from)
        ),
        0
      )
    ), H = b(() => {
      if (e.title !== void 0 && e.title !== null && e.title.length !== 0)
        return e.title;
      if (P.value !== null) {
        const X = P.value.init, be = K.value(X);
        return y.value.daysShort[be.getDay()] + ", " + y.value.monthsShort[X.month - 1] + " " + X.day + Kl + "?";
      }
      if (W.value === 0)
        return Kl;
      if (W.value > 1)
        return `${W.value} ${y.value.pluralDay}`;
      const F = q.value[0], N = K.value(F);
      return isNaN(N.valueOf()) === !0 ? Kl : y.value.headerTitle !== void 0 ? y.value.headerTitle(N, F) : y.value.daysShort[N.getDay()] + ", " + y.value.monthsShort[F.month - 1] + " " + F.day;
    }), R = b(() => q.value.concat(Y.value.map((N) => N.from)).sort((N, X) => N.year - X.year || N.month - X.month)[0]), ie = b(() => q.value.concat(Y.value.map((N) => N.to)).sort((N, X) => X.year - N.year || X.month - N.month)[0]), te = b(() => {
      if (e.subtitle !== void 0 && e.subtitle !== null && e.subtitle.length !== 0)
        return e.subtitle;
      if (W.value === 0)
        return Kl;
      if (W.value > 1) {
        const F = R.value, N = ie.value, X = y.value.monthsShort;
        return X[F.month - 1] + (F.year !== N.year ? " " + F.year + Kl + X[N.month - 1] + " " : F.month !== N.month ? Kl + X[N.month - 1] : "") + " " + N.year;
      }
      return q.value[0].year;
    }), oe = b(() => {
      const F = [a.iconSet.datetime.arrowLeft, a.iconSet.datetime.arrowRight];
      return a.lang.rtl === !0 ? F.reverse() : F;
    }), fe = b(() => e.firstDayOfWeek !== void 0 ? Number(e.firstDayOfWeek) : y.value.firstDayOfWeek), Z = b(() => {
      const F = y.value.daysShort, N = fe.value;
      return N > 0 ? F.slice(N, 7).concat(F.slice(0, N)) : F;
    }), j = b(() => {
      const F = h.value;
      return e.calendar !== "persian" ? new Date(F.year, F.month, 0).getDate() : Nn(F.year, F.month);
    }), he = b(() => typeof e.eventColor == "function" ? e.eventColor : () => e.eventColor), we = b(() => {
      if (e.navigationMinYearMonth === void 0)
        return null;
      const F = e.navigationMinYearMonth.split("/");
      return { year: parseInt(F[0], 10), month: parseInt(F[1], 10) };
    }), Ie = b(() => {
      if (e.navigationMaxYearMonth === void 0)
        return null;
      const F = e.navigationMaxYearMonth.split("/");
      return { year: parseInt(F[0], 10), month: parseInt(F[1], 10) };
    }), ot = b(() => {
      const F = {
        month: { prev: !0, next: !0 },
        year: { prev: !0, next: !0 }
      };
      return we.value !== null && we.value.year >= h.value.year && (F.year.prev = !1, we.value.year === h.value.year && we.value.month >= h.value.month && (F.month.prev = !1)), Ie.value !== null && Ie.value.year <= h.value.year && (F.year.next = !1, Ie.value.year === h.value.year && Ie.value.month <= h.value.month && (F.month.next = !1)), F;
    }), St = b(() => {
      const F = {};
      return q.value.forEach((N) => {
        const X = Sl(N);
        F[X] === void 0 && (F[X] = []), F[X].push(N.day);
      }), F;
    }), xt = b(() => {
      const F = {};
      return Y.value.forEach((N) => {
        const X = Sl(N.from), be = Sl(N.to);
        if (F[X] === void 0 && (F[X] = []), F[X].push({
          from: N.from.day,
          to: X === be ? N.to.day : void 0,
          range: N
        }), X < be) {
          let pe;
          const { year: Ge, month: xe } = N.from, Be = xe < 12 ? { year: Ge, month: xe + 1 } : { year: Ge + 1, month: 1 };
          for (; (pe = Sl(Be)) <= be; )
            F[pe] === void 0 && (F[pe] = []), F[pe].push({
              from: void 0,
              to: pe === be ? N.to.day : void 0,
              range: N
            }), Be.month++, Be.month > 12 && (Be.year++, Be.month = 1);
        }
      }), F;
    }), qt = b(() => {
      if (P.value === null)
        return;
      const { init: F, initHash: N, final: X, finalHash: be } = P.value, [pe, Ge] = N <= be ? [F, X] : [X, F], xe = Sl(pe), Be = Sl(Ge);
      if (xe !== pt.value && Be !== pt.value)
        return;
      const et = {};
      return xe === pt.value ? (et.from = pe.day, et.includeFrom = !0) : et.from = 1, Be === pt.value ? (et.to = Ge.day, et.includeTo = !0) : et.to = j.value, et;
    }), pt = b(() => Sl(h.value)), Wt = b(() => {
      const F = {};
      if (e.options === void 0) {
        for (let X = 1; X <= j.value; X++)
          F[X] = !0;
        return F;
      }
      const N = typeof e.options == "function" ? e.options : (X) => e.options.includes(X);
      for (let X = 1; X <= j.value; X++) {
        const be = pt.value + "/" + Xe(X);
        F[X] = N(be);
      }
      return F;
    }), el = b(() => {
      const F = {};
      if (e.events === void 0)
        for (let N = 1; N <= j.value; N++)
          F[N] = !1;
      else {
        const N = typeof e.events == "function" ? e.events : (X) => e.events.includes(X);
        for (let X = 1; X <= j.value; X++) {
          const be = pt.value + "/" + Xe(X);
          F[X] = N(be) === !0 && he.value(be);
        }
      }
      return F;
    }), ft = b(() => {
      let F, N;
      const { year: X, month: be } = h.value;
      if (e.calendar !== "persian")
        F = new Date(X, be - 1, 1), N = new Date(X, be - 1, 0).getDate();
      else {
        const pe = gi(X, be, 1);
        F = new Date(pe.gy, pe.gm - 1, pe.gd);
        let Ge = be - 1, xe = X;
        Ge === 0 && (Ge = 12, xe--), N = Nn(xe, Ge);
      }
      return {
        days: F.getDay() - fe.value - 1,
        endDay: N
      };
    }), ue = b(() => {
      const F = [], { days: N, endDay: X } = ft.value, be = N < 0 ? N + 7 : N;
      if (be < 6)
        for (let xe = X - be; xe <= X; xe++)
          F.push({ i: xe, fill: !0 });
      const pe = F.length;
      for (let xe = 1; xe <= j.value; xe++) {
        const Be = { i: xe, event: el.value[xe], classes: [] };
        Wt.value[xe] === !0 && (Be.in = !0, Be.flat = !0), F.push(Be);
      }
      if (St.value[pt.value] !== void 0 && St.value[pt.value].forEach((xe) => {
        const Be = pe + xe - 1;
        Object.assign(F[Be], {
          selected: !0,
          unelevated: !0,
          flat: !1,
          color: k.value,
          textColor: g.value
        });
      }), xt.value[pt.value] !== void 0 && xt.value[pt.value].forEach((xe) => {
        if (xe.from !== void 0) {
          const Be = pe + xe.from - 1, et = pe + (xe.to || j.value) - 1;
          for (let Zt = Be; Zt <= et; Zt++)
            Object.assign(F[Zt], {
              range: xe.range,
              unelevated: !0,
              color: k.value,
              textColor: g.value
            });
          Object.assign(F[Be], {
            rangeFrom: !0,
            flat: !1
          }), xe.to !== void 0 && Object.assign(F[et], {
            rangeTo: !0,
            flat: !1
          });
        } else if (xe.to !== void 0) {
          const Be = pe + xe.to - 1;
          for (let et = pe; et <= Be; et++)
            Object.assign(F[et], {
              range: xe.range,
              unelevated: !0,
              color: k.value,
              textColor: g.value
            });
          Object.assign(F[Be], {
            flat: !1,
            rangeTo: !0
          });
        } else {
          const Be = pe + j.value - 1;
          for (let et = pe; et <= Be; et++)
            Object.assign(F[et], {
              range: xe.range,
              unelevated: !0,
              color: k.value,
              textColor: g.value
            });
        }
      }), qt.value !== void 0) {
        const xe = pe + qt.value.from - 1, Be = pe + qt.value.to - 1;
        for (let et = xe; et <= Be; et++)
          F[et].color = k.value, F[et].editRange = !0;
        qt.value.includeFrom === !0 && (F[xe].editRangeFrom = !0), qt.value.includeTo === !0 && (F[Be].editRangeTo = !0);
      }
      h.value.year === S.value.year && h.value.month === S.value.month && (F[pe + S.value.day - 1].today = !0);
      const Ge = F.length % 7;
      if (Ge > 0) {
        const xe = 7 - Ge;
        for (let Be = 1; Be <= xe; Be++)
          F.push({ i: Be, fill: !0 });
      }
      return F.forEach((xe) => {
        let Be = "q-date__calendar-item ";
        xe.fill === !0 ? Be += "q-date__calendar-item--fill" : (Be += `q-date__calendar-item--${xe.in === !0 ? "in" : "out"}`, xe.range !== void 0 && (Be += ` q-date__range${xe.rangeTo === !0 ? "-to" : xe.rangeFrom === !0 ? "-from" : ""}`), xe.editRange === !0 && (Be += ` q-date__edit-range${xe.editRangeFrom === !0 ? "-from" : ""}${xe.editRangeTo === !0 ? "-to" : ""}`), (xe.range !== void 0 || xe.editRange === !0) && (Be += ` text-${xe.color}`)), xe.classes = Be;
      }), F;
    }), _e = b(() => e.disable === !0 ? { "aria-disabled": "true" } : e.readonly === !0 ? { "aria-readonly": "true" } : {});
    me(() => e.modelValue, (F) => {
      if (m === F)
        m = 0;
      else {
        const N = ne(v.value, y.value);
        Dt(N.year, N.month, N);
      }
    }), me(C, () => {
      _.value !== null && n.$el.contains(document.activeElement) === !0 && _.value.focus();
    }), me(() => h.value.year + "|" + h.value.month, () => {
      l("navigation", { year: h.value.year, month: h.value.month });
    }), me(M, (F) => {
      le(F, y.value, "mask"), v.value = F;
    }), me(w, (F) => {
      le(v.value, F, "locale"), y.value = F;
    });
    function $e() {
      const F = S.value, N = St.value[Sl(F)];
      (N === void 0 || N.includes(F.day) === !1) && _l(F), Re(F.year, F.month);
    }
    function tt(F) {
      Ci(F) === !0 && (C.value = F);
    }
    function Je(F, N) {
      ["month", "year"].includes(F) && (F === "month" ? ke : Pe)(N === !0 ? -1 : 1);
    }
    function Re(F, N) {
      C.value = "Calendar", Dt(F, N);
    }
    function Ue(F, N) {
      if (e.range === !1 || !F) {
        P.value = null;
        return;
      }
      const X = Object.assign({ ...h.value }, F), be = N !== void 0 ? Object.assign({ ...h.value }, N) : X;
      P.value = {
        init: X,
        initHash: pl(X),
        final: be,
        finalHash: pl(be)
      }, Re(X.year, X.month);
    }
    function bt() {
      return e.calendar === "persian" ? "YYYY/MM/DD" : e.mask;
    }
    function ht(F, N, X) {
      return yn(
        F,
        N,
        X,
        e.calendar,
        {
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }
      );
    }
    function ne(F, N) {
      const X = Array.isArray(e.modelValue) === !0 ? e.modelValue : e.modelValue ? [e.modelValue] : [];
      if (X.length === 0)
        return de();
      const be = X[X.length - 1], pe = ht(
        be.from !== void 0 ? be.from : be,
        F,
        N
      );
      return pe.dateHash === null ? de() : pe;
    }
    function de() {
      let F, N;
      if (e.defaultYearMonth !== void 0) {
        const X = e.defaultYearMonth.split("/");
        F = parseInt(X[0], 10), N = parseInt(X[1], 10);
      } else {
        const X = S.value !== void 0 ? S.value : u();
        F = X.year, N = X.month;
      }
      return {
        year: F,
        month: N,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        dateHash: F + "/" + Xe(N) + "/01"
      };
    }
    function ke(F) {
      let N = h.value.year, X = Number(h.value.month) + F;
      X === 13 ? (X = 1, N++) : X === 0 && (X = 12, N--), Dt(N, X), x.value === !0 && ol("month");
    }
    function Pe(F) {
      const N = Number(h.value.year) + F;
      Dt(N, h.value.month), x.value === !0 && ol("year");
    }
    function Ye(F) {
      Dt(F, h.value.month), C.value = e.defaultView === "Years" ? "Months" : "Calendar", x.value === !0 && ol("year");
    }
    function At(F) {
      Dt(h.value.year, F), C.value = "Calendar", x.value === !0 && ol("month");
    }
    function He(F, N) {
      const X = St.value[N];
      (X !== void 0 && X.includes(F.day) === !0 ? Dl : _l)(F);
    }
    function it(F) {
      return { year: F.year, month: F.month, day: F.day };
    }
    function Dt(F, N, X) {
      if (we.value !== null && F <= we.value.year && (F = we.value.year, N < we.value.month && (N = we.value.month)), Ie.value !== null && F >= Ie.value.year && (F = Ie.value.year, N > Ie.value.month && (N = Ie.value.month)), X !== void 0) {
        const { hour: pe, minute: Ge, second: xe, millisecond: Be, timezoneOffset: et, timeHash: Zt } = X;
        Object.assign(h.value, { hour: pe, minute: Ge, second: xe, millisecond: Be, timezoneOffset: et, timeHash: Zt });
      }
      const be = F + "/" + Xe(N) + "/01";
      be !== h.value.dateHash && (I.value = h.value.dateHash < be == (a.lang.rtl !== !0) ? "left" : "right", F !== h.value.year && (E.value = I.value), lt(() => {
        O.value = F - F % Fl - (F < 0 ? Fl : 0), Object.assign(h.value, {
          year: F,
          month: N,
          day: 1,
          dateHash: be
        });
      }));
    }
    function tl(F, N, X) {
      const be = F !== null && F.length === 1 && e.multiple === !1 ? F[0] : F;
      m = be;
      const { reason: pe, details: Ge } = Hl(N, X);
      l("update:modelValue", be, pe, Ge);
    }
    function ol(F) {
      const N = q.value[0] !== void 0 && q.value[0].dateHash !== null ? { ...q.value[0] } : { ...h.value };
      lt(() => {
        N.year = h.value.year, N.month = h.value.month;
        const X = e.calendar !== "persian" ? new Date(N.year, N.month, 0).getDate() : Nn(N.year, N.month);
        N.day = Math.min(Math.max(1, N.day), X);
        const be = sl(N);
        m = be;
        const { details: pe } = Hl("", N);
        l("update:modelValue", be, F, pe);
      });
    }
    function Hl(F, N) {
      return N.from !== void 0 ? {
        reason: `${F}-range`,
        details: {
          ...it(N.target),
          from: it(N.from),
          to: it(N.to)
        }
      } : {
        reason: `${F}-day`,
        details: it(N)
      };
    }
    function sl(F, N, X) {
      return F.from !== void 0 ? { from: Q.value(F.from, N, X), to: Q.value(F.to, N, X) } : Q.value(F, N, X);
    }
    function _l(F) {
      let N;
      if (e.multiple === !0)
        if (F.from !== void 0) {
          const X = pl(F.from), be = pl(F.to), pe = q.value.filter((xe) => xe.dateHash < X || xe.dateHash > be), Ge = Y.value.filter(({ from: xe, to: Be }) => Be.dateHash < X || xe.dateHash > be);
          N = pe.concat(Ge).concat(F).map((xe) => sl(xe));
        } else {
          const X = B.value.slice();
          X.push(sl(F)), N = X;
        }
      else
        N = sl(F);
      tl(N, "add", F);
    }
    function Dl(F) {
      if (e.noUnset === !0)
        return;
      let N = null;
      if (e.multiple === !0 && Array.isArray(e.modelValue) === !0) {
        const X = sl(F);
        F.from !== void 0 ? N = e.modelValue.filter(
          (be) => be.from !== void 0 ? be.from !== X.from && be.to !== X.to : !0
        ) : N = e.modelValue.filter((be) => be !== X), N.length === 0 && (N = null);
      }
      tl(N, "remove", F);
    }
    function le(F, N, X) {
      const be = q.value.concat(Y.value).map((pe) => sl(pe, F, N)).filter((pe) => pe.from !== void 0 ? pe.from.dateHash !== null && pe.to.dateHash !== null : pe.dateHash !== null);
      l("update:modelValue", (e.multiple === !0 ? be : be[0]) || null, X);
    }
    function ye() {
      if (e.minimal !== !0)
        return V("div", {
          class: "q-date__header " + d.value
        }, [
          V("div", {
            class: "relative-position"
          }, [
            V(Qt, {
              name: "q-transition--fade"
            }, () => V("div", {
              key: "h-yr-" + te.value,
              class: "q-date__header-subtitle q-date__header-link " + (C.value === "Years" ? "q-date__header-link--active" : "cursor-pointer"),
              tabindex: s.value,
              ...r("vY", {
                onClick() {
                  C.value = "Years";
                },
                onKeyup(F) {
                  F.keyCode === 13 && (C.value = "Years");
                }
              })
            }, [te.value]))
          ]),
          V("div", {
            class: "q-date__header-title relative-position flex no-wrap"
          }, [
            V("div", {
              class: "relative-position col"
            }, [
              V(Qt, {
                name: "q-transition--fade"
              }, () => V("div", {
                key: "h-sub" + H.value,
                class: "q-date__header-title-label q-date__header-link " + (C.value === "Calendar" ? "q-date__header-link--active" : "cursor-pointer"),
                tabindex: s.value,
                ...r("vC", {
                  onClick() {
                    C.value = "Calendar";
                  },
                  onKeyup(F) {
                    F.keyCode === 13 && (C.value = "Calendar");
                  }
                })
              }, [H.value]))
            ]),
            e.todayBtn === !0 ? V(se, {
              class: "q-date__header-today self-start",
              icon: a.iconSet.datetime.today,
              flat: !0,
              size: "sm",
              round: !0,
              tabindex: s.value,
              onClick: $e
            }) : null
          ])
        ]);
    }
    function Te({ label: F, type: N, key: X, dir: be, goTo: pe, boundaries: Ge, cls: xe }) {
      return [
        V("div", {
          class: "row items-center q-date__arrow"
        }, [
          V(se, {
            round: !0,
            dense: !0,
            size: "sm",
            flat: !0,
            icon: oe.value[0],
            tabindex: s.value,
            disable: Ge.prev === !1,
            ...r("go-#" + N, { onClick() {
              pe(-1);
            } })
          })
        ]),
        V("div", {
          class: "relative-position overflow-hidden flex flex-center" + xe
        }, [
          V(Qt, {
            name: "q-transition--jump-" + be
          }, () => V("div", { key: X }, [
            V(se, {
              flat: !0,
              dense: !0,
              noCaps: !0,
              label: F,
              tabindex: s.value,
              ...r("view#" + N, { onClick: () => {
                C.value = N;
              } })
            })
          ]))
        ]),
        V("div", {
          class: "row items-center q-date__arrow"
        }, [
          V(se, {
            round: !0,
            dense: !0,
            size: "sm",
            flat: !0,
            icon: oe.value[1],
            tabindex: s.value,
            disable: Ge.next === !1,
            ...r("go+#" + N, { onClick() {
              pe(1);
            } })
          })
        ])
      ];
    }
    const Fe = {
      Calendar: () => [
        V("div", {
          key: "calendar-view",
          class: "q-date__view q-date__calendar"
        }, [
          V("div", {
            class: "q-date__navigation row items-center no-wrap"
          }, Te({
            label: y.value.months[h.value.month - 1],
            type: "Months",
            key: h.value.month,
            dir: I.value,
            goTo: ke,
            boundaries: ot.value.month,
            cls: " col"
          }).concat(Te({
            label: h.value.year,
            type: "Years",
            key: h.value.year,
            dir: E.value,
            goTo: Pe,
            boundaries: ot.value.year,
            cls: ""
          }))),
          V("div", {
            class: "q-date__calendar-weekdays row items-center no-wrap"
          }, Z.value.map((F) => V("div", { class: "q-date__calendar-item" }, [V("div", F)]))),
          V("div", {
            class: "q-date__calendar-days-container relative-position overflow-hidden"
          }, [
            V(Qt, {
              name: "q-transition--slide-" + I.value
            }, () => V("div", {
              key: pt.value,
              class: "q-date__calendar-days fit"
            }, ue.value.map((F) => V("div", { class: F.classes }, [
              F.in === !0 ? V(
                se,
                {
                  class: F.today === !0 ? "q-date__today" : "",
                  dense: !0,
                  flat: F.flat,
                  unelevated: F.unelevated,
                  color: F.color,
                  textColor: F.textColor,
                  label: F.i,
                  tabindex: s.value,
                  ...r("day#" + F.i, {
                    onClick: () => {
                      je(F.i);
                    },
                    onMouseover: () => {
                      gt(F.i);
                    }
                  })
                },
                F.event !== !1 ? () => V("div", { class: "q-date__event bg-" + F.event }) : null
              ) : V("div", "" + F.i)
            ]))))
          ])
        ])
      ],
      Months() {
        const F = h.value.year === S.value.year, N = (be) => we.value !== null && h.value.year === we.value.year && we.value.month > be || Ie.value !== null && h.value.year === Ie.value.year && Ie.value.month < be, X = y.value.monthsShort.map((be, pe) => {
          const Ge = h.value.month === pe + 1;
          return V("div", {
            class: "q-date__months-item flex flex-center"
          }, [
            V(se, {
              class: F === !0 && S.value.month === pe + 1 ? "q-date__today" : null,
              flat: Ge !== !0,
              label: be,
              unelevated: Ge,
              color: Ge === !0 ? k.value : null,
              textColor: Ge === !0 ? g.value : null,
              tabindex: s.value,
              disable: N(pe + 1),
              ...r("month#" + pe, { onClick: () => {
                At(pe + 1);
              } })
            })
          ]);
        });
        return e.yearsInMonthView === !0 && X.unshift(
          V("div", { class: "row no-wrap full-width" }, [
            Te({
              label: h.value.year,
              type: "Years",
              key: h.value.year,
              dir: E.value,
              goTo: Pe,
              boundaries: ot.value.year,
              cls: " col"
            })
          ])
        ), V("div", {
          key: "months-view",
          class: "q-date__view q-date__months flex flex-center"
        }, X);
      },
      Years() {
        const F = O.value, N = F + Fl, X = [], be = (pe) => we.value !== null && we.value.year > pe || Ie.value !== null && Ie.value.year < pe;
        for (let pe = F; pe <= N; pe++) {
          const Ge = h.value.year === pe;
          X.push(
            V("div", {
              class: "q-date__years-item flex flex-center"
            }, [
              V(se, {
                key: "yr" + pe,
                class: S.value.year === pe ? "q-date__today" : null,
                flat: !Ge,
                label: pe,
                dense: !0,
                unelevated: Ge,
                color: Ge === !0 ? k.value : null,
                textColor: Ge === !0 ? g.value : null,
                tabindex: s.value,
                disable: be(pe),
                ...r("yr#" + pe, { onClick: () => {
                  Ye(pe);
                } })
              })
            ])
          );
        }
        return V("div", {
          class: "q-date__view q-date__years flex flex-center"
        }, [
          V("div", {
            class: "col-auto"
          }, [
            V(se, {
              round: !0,
              dense: !0,
              flat: !0,
              icon: oe.value[0],
              tabindex: s.value,
              disable: be(F),
              ...r("y-", { onClick: () => {
                O.value -= Fl;
              } })
            })
          ]),
          V("div", {
            class: "q-date__years-content col self-stretch row items-center"
          }, X),
          V("div", {
            class: "col-auto"
          }, [
            V(se, {
              round: !0,
              dense: !0,
              flat: !0,
              icon: oe.value[1],
              tabindex: s.value,
              disable: be(N),
              ...r("y+", { onClick: () => {
                O.value += Fl;
              } })
            })
          ])
        ]);
      }
    };
    function je(F) {
      const N = { ...h.value, day: F };
      if (e.range === !1) {
        He(N, pt.value);
        return;
      }
      if (P.value === null) {
        const X = ue.value.find((pe) => pe.fill !== !0 && pe.i === F);
        if (e.noUnset !== !0 && X.range !== void 0) {
          Dl({ target: N, from: X.range.from, to: X.range.to });
          return;
        }
        if (X.selected === !0) {
          Dl(N);
          return;
        }
        const be = pl(N);
        P.value = {
          init: N,
          initHash: be,
          final: N,
          finalHash: be
        }, l("rangeStart", it(N));
      } else {
        const X = P.value.initHash, be = pl(N), pe = X <= be ? { from: P.value.init, to: N } : { from: N, to: P.value.init };
        P.value = null, _l(X === be ? N : { target: N, ...pe }), l("rangeEnd", {
          from: it(pe.from),
          to: it(pe.to)
        });
      }
    }
    function gt(F) {
      if (P.value !== null) {
        const N = { ...h.value, day: F };
        Object.assign(P.value, {
          final: N,
          finalHash: pl(N)
        });
      }
    }
    return Object.assign(n, {
      setToday: $e,
      setView: tt,
      offsetCalendar: Je,
      setCalendarTo: Re,
      setEditingRange: Ue
    }), () => {
      const F = [
        V("div", {
          class: "q-date__content col relative-position"
        }, [
          V(Qt, {
            name: "q-transition--fade"
          }, Fe[C.value])
        ])
      ], N = We(t.default);
      return N !== void 0 && F.push(
        V("div", { class: "q-date__actions" }, N)
      ), e.name !== void 0 && e.disable !== !0 && f(F, "push"), V("div", {
        class: $.value,
        ..._e.value
      }, [
        ye(),
        V("div", {
          ref: _,
          class: "q-date__main col column",
          tabindex: -1
        }, F)
      ]);
    };
  }
}), gf = { key: 1 }, yf = /* @__PURE__ */ Ce({
  __name: "DateTime",
  setup(e) {
    var s, d;
    const t = Me("_uct"), l = [
      { value: "days", label: t("builder.tabs.validation.date.days") },
      { value: "weeks", label: t("builder.tabs.validation.date.weeks") },
      { value: "months", label: t("builder.tabs.validation.date.months") },
      { value: "years", label: t("builder.tabs.validation.date.years") }
    ], n = Ee(), { field: a, itemId: i } = Ke(), r = G(!((d = (s = a.value) == null ? void 0 : s.authorizedDates) != null && d.length));
    return me(r, () => {
      if (r.value) {
        n.updateField(i.value, "authorizedDates", null);
        return;
      }
      n.updateField(i.value, "minValue", null), n.updateField(i.value, "minUnit", null), n.updateField(i.value, "minDateFuture", null), n.updateField(i.value, "maxValue", null), n.updateField(i.value, "maxUnit", null), n.updateField(i.value, "maxDateFuture", null);
    }), (c, u) => {
      var m, p, f, _, v, y, M, w, S;
      return z(), re("section", null, [
        ee("h2", null, J(o(t)("builder.tabs.validation.date.title")), 1),
        D(at, {
          label: o(t)("builder.tabs.validation.date.multiple"),
          "model-value": ((m = o(a)) == null ? void 0 : m.dateMultiple) || !1,
          "onUpdate:modelValue": u[0] || (u[0] = (h) => o(n).updateField(o(i), "dateMultiple", h || null))
        }, null, 8, ["label", "model-value"]),
        D(at, {
          label: o(t)("builder.tabs.validation.date.period"),
          "model-value": ((p = o(a)) == null ? void 0 : p.dateIsRange) || !1,
          "onUpdate:modelValue": u[1] || (u[1] = (h) => o(n).updateField(o(i), "dateIsRange", h || null))
        }, null, 8, ["label", "model-value"]),
        D(at, {
          modelValue: r.value,
          "onUpdate:modelValue": u[2] || (u[2] = (h) => r.value = h),
          label: o(t)("builder.tabs.validation.date.isRelativeValidationDate")
        }, null, 8, ["modelValue", "label"]),
        r.value ? (z(), re(Ve, { key: 0 }, [
          ee("section", null, [
            ee("h3", null, J(o(t)("builder.tabs.validation.minimum")), 1),
            ee("div", null, [
              D(Ne, {
                label: o(t)("builder.tabs.validation.minValue"),
                "model-value": (f = o(a)) == null ? void 0 : f.minValue,
                clearable: "",
                type: "number",
                "onUpdate:modelValue": u[3] || (u[3] = (h) => o(n).updateField(o(i), "minValue", h))
              }, null, 8, ["label", "model-value"]),
              D(Rt, {
                label: o(t)("builder.tabs.validation.unit"),
                "model-value": (_ = o(a)) == null ? void 0 : _.minUnit,
                options: l,
                clearable: "",
                "emit-value": "",
                "map-options": "",
                "onUpdate:modelValue": u[4] || (u[4] = (h) => o(n).updateField(o(i), "minUnit", h))
              }, null, 8, ["label", "model-value"]),
              D(Bt, {
                label: o(t)("builder.tabs.validation.futureLabel"),
                "model-value": ((v = o(a)) == null ? void 0 : v.minDateFuture) || !1,
                "onUpdate:modelValue": u[5] || (u[5] = (h) => o(n).updateField(o(i), "minDateFuture", h))
              }, null, 8, ["label", "model-value"])
            ])
          ]),
          D(ln),
          ee("section", null, [
            ee("h3", null, J(o(t)("builder.tabs.validation.maximum")), 1),
            ee("div", null, [
              D(Ne, {
                label: o(t)("builder.tabs.validation.maxValue"),
                "model-value": (y = o(a)) == null ? void 0 : y.maxValue,
                clearable: "",
                type: "number",
                "onUpdate:modelValue": u[6] || (u[6] = (h) => o(n).updateField(o(i), "maxValue", h))
              }, null, 8, ["label", "model-value"]),
              D(Rt, {
                label: o(t)("builder.tabs.validation.unit"),
                "model-value": (M = o(a)) == null ? void 0 : M.maxUnit,
                options: l,
                clearable: "",
                "emit-value": "",
                "map-options": "",
                "onUpdate:modelValue": u[7] || (u[7] = (h) => o(n).updateField(o(i), "maxUnit", h))
              }, null, 8, ["label", "model-value"]),
              D(Bt, {
                label: o(t)("builder.tabs.validation.futureLabel"),
                "model-value": ((w = o(a)) == null ? void 0 : w.maxDateFuture) || !1,
                "onUpdate:modelValue": u[8] || (u[8] = (h) => o(n).updateField(o(i), "maxDateFuture", h))
              }, null, 8, ["label", "model-value"])
            ])
          ])
        ], 64)) : (z(), re("section", gf, [
          ee("h3", null, J(o(t)("builder.tabs.validation.date.list.title")), 1),
          D(iu, {
            "model-value": (S = o(a)) == null ? void 0 : S.authorizedDates,
            multiple: "",
            "onUpdate:modelValue": u[9] || (u[9] = (h) => o(n).updateField(o(i), "authorizedDates", h))
          }, null, 8, ["model-value"])
        ]))
      ]);
    };
  }
});
const _f = /* @__PURE__ */ Oe(yf, [["__scopeId", "data-v-b9225e61"]]), Sf = /* @__PURE__ */ Ce({
  __name: "DefaultText",
  setup(e) {
    var u;
    const t = Me("_uct"), l = Lt(), n = Ee(), { field: a, itemId: i, isDateField: r, isDefaultTokenValueField: s } = Ke(), d = G(!!((u = a.value) != null && u.defaultTokenValue)), c = (m) => {
      d.value = m, m ? n.updateField(i.value, "defaultTokenValue", "") : n.updateField(i.value, "defaultTokenValue", null);
    };
    return (m, p) => {
      var f, _;
      return z(), re("section", null, [
        ee("h2", null, J(o(t)("builder.tabs.validation.tokenField.title")), 1),
        o(l).isHybridForm && o(s) ? (z(), ae(at, {
          key: 0,
          label: o(t)("builder.tabs.validation.tokenField.switchLabel"),
          "model-value": d.value,
          "onUpdate:modelValue": c
        }, null, 8, ["label", "model-value"])) : ce("", !0),
        d.value ? (z(), ae(Rt, {
          key: 1,
          "model-value": (f = o(a)) == null ? void 0 : f.defaultTokenValue,
          options: o(l).userTokenInfo,
          "onUpdate:modelValue": p[0] || (p[0] = (v) => o(n).updateField(o(i), "defaultTokenValue", v))
        }, null, 8, ["model-value", "options"])) : !d.value && !o(r) ? (z(), ae(Ne, {
          key: 2,
          label: o(t)("builder.tabs.validation.defaultValue"),
          "model-value": (_ = o(a)) == null ? void 0 : _.defaultValue,
          "onUpdate:modelValue": p[1] || (p[1] = (v) => o(n).updateField(o(i), "defaultValue", v))
        }, null, 8, ["label", "model-value"])) : ce("", !0)
      ]);
    };
  }
}), wf = /* @__PURE__ */ Ce({
  __name: "FileSizeInput",
  setup(e) {
    const t = Me("_uct"), l = Ee(), { itemId: n } = Ke(), { convertFileSize: a, fileSizeMultipliers: i, getFileSizeMultiplier: r } = wo(n);
    return (s, d) => (z(), re("section", null, [
      ee("h2", null, J(o(t)("builder.tabs.validation.fileSize.title")), 1),
      ee("div", null, [
        D(Ne, {
          label: o(t)("builder.tabs.validation.fileSize.max"),
          "model-value": o(a),
          type: "number",
          "onUpdate:modelValue": d[0] || (d[0] = (c) => o(l).updateField(o(n), "max", c * o(r)))
        }, null, 8, ["label", "model-value"]),
        D(Rt, {
          label: o(t)("builder.tabs.validation.unit"),
          "model-value": o(r),
          options: o(i),
          "emit-value": "",
          "map-options": "",
          "onUpdate:modelValue": d[1] || (d[1] = (c) => o(l).updateField(o(n), "max", o(a) * c))
        }, null, 8, ["label", "model-value", "options"])
      ])
    ]));
  }
});
const xf = /* @__PURE__ */ Oe(wf, [["__scopeId", "data-v-8e4acd05"]]), Ra = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/svg+xml",
  "image/webp",
  "image/x-icon"
], za = [
  "video/mp4",
  "video/webm",
  "video/ogg",
  "video/x-flv",
  "video/x-msvideo",
  "video/x-ms-wmv",
  "video/quicktime"
], Ua = [
  "audio/mpeg",
  "audio/wav",
  "audio/ogg",
  "audio/flac",
  "audio/aac",
  "audio/x-m4a"
], Al = [
  "application/pdf",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.ms-powerpoint",
  "application/vnd.oasis.opendocument.text",
  "application/vnd.oasis.opendocument.spreadsheet",
  "application/vnd.oasis.opendocument.presentation",
  "application/vnd.oasis.opendocument.graphics",
  "application/vnd.oasis.opendocument.chart",
  "application/vnd.oasis.opendocument.formula",
  "text/plain",
  "text/rtf",
  "text/csv",
  "application/zip",
  "application/x-rar-compressed",
  "application/x-7z-compressed"
], kf = (e) => {
  const t = Ee(), { field: l, itemId: n } = Ke(), a = [
    {
      label: e("builder.tabs.validation.fileType.types.image"),
      value: "image/*",
      children: [
        { label: ".jpg/.jpeg", value: "image/jpeg" },
        { label: ".png", value: "image/png" },
        { label: ".gif", value: "image/gif" },
        { label: ".svg", value: "image/svg+xml" },
        { label: ".webp", value: "image/webp" },
        { label: ".ico", value: "image/x-icon" }
      ]
    },
    {
      label: e("builder.tabs.validation.fileType.types.video"),
      value: "video/*",
      children: [
        { label: ".mp4", value: "video/mp4" },
        { label: ".webm", value: "video/webm" },
        { label: ".ogg", value: "video/ogg" },
        { label: ".flv", value: "video/x-flv" },
        { label: ".avi", value: "video/x-msvideo" },
        { label: ".wmv", value: "video/x-ms-wmv" },
        { label: ".mov", value: "video/quicktime" }
      ]
    },
    {
      label: e("builder.tabs.validation.fileType.types.audio"),
      value: "audio/*",
      children: [
        { label: ".mp3", value: "audio/mpeg" },
        { label: ".wav", value: "audio/wav" },
        { label: ".ogg", value: "audio/ogg" },
        { label: ".flac", value: "audio/flac" },
        { label: ".aac", value: "audio/aac" },
        { label: ".m4a", value: "audio/x-m4a" }
      ]
    },
    {
      label: e("builder.tabs.validation.fileType.types.file"),
      value: "document",
      children: [
        { label: ".pdf", value: "application/pdf" },
        { label: ".doc/.docx", value: "application/msword" },
        { label: ".xls/.xlsx", value: "application/vnd.ms-excel" },
        { label: ".ppt/.pptx", value: "application/vnd.ms-powerpoint" },
        { label: ".odt", value: "application/vnd.oasis.opendocument.text" },
        { label: ".ods", value: "application/vnd.oasis.opendocument.spreadsheet" },
        { label: ".odp", value: "application/vnd.oasis.opendocument.presentation" },
        { label: ".odg", value: "application/vnd.oasis.opendocument.graphics" },
        { label: ".odc", value: "application/vnd.oasis.opendocument.chart" },
        { label: ".odf", value: "application/vnd.oasis.opendocument.formula" },
        { label: ".txt", value: "text/plain" },
        { label: ".rtf", value: "text/rtf" },
        { label: ".csv", value: "text/csv" },
        { label: ".json", value: "application/json" },
        { label: ".zip", value: "application/zip" },
        { label: ".rar", value: "application/x-rar-compressed" },
        { label: ".7z", value: "application/x-7z-compressed" }
      ]
    }
  ], i = (c) => {
    var p, f, _, v;
    if (((p = l.value) == null ? void 0 : p.accept) === void 0 && t.updateField(n.value, "accept", "*/*"), c === "all") {
      if (((f = l.value) == null ? void 0 : f.accept) === "*/*") {
        t.updateField(n.value, "accept", "", !1, !0);
        return;
      }
      t.updateField(n.value, "accept", "*/*");
      return;
    }
    if (((_ = l.value) == null ? void 0 : _.accept) === "*/*") {
      i("all");
      const y = ["image/*", "video/*", "audio/*", "document"];
      if (c === "image/*" || c === "video/*" || c === "audio/*" || c === "document") {
        y.filter((S) => S !== c).forEach((S) => i(S));
        return;
      }
      const M = () => c.includes("image/") ? Ra : c.includes("video/") ? za : c.includes("audio/") ? Ua : Al, w = () => c.includes("image/") ? y.filter((S) => S !== "image/*") : c.includes("video/") ? y.filter((S) => S !== "video/*") : c.includes("audio/") ? y.filter((S) => S !== "audio/*") : y.filter((S) => S !== "document");
      M().filter((S) => S !== c).forEach((S) => i(S)), w().forEach((S) => i(S));
      return;
    }
    let u = (((v = l.value) == null ? void 0 : v.accept) || "").split(",").filter((y) => y !== "*/*" && y !== "");
    if (u.includes(c)) {
      u.splice(u.indexOf(c), 1), t.updateField(n.value, "accept", u.join(","), !1, !0);
      return;
    }
    const m = () => Al.every((y) => u.includes(y)) && u.includes("image/*") && u.includes("video/*") && u.includes("audio/*");
    if (c === "image/*" || c === "video/*" || c === "audio/*") {
      if (u = u.filter((y) => !y.includes(c.substring(0, c.length - 1))), u.push(c), m()) {
        t.updateField(n.value, "accept", "*/*");
        return;
      }
      t.updateField(n.value, "accept", u.join(","));
      return;
    }
    if (c === "document") {
      if (Al.every((y) => u.includes(y))) {
        u = u.filter((y) => !Al.includes(y)), t.updateField(n.value, "accept", u.join(","));
        return;
      }
      if (u = u.filter((y) => !Al.includes(y)), u.push(...Al), m()) {
        t.updateField(n.value, "accept", "*/*");
        return;
      }
      t.updateField(n.value, "accept", u.join(","));
      return;
    }
    if (c.includes("image/") && u.includes("image/*"))
      u = u.filter((y) => y !== c.split("/")[0] + "/*"), u.push(...Ra.filter((y) => y !== c));
    else if (c.includes("video/") && u.includes("video/*"))
      u = u.filter((y) => y !== c.split("/")[0] + "/*"), u.push(...za.filter((y) => y !== c));
    else if (c.includes("audio/") && u.includes("audio/*"))
      u = u.filter((y) => y !== c.split("/")[0] + "/*"), u.push(...Ua.filter((y) => y !== c));
    else if (u.push(c), (c.includes("application/") || c.includes("text/")) && m()) {
      t.updateField(n.value, "accept", "*/*");
      return;
    }
    if (Ra.every((y) => u.includes(y))) {
      i("image/*");
      return;
    }
    if (Ua.every((y) => u.includes(y))) {
      i("audio/*");
      return;
    }
    if (za.every((y) => u.includes(y))) {
      i("video/*");
      return;
    }
    t.updateField(n.value, "accept", u.join(","), !1, !0);
  }, r = b(() => {
    var c;
    return ((c = l.value) == null ? void 0 : c.accept) === void 0 || l.value.accept === "*/*" ? !0 : l.value.accept === "" ? !1 : null;
  }), s = (c) => {
    var u, m, p, f, _, v, y, M, w, S, h, C, T, I, E, A;
    if (r.value)
      return !0;
    switch (c) {
      case "image/*":
        return (m = (u = l.value) == null ? void 0 : u.accept) != null && m.includes("image/*") ? !0 : (f = (p = l.value) == null ? void 0 : p.accept) != null && f.includes("image/") ? null : !1;
      case "video/*":
        return (v = (_ = l.value) == null ? void 0 : _.accept) != null && v.includes("video/*") ? !0 : (M = (y = l.value) == null ? void 0 : y.accept) != null && M.includes("video/") ? null : !1;
      case "audio/*":
        return (S = (w = l.value) == null ? void 0 : w.accept) != null && S.includes("audio/*") ? !0 : (C = (h = l.value) == null ? void 0 : h.accept) != null && C.includes("audio/") ? null : !1;
      case "document":
        return Al.every((O) => {
          var P, $;
          return ($ = (P = l.value) == null ? void 0 : P.accept) == null ? void 0 : $.includes(O);
        }) ? !0 : (I = (T = l.value) == null ? void 0 : T.accept) != null && I.includes("application/") || (A = (E = l.value) == null ? void 0 : E.accept) != null && A.includes("text/") ? null : !1;
    }
  };
  return {
    fileTypeList: a,
    updateFileType: i,
    all: r,
    getFileTypeParent: s,
    getFileType: (c) => {
      var u, m;
      return r.value || (m = (u = l.value) == null ? void 0 : u.accept) != null && m.includes(c) ? !0 : c.includes("image/") ? !!s("image/*") : c.includes("video/") ? !!s("video/*") : c.includes("audio/") ? !!s("audio/*") : !!s("document");
    }
  };
}, Cf = { key: 1 }, qf = /* @__PURE__ */ Ce({
  __name: "FileTypeInput",
  setup(e) {
    const t = Me("_uct"), l = G(!1), { field: n, itemId: a } = Ke(), i = Ee(), { fileTypeList: r, all: s, updateFileType: d, getFileTypeParent: c, getFileType: u } = kf(t);
    return (m, p) => {
      var f;
      return z(), re("section", null, [
        ee("h2", null, J(o(t)("builder.tabs.validation.fileType.title")), 1),
        D(at, {
          modelValue: l.value,
          "onUpdate:modelValue": p[0] || (p[0] = (_) => l.value = _),
          label: o(t)("builder.tabs.validation.fileType.isCustomList")
        }, null, 8, ["modelValue", "label"]),
        l.value ? (z(), ae(Ne, {
          key: 0,
          label: o(t)("builder.tabs.validation.fileType.isCustomList"),
          "model-value": ((f = o(n)) == null ? void 0 : f.accept) || "",
          "onUpdate:modelValue": p[1] || (p[1] = (_) => o(i).updateField(o(a), "accept", _))
        }, null, 8, ["label", "model-value"])) : (z(), re("ul", Cf, [
          ee("li", null, [
            D(Bt, {
              label: o(t)("builder.tabs.validation.fileType.types.all"),
              "model-value": o(s),
              "onUpdate:modelValue": p[2] || (p[2] = (_) => o(d)("all"))
            }, null, 8, ["label", "model-value"])
          ]),
          ee("li", null, [
            ee("ul", null, [
              (z(!0), re(Ve, null, dt(o(r), (_) => (z(), re(Ve, {
                key: _.value
              }, [
                ee("li", null, [
                  D(Bt, {
                    label: _.label,
                    "model-value": o(c)(_.value),
                    "onUpdate:modelValue": (v) => o(d)(_.value)
                  }, null, 8, ["label", "model-value", "onUpdate:modelValue"])
                ]),
                ee("li", null, [
                  ee("ul", null, [
                    (z(!0), re(Ve, null, dt(_.children, (v) => (z(), re("li", {
                      key: v.value
                    }, [
                      D(Bt, {
                        label: v.label,
                        "model-value": o(u)(v.value),
                        "onUpdate:modelValue": (y) => o(d)(v.value)
                      }, null, 8, ["label", "model-value", "onUpdate:modelValue"])
                    ]))), 128))
                  ])
                ])
              ], 64))), 128))
            ])
          ])
        ]))
      ]);
    };
  }
});
const Vf = /* @__PURE__ */ Oe(qf, [["__scopeId", "data-v-346ce1bf"]]), Tf = { scope: "col" }, Mf = { scope: "col" }, Df = { scope: "row" }, If = /* @__PURE__ */ Ce({
  __name: "MaskWrite",
  setup(e) {
    const t = Me("_uct"), l = Ee(), { field: n, itemId: a } = Ke(), i = [
      { token: "#", description: t("builder.tabs.validation.mask.banner.table.descriptions.numeric") },
      { token: "S", description: t("builder.tabs.validation.mask.banner.table.descriptions.alpha") },
      { token: "N", description: t("builder.tabs.validation.mask.banner.table.descriptions.alphanumeric") },
      { token: "A", description: t("builder.tabs.validation.mask.banner.table.descriptions.uppercase") },
      { token: "a", description: t("builder.tabs.validation.mask.banner.table.descriptions.lowercase") },
      { token: "X", description: t("builder.tabs.validation.mask.banner.table.descriptions.alphanumericUpper") },
      { token: "x", description: t("builder.tabs.validation.mask.banner.table.descriptions.alphanumericLower") }
    ];
    return (r, s) => {
      var d, c, u;
      return z(), re("section", null, [
        ee("h2", null, J(o(t)("builder.tabs.validation.mask.title")), 1),
        D(Vl, { class: "bg-info" }, {
          avatar: L(() => [
            D(Qe, { name: "mdi-information-outline" })
          ]),
          default: L(() => [
            ve(" " + J(o(t)("builder.tabs.validation.mask.banner.core")) + " ", 1),
            ee("table", null, [
              ee("thead", null, [
                ee("tr", null, [
                  ee("th", Tf, J(o(t)("builder.tabs.validation.mask.banner.table.headers.token")), 1),
                  ee("th", Mf, J(o(t)("builder.tabs.validation.mask.banner.table.headers.description")), 1)
                ])
              ]),
              ee("tbody", null, [
                (z(), re(Ve, null, dt(i, (m) => ee("tr", {
                  key: m.token
                }, [
                  ee("th", Df, J(m.token), 1),
                  ee("td", null, J(m.description), 1)
                ])), 64))
              ])
            ]),
            ee("p", null, [
              D(Qe, { name: "mdi-alert-outline" }),
              ve(" " + J(o(t)("builder.tabs.validation.mask.banner.warning")), 1)
            ]),
            ee("p", null, J(o(t)("builder.tabs.validation.mask.banner.example")), 1),
            ee("p", null, J(o(t)("builder.tabs.validation.mask.modelUnmasked.hint")), 1)
          ]),
          _: 1
        }),
        D(Ne, {
          label: o(t)("builder.tabs.validation.mask.title"),
          "model-value": ((d = o(n)) == null ? void 0 : d.mask) || "",
          "onUpdate:modelValue": s[0] || (s[0] = (m) => o(l).updateField(o(a), "mask", m))
        }, null, 8, ["label", "model-value"]),
        D(at, {
          label: o(t)("builder.tabs.validation.mask.filling"),
          "model-value": ((c = o(n)) == null ? void 0 : c.maskFilling) || !1,
          "onUpdate:modelValue": s[1] || (s[1] = (m) => o(l).updateField(o(a), "maskFilling", m))
        }, null, 8, ["label", "model-value"]),
        D(at, {
          label: o(t)("builder.tabs.validation.mask.modelUnmasked.label"),
          "model-value": ((u = o(n)) == null ? void 0 : u.modelUnmasked) || !1,
          "onUpdate:modelValue": s[2] || (s[2] = (m) => o(l).updateField(o(a), "modelUnmasked", m))
        }, null, 8, ["label", "model-value"])
      ]);
    };
  }
});
const $f = /* @__PURE__ */ Oe(If, [["__scopeId", "data-v-77f44d09"]]), Ff = /* @__PURE__ */ Ce({
  __name: "TextBased",
  setup(e) {
    const t = Me("_uct"), l = Ee(), { field: n, itemId: a } = Ke();
    return (i, r) => {
      var s, d, c, u;
      return z(), re("section", null, [
        ee("h2", null, J(o(t)("builder.tabs.validation.fieldSize")), 1),
        ee("div", null, [
          D(Ne, {
            label: o(t)("builder.tabs.validation.minimum"),
            "model-value": (s = o(n)) == null ? void 0 : s.min,
            type: "number",
            "onUpdate:modelValue": r[0] || (r[0] = (m) => o(l).updateField(o(a), "min", m === "" ? "" : parseFloat(m)))
          }, null, 8, ["label", "model-value"]),
          D(Ne, {
            label: o(t)("builder.tabs.validation.maximum"),
            "model-value": (d = o(n)) == null ? void 0 : d.max,
            type: "number",
            "onUpdate:modelValue": r[1] || (r[1] = (m) => o(l).updateField(o(a), "max", m === "" ? "" : parseFloat(m)))
          }, null, 8, ["label", "model-value"]),
          ((c = o(n)) == null ? void 0 : c.type) === "number" ? (z(), ae(Ne, {
            key: 0,
            label: o(t)("builder.tabs.validation.step"),
            "model-value": (u = o(n)) == null ? void 0 : u.step,
            type: "number",
            "onUpdate:modelValue": r[2] || (r[2] = (m) => o(l).updateField(o(a), "step", m === "" ? "" : parseFloat(m)))
          }, null, 8, ["label", "model-value"])) : ce("", !0)
        ])
      ]);
    };
  }
});
const Af = /* @__PURE__ */ Oe(Ff, [["__scopeId", "data-v-ff4d0cb4"]]), Of = /* @__PURE__ */ Ce({
  __name: "ValidationTab",
  setup(e) {
    const t = Me("_uct"), l = Ee(), { field: n, itemId: a, hasDefaultText: i, isTextBased: r, isFile: s, isDateTime: d, isInput: c } = Ke();
    return (u, m) => {
      var p;
      return z(), re("section", null, [
        ee("section", null, [
          ee("h2", null, J(o(t)("builder.tabs.validation.required.title")), 1),
          D(at, {
            label: o(t)("builder.tabs.validation.required.label"),
            "model-value": ((p = o(n)) == null ? void 0 : p.required) || !1,
            "onUpdate:modelValue": m[0] || (m[0] = (f) => o(l).updateField(o(a), "required", f))
          }, null, 8, ["label", "model-value"])
        ]),
        o(i) ? (z(), ae(Sf, { key: 0 })) : ce("", !0),
        o(c) ? (z(), ae($f, { key: 1 })) : ce("", !0),
        o(r) ? (z(), ae(Af, { key: 2 })) : ce("", !0),
        o(s) ? (z(), re(Ve, { key: 3 }, [
          D(xf),
          D(Vf)
        ], 64)) : ce("", !0),
        o(d) ? (z(), ae(_f, { key: 4 })) : ce("", !0)
      ]);
    };
  }
});
const Bf = /* @__PURE__ */ Oe(Of, [["__scopeId", "data-v-000ecc2d"]]), Lf = /* @__PURE__ */ Ce({
  __name: "ErrorTab",
  setup(e) {
    const t = Me("_uct");
    return (l, n) => (z(), re("section", null, [
      ee("section", null, [
        ee("h2", null, J(o(t)("builder.tabs.error.title")), 1),
        ve(" " + J(o(t)("builder.tabs.error.message")), 1)
      ])
    ]));
  }
});
const Ef = /* @__PURE__ */ Oe(Lf, [["__scopeId", "data-v-fe427c92"]]), qe = Rl({
  control: null,
  field: null,
  isItem: !0,
  itemId: "",
  tabSelectedName: "API"
}), Ke = (e) => {
  const t = Ee(), l = sn(), n = G(!1), a = (R = "") => {
    var ie;
    R ? (qe.isItem = !0, qe.itemId = R, qe.field = t.fields[R], qe.control = l.controls[((ie = qe.field) == null ? void 0 : ie.component) ?? ""]) : qe.isItem = !1, n.value = !0;
  }, i = (R) => {
    R || (n.value = !1, qe.control = null, qe.field = null, qe.itemId = "", qe.isItem = !0);
  };
  me(() => n.value, () => {
    qe.tabSelectedName = qe.isItem ? "API" : "Internationalization";
  });
  const r = b(() => {
    var R, ie, te;
    return qe.field ? qe.field.component !== "UsfRow" || qe.field.hasFieldset ? ((R = qe.control) == null ? void 0 : R.settingsModalTabs) ?? [] : ((te = (ie = qe.control) == null ? void 0 : ie.settingsModalTabs) == null ? void 0 : te.filter((oe) => oe.name !== "Internationalization")) ?? [] : [];
  }), { settingsTabs: s } = ga(), d = (R) => {
    var ie, te;
    switch (R) {
      case "ApiTab":
        return ad;
      case "ConditionalTab":
        return wd;
      case "DataTab":
        return Ic;
      case "DisplayTab":
        return ((ie = qe.control) == null ? void 0 : ie.usfType) === "input" ? Kc : (te = qe.control) != null && te.usfSubtypes.includes("accordion") ? Zc : ef;
      case "InternationalizationTab":
        return af;
      case "ValidationTab":
        return Bf;
      default:
        return s.value(R) ?? Ef;
    }
  }, c = (R) => {
    var ie;
    return ((ie = qe.control) == null ? void 0 : ie.usfType) === "custom" ? R : e ? e(`builder.tabs.names.${R.toLowerCase()}`) : "";
  }, u = b(() => {
    var R, ie;
    return (ie = (R = qe.field) == null ? void 0 : R.fields) == null ? void 0 : ie.map((te) => t.fields[te]);
  }), m = b(() => {
    var R, ie;
    return ((ie = (R = qe.field) == null ? void 0 : R.fields) == null ? void 0 : ie.reduce((te, oe) => te + parseInt(t.fields[oe].width || "0"), 0)) || 0;
  }), p = (R) => {
    var ie;
    return (ie = qe.field) != null && ie.defaultOption ? R.id === qe.field.defaultOption : !1;
  }, f = G([]), _ = (R) => {
    var ie, te, oe;
    return !R && !((ie = qe.field) != null && ie.dependsOn) ? [] : ((oe = (te = t.fields[R ?? qe.field.dependsOn]) == null ? void 0 : te.options) == null ? void 0 : oe.map((fe) => t.options[fe])) || [];
  }, v = (R, ie) => {
    if (R === "") {
      ie(() => {
        f.value = _();
      });
      return;
    }
    ie(() => {
      const te = R.toLowerCase();
      f.value = _().filter(({ value: oe, label: fe }) => oe.toLowerCase().includes(te) || fe.toLowerCase().includes(te));
    });
  }, y = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("repeatable"));
  }), M = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("style"));
  }), w = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("type"));
  }), S = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("defaultValue"));
  }), h = b(() => {
    var R;
    return !!u.value && ((R = u.value) == null ? void 0 : R.length) > 1;
  }), C = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("boxInput"));
  }), T = b(() => {
    var R;
    return ((R = qe.field) == null ? void 0 : R.component) === "UsfDateTime";
  }), I = b(() => {
    var R, ie;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("dateTime")) && ((ie = qe.field) == null ? void 0 : ie.type) === "date";
  }), E = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("defaultTokenValue"));
  }), A = b(() => {
    var R;
    return ((R = qe.field) == null ? void 0 : R.component) === "UsfText";
  }), O = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("file"));
  }), P = b(() => {
    var R;
    return ((R = qe.control) == null ? void 0 : R.id) === "UsfRadioGroup";
  }), $ = b(() => {
    var R;
    return ((R = qe.field) == null ? void 0 : R.component) === "UsfSelect";
  }), k = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("selectElement"));
  }), g = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("selectable"));
  }), x = b(() => {
    var R;
    return ((R = qe.control) == null ? void 0 : R.id) === "UsfTextArea";
  }), B = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("text"));
  }), q = b(() => {
    var R;
    return ((R = qe.field) == null ? void 0 : R.type) === "wysiwyg";
  }), Y = b(() => {
    var ie;
    if (!((ie = qe.field) != null && ie.parentId) || qe.field.parentId === "root")
      return !1;
    const R = t.fields[qe.field.parentId];
    if (!R)
      return !1;
    if (R.component === "UsfCol") {
      if (!R.parentId || R.parentId === "root")
        return !1;
      const te = t.fields[R.parentId];
      return te ? !!te.repeatable : !1;
    }
    return !!R.repeatable;
  }), K = b(() => {
    var R;
    return ((R = qe.field) == null ? void 0 : R.type) === "date";
  }), Q = b(() => {
    var R;
    return !!((R = qe.control) != null && R.usfSubtypes.includes("withOptions"));
  }), W = () => {
    t.updateField(qe.itemId, "component", $.value ? "UsfRadioGroup" : "UsfSelect");
  }, H = () => {
    qe.field && !qe.field.name && t.updateField(qe.itemId, "name", Ur(qe.field.label ?? ""));
  };
  return {
    ...ct(qe),
    settingsDialogDisplayed: n,
    closeDialog: i,
    openDialog: a,
    isDefaultOption: p,
    dependsOnOptionList: f,
    filterDependsOnOptions: v,
    tabLabel: c,
    tabs: r,
    tabSelected: d,
    children: u,
    columnSizeSum: m,
    selectRadioSwitch: W,
    onUpdateNameWithLabel: H,
    fieldIsRepeatable: y,
    hasAStyleOption: M,
    hasATypeOption: w,
    hasDefaultText: S,
    hasMultipleChildren: h,
    isBoxInput: C,
    isDateField: T,
    isDateTime: I,
    isDefaultTokenValueField: E,
    isFile: O,
    isInput: A,
    isRadioGroup: P,
    isSelect: $,
    isSelectElement: k,
    isSelectable: g,
    isTextArea: x,
    isTextBased: B,
    isWYSIWYG: q,
    parentIsRepeatable: Y,
    typeIsDate: K,
    withOptions: Q
  };
}, vn = Dn("UsfSubmission", {
  actions: {
    removeValue(e, t = -1, l = "", n = -1) {
      var a, i;
      if (l !== "") {
        if (e === "") {
          this.submission[l].splice(n - 1, 1), Array.isArray(this.submission[l]) && this.submission[l].length === 0 && delete this.submission[l];
          return;
        }
        if (t === -1) {
          delete this.submission[l][n - 1][e];
          return;
        }
        (a = this.submission[l][n - 1][e]) == null || a.splice(t - 1, 1), Array.isArray(this.submission[l][n - 1][e]) && this.submission[l][n - 1][e].length === 0 && delete this.submission[l][n - 1][e];
        return;
      }
      if (t !== -1) {
        (i = this.submission[e]) == null || i.splice(t - 1, 1), Array.isArray(this.submission[e]) && this.submission[e].length === 0 && delete this.submission[e];
        return;
      }
      delete this.submission[e];
    },
    setValue(e, t, l = -1, n = "", a = -1) {
      if (n !== "") {
        if (this.submission[n] || (this.submission[n] = []), this.submission[n][a - 1] || (this.submission[n][a - 1] = {}), l === -1) {
          this.submission[n][a - 1][e] = t;
          return;
        }
        this.submission[n][a - 1][e] || (this.submission[n][a - 1][e] = []), this.submission[n][a - 1][e][l - 1] = t;
        return;
      }
      if (l !== -1) {
        this.submission[e] || (this.submission[e] = []), this.submission[e][l - 1] = t;
        return;
      }
      this.submission[e] = t;
    }
  },
  getters: {
    getValue(e) {
      return (t, l = -1, n = "", a = -1) => {
        var i, r, s, d, c, u;
        return n !== "" ? l !== -1 ? ((s = (r = (i = e.submission[n]) == null ? void 0 : i[a - 1]) == null ? void 0 : r[t]) == null ? void 0 : s[l - 1]) ?? null : ((c = (d = e.submission[n]) == null ? void 0 : d[a - 1]) == null ? void 0 : c[t]) ?? null : l !== -1 ? ((u = e.submission[t]) == null ? void 0 : u[l - 1]) ?? null : e.submission[t] ?? null;
      };
    }
  },
  state: () => ({
    submission: {}
  })
}), On = () => {
  const { field: e } = Ke(), t = vn(), l = Ee(), n = (k, g) => !!k[g + 1] && k[g + 1].type === "item" && (k[g + 1].value === "||" || k[g + 1].value === "&&") && !!k[g + 2] && (k[g + 2].type === "field" || k[g + 2].type === "token"), a = (k, g) => !!k[g + 1] && k[g + 1].type === "item" && (k[g + 1].value === "||" || k[g + 1].value === "&&") && !!k[g + 2] && k[g + 2].type === "item" && k[g + 2].value === "(", i = (k, g) => (k[g].type === "field" || k[g].type === "token") && n(k, g), r = (k, g) => (k[g].type === "field" || k[g].type === "token") && a(k, g), s = (k, g, x) => {
    const B = u(k, g).subConditions;
    let q = u(k, g).i;
    const Y = Yt();
    if (x.push({ child: { id: Y, subConditions: B } }), a(k, q)) {
      const { subConditions: K, i: Q } = u(k, q + 2), W = Yt();
      x.push({
        fieldA: { id: Y, value: "child" },
        operator: k[q + 1].value,
        fieldB: { id: W, value: "child" }
      }), x.push({ child: { id: W, subConditions: K } }), q = Q;
    } else
      n(k, q) && (x.push({
        fieldA: { id: Y, value: "child" },
        operator: k[q + 1].value,
        fieldB: { id: k[q + 2].id, value: k[q + 2].value }
      }), q += 2);
    return q;
  }, d = (k, g, x) => (x.push({
    fieldA: { id: k[g].id, value: k[g].value },
    operator: k[g + 1].value,
    fieldB: { id: k[g + 2].id, value: k[g + 2].value }
  }), g++, g), c = (k, g, x) => {
    var B, q;
    if (k[g].type === "item" && k[g].value === "(" && g !== k.length - 1)
      g = s(k, g, x);
    else if (i(k, g))
      g = d(k, g, x);
    else if (r(k, g)) {
      const Y = [], K = s(k, g + 2, Y);
      x.push({
        fieldA: { id: k[g].id, value: k[g].value },
        operator: k[g + 1].value,
        fieldB: { id: (q = (B = Y[0]) == null ? void 0 : B.child) == null ? void 0 : q.id, value: "child" }
      }), x.push(Y[0]), g = K;
    } else if (k[g].type === "item" && k[g].value === "(" && g === k.length - 1 || g !== k.length - 1 && k[g + 1].value !== ")")
      throw new Error("Invalid condition");
    return g;
  };
  function u(k, g) {
    const x = [];
    let B = 0;
    for (let q = ++g; q < k.length; q++) {
      if (k[q].type === "item" && k[q].value === ")") {
        B = q;
        break;
      }
      q = c(k, q, x);
    }
    return { subConditions: x, i: B };
  }
  const m = (k) => {
    const g = (x, B) => {
      x.value !== "child" && (B.find((Y) => Y.id === x.id && Y.value === x.value) || B.push({
        id: x.id,
        value: x.value,
        type: x.id.startsWith("user.") ? "token" : "field"
      }));
    };
    return k.reduce((x, { fieldA: B, fieldB: q, operator: Y, child: K }) => (K ? (x.push({
      id: Yt(),
      type: "item",
      value: "("
    }), x = [...x, ...m(K.subConditions)], x.push({
      id: Yt(),
      type: "item",
      value: ")"
    })) : (g(B, x), Y && x.push({
      id: Yt(),
      type: "item",
      value: Y
    }), q && g(q, x)), x), []);
  }, p = (k) => {
    var B, q;
    if (!k)
      return !1;
    let g = !1, x = !1;
    for (let Y = 0; Y < k.length; Y++) {
      const K = k[Y];
      if (k.length === 1 && K.fieldB === void 0 && K.operator === void 0) {
        g = "child" in k[0] ? p((q = (B = k[0]) == null ? void 0 : B.child) == null ? void 0 : q.subConditions) : _(K.fieldA, k);
        continue;
      }
      if (!("child" in K)) {
        const { fieldA: Q, fieldB: W, operator: H } = K;
        let R = null;
        const ie = _(Q, k), te = _(W, k);
        switch (H) {
          case "||":
            x = ie || te;
            break;
          case "&&":
            x = ie && te;
            break;
        }
        if (Y !== 0) {
          switch (R = k[Y - 1].operator, R) {
            case null:
            case void 0:
              g = x;
              break;
            case "&&":
              g && (g = x);
              break;
            case "||":
              g || (g = x);
              break;
          }
          continue;
        }
        g = x;
      }
    }
    return g;
  }, f = (k, g) => {
    if (g === null)
      return !1;
    if (k.value === "true")
      return g === !0;
    if (k.value === "false")
      return g === !1;
    if (Bo(g))
      return k.value === g;
    if (Lo(g))
      return k.value === (g == null ? void 0 : g.value);
    if (Array.isArray(g) && Bo(g[0]))
      return g.includes(k.value);
    if (Array.isArray(g) && Lo(g[0]))
      return g.some(
        (x) => k.value === (x == null ? void 0 : x.value)
      );
    throw new Error("[Composable: useCondition.valueCheckCondition] => Use case not implemented");
  };
  function _(k, g) {
    var x, B, q;
    if (k.id.startsWith("user.")) {
      const [Y, K] = k.id.split("."), Q = Lt();
      return Q.isAttributeArray(Y, K) ? ((x = Q.user[K]) == null ? void 0 : x.includes(k.value)) || !1 : Q.user[K] === k.value;
    }
    return k.value === "child" ? p(
      (q = (B = g == null ? void 0 : g.find((Y) => {
        var K;
        return "child" in Y && ((K = Y == null ? void 0 : Y.child) == null ? void 0 : K.id) === k.id;
      })) == null ? void 0 : B.child) == null ? void 0 : q.subConditions
    ) : f(
      k,
      t.getValue(l.fields[k.id].name || l.fields[k.id].id)
    );
  }
  const v = (k) => {
    if (k != null && k.length)
      return m(k);
  }, y = (k, g) => {
    var x;
    return p((x = g == null ? void 0 : g.conditional) == null ? void 0 : x.basic[k]);
  }, M = b(() => {
    var B, q;
    if (!((q = (B = e.value) == null ? void 0 : B.conditional) != null && q.basic))
      return !0;
    const { exist: k, visible: g, required: x } = e.value.conditional.basic;
    return !k && !g && !x;
  }), w = b(() => {
    var k, g, x;
    return (x = (g = (k = e.value) == null ? void 0 : k.conditional) == null ? void 0 : g.basic) != null && x.exist ? v(e.value.conditional.basic.exist) || [] : [];
  }), S = b(() => !!w.value.length), h = b(() => {
    var k, g, x;
    return (x = (g = (k = e.value) == null ? void 0 : k.conditional) == null ? void 0 : g.basic) != null && x.required ? v(e.value.conditional.basic.required) || [] : [];
  }), C = b(() => !!h.value.length), T = b(() => {
    var k, g, x;
    return (x = (g = (k = e.value) == null ? void 0 : k.conditional) == null ? void 0 : g.basic) != null && x.visible ? v(e.value.conditional.basic.visible) || [] : [];
  }), I = b(() => !!T.value.length), E = (k, g, x) => {
    var K, Q, W;
    const B = [];
    if (k.length === 1)
      B.push({
        fieldA: {
          id: k[0].id,
          value: k[0].value
        }
      });
    else
      for (let H = 0; H < k.length; H++)
        H = c(k, H, B);
    const q = Ee(), Y = { basic: {} };
    (Q = (K = q.fields[g]) == null ? void 0 : K.conditional) != null && Q.basic && (Y.basic = {
      ...(W = q.fields[g].conditional) == null ? void 0 : W.basic
    }), Y.basic[x] = B, q.updateField(g, "conditional", Y);
  };
  return {
    checkCondition: y,
    fieldConditionDisplayed: T,
    fieldConditionExist: w,
    fieldConditionRequired: h,
    fieldConditionsIsEmpty: M,
    fieldHasConditionDisplayed: I,
    fieldHasConditionExist: S,
    fieldHasConditionRequired: C,
    getConditions: v,
    translateCondition: E,
    copyCondition: (k) => {
      var x, B;
      const g = v(((B = (x = e.value) == null ? void 0 : x.conditional) == null ? void 0 : B.basic[k]) || []);
      g != null && g.length && sessionStorage.setItem("condition", JSON.stringify({ [k]: g }));
    },
    pasteCondition: () => {
      if (!e.value)
        return !1;
      const k = sessionStorage.getItem("condition");
      if (k) {
        sessionStorage.removeItem("condition");
        const g = JSON.parse(k);
        e.value.conditional || (e.value.conditional = { basic: {} });
        for (const x in g)
          E(
            g[x],
            e.value.id,
            x
          );
        return !0;
      }
      return !1;
    },
    deleteCondition: (k) => {
      var x, B;
      const g = (B = (x = e.value) == null ? void 0 : x.conditional) == null ? void 0 : B.basic;
      if (!(!g || !e.value)) {
        if (delete g[k], Object.keys(g).length === 0) {
          l.updateField(e.value.id, "conditional", ""), l.initDependenciesForAllFields();
          return;
        }
        l.updateField(e.value.id, "conditional", { basic: g }), l.initDependenciesForAllFields();
      }
    },
    updateConditionValue: (k, g, x) => {
      var Y, K, Q;
      let B = l.options[k].owner;
      if (!B) {
        const W = Object.values(l.fields).find((H) => {
          var R;
          return (R = H.options) == null ? void 0 : R.includes(k);
        });
        B = W == null ? void 0 : W.id;
      }
      const q = (W) => {
        var H, R, ie, te;
        B && (((H = W.fieldA) == null ? void 0 : H.id) === B && W.fieldA.value === g && (W.fieldA.value = x), ((R = W.fieldB) == null ? void 0 : R.id) === B && W.fieldB.value === g && (W.fieldB.value = x), (te = (ie = W.child) == null ? void 0 : ie.subConditions) != null && te.length && W.child.subConditions.forEach(q));
      };
      for (const W in l.fields)
        (Q = (K = (Y = l.fields[W].conditional) == null ? void 0 : Y.basic) == null ? void 0 : K.exist) == null || Q.forEach(q);
    }
  };
}, zt = (e, t) => {
  const l = Lt(), n = vn(), a = st(), i = Ee(), r = b(() => e.value.name || e.value.id || ""), { checkCondition: s } = On(), d = b(() => {
    var h, C;
    return Zl(e.value, "conditional.basic.exist") && ((C = (h = e.value.conditional) == null ? void 0 : h.basic.exist) != null && C.length) ? s("exist", e.value) : e.value.exist;
  }), c = b(() => {
    var h, C;
    return Zl(e.value, "conditional.basic.required") && ((C = (h = e.value.conditional) == null ? void 0 : h.basic.required) != null && C.length) ? s("required", e.value) : !!e.value.required;
  }), u = b(() => {
    var h, C;
    return Zl(e.value, "conditional.basic.visible") && ((C = (h = e.value.conditional) == null ? void 0 : h.basic.visible) != null && C.length) ? s("visible", e.value) : e.value.visible;
  }), m = () => {
    n.submission[r.value] && delete n.submission[r.value], t && t("update:child-exists", d.value);
  }, p = (h) => e.value[h] ? l.iconNameFn ? l.iconNameFn(e, h) : `mdi mdi-${e.value[h]}` : "", f = b(() => p("appendIcon")), _ = b(() => p("prependIcon")), v = b(() => (h) => (a.translated(e.value.id, "label") || e.value.label || e.value.name || "") + (e.value.repeatable && h ? ` ${h}` : "") + (c.value ? "*" : "")), y = b(() => {
    if (e.value.parentId === "root")
      return !1;
    const h = i.fields[e.value.parentId];
    if (!h)
      return !1;
    if (h.component === "UsfCol") {
      const C = i.fields[h.parentId];
      return C ? !!C.repeatable : !1;
    }
    return !!h.repeatable;
  }), M = (h, C = -1) => {
    if (h === null || Array.isArray(h) && !h.length) {
      n.removeValue(r.value, C);
      return;
    }
    if ((e.value.repeatable || y.value) && C !== void 0) {
      n.setValue(r.value, h, C);
      return;
    }
    n.setValue(r.value, h);
  }, w = b(() => (h) => (e.value.repeatable || y.value) && h !== void 0 ? n.getValue(r.value, h) : n.getValue(r.value)), S = b(() => !!e.value.defaultTokenValue && l.autoCompletionIsActive);
  return wt(() => {
    const h = new URLSearchParams(window.location.search);
    if (h.has(r.value))
      return M(h.get(r.value)), h.get(r.value);
    if (e.value.defaultTokenValue && l.user[e.value.defaultTokenValue] && l.autoCompletionIsActive)
      return M(l.user[e.value.defaultTokenValue]), l.user[e.value.defaultTokenValue];
    if (e.value.defaultOption) {
      const C = i.options[e.value.defaultOption];
      if (C) {
        let T = {
          label: C.label,
          value: C.value
        };
        return (e.value.component === "UsfSelect" && l.selectEmitValue || e.value.component === "UsfRadio" && l.radioEmitValue) && (T = C.value), (e.value.multiple || e.value.repeatable) && (T = [T]), M(T), T;
      }
    }
  }), me(d, () => {
    d.value || m();
  }), {
    appendIcon: f,
    fieldIdentification: r,
    getValue: w,
    label: v,
    prependIcon: _,
    setValue: M,
    fieldOnReadOnly: S,
    exist: d,
    required: c,
    visible: u
  };
};
var ru = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function uu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var su = { exports: {} };
(function(e, t) {
  (function(l, n) {
    e.exports = n();
  })(ru, function() {
    var l = 1e3, n = 6e4, a = 36e5, i = "millisecond", r = "second", s = "minute", d = "hour", c = "day", u = "week", m = "month", p = "quarter", f = "year", _ = "date", v = "Invalid Date", y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, M = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, w = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(k) {
      var g = ["th", "st", "nd", "rd"], x = k % 100;
      return "[" + k + (g[(x - 20) % 10] || g[x] || g[0]) + "]";
    } }, S = function(k, g, x) {
      var B = String(k);
      return !B || B.length >= g ? k : "" + Array(g + 1 - B.length).join(x) + k;
    }, h = { s: S, z: function(k) {
      var g = -k.utcOffset(), x = Math.abs(g), B = Math.floor(x / 60), q = x % 60;
      return (g <= 0 ? "+" : "-") + S(B, 2, "0") + ":" + S(q, 2, "0");
    }, m: function k(g, x) {
      if (g.date() < x.date())
        return -k(x, g);
      var B = 12 * (x.year() - g.year()) + (x.month() - g.month()), q = g.clone().add(B, m), Y = x - q < 0, K = g.clone().add(B + (Y ? -1 : 1), m);
      return +(-(B + (x - q) / (Y ? q - K : K - q)) || 0);
    }, a: function(k) {
      return k < 0 ? Math.ceil(k) || 0 : Math.floor(k);
    }, p: function(k) {
      return { M: m, y: f, w: u, d: c, D: _, h: d, m: s, s: r, ms: i, Q: p }[k] || String(k || "").toLowerCase().replace(/s$/, "");
    }, u: function(k) {
      return k === void 0;
    } }, C = "en", T = {};
    T[C] = w;
    var I = function(k) {
      return k instanceof P;
    }, E = function k(g, x, B) {
      var q;
      if (!g)
        return C;
      if (typeof g == "string") {
        var Y = g.toLowerCase();
        T[Y] && (q = Y), x && (T[Y] = x, q = Y);
        var K = g.split("-");
        if (!q && K.length > 1)
          return k(K[0]);
      } else {
        var Q = g.name;
        T[Q] = g, q = Q;
      }
      return !B && q && (C = q), q || !B && C;
    }, A = function(k, g) {
      if (I(k))
        return k.clone();
      var x = typeof g == "object" ? g : {};
      return x.date = k, x.args = arguments, new P(x);
    }, O = h;
    O.l = E, O.i = I, O.w = function(k, g) {
      return A(k, { locale: g.$L, utc: g.$u, x: g.$x, $offset: g.$offset });
    };
    var P = function() {
      function k(x) {
        this.$L = E(x.locale, null, !0), this.parse(x);
      }
      var g = k.prototype;
      return g.parse = function(x) {
        this.$d = function(B) {
          var q = B.date, Y = B.utc;
          if (q === null)
            return /* @__PURE__ */ new Date(NaN);
          if (O.u(q))
            return /* @__PURE__ */ new Date();
          if (q instanceof Date)
            return new Date(q);
          if (typeof q == "string" && !/Z$/i.test(q)) {
            var K = q.match(y);
            if (K) {
              var Q = K[2] - 1 || 0, W = (K[7] || "0").substring(0, 3);
              return Y ? new Date(Date.UTC(K[1], Q, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, W)) : new Date(K[1], Q, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, W);
            }
          }
          return new Date(q);
        }(x), this.$x = x.x || {}, this.init();
      }, g.init = function() {
        var x = this.$d;
        this.$y = x.getFullYear(), this.$M = x.getMonth(), this.$D = x.getDate(), this.$W = x.getDay(), this.$H = x.getHours(), this.$m = x.getMinutes(), this.$s = x.getSeconds(), this.$ms = x.getMilliseconds();
      }, g.$utils = function() {
        return O;
      }, g.isValid = function() {
        return this.$d.toString() !== v;
      }, g.isSame = function(x, B) {
        var q = A(x);
        return this.startOf(B) <= q && q <= this.endOf(B);
      }, g.isAfter = function(x, B) {
        return A(x) < this.startOf(B);
      }, g.isBefore = function(x, B) {
        return this.endOf(B) < A(x);
      }, g.$g = function(x, B, q) {
        return O.u(x) ? this[B] : this.set(q, x);
      }, g.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, g.valueOf = function() {
        return this.$d.getTime();
      }, g.startOf = function(x, B) {
        var q = this, Y = !!O.u(B) || B, K = O.p(x), Q = function(Z, j) {
          var he = O.w(q.$u ? Date.UTC(q.$y, j, Z) : new Date(q.$y, j, Z), q);
          return Y ? he : he.endOf(c);
        }, W = function(Z, j) {
          return O.w(q.toDate()[Z].apply(q.toDate("s"), (Y ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(j)), q);
        }, H = this.$W, R = this.$M, ie = this.$D, te = "set" + (this.$u ? "UTC" : "");
        switch (K) {
          case f:
            return Y ? Q(1, 0) : Q(31, 11);
          case m:
            return Y ? Q(1, R) : Q(0, R + 1);
          case u:
            var oe = this.$locale().weekStart || 0, fe = (H < oe ? H + 7 : H) - oe;
            return Q(Y ? ie - fe : ie + (6 - fe), R);
          case c:
          case _:
            return W(te + "Hours", 0);
          case d:
            return W(te + "Minutes", 1);
          case s:
            return W(te + "Seconds", 2);
          case r:
            return W(te + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, g.endOf = function(x) {
        return this.startOf(x, !1);
      }, g.$set = function(x, B) {
        var q, Y = O.p(x), K = "set" + (this.$u ? "UTC" : ""), Q = (q = {}, q[c] = K + "Date", q[_] = K + "Date", q[m] = K + "Month", q[f] = K + "FullYear", q[d] = K + "Hours", q[s] = K + "Minutes", q[r] = K + "Seconds", q[i] = K + "Milliseconds", q)[Y], W = Y === c ? this.$D + (B - this.$W) : B;
        if (Y === m || Y === f) {
          var H = this.clone().set(_, 1);
          H.$d[Q](W), H.init(), this.$d = H.set(_, Math.min(this.$D, H.daysInMonth())).$d;
        } else
          Q && this.$d[Q](W);
        return this.init(), this;
      }, g.set = function(x, B) {
        return this.clone().$set(x, B);
      }, g.get = function(x) {
        return this[O.p(x)]();
      }, g.add = function(x, B) {
        var q, Y = this;
        x = Number(x);
        var K = O.p(B), Q = function(R) {
          var ie = A(Y);
          return O.w(ie.date(ie.date() + Math.round(R * x)), Y);
        };
        if (K === m)
          return this.set(m, this.$M + x);
        if (K === f)
          return this.set(f, this.$y + x);
        if (K === c)
          return Q(1);
        if (K === u)
          return Q(7);
        var W = (q = {}, q[s] = n, q[d] = a, q[r] = l, q)[K] || 1, H = this.$d.getTime() + x * W;
        return O.w(H, this);
      }, g.subtract = function(x, B) {
        return this.add(-1 * x, B);
      }, g.format = function(x) {
        var B = this, q = this.$locale();
        if (!this.isValid())
          return q.invalidDate || v;
        var Y = x || "YYYY-MM-DDTHH:mm:ssZ", K = O.z(this), Q = this.$H, W = this.$m, H = this.$M, R = q.weekdays, ie = q.months, te = function(j, he, we, Ie) {
          return j && (j[he] || j(B, Y)) || we[he].slice(0, Ie);
        }, oe = function(j) {
          return O.s(Q % 12 || 12, j, "0");
        }, fe = q.meridiem || function(j, he, we) {
          var Ie = j < 12 ? "AM" : "PM";
          return we ? Ie.toLowerCase() : Ie;
        }, Z = { YY: String(this.$y).slice(-2), YYYY: O.s(this.$y, 4, "0"), M: H + 1, MM: O.s(H + 1, 2, "0"), MMM: te(q.monthsShort, H, ie, 3), MMMM: te(ie, H), D: this.$D, DD: O.s(this.$D, 2, "0"), d: String(this.$W), dd: te(q.weekdaysMin, this.$W, R, 2), ddd: te(q.weekdaysShort, this.$W, R, 3), dddd: R[this.$W], H: String(Q), HH: O.s(Q, 2, "0"), h: oe(1), hh: oe(2), a: fe(Q, W, !0), A: fe(Q, W, !1), m: String(W), mm: O.s(W, 2, "0"), s: String(this.$s), ss: O.s(this.$s, 2, "0"), SSS: O.s(this.$ms, 3, "0"), Z: K };
        return Y.replace(M, function(j, he) {
          return he || Z[j] || K.replace(":", "");
        });
      }, g.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, g.diff = function(x, B, q) {
        var Y, K = O.p(B), Q = A(x), W = (Q.utcOffset() - this.utcOffset()) * n, H = this - Q, R = O.m(this, Q);
        return R = (Y = {}, Y[f] = R / 12, Y[m] = R, Y[p] = R / 3, Y[u] = (H - W) / 6048e5, Y[c] = (H - W) / 864e5, Y[d] = H / a, Y[s] = H / n, Y[r] = H / l, Y)[K] || H, q ? R : O.a(R);
      }, g.daysInMonth = function() {
        return this.endOf(m).$D;
      }, g.$locale = function() {
        return T[this.$L];
      }, g.locale = function(x, B) {
        if (!x)
          return this.$L;
        var q = this.clone(), Y = E(x, B, !0);
        return Y && (q.$L = Y), q;
      }, g.clone = function() {
        return O.w(this.$d, this);
      }, g.toDate = function() {
        return new Date(this.valueOf());
      }, g.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, g.toISOString = function() {
        return this.$d.toISOString();
      }, g.toString = function() {
        return this.$d.toUTCString();
      }, k;
    }(), $ = P.prototype;
    return A.prototype = $, [["$ms", i], ["$s", r], ["$m", s], ["$H", d], ["$W", c], ["$M", m], ["$y", f], ["$D", _]].forEach(function(k) {
      $[k[1]] = function(g) {
        return this.$g(g, k[0], k[1]);
      };
    }), A.extend = function(k, g) {
      return k.$i || (k(g, P, A), k.$i = !0), A;
    }, A.locale = E, A.isDayjs = I, A.unix = function(k) {
      return A(1e3 * k);
    }, A.en = T[C], A.Ls = T, A.p = {}, A;
  });
})(su);
var Pf = su.exports;
const ut = /* @__PURE__ */ uu(Pf), Ul = (e, t) => {
  const l = Me("_uct"), n = [
    (_, v) => t || e.value.type !== "email" || e.value.required && v.email(_) || !e.value.required && (v.email(_) || _ === "") || l("renderer.fields.UsfText.errors.emailFormat")
  ], a = [
    (_) => {
      const v = (y) => /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]+\.[a-zA-Z0-9()]{2,}.*/.test(y);
      return t || e.value.type !== "url" || e.value.required && v(_) || !e.value.required && (v(_) || _ === "") || l("renderer.fields.UsfText.errors.urlFormat");
    }
  ], i = [
    (_) => {
      const v = () => e.value.type === "number" ? !!_ && parseFloat(_) <= e.value.max : !!_ && _.length <= e.value.max, y = () => e.value.type === "number" ? l("renderer.fields.UsfText.errors.numberMax", { max: `${e.value.max}` }) : l("renderer.fields.UsfText.errors.textMax", { max: `${e.value.max}` });
      return t || e.value.max === void 0 || !_ || v() || y();
    }
  ], r = [
    (_) => {
      const v = () => e.value.type === "number" ? !!_ && parseFloat(_) >= e.value.min : !!_ && _.length >= e.value.min, y = () => e.value.type === "number" ? l("renderer.fields.UsfText.errors.numberMin", { min: `${e.value.min}` }) : l("renderer.fields.UsfText.errors.textMin", { min: `${e.value.min}` });
      return t || e.value.min === void 0 || !_ || v() || y();
    }
  ], s = [
    (_) => t || !e.value.required || (typeof _ == "string" ? !!_.trim() : !!_) || l("renderer.fields.core.errors.required")
  ], d = [
    (_) => t || e.value.type !== "number" || !_ || !isNaN(parseFloat(_)) || l("renderer.fields.UsfText.errors.numberFormat")
  ], c = [
    (_) => t || !e.value.required && _ === "" ? !0 : ut(_, "DD/MM/YYYY").isValid() || l("renderer.fields.UsfDateHour.date.placeholder")
  ], u = [
    (_) => {
      if (t)
        return !0;
      const v = ut(_, "DD/MM/YYYY");
      if (!e.value.minValue)
        return !0;
      const y = e.value.minDateFuture ? ut().add(e.value.minValue, e.value.minUnit || "years").startOf("date") : ut().subtract(e.value.minValue, e.value.minUnit || "years").startOf("date");
      return v.isBefore(y) ? l(
        "renderer.fields.UsfDateHour.errors.min",
        { min: y.format("DD/MM/YYYY") }
      ) : !0;
    }
  ], m = [
    (_) => {
      if (t)
        return !0;
      const v = ut(_, "DD/MM/YYYY");
      if (!e.value.maxValue)
        return !0;
      const y = e.value.maxDateFuture ? ut().add(e.value.maxValue, e.value.maxUnit || "years").startOf("date") : ut().subtract(e.value.maxValue, e.value.maxUnit || "years").startOf("date");
      return v.isAfter(y) ? l(
        "renderer.fields.UsfDateHour.errors.max",
        { max: y.format("DD/MM/YYYY") }
      ) : !0;
    }
  ], p = b(() => e.value.type === "time" ? [] : [
    ...c,
    ...u,
    ...m
  ]);
  return {
    inputRules: b(() => [
      ...s,
      ...a,
      ...n,
      ...d,
      ...r,
      ...i
    ]),
    dateRules: p,
    requiredRules: s
  };
}, Rf = (e) => {
  const { getValue: t } = zt(e), l = b(() => e.value.type === "switch" ? at : Bt), n = b(() => (a) => !!t.value(a));
  return {
    componentIs: l,
    getBinaryValue: n
  };
}, zf = /* @__PURE__ */ Ce({
  __name: "CheckboxSwitchItem",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, { field: n, editorMode: a } = ct(l), i = st(), {
      exist: r,
      fieldOnReadOnly: s,
      label: d,
      required: c,
      setValue: u,
      visible: m
    } = zt(n, t), { requiredRules: p } = Ul(n, a.value), { componentIs: f, getBinaryValue: _ } = Rf(n);
    return (v, y) => o(a) || o(r) ? Ct((z(), ae(ha, {
      key: 0,
      "model-value": o(_)(v.parentIndex),
      rules: o(p),
      borderless: "",
      dense: ""
    }, {
      default: L(() => [
        (z(), ae(eo(o(f)), {
          id: o(n).id,
          key: o(n).id,
          disable: o(s),
          "hide-hint": !o(n).persistentHint,
          hint: o(i).translated(o(n).id, "hint"),
          label: o(d)(),
          "model-value": o(_)(v.parentIndex),
          required: o(c),
          "onUpdate:modelValue": y[0] || (y[0] = (M) => o(u)(M, v.parentIndex))
        }, null, 8, ["id", "disable", "hide-hint", "hint", "label", "model-value", "required"]))
      ]),
      _: 1
    }, 8, ["model-value", "rules"])), [
      [Nt, o(a) || o(m)]
    ]) : ce("", !0);
  }
});
const Uf = /* @__PURE__ */ Oe(zf, [["__scopeId", "data-v-78b3cfbf"]]), Hf = /* @__PURE__ */ Ce({
  __name: "ColItem",
  props: {
    editorMode: { type: Boolean, default: !1 },
    field: {}
  },
  setup(e) {
    const t = e, { field: l } = ct(t), n = Me("_uct"), a = Ee(), i = G([]), r = b(() => i.value.length > 0), s = () => {
      if (l.value.fields.length) {
        i.value = [...l.value.fields.map((d) => d.id)];
        return;
      }
      i.value = [];
    };
    return wt(s), me(l, s, { deep: !0 }), (d, c) => (z(), ae(o(na), {
      id: o(l).id,
      class: Ft([{ notEmpty: r.value }, "dragColPanelContainer"]),
      group: { name: "formbuilder", put: !r.value },
      list: i.value,
      "item-key": "id",
      onAdd: o(a).onMoveFieldPositionToSubItem
    }, vl({
      item: L(({ index: u }) => [
        r.value ? (z(), ae(ko, {
          key: 0,
          index: u,
          "parent-id": o(l).id
        }, null, 8, ["index", "parent-id"])) : ce("", !0)
      ]),
      _: 2
    }, [
      r.value ? void 0 : {
        name: "header",
        fn: L(() => [
          ee("p", null, J(o(n)("renderer.fields.UsfCol.noItem")), 1)
        ]),
        key: "0"
      }
    ]), 1032, ["id", "class", "group", "list", "onAdd"]));
  }
});
const du = /* @__PURE__ */ Oe(Hf, [["__scopeId", "data-v-03b3b0ff"]]), So = {
  left: !0,
  right: !0,
  up: !0,
  down: !0,
  horizontal: !0,
  vertical: !0
}, Yf = Object.keys(So);
So.all = !0;
function ta(e) {
  const t = {};
  for (const l of Yf)
    e[l] === !0 && (t[l] = !0);
  return Object.keys(t).length === 0 ? So : (t.horizontal === !0 ? t.left = t.right = !0 : t.left === !0 && t.right === !0 && (t.horizontal = !0), t.vertical === !0 ? t.up = t.down = !0 : t.up === !0 && t.down === !0 && (t.vertical = !0), t.horizontal === !0 && t.vertical === !0 && (t.all = !0), t);
}
const jf = ["INPUT", "TEXTAREA"];
function la(e, t) {
  return t.event === void 0 && e.target !== void 0 && e.target.draggable !== !0 && typeof t.handler == "function" && jf.includes(e.target.nodeName.toUpperCase()) === !1 && (e.qClonedBy === void 0 || e.qClonedBy.indexOf(t.uid) === -1);
}
function Ha(e, t, l) {
  const n = Cl(e);
  let a, i = n.left - t.event.x, r = n.top - t.event.y, s = Math.abs(i), d = Math.abs(r);
  const c = t.direction;
  c.horizontal === !0 && c.vertical !== !0 ? a = i < 0 ? "left" : "right" : c.horizontal !== !0 && c.vertical === !0 ? a = r < 0 ? "up" : "down" : c.up === !0 && r < 0 ? (a = "up", s > d && (c.left === !0 && i < 0 ? a = "left" : c.right === !0 && i > 0 && (a = "right"))) : c.down === !0 && r > 0 ? (a = "down", s > d && (c.left === !0 && i < 0 ? a = "left" : c.right === !0 && i > 0 && (a = "right"))) : c.left === !0 && i < 0 ? (a = "left", s < d && (c.up === !0 && r < 0 ? a = "up" : c.down === !0 && r > 0 && (a = "down"))) : c.right === !0 && i > 0 && (a = "right", s < d && (c.up === !0 && r < 0 ? a = "up" : c.down === !0 && r > 0 && (a = "down")));
  let u = !1;
  if (a === void 0 && l === !1) {
    if (t.event.isFirst === !0 || t.event.lastDir === void 0)
      return {};
    a = t.event.lastDir, u = !0, a === "left" || a === "right" ? (n.left -= i, s = 0, i = 0) : (n.top -= r, d = 0, r = 0);
  }
  return {
    synthetic: u,
    payload: {
      evt: e,
      touch: t.event.mouse !== !0,
      mouse: t.event.mouse === !0,
      position: n,
      direction: a,
      isFirst: t.event.isFirst,
      isFinal: l === !0,
      duration: Date.now() - t.event.time,
      distance: {
        x: s,
        y: d
      },
      offset: {
        x: i,
        y: r
      },
      delta: {
        x: n.left - t.event.lastX,
        y: n.top - t.event.lastY
      }
    }
  };
}
let Nf = 0;
const Wf = aa(
  {
    name: "touch-pan",
    beforeMount(e, { value: t, modifiers: l }) {
      if (l.mouse !== !0 && mt.has.touch !== !0)
        return;
      function n(i, r) {
        l.mouse === !0 && r === !0 ? Ze(i) : (l.stop === !0 && Pt(i), l.prevent === !0 && Ot(i));
      }
      const a = {
        uid: "qvtp_" + Nf++,
        handler: t,
        modifiers: l,
        direction: ta(l),
        noop: In,
        mouseStart(i) {
          la(i, a) && Yi(i) && (Jt(a, "temp", [
            [document, "mousemove", "move", "notPassiveCapture"],
            [document, "mouseup", "end", "passiveCapture"]
          ]), a.start(i, !0));
        },
        touchStart(i) {
          if (la(i, a)) {
            const r = i.target;
            Jt(a, "temp", [
              [r, "touchmove", "move", "notPassiveCapture"],
              [r, "touchcancel", "end", "passiveCapture"],
              [r, "touchend", "end", "passiveCapture"]
            ]), a.start(i);
          }
        },
        start(i, r) {
          if (mt.is.firefox === !0 && Gl(e, !0), a.lastEvt = i, r === !0 || l.stop === !0) {
            if (a.direction.all !== !0 && (r !== !0 || a.modifiers.mouseAllDir !== !0 && a.modifiers.mousealldir !== !0)) {
              const c = i.type.indexOf("mouse") > -1 ? new MouseEvent(i.type, i) : new TouchEvent(i.type, i);
              i.defaultPrevented === !0 && Ot(c), i.cancelBubble === !0 && Pt(c), Object.assign(c, {
                qKeyEvent: i.qKeyEvent,
                qClickOutside: i.qClickOutside,
                qAnchorHandled: i.qAnchorHandled,
                qClonedBy: i.qClonedBy === void 0 ? [a.uid] : i.qClonedBy.concat(a.uid)
              }), a.initialEvent = {
                target: i.target,
                event: c
              };
            }
            Pt(i);
          }
          const { left: s, top: d } = Cl(i);
          a.event = {
            x: s,
            y: d,
            time: Date.now(),
            mouse: r === !0,
            detected: !1,
            isFirst: !0,
            isFinal: !1,
            lastX: s,
            lastY: d
          };
        },
        move(i) {
          if (a.event === void 0)
            return;
          const r = Cl(i), s = r.left - a.event.x, d = r.top - a.event.y;
          if (s === 0 && d === 0)
            return;
          a.lastEvt = i;
          const c = a.event.mouse === !0, u = () => {
            n(i, c);
            let f;
            l.preserveCursor !== !0 && l.preservecursor !== !0 && (f = document.documentElement.style.cursor || "", document.documentElement.style.cursor = "grabbing"), c === !0 && document.body.classList.add("no-pointer-events--children"), document.body.classList.add("non-selectable"), kn(), a.styleCleanup = (_) => {
              if (a.styleCleanup = void 0, f !== void 0 && (document.documentElement.style.cursor = f), document.body.classList.remove("non-selectable"), c === !0) {
                const v = () => {
                  document.body.classList.remove("no-pointer-events--children");
                };
                _ !== void 0 ? setTimeout(() => {
                  v(), _();
                }, 50) : v();
              } else
                _ !== void 0 && _();
            };
          };
          if (a.event.detected === !0) {
            a.event.isFirst !== !0 && n(i, a.event.mouse);
            const { payload: f, synthetic: _ } = Ha(i, a, !1);
            f !== void 0 && (a.handler(f) === !1 ? a.end(i) : (a.styleCleanup === void 0 && a.event.isFirst === !0 && u(), a.event.lastX = f.position.left, a.event.lastY = f.position.top, a.event.lastDir = _ === !0 ? void 0 : f.direction, a.event.isFirst = !1));
            return;
          }
          if (a.direction.all === !0 || c === !0 && (a.modifiers.mouseAllDir === !0 || a.modifiers.mousealldir === !0)) {
            u(), a.event.detected = !0, a.move(i);
            return;
          }
          const m = Math.abs(s), p = Math.abs(d);
          m !== p && (a.direction.horizontal === !0 && m > p || a.direction.vertical === !0 && m < p || a.direction.up === !0 && m < p && d < 0 || a.direction.down === !0 && m < p && d > 0 || a.direction.left === !0 && m > p && s < 0 || a.direction.right === !0 && m > p && s > 0 ? (a.event.detected = !0, a.move(i)) : a.end(i, !0));
        },
        end(i, r) {
          if (a.event !== void 0) {
            if (fl(a, "temp"), mt.is.firefox === !0 && Gl(e, !1), r === !0)
              a.styleCleanup !== void 0 && a.styleCleanup(), a.event.detected !== !0 && a.initialEvent !== void 0 && a.initialEvent.target.dispatchEvent(a.initialEvent.event);
            else if (a.event.detected === !0) {
              a.event.isFirst === !0 && a.handler(Ha(i === void 0 ? a.lastEvt : i, a).payload);
              const { payload: s } = Ha(i === void 0 ? a.lastEvt : i, a, !0), d = () => {
                a.handler(s);
              };
              a.styleCleanup !== void 0 ? a.styleCleanup(d) : d();
            }
            a.event = void 0, a.initialEvent = void 0, a.lastEvt = void 0;
          }
        }
      };
      if (e.__qtouchpan = a, l.mouse === !0) {
        const i = l.mouseCapture === !0 || l.mousecapture === !0 ? "Capture" : "";
        Jt(a, "main", [
          [e, "mousedown", "mouseStart", `passive${i}`]
        ]);
      }
      mt.has.touch === !0 && Jt(a, "main", [
        [e, "touchstart", "touchStart", `passive${l.capture === !0 ? "Capture" : ""}`],
        [e, "touchmove", "noop", "notPassiveCapture"]
        // cannot be passive (ex: iOS scroll)
      ]);
    },
    updated(e, t) {
      const l = e.__qtouchpan;
      l !== void 0 && (t.oldValue !== t.value && (typeof value != "function" && l.end(), l.handler = t.value), l.direction = ta(t.modifiers));
    },
    beforeUnmount(e) {
      const t = e.__qtouchpan;
      t !== void 0 && (t.event !== void 0 && t.end(), fl(t, "main"), fl(t, "temp"), mt.is.firefox === !0 && Gl(e, !1), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchpan);
    }
  }
);
function Qf(e, t) {
  if (e.hour !== null) {
    if (e.minute === null)
      return "minute";
    if (t === !0 && e.second === null)
      return "second";
  }
  return "hour";
}
function Kf() {
  const e = /* @__PURE__ */ new Date();
  return {
    hour: e.getHours(),
    minute: e.getMinutes(),
    second: e.getSeconds(),
    millisecond: e.getMilliseconds()
  };
}
const Gf = De({
  name: "QTime",
  props: {
    ...Tt,
    ...Ml,
    ...Xr,
    mask: {
      default: null
    },
    format24h: {
      type: Boolean,
      default: null
    },
    defaultDate: {
      type: String,
      validator: (e) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(e)
    },
    options: Function,
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    withSeconds: Boolean,
    nowBtn: Boolean
  },
  emits: Jr,
  setup(e, { slots: t, emit: l }) {
    const n = Ae(), { $q: a } = n.proxy, i = Mt(e, a), { tabindex: r, headerClass: s, getLocale: d, getCurrentDate: c } = eu(e, a), u = mr(e), m = An(u);
    let p, f;
    const _ = G(null), v = b(() => te()), y = b(() => d()), M = b(() => oe()), w = yn(
      e.modelValue,
      v.value,
      // initial mask
      y.value,
      // initial locale
      e.calendar,
      M.value
    ), S = G(Qf(w)), h = G(w), C = G(w.hour === null || w.hour < 12), T = b(
      () => `q-time q-time--${e.landscape === !0 ? "landscape" : "portrait"}` + (i.value === !0 ? " q-time--dark q-dark" : "") + (e.disable === !0 ? " disabled" : e.readonly === !0 ? " q-time--readonly" : "") + (e.bordered === !0 ? " q-time--bordered" : "") + (e.square === !0 ? " q-time--square no-border-radius" : "") + (e.flat === !0 ? " q-time--flat no-shadow" : "")
    ), I = b(() => {
      const ne = h.value;
      return {
        hour: ne.hour === null ? "--" : E.value === !0 ? Xe(ne.hour) : String(
          C.value === !0 ? ne.hour === 0 ? 12 : ne.hour : ne.hour > 12 ? ne.hour - 12 : ne.hour
        ),
        minute: ne.minute === null ? "--" : Xe(ne.minute),
        second: ne.second === null ? "--" : Xe(ne.second)
      };
    }), E = b(() => e.format24h !== null ? e.format24h : a.lang.date.format24h), A = b(() => {
      const ne = S.value === "hour", de = ne === !0 ? 12 : 60, ke = h.value[S.value];
      let Ye = `rotate(${Math.round(ke * (360 / de)) - 180}deg) translateX(-50%)`;
      return ne === !0 && E.value === !0 && h.value.hour >= 12 && (Ye += " scale(.7)"), { transform: Ye };
    }), O = b(() => h.value.hour !== null), P = b(() => O.value === !0 && h.value.minute !== null), $ = b(() => e.hourOptions !== void 0 ? (ne) => e.hourOptions.includes(ne) : e.options !== void 0 ? (ne) => e.options(ne, null, null) : null), k = b(() => e.minuteOptions !== void 0 ? (ne) => e.minuteOptions.includes(ne) : e.options !== void 0 ? (ne) => e.options(h.value.hour, ne, null) : null), g = b(() => e.secondOptions !== void 0 ? (ne) => e.secondOptions.includes(ne) : e.options !== void 0 ? (ne) => e.options(h.value.hour, h.value.minute, ne) : null), x = b(() => {
      if ($.value === null)
        return null;
      const ne = H(0, 11, $.value), de = H(12, 11, $.value);
      return { am: ne, pm: de, values: ne.values.concat(de.values) };
    }), B = b(() => k.value !== null ? H(0, 59, k.value) : null), q = b(() => g.value !== null ? H(0, 59, g.value) : null), Y = b(() => {
      switch (S.value) {
        case "hour":
          return x.value;
        case "minute":
          return B.value;
        case "second":
          return q.value;
      }
    }), K = b(() => {
      let ne, de, ke = 0, Pe = 1;
      const Ye = Y.value !== null ? Y.value.values : void 0;
      S.value === "hour" ? E.value === !0 ? (ne = 0, de = 23) : (ne = 0, de = 11, C.value === !1 && (ke = 12)) : (ne = 0, de = 55, Pe = 5);
      const At = [];
      for (let He = ne, it = ne; He <= de; He += Pe, it++) {
        const Dt = He + ke, tl = Ye !== void 0 && Ye.includes(Dt) === !1, ol = S.value === "hour" && He === 0 ? E.value === !0 ? "00" : "12" : He;
        At.push({ val: Dt, index: it, disable: tl, label: ol });
      }
      return At;
    }), Q = b(() => [[
      Wf,
      j,
      void 0,
      {
        stop: !0,
        prevent: !0,
        mouse: !0
      }
    ]]);
    me(() => e.modelValue, (ne) => {
      const de = yn(
        ne,
        v.value,
        y.value,
        e.calendar,
        M.value
      );
      (de.dateHash !== h.value.dateHash || de.timeHash !== h.value.timeHash) && (h.value = de, de.hour === null ? S.value = "hour" : C.value = de.hour < 12);
    }), me([v, y], () => {
      lt(() => {
        Ue();
      });
    });
    function W() {
      const ne = {
        ...c(),
        ...Kf()
      };
      Ue(ne), Object.assign(h.value, ne), S.value = "hour";
    }
    function H(ne, de, ke) {
      const Pe = Array.apply(null, { length: de + 1 }).map((Ye, At) => {
        const He = At + ne;
        return {
          index: He,
          val: ke(He) === !0
          // force boolean
        };
      }).filter((Ye) => Ye.val === !0).map((Ye) => Ye.index);
      return {
        min: Pe[0],
        max: Pe[Pe.length - 1],
        values: Pe,
        threshold: de + 1
      };
    }
    function R(ne, de, ke) {
      const Pe = Math.abs(ne - de);
      return Math.min(Pe, ke - Pe);
    }
    function ie(ne, { min: de, max: ke, values: Pe, threshold: Ye }) {
      if (ne === de)
        return de;
      if (ne < de || ne > ke)
        return R(ne, de, Ye) <= R(ne, ke, Ye) ? de : ke;
      const At = Pe.findIndex((Dt) => ne <= Dt), He = Pe[At - 1], it = Pe[At];
      return ne - He <= it - ne ? He : it;
    }
    function te() {
      return e.calendar !== "persian" && e.mask !== null ? e.mask : `HH:mm${e.withSeconds === !0 ? ":ss" : ""}`;
    }
    function oe() {
      if (typeof e.defaultDate != "string") {
        const ne = c(!0);
        return ne.dateHash = pl(ne), ne;
      }
      return yn(e.defaultDate, "YYYY/MM/DD", void 0, e.calendar);
    }
    function fe() {
      return oa(n) === !0 || Y.value !== null && (Y.value.values.length === 0 || S.value === "hour" && E.value !== !0 && x.value[C.value === !0 ? "am" : "pm"].values.length === 0);
    }
    function Z() {
      const ne = _.value, { top: de, left: ke, width: Pe } = ne.getBoundingClientRect(), Ye = Pe / 2;
      return {
        top: de + Ye,
        left: ke + Ye,
        dist: Ye * 0.7
      };
    }
    function j(ne) {
      if (fe() !== !0) {
        if (ne.isFirst === !0) {
          p = Z(), f = we(ne.evt, p);
          return;
        }
        f = we(ne.evt, p, f), ne.isFinal === !0 && (p = !1, f = null, he());
      }
    }
    function he() {
      S.value === "hour" ? S.value = "minute" : e.withSeconds && S.value === "minute" && (S.value = "second");
    }
    function we(ne, de, ke) {
      const Pe = Cl(ne), Ye = Math.abs(Pe.top - de.top), At = Math.sqrt(
        Math.pow(Math.abs(Pe.top - de.top), 2) + Math.pow(Math.abs(Pe.left - de.left), 2)
      );
      let He, it = Math.asin(Ye / At) * (180 / Math.PI);
      if (Pe.top < de.top ? it = de.left < Pe.left ? 90 - it : 270 + it : it = de.left < Pe.left ? it + 90 : 270 - it, S.value === "hour") {
        if (He = it / 30, x.value !== null) {
          const Dt = E.value !== !0 ? C.value === !0 : x.value.am.values.length !== 0 && x.value.pm.values.length !== 0 ? At >= de.dist : x.value.am.values.length !== 0;
          He = ie(
            He + (Dt === !0 ? 0 : 12),
            x.value[Dt === !0 ? "am" : "pm"]
          );
        } else
          He = Math.round(He), E.value === !0 ? At < de.dist ? He < 12 && (He += 12) : He === 12 && (He = 0) : C.value === !0 && He === 12 ? He = 0 : C.value === !1 && He !== 12 && (He += 12);
        E.value === !0 && (C.value = He < 12);
      } else
        He = Math.round(it / 6) % 60, S.value === "minute" && B.value !== null ? He = ie(He, B.value) : S.value === "second" && q.value !== null && (He = ie(He, q.value));
      return ke !== He && $e[S.value](He), He;
    }
    const Ie = {
      hour() {
        S.value = "hour";
      },
      minute() {
        S.value = "minute";
      },
      second() {
        S.value = "second";
      }
    };
    function ot(ne) {
      ne.keyCode === 13 && tt();
    }
    function St(ne) {
      ne.keyCode === 13 && Je();
    }
    function xt(ne) {
      fe() !== !0 && (a.platform.is.desktop !== !0 && we(ne, Z()), he());
    }
    function qt(ne) {
      fe() !== !0 && we(ne, Z());
    }
    function pt(ne) {
      if (ne.keyCode === 13)
        S.value = "hour";
      else if ([37, 39].includes(ne.keyCode)) {
        const de = ne.keyCode === 37 ? -1 : 1;
        if (x.value !== null) {
          const ke = E.value === !0 ? x.value.values : x.value[C.value === !0 ? "am" : "pm"].values;
          if (ke.length === 0)
            return;
          if (h.value.hour === null)
            ft(ke[0]);
          else {
            const Pe = (ke.length + ke.indexOf(h.value.hour) + de) % ke.length;
            ft(ke[Pe]);
          }
        } else {
          const ke = E.value === !0 ? 24 : 12, Pe = E.value !== !0 && C.value === !1 ? 12 : 0, Ye = h.value.hour === null ? -de : h.value.hour;
          ft(Pe + (24 + Ye + de) % ke);
        }
      }
    }
    function Wt(ne) {
      if (ne.keyCode === 13)
        S.value = "minute";
      else if ([37, 39].includes(ne.keyCode)) {
        const de = ne.keyCode === 37 ? -1 : 1;
        if (B.value !== null) {
          const ke = B.value.values;
          if (ke.length === 0)
            return;
          if (h.value.minute === null)
            ue(ke[0]);
          else {
            const Pe = (ke.length + ke.indexOf(h.value.minute) + de) % ke.length;
            ue(ke[Pe]);
          }
        } else {
          const ke = h.value.minute === null ? -de : h.value.minute;
          ue((60 + ke + de) % 60);
        }
      }
    }
    function el(ne) {
      if (ne.keyCode === 13)
        S.value = "second";
      else if ([37, 39].includes(ne.keyCode)) {
        const de = ne.keyCode === 37 ? -1 : 1;
        if (q.value !== null) {
          const ke = q.value.values;
          if (ke.length === 0)
            return;
          if (h.value.seconds === null)
            _e(ke[0]);
          else {
            const Pe = (ke.length + ke.indexOf(h.value.second) + de) % ke.length;
            _e(ke[Pe]);
          }
        } else {
          const ke = h.value.second === null ? -de : h.value.second;
          _e((60 + ke + de) % 60);
        }
      }
    }
    function ft(ne) {
      h.value.hour !== ne && (h.value.hour = ne, Re());
    }
    function ue(ne) {
      h.value.minute !== ne && (h.value.minute = ne, Re());
    }
    function _e(ne) {
      h.value.second !== ne && (h.value.second = ne, Re());
    }
    const $e = {
      hour: ft,
      minute: ue,
      second: _e
    };
    function tt() {
      C.value === !1 && (C.value = !0, h.value.hour !== null && (h.value.hour -= 12, Re()));
    }
    function Je() {
      C.value === !0 && (C.value = !1, h.value.hour !== null && (h.value.hour += 12, Re()));
    }
    function Re() {
      if ($.value !== null && $.value(h.value.hour) !== !0) {
        h.value = yn(), S.value = "hour";
        return;
      }
      if (k.value !== null && k.value(h.value.minute) !== !0) {
        h.value.minute = null, h.value.second = null, S.value = "minute";
        return;
      }
      if (e.withSeconds === !0 && g.value !== null && g.value(h.value.second) !== !0) {
        h.value.second = null, S.value = "second";
        return;
      }
      h.value.hour === null || h.value.minute === null || e.withSeconds === !0 && h.value.second === null || Ue();
    }
    function Ue(ne) {
      const de = Object.assign({ ...h.value }, ne), ke = e.calendar === "persian" ? Xe(de.hour) + ":" + Xe(de.minute) + (e.withSeconds === !0 ? ":" + Xe(de.second) : "") : ou(
        new Date(
          de.year,
          de.month === null ? null : de.month - 1,
          de.day,
          de.hour,
          de.minute,
          de.second,
          de.millisecond
        ),
        v.value,
        y.value,
        de.year,
        de.timezoneOffset
      );
      de.changed = ke !== e.modelValue, l("update:modelValue", ke, de);
    }
    function bt() {
      const ne = [
        V("div", {
          class: "q-time__link " + (S.value === "hour" ? "q-time__link--active" : "cursor-pointer"),
          tabindex: r.value,
          onClick: Ie.hour,
          onKeyup: pt
        }, I.value.hour),
        V("div", ":"),
        V(
          "div",
          O.value === !0 ? {
            class: "q-time__link " + (S.value === "minute" ? "q-time__link--active" : "cursor-pointer"),
            tabindex: r.value,
            onKeyup: Wt,
            onClick: Ie.minute
          } : { class: "q-time__link" },
          I.value.minute
        )
      ];
      e.withSeconds === !0 && ne.push(
        V("div", ":"),
        V(
          "div",
          P.value === !0 ? {
            class: "q-time__link " + (S.value === "second" ? "q-time__link--active" : "cursor-pointer"),
            tabindex: r.value,
            onKeyup: el,
            onClick: Ie.second
          } : { class: "q-time__link" },
          I.value.second
        )
      );
      const de = [
        V("div", {
          class: "q-time__header-label row items-center no-wrap",
          dir: "ltr"
        }, ne)
      ];
      return E.value === !1 && de.push(
        V("div", {
          class: "q-time__header-ampm column items-between no-wrap"
        }, [
          V("div", {
            class: "q-time__link " + (C.value === !0 ? "q-time__link--active" : "cursor-pointer"),
            tabindex: r.value,
            onClick: tt,
            onKeyup: ot
          }, "AM"),
          V("div", {
            class: "q-time__link " + (C.value !== !0 ? "q-time__link--active" : "cursor-pointer"),
            tabindex: r.value,
            onClick: Je,
            onKeyup: St
          }, "PM")
        ])
      ), V("div", {
        class: "q-time__header flex flex-center no-wrap " + s.value
      }, de);
    }
    function ht() {
      const ne = h.value[S.value];
      return V("div", {
        class: "q-time__content col relative-position"
      }, [
        V(Qt, {
          name: "q-transition--scale"
        }, () => V("div", {
          key: "clock" + S.value,
          class: "q-time__container-parent absolute-full"
        }, [
          V("div", {
            ref: _,
            class: "q-time__container-child fit overflow-hidden"
          }, [
            Ct(
              V("div", {
                class: "q-time__clock cursor-pointer non-selectable",
                onClick: xt,
                onMousedown: qt
              }, [
                V("div", { class: "q-time__clock-circle fit" }, [
                  V("div", {
                    class: "q-time__clock-pointer" + (h.value[S.value] === null ? " hidden" : e.color !== void 0 ? ` text-${e.color}` : ""),
                    style: A.value
                  }),
                  K.value.map((de) => V("div", {
                    class: `q-time__clock-position row flex-center q-time__clock-pos-${de.index}` + (de.val === ne ? " q-time__clock-position--active " + s.value : de.disable === !0 ? " q-time__clock-position--disable" : "")
                  }, [V("span", de.label)]))
                ])
              ]),
              Q.value
            )
          ])
        ])),
        e.nowBtn === !0 ? V(se, {
          class: "q-time__now-button absolute",
          icon: a.iconSet.datetime.now,
          unelevated: !0,
          size: "sm",
          round: !0,
          color: e.color,
          textColor: e.textColor,
          tabindex: r.value,
          onClick: W
        }) : null
      ]);
    }
    return n.proxy.setNow = W, () => {
      const ne = [ht()], de = We(t.default);
      return de !== void 0 && ne.push(
        V("div", { class: "q-time__actions" }, de)
      ), e.name !== void 0 && e.disable !== !0 && m(ne, "push"), V("div", {
        class: T.value,
        tabindex: -1
      }, [
        bt(),
        V("div", { class: "q-time__main col overflow-auto" }, ne)
      ]);
    };
  }
}), Zf = De({
  name: "QPopupProxy",
  props: {
    ...ro,
    breakpoint: {
      type: [String, Number],
      default: 450
    }
  },
  emits: ["show", "hide"],
  setup(e, { slots: t, emit: l, attrs: n }) {
    const { proxy: a } = Ae(), { $q: i } = a, r = G(!1), s = G(null), d = b(() => parseInt(e.breakpoint, 10)), { canShow: c } = uo({ showing: r });
    function u() {
      return i.screen.width < d.value || i.screen.height < d.value ? "dialog" : "menu";
    }
    const m = G(u()), p = b(
      () => m.value === "menu" ? { maxHeight: "99vh" } : {}
    );
    me(() => u(), (v) => {
      r.value !== !0 && (m.value = v);
    });
    function f(v) {
      r.value = !0, l("show", v);
    }
    function _(v) {
      r.value = !1, m.value = u(), l("hide", v);
    }
    return Object.assign(a, {
      show(v) {
        c(v) === !0 && s.value.show(v);
      },
      hide(v) {
        s.value.hide(v);
      },
      toggle(v) {
        s.value.toggle(v);
      }
    }), Kt(a, "currentComponent", () => ({
      type: m.value,
      ref: s.value
    })), () => {
      const v = {
        ref: s,
        ...p.value,
        ...n,
        onShow: f,
        onHide: _
      };
      let y;
      return m.value === "dialog" ? y = $n : (y = _a, Object.assign(v, {
        target: e.target,
        contextMenu: e.contextMenu,
        noParentEvent: !0,
        separateClosePopup: !0
      })), V(y, v, t.default);
    };
  }
}), Xf = (e) => {
  const t = b(() => e.value.type === "date" ? "mdi-calendar" : "mdi-clock"), l = b(() => e.value.type === "date"), n = b(() => e.value.type === "date" ? "##/##/####" : "##:##"), a = (S) => ut(S, "YYYY/MM/DD").format("DD/MM/YYYY"), i = (S) => `${a(S.from)} → ${a(S.to)}`, r = Me("_uct"), s = b(() => r(`renderer.fields.UsfDateHour.${l.value ? "date" : "hour"}.placeholder`)), d = Me("locale"), c = b(() => d !== "en"), { getValue: u, setValue: m } = zt(e), p = b(() => (S, h) => {
    var T, I, E;
    const C = u.value(S);
    if (!C)
      return "";
    if ((T = e.value) != null && T.dateIsRange)
      return h ? C : (I = e.value) != null && I.dateMultiple ? C.map(i).join(", ") : i(C);
    if ((E = e.value) != null && E.dateMultiple)
      return h ? C : C.map(a).join(", ");
    if (l.value) {
      const A = ut(C, "YYYY-MM-DD");
      if (A.isValid())
        return A.format(h ? "YYYY/MM/DD" : "DD/MM/YYYY");
    }
    return C;
  }), f = (S, h, C) => {
    var T, I, E;
    if ((T = e.value) != null && T.dateIsRange) {
      if (S === "" || !C)
        return;
      if ((I = e.value) != null && I.dateMultiple) {
        const A = S.sort((O, P) => ut(O.from, "YYYY/MM/DD").diff(ut(P.from, "YYYY/MM/DD")));
        m(A, h);
      }
      m(S, h);
      return;
    }
    if ((E = e.value) != null && E.dateMultiple) {
      if (S === "" || !C)
        return;
      const A = S.filter((O) => O !== "").sort((O, P) => ut(O, "YYYY/MM/DD").diff(ut(P, "YYYY/MM/DD")));
      m(A, h);
      return;
    }
    if (l.value && /\d{2}\/\d{2}\/\d{4}/.test(S)) {
      const A = ut(S, "DD/MM/YYYY");
      if (A.isValid()) {
        m(A.format("YYYY-MM-DD"), h);
        return;
      }
    }
    m(S, h);
  }, _ = b(() => e.value.style === "birthday" ? "Years" : "Calendar"), v = b(() => {
    var S, h;
    return (h = (S = e.value) == null ? void 0 : S.authorizedDates) != null && h.length ? e.value.authorizedDates : !e.value.minValue && !e.value.maxValue ? (C) => !!C : (C) => {
      const T = ut(C, "YYYY/MM/DD");
      if (e.value.minValue) {
        const I = e.value.minDateFuture ? ut().add(e.value.minValue, e.value.minUnit || "years").startOf("date") : ut().subtract(e.value.minValue, e.value.minUnit || "years").startOf("date");
        if (T.isBefore(I))
          return !1;
      }
      if (e.value.maxValue) {
        const I = e.value.maxDateFuture ? ut().add(e.value.maxValue, e.value.maxUnit || "years").startOf("date") : ut().subtract(e.value.maxValue, e.value.maxUnit || "years").startOf("date");
        if (T.isAfter(I))
          return !1;
      }
      return !0;
    };
  }), y = b(() => {
    var S;
    if ((S = e.value.authorizedDates) != null && S.length) {
      const h = e.value.authorizedDates.map((C) => ut(C, "YYYY/MM/DD")).sort((C, T) => C.diff(T));
      return h[h.length - 1].format("YYYY/MM");
    }
    return e.value.maxValue ? e.value.maxDateFuture ? ut().add(e.value.maxValue, e.value.maxUnit || "years").format("YYYY/MM") : ut().subtract(e.value.maxValue, e.value.maxUnit || "years").format("YYYY/MM") : "";
  }), M = b(() => {
    var S;
    return (S = e.value.authorizedDates) != null && S.length ? e.value.authorizedDates.map((C) => ut(C, "YYYY/MM/DD")).sort((C, T) => C.diff(T))[0].format("YYYY/MM") : e.value.minValue ? e.value.minDateFuture ? ut().add(e.value.minValue, e.value.minUnit || "years").format("YYYY/MM") : ut().subtract(e.value.minValue, e.value.minUnit || "years").format("YYYY/MM") : "";
  }), w = b(() => {
    if (e.value.maxValue && !e.value.maxDateFuture)
      return ut().subtract(e.value.maxValue, e.value.maxUnit || "years").format("YYYY/MM");
  });
  return {
    defaultView: _,
    defaultYearMonth: w,
    getValue: p,
    icon: t,
    is24Hour: c,
    isDate: l,
    mask: n,
    navigationMaxYearMonth: y,
    navigationMinYearMonth: M,
    options: v,
    placeHolder: s,
    setValue: f
  };
}, yl = (e) => {
  const t = Ee(), l = vn(), { fieldIdentification: n } = zt(e);
  wt(() => {
    if (e.value.repeatable) {
      const d = l.submission[n.value];
      if (d && Array.isArray(d) && d.length > 0) {
        t.updateField(e.value.id, "repeatNumber", d.length);
        return;
      }
      t.updateField(
        e.value.id,
        "repeatNumber",
        e.value.defaultRepeat || 1
      );
    }
  });
  const a = () => {
    e.value.repeatable && t.updateField(e.value.id, "repeatNumber", (e.value.repeatNumber ?? 0) + 1);
  }, i = (d, c) => {
    if (c) {
      c.repeatable && (c.repeatNumber ?? 0) > 1 && (c.fields.forEach((u) => {
        var p, f;
        const m = ((p = u.fields[0]) == null ? void 0 : p.name) ?? ((f = u.fields[0]) == null ? void 0 : f.id) ?? "";
        m && l.removeValue(m, d);
      }), t.updateField(c.id, "repeatNumber", (c.repeatNumber ?? 0) - 1));
      return;
    }
    e.value.repeatable && (e.value.repeatNumber ?? 0) > 1 && (l.removeValue(n.value, d), t.updateField(e.value.id, "repeatNumber", (e.value.repeatNumber ?? 0) - 1));
  }, r = b(() => (d) => !e.value.repeatNumber || !e.value.maxRepeat ? !1 : d === e.value.repeatNumber && d < e.value.maxRepeat), s = b(() => (d) => !e.value.repeatNumber || !e.value.maxRepeat ? !1 : d === e.value.maxRepeat || d < e.value.repeatNumber);
  return {
    addRepeatField: a,
    removeRepeatField: i,
    plusButtonDisplayed: r,
    minusButtonDisplayed: s
  };
}, Jf = { class: "row items-center justify-end" }, ev = { class: "row items-center justify-end" }, tv = /* @__PURE__ */ Ce({
  __name: "DateHourItem",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, n = Me("_uct"), { field: a, editorMode: i } = ct(l), r = st(), {
      exist: s,
      fieldOnReadOnly: d,
      label: c,
      required: u,
      visible: m
    } = zt(a, t), { dateRules: p } = Ul(a, i.value), {
      defaultView: f,
      defaultYearMonth: _,
      getValue: v,
      icon: y,
      is24Hour: M,
      isDate: w,
      mask: S,
      navigationMaxYearMonth: h,
      navigationMinYearMonth: C,
      options: T,
      placeHolder: I,
      setValue: E
    } = Xf(a), { addRepeatField: A, removeRepeatField: O, minusButtonDisplayed: P, plusButtonDisplayed: $ } = yl(a);
    return (k, g) => o(i) || o(s) ? (z(!0), re(Ve, { key: 0 }, dt(o(a).repeatNumber || 1, (x) => {
      var B, q, Y, K, Q, W, H;
      return Ct((z(), ae(Ne, {
        id: `${o(a).id + x}`,
        key: `${o(a).id + x}`,
        disable: o(d),
        "hide-hint": !o(a).persistentHint,
        hint: o(r).translated(o(a).id, "hint"),
        label: o(c)(x),
        mask: (B = o(a)) != null && B.dateIsRange || (q = o(a)) != null && q.dateMultiple ? void 0 : o(S),
        "model-value": o(v)((Y = o(a)) != null && Y.repeatable ? x : k.parentIndex ?? x, !1),
        outlined: o(a).outlined,
        placeholder: o(I),
        prefix: o(r).translated(o(a).id, "prefix"),
        readonly: ((K = o(a)) == null ? void 0 : K.dateIsRange) || ((Q = o(a)) == null ? void 0 : Q.dateMultiple) || !1,
        required: o(u),
        rounded: o(a).rounded,
        rules: (W = o(a)) != null && W.dateIsRange || (H = o(a)) != null && H.dateMultiple ? [] : o(p),
        suffix: o(r).translated(o(a).id, "suffix"),
        "onUpdate:modelValue": (R) => {
          var ie;
          return o(E)(R, (ie = o(a)) != null && ie.repeatable ? x : k.parentIndex ?? x, !1);
        }
      }, vl({
        append: L(() => [
          D(Qe, { name: o(y) }, {
            default: L(() => [
              D(Zf, {
                cover: "",
                "transition-hide": "scale",
                "transition-show": "scale"
              }, {
                default: L(() => {
                  var R, ie;
                  return [
                    o(w) ? (z(), ae(iu, {
                      key: 0,
                      "default-view": o(f),
                      "default-year-month": o(_),
                      "model-value": o(v)((R = o(a)) != null && R.repeatable ? x : k.parentIndex ?? x, !0),
                      multiple: o(a).dateMultiple || !1,
                      "navigation-max-year-month": o(h),
                      "navigation-min-year-month": o(C),
                      options: o(T),
                      range: o(a).dateIsRange || !1,
                      "onUpdate:modelValue": (te) => {
                        var oe;
                        return o(E)(te, (oe = o(a)) != null && oe.repeatable ? x : k.parentIndex ?? x, !0);
                      }
                    }, {
                      default: L(() => [
                        ee("div", Jf, [
                          Ct(D(se, {
                            label: o(n)("core.buttons.close"),
                            color: "primary",
                            flat: ""
                          }, null, 8, ["label"]), [
                            [Za]
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["default-view", "default-year-month", "model-value", "multiple", "navigation-max-year-month", "navigation-min-year-month", "options", "range", "onUpdate:modelValue"])) : (z(), ae(Gf, {
                      key: 1,
                      format24h: o(M),
                      "model-value": o(v)((ie = o(a)) != null && ie.repeatable ? x : k.parentIndex ?? x, !0),
                      "onUpdate:modelValue": (te) => {
                        var oe;
                        return o(E)(te, (oe = o(a)) != null && oe.repeatable ? x : k.parentIndex ?? x, !0);
                      }
                    }, {
                      default: L(() => [
                        ee("div", ev, [
                          Ct(D(se, {
                            label: o(n)("core.buttons.close"),
                            color: "primary",
                            flat: ""
                          }, null, 8, ["label"]), [
                            [Za]
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["format24h", "model-value", "onUpdate:modelValue"]))
                  ];
                }),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["name"])
        ]),
        _: 2
      }, [
        o(a).repeatable && !o(i) ? {
          name: "after",
          fn: L(() => [
            o($)(x) ? (z(), ae(se, {
              key: 0,
              dense: "",
              flat: "",
              icon: "mdi-plus",
              round: "",
              onClick: o(A)
            }, null, 8, ["onClick"])) : o(P)(x) ? (z(), ae(se, {
              key: 1,
              dense: "",
              flat: "",
              icon: "mdi-minus",
              round: "",
              onClick: (R) => o(O)(x)
            }, null, 8, ["onClick"])) : ce("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "disable", "hide-hint", "hint", "label", "mask", "model-value", "outlined", "placeholder", "prefix", "readonly", "required", "rounded", "rules", "suffix", "onUpdate:modelValue"])), [
        [Nt, o(i) || o(m)]
      ]);
    }), 128)) : ce("", !0);
  }
});
const lv = /* @__PURE__ */ Oe(tv, [["__scopeId", "data-v-5e544e47"]]), nv = (e) => {
  const { label: t, getValue: l } = zt(e), { convertFileSize: n, getFileSizeMultiplier: a } = wo(G(e.value.id)), { addRepeatField: i, removeRepeatField: r } = yl(e), s = Me("_uct"), d = b(() => (v) => t.value(v) + `${e.value.max !== void 0 ? ` (${n.value} ${a.value.label})` : ""}`), c = G([]), u = b(() => s(
    "renderer.fields.UsfFile.errors.max",
    { max: n.value + a.value.label }
  )), m = (v, y) => {
    var M;
    c.value[y] = ((M = v[0]) == null ? void 0 : M.failedPropValidation) === "max-file-size";
  }, p = () => {
    e.value.repeatable && (i(), c.value.push(!1));
  }, f = (v) => {
    e.value.repeatable && (e.value.repeatNumber || 0) > 1 && (r(v), c.value.splice(v, 1));
  }, _ = b(() => (v) => {
    const y = l.value(v);
    return y === "" ? null : y;
  });
  return {
    label: d,
    errorMessage: u,
    fileRejected: m,
    hasError: c,
    getValue: _,
    addRepeatField: p,
    removeRepeatField: f
  };
}, av = (e) => (Ai("data-v-7d198ba8"), e = e(), Oi(), e), ov = /* @__PURE__ */ av(() => /* @__PURE__ */ ee("i", { class: "mdi mdi-paperclip" }, null, -1)), iv = /* @__PURE__ */ Ce({
  __name: "FileItem",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, { field: n, editorMode: a } = ct(l), i = st(), {
      appendIcon: r,
      exist: s,
      fieldOnReadOnly: d,
      required: c,
      setValue: u,
      visible: m
    } = zt(n, t), {
      addRepeatField: p,
      errorMessage: f,
      fileRejected: _,
      getValue: v,
      hasError: y,
      label: M,
      removeRepeatField: w
    } = nv(n), { minusButtonDisplayed: S, plusButtonDisplayed: h } = yl(n);
    return (C, T) => o(a) || o(s) ? (z(!0), re(Ve, { key: 0 }, dt(o(n).repeatNumber || 1, (I) => {
      var E;
      return Ct((z(), ae(Hr, {
        id: `${o(n).id + I}`,
        key: `${o(n).id + I}`,
        accept: o(n).accept || "*/*",
        clearable: o(n).clearable,
        disable: o(d),
        error: o(y)[I],
        "error-message": o(f),
        filled: o(n).filled,
        "hide-hint": !o(n).persistentHint,
        hint: o(i).translated(o(n).id, "hint"),
        label: o(M)(I),
        "max-file-size": o(n).max,
        "model-value": o(v)((E = o(n)) != null && E.repeatable ? I : C.parentIndex ?? I),
        outlined: o(n).outlined,
        placeholder: o(i).translated(o(n).id, "placeholder"),
        prefix: o(i).translated(o(n).id, "prefix"),
        required: o(c),
        rounded: o(n).rounded,
        suffix: o(i).translated(o(n).id, "suffix"),
        "use-chips": o(n).chips,
        onRejected: (A) => o(_)(A, I),
        "onUpdate:modelValue": (A) => {
          var O;
          return o(u)(A, (O = o(n)) != null && O.repeatable ? I : C.parentIndex ?? I);
        }
      }, vl({
        prepend: L(() => [
          ov
        ]),
        _: 2
      }, [
        o(n).appendIcon ? {
          name: "append",
          fn: L(() => [
            ee("i", {
              class: Ft(o(r))
            }, null, 2)
          ]),
          key: "0"
        } : void 0,
        o(n).repeatable && !o(a) ? {
          name: "after",
          fn: L(() => [
            o(h)(I) ? (z(), ae(se, {
              key: 0,
              dense: "",
              flat: "",
              icon: "mdi-plus",
              round: "",
              onClick: o(p)
            }, null, 8, ["onClick"])) : o(S)(I) ? (z(), ae(se, {
              key: 1,
              dense: "",
              flat: "",
              icon: "mdi-minus",
              round: "",
              onClick: (A) => o(w)(I)
            }, null, 8, ["onClick"])) : ce("", !0)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["id", "accept", "clearable", "disable", "error", "error-message", "filled", "hide-hint", "hint", "label", "max-file-size", "model-value", "outlined", "placeholder", "prefix", "required", "rounded", "suffix", "use-chips", "onRejected", "onUpdate:modelValue"])), [
        [Nt, o(a) || o(m)]
      ]);
    }), 128)) : ce("", !0);
  }
});
const rv = /* @__PURE__ */ Oe(iv, [["__scopeId", "data-v-7d198ba8"]]), uv = /* @__PURE__ */ Ce({
  __name: "InputItem",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, { field: n, editorMode: a } = ct(l), i = st(), {
      appendIcon: r,
      exist: s,
      fieldOnReadOnly: d,
      getValue: c,
      label: u,
      prependIcon: m,
      required: p,
      setValue: f,
      visible: _
    } = zt(n, t), { inputRules: v } = Ul(n, a.value), { addRepeatField: y, removeRepeatField: M, minusButtonDisplayed: w, plusButtonDisplayed: S } = yl(n);
    return (h, C) => o(a) || o(s) ? (z(!0), re(Ve, { key: 0 }, dt(o(n).repeatNumber || 1, (T) => {
      var I;
      return Ct((z(), ae(Ne, {
        id: `${o(n).id + T}`,
        key: `${o(n).id + T}`,
        clearable: o(n).clearable,
        disable: o(d),
        "fill-mask": o(n).maskFilling || !1,
        filled: o(n).filled,
        "hide-hint": !o(n).persistentHint,
        hint: o(i).translated(o(n).id, "hint"),
        label: o(u)(T),
        mask: o(n).mask || "",
        max: o(n).type === "number" ? o(n).max : void 0,
        min: o(n).type === "number" ? o(n).min : void 0,
        "model-value": o(c)((I = o(n)) != null && I.repeatable ? T : h.parentIndex ?? T),
        outlined: o(n).outlined,
        placeholder: o(i).translated(o(n).id, "placeholder"),
        prefix: o(i).translated(o(n).id, "prefix"),
        required: o(p),
        rounded: o(n).rounded,
        rules: o(v),
        step: o(n).type === "number" ? o(n).step : void 0,
        suffix: o(i).translated(o(n).id, "suffix"),
        type: o(n).type,
        "unmasked-value": o(n).modelUnmasked || !1,
        "onUpdate:modelValue": (E) => {
          var A;
          return o(f)(E, (A = o(n)) != null && A.repeatable ? T : h.parentIndex ?? T);
        }
      }, vl({ _: 2 }, [
        o(n).prependIcon ? {
          name: "prepend",
          fn: L(() => [
            ee("i", {
              class: Ft(o(m))
            }, null, 2)
          ]),
          key: "0"
        } : void 0,
        o(n).appendIcon ? {
          name: "append",
          fn: L(() => [
            ee("i", {
              class: Ft(o(r))
            }, null, 2)
          ]),
          key: "1"
        } : void 0,
        o(n).repeatable && !o(a) ? {
          name: "after",
          fn: L(() => [
            o(S)(T) ? (z(), ae(se, {
              key: 0,
              dense: "",
              flat: "",
              icon: "mdi-plus",
              round: "",
              onClick: o(y)
            }, null, 8, ["onClick"])) : o(w)(T) ? (z(), ae(se, {
              key: 1,
              dense: "",
              flat: "",
              icon: "mdi-minus",
              round: "",
              onClick: (E) => o(M)(T)
            }, null, 8, ["onClick"])) : ce("", !0)
          ]),
          key: "2"
        } : void 0
      ]), 1032, ["id", "clearable", "disable", "fill-mask", "filled", "hide-hint", "hint", "label", "mask", "max", "min", "model-value", "outlined", "placeholder", "prefix", "required", "rounded", "rules", "step", "suffix", "type", "unmasked-value", "onUpdate:modelValue"])), [
        [Nt, o(a) || o(_)]
      ]);
    }), 128)) : ce("", !0);
  }
});
const sv = /* @__PURE__ */ Oe(uv, [["__scopeId", "data-v-459137c7"]]), cu = (e, t) => {
  const l = Ee(), n = st(), a = Lt(), i = vn(), { exist: r, fieldIdentification: s, getValue: d, setValue: c } = zt(e), u = G(""), m = b(() => {
    if (!e.value.defaultOption)
      return null;
    const C = l.options[e.value.defaultOption];
    return C ? a.selectEmitValue ? C.value : {
      label: C.label,
      value: C.value
    } : null;
  });
  wt(() => {
    e.value.defaultOption && m.value && i.setValue(
      s.value,
      e.value.repeatable || a.selectOnlyArray ? [m.value] : m.value
    );
  });
  const p = b(() => {
    var T;
    const C = ((T = e.value.options) == null ? void 0 : T.map((I) => {
      const E = I.id ? n.translated(I.id, "label", "options") : I.label;
      return {
        ...I,
        label: E
      };
    })) || [];
    if (t || !e.value.dependsOn)
      return C;
    if (e.value.dependsOn.startsWith("user.")) {
      const [I, E] = e.value.dependsOn.split(".");
      return C.filter((A) => {
        var O;
        return (O = A == null ? void 0 : A.displayedBy) == null ? void 0 : O.some((P) => a.isAttributeArray(I, E) ? a.user[E].includes(P) : a.user[E] === P);
      });
    }
    return C.filter((I) => {
      var P;
      const E = l.fields[e.value.dependsOn ?? ""], A = i.getValue((E == null ? void 0 : E.name) || (E == null ? void 0 : E.id) || ""), O = ((P = I.displayedBy) == null ? void 0 : P.map(($) => l.options[$])) ?? [];
      return A ? typeof A == "string" ? O.some(($) => $.value === A) : Array.isArray(A) ? A.length === 0 ? !1 : typeof A[0] == "string" ? A.some(($) => O.some((k) => k.value === $)) : A.some(($) => O.some((k) => k.value === ($ == null ? void 0 : $.value))) : O.some(($) => $.value === A.value) : !1;
    });
  }), f = b(() => r.value ? p.value.length !== 0 : !1), _ = b(() => p.value.length > 0), v = b(() => (C) => {
    if ("interdependentFields" in e.value && e.value.interdependentFields) {
      const T = i.getValue(
        s.value
      ), I = i.getValue(
        s.value,
        C
      );
      if (T)
        return p.value.filter((E) => {
          if (u.value && (!E.label.toLowerCase().includes(u.value.toLowerCase()) || E.value.toLowerCase().includes(u.value.toLowerCase())))
            return !1;
          if (E.value === I)
            return !0;
          if (Array.isArray(T))
            return T.length === 0 ? !0 : !T.some((A) => typeof A == "string" ? E.value === A : E.value === (A == null ? void 0 : A.value));
          if (T && T === E.value)
            return !0;
        });
    }
    return u.value ? p.value.filter(
      (T) => T.label.toLowerCase().includes(u.value.toLowerCase()) || T.value.toLowerCase().includes(u.value.toLowerCase())
    ) : p.value;
  }), y = (C, T, I = !1) => {
    if (C === null) {
      c(null, T);
      return;
    }
    const E = (O) => {
      if (I) {
        if (a.radioEmitValue)
          return O;
        const P = v.value(T).find(($) => $.value === O);
        return P ? {
          value: P.value,
          label: P.label
        } : O;
      }
      return typeof O == "string" ? O : {
        value: O.value,
        label: O.label
      };
    }, A = Array.isArray(C) ? C.map(E) : E(C);
    if (a.selectOnlyArray && !e.value.repeatable && !Array.isArray(C)) {
      c([A], T);
      return;
    }
    c(A, T);
  }, M = b(() => (C, T = !1) => {
    if (T) {
      const I = d.value(C);
      return a.radioEmitValue ? I : I == null ? void 0 : I.value;
    }
    if (a.selectOnlyArray && !e.value.repeatable && !e.value.multiple) {
      const I = d.value(C);
      return Array.isArray(I) ? I[0] : I;
    }
    return d.value(C) || null;
  }), w = (C, T) => {
    T(() => {
      u.value = C;
    });
  }, S = b(() => {
    if (!e.value.dependsOn)
      return "";
    const C = l.fields[e.value.dependsOn];
    return C ? n.translated(C == null ? void 0 : C.id, "label") : "";
  }), h = b(() => {
    if (!e.value.dependsOn)
      return "";
    const C = l.fields[e.value.dependsOn];
    return C && (C.name || C.id) || "";
  });
  return me(() => i.submission[h.value], () => {
    for (let C = 1; C <= (e.value.repeatNumber || 1); C++)
      c("", C);
  }), {
    dependsOnFieldIdentification: h,
    dependsOnFieldLabel: S,
    exist: f,
    fieldOptions: p,
    filterFn: w,
    getDefaultOption: m,
    getValue: M,
    hasOptions: _,
    selectValues: v,
    setValue: y
  };
}, dv = /* @__PURE__ */ Ce({
  __name: "RadioItem",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, { field: n, editorMode: a } = ct(l), i = st(), {
      exist: r,
      fieldOnReadOnly: s,
      label: d,
      required: c,
      visible: u
    } = zt(n, t), { requiredRules: m } = Ul(n, a.value), { getValue: p, hasOptions: f, selectValues: _, setValue: v } = cu(n, a.value), { addRepeatField: y, removeRepeatField: M, minusButtonDisplayed: w, plusButtonDisplayed: S } = yl(n);
    return (h, C) => o(a) || o(f) && o(r) ? (z(!0), re(Ve, { key: 0 }, dt(o(n).repeatNumber || 1, (T) => {
      var I;
      return Ct((z(), ae(ha, {
        id: `${o(n).id + T}`,
        key: `${o(n).id + T}`,
        "hide-hint": !o(n).persistentHint,
        hint: o(i).translated(o(n).id, "hint"),
        label: o(d)(T),
        "model-value": o(p)((I = o(n)) != null && I.repeatable ? T : h.parentIndex ?? T, !0),
        required: o(c),
        rules: o(m),
        borderless: "",
        "stack-label": ""
      }, vl({
        default: L(() => [
          D(Wr, {
            disable: o(s),
            inline: o(n).horizontal,
            "model-value": o(p)(h.parentIndex ?? T, !0),
            options: o(_)(T),
            "onUpdate:modelValue": (E) => {
              var A;
              return o(v)(E, (A = o(n)) != null && A.repeatable ? T : h.parentIndex ?? T, !0);
            }
          }, {
            label: L(({ label: E, tooltip: A }) => [
              ee("span", null, J(E), 1),
              A ? (z(), ae(nt, { key: 0 }, {
                default: L(() => [
                  ve(J(A), 1)
                ]),
                _: 2
              }, 1024)) : ce("", !0)
            ]),
            _: 2
          }, 1032, ["disable", "inline", "model-value", "options", "onUpdate:modelValue"])
        ]),
        _: 2
      }, [
        o(n).repeatable && !o(a) ? {
          name: "after",
          fn: L(() => [
            o(S)(T) ? (z(), ae(se, {
              key: 0,
              dense: "",
              flat: "",
              icon: "mdi-plus",
              round: "",
              onClick: o(y)
            }, null, 8, ["onClick"])) : o(w)(T) ? (z(), ae(se, {
              key: 1,
              dense: "",
              flat: "",
              icon: "mdi-minus",
              round: "",
              onClick: (E) => o(M)(T)
            }, null, 8, ["onClick"])) : ce("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["id", "hide-hint", "hint", "label", "model-value", "required", "rules"])), [
        [Nt, o(a) || o(u)]
      ]);
    }), 128)) : ce("", !0);
  }
});
const cv = /* @__PURE__ */ Oe(dv, [["__scopeId", "data-v-cb6dfc10"]]), fv = ["innerHTML"], vv = /* @__PURE__ */ Ce({
  __name: "RichTextItem",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, { field: n } = ct(l), a = st(), { exist: i, visible: r } = zt(n, t);
    return (s, d) => s.editorMode || o(i) ? Ct((z(), re("p", {
      key: 0,
      innerHTML: o(a).translated(o(n).id, "content", "fields", !0)
    }, null, 8, fv)), [
      [Nt, s.editorMode || o(r)]
    ]) : ce("", !0);
  }
});
const mv = /* @__PURE__ */ Oe(vv, [["__scopeId", "data-v-cd2168d2"]]), pv = (e, t) => {
  const l = st(), n = b(() => {
    var r;
    return !t.value && e.value.type === "container" && !e.value.hasFieldset && !!((r = e.value) != null && r.repeatable);
  }), a = b(() => {
    var r;
    return (r = e.value) != null && r.hasFieldset && (l.translated(e.value.id, "fieldset") || e.value.fieldset) || "";
  });
  return {
    gridTemplateColumns: b(() => {
      var d;
      if (e.value.type === "container")
        return "1fr";
      let r = 12, s = "";
      return (d = e.value.fields) == null || d.forEach((c, u) => {
        c.width && (s += `${(u === 0 ? "" : " ") + c.width}fr`, r -= parseInt(c.width));
      }), r > 0 && (s += ` ${r}fr`), e.value.repeatable && !t.value && (s += " 34px"), s;
    }),
    hasRowBorder: n,
    legend: a
  };
}, bv = { key: 0 }, hv = { key: 0 }, gv = { key: 1 }, yv = /* @__PURE__ */ Ce({
  __name: "RowItem",
  props: {
    childExists: { type: Boolean },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  setup(e) {
    const t = e;
    Su((v) => ({
      cb39b758: o(r)
    }));
    const { field: l, editorMode: n } = ct(t), { exist: a, visible: i } = zt(l), { gridTemplateColumns: r, hasRowBorder: s, legend: d } = pv(l, n), { addRepeatField: c, removeRepeatField: u, minusButtonDisplayed: m, plusButtonDisplayed: p } = yl(l), f = Rl({}), _ = b(() => Object.keys(f).length === 0 ? !1 : Object.values(f).some((v) => v));
    return l.value.fields.forEach(({ fields: v }) => {
      var y;
      f[((y = v[0]) == null ? void 0 : y.id) ?? ""] = !1;
    }), (v, y) => (z(!0), re(Ve, null, dt(o(l).repeatNumber || 1, (M) => (z(), re("div", {
      key: `${o(l).id + M}`,
      class: Ft({ rowContainer: o(s) && _.value, hasFieldset: o(l).hasFieldset, editorMode: o(n) }),
      "data-type": "row"
    }, [
      o(n) ? (z(!0), re(Ve, { key: 0 }, dt(o(l).fields, (w) => (z(), ae(du, {
        key: w.id,
        "editor-mode": o(n),
        field: w
      }, null, 8, ["editor-mode", "field"]))), 128)) : (z(), re(Ve, { key: 1 }, [
        o(a) ? (z(), re(Ve, { key: 0 }, [
          o(l).hasFieldset ? Ct((z(), re("fieldset", bv, [
            o(d) ? (z(), re("legend", hv, J(o(d)), 1)) : ce("", !0),
            (z(!0), re(Ve, null, dt(o(l).fields, (w) => (z(), ae(Vn, {
              key: w.fields[0].id,
              "child-exists": f[w.fields[0].id],
              "editor-mode": o(n),
              field: w.fields[0],
              "parent-index": M,
              "onUpdate:childExists": (S) => f[w.fields[0].id] = S
            }, null, 8, ["child-exists", "editor-mode", "field", "parent-index", "onUpdate:childExists"]))), 128)),
            o(l).repeatable && !o(n) ? (z(), re(Ve, { key: 1 }, [
              o(p)(M) ? (z(), ae(se, {
                key: 0,
                class: "repeatButton",
                dense: "",
                flat: "",
                icon: "mdi-plus",
                round: "",
                onClick: o(c)
              }, null, 8, ["onClick"])) : o(m)(M) ? (z(), ae(se, {
                key: 1,
                class: "repeatButton",
                dense: "",
                flat: "",
                icon: "mdi-minus",
                round: "",
                onClick: (w) => o(u)(M, o(l))
              }, null, 8, ["onClick"])) : ce("", !0)
            ], 64)) : ce("", !0)
          ], 512)), [
            [Nt, o(i) && _.value]
          ]) : Ct((z(), re("div", gv, [
            (z(!0), re(Ve, null, dt(o(l).fields, (w) => (z(), ae(Vn, {
              key: w.fields[0].id,
              "child-exists": f[w.fields[0].id],
              "editor-mode": o(n),
              field: w.fields[0],
              "parent-index": M,
              "onUpdate:childExists": (S) => f[w.fields[0].id] = S
            }, null, 8, ["child-exists", "editor-mode", "field", "parent-index", "onUpdate:childExists"]))), 128)),
            o(l).repeatable && !o(n) ? (z(), re(Ve, { key: 0 }, [
              o(p)(M) ? (z(), ae(se, {
                key: 0,
                class: "repeatButton",
                dense: "",
                flat: "",
                icon: "mdi-plus",
                round: "",
                onClick: o(c)
              }, null, 8, ["onClick"])) : o(m)(M) ? (z(), ae(se, {
                key: 1,
                class: "repeatButton",
                dense: "",
                flat: "",
                icon: "mdi-minus",
                round: "",
                onClick: (w) => o(u)(M, o(l))
              }, null, 8, ["onClick"])) : ce("", !0)
            ], 64)) : ce("", !0)
          ], 512)), [
            [Nt, o(i)]
          ])
        ], 64)) : ce("", !0)
      ], 64))
    ], 2))), 128));
  }
});
const _v = /* @__PURE__ */ Oe(yv, [["__scopeId", "data-v-b966e68c"]]), Sv = { class: "noOption" }, wv = /* @__PURE__ */ Ce({
  __name: "SelectItem",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, { field: n, editorMode: a } = ct(l), i = Lt(), r = st(), s = Ee(), {
      appendIcon: d,
      fieldOnReadOnly: c,
      label: u,
      prependIcon: m,
      required: p,
      visible: f
    } = zt(n, t), _ = Me("_uct"), { requiredRules: v } = Ul(n, a.value), {
      dependsOnFieldLabel: y,
      exist: M,
      filterFn: w,
      getValue: S,
      selectValues: h,
      setValue: C
    } = cu(n, a.value), { addRepeatField: T, removeRepeatField: I, minusButtonDisplayed: E, plusButtonDisplayed: A } = yl(n), { APIData: O, loadAPI: P, loadDeepValue: $ } = go(_, n, G(""));
    return wt(async () => {
      var k;
      n.value.optionsApi && (await P(!1), s.addOptions(
        n.value.id,
        ((k = O.value) == null ? void 0 : k.map((g) => {
          var x, B;
          return {
            label: $(g, ((x = n.value) == null ? void 0 : x.optionLabel) || ""),
            value: $(g, ((B = n.value) == null ? void 0 : B.optionValue) || "")
          };
        })) || []
      ));
    }), (k, g) => o(a) || o(M) ? (z(!0), re(Ve, { key: 0 }, dt(o(n).repeatNumber || 1, (x) => {
      var B, q;
      return Ct((z(), ae(Rt, {
        id: `${o(n).id + x}`,
        key: `${o(n).id + x}`,
        clearable: o(n).clearable || o(n).interdependentFields,
        disable: o(c),
        "emit-value": o(i).selectEmitValue,
        filled: o(n).filled,
        "hide-hint": !o(n).persistentHint,
        hint: o(r).translated(o(n).id, "hint"),
        label: o(u)(x),
        "map-options": o(i).selectEmitValue,
        "model-value": o(S)((B = o(n)) != null && B.repeatable ? x : k.parentIndex ?? x),
        multiple: o(n).multiple,
        options: o(h)(x),
        outlined: o(n).outlined,
        placeholder: o(r).translated(o(n).id, "placeholder"),
        prefix: o(r).translated(o(n).id, "prefix"),
        rounded: o(n).rounded,
        rules: o(v),
        suffix: o(r).translated(o(n).id, "suffix"),
        "use-chips": o(n).chips,
        "use-input": o(n).filterable,
        "option-label": "label",
        "option-value": "value",
        onFilter: o(w),
        "onUpdate:modelValue": (Y) => {
          var K;
          return o(C)(
            Y,
            (K = o(n)) != null && K.repeatable ? x : k.parentIndex ?? x ?? void 0
          );
        }
      }, vl({ _: 2 }, [
        (q = o(n)) != null && q.dependsOn ? {
          name: "no-option",
          fn: L(() => [
            ee("p", Sv, J(o(_)("renderer.fields.UsfSelect.noOption")) + " " + J(o(y)), 1)
          ]),
          key: "0"
        } : void 0,
        o(n).prependIcon ? {
          name: "prepend",
          fn: L(() => [
            ee("i", {
              class: Ft(o(m))
            }, null, 2)
          ]),
          key: "1"
        } : void 0,
        o(n).appendIcon ? {
          name: "append",
          fn: L(() => [
            ee("i", {
              class: Ft(o(d))
            }, null, 2)
          ]),
          key: "2"
        } : void 0,
        o(n).repeatable && !o(a) ? {
          name: "after",
          fn: L(() => [
            o(A)(x) ? (z(), ae(se, {
              key: 0,
              dense: "",
              flat: "",
              icon: "mdi-plus",
              round: "",
              onClick: o(T)
            }, null, 8, ["onClick"])) : o(E)(x) ? (z(), ae(se, {
              key: 1,
              dense: "",
              flat: "",
              icon: "mdi-minus",
              round: "",
              onClick: (Y) => o(I)(x)
            }, null, 8, ["onClick"])) : ce("", !0)
          ]),
          key: "3"
        } : void 0,
        o(n).multiple || o(n).optionsHasTooltip ? {
          name: "option",
          fn: L(({ itemProps: Y, opt: K, selected: Q, toggleOption: W }) => [
            D(Tl, lo(no(Y)), {
              default: L(() => [
                o(n).multiple ? (z(), ae(jt, {
                  key: 0,
                  side: ""
                }, {
                  default: L(() => [
                    D(Bt, {
                      "model-value": Q,
                      "onUpdate:modelValue": (H) => W(K)
                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024)) : ce("", !0),
                D(jt, null, {
                  default: L(() => [
                    K.tooltip ? (z(), ae(nt, { key: 0 }, {
                      default: L(() => [
                        ve(J(K.tooltip), 1)
                      ]),
                      _: 2
                    }, 1024)) : ce("", !0),
                    D(ql, null, {
                      default: L(() => [
                        ve(J(K.label), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1040)
          ]),
          key: "4"
        } : void 0
      ]), 1032, ["id", "clearable", "disable", "emit-value", "filled", "hide-hint", "hint", "label", "map-options", "model-value", "multiple", "options", "outlined", "placeholder", "prefix", "rounded", "rules", "suffix", "use-chips", "use-input", "onFilter", "onUpdate:modelValue"])), [
        [Nt, o(a) || o(f)]
      ]);
    }), 128)) : ce("", !0);
  }
});
const xv = /* @__PURE__ */ Oe(wv, [["__scopeId", "data-v-0b58e4b0"]]), kv = /* @__PURE__ */ Ce({
  __name: "TextareaComponent",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, { field: n, editorMode: a } = ct(l), i = st(), {
      appendIcon: r,
      fieldOnReadOnly: s,
      getValue: d,
      label: c,
      prependIcon: u,
      required: m,
      setValue: p,
      visible: f
    } = zt(n, t), { inputRules: _ } = Ul(n, a.value), { addRepeatField: v, removeRepeatField: y, minusButtonDisplayed: M, plusButtonDisplayed: w } = yl(n);
    return (S, h) => (z(!0), re(Ve, null, dt(o(n).repeatNumber || 1, (C) => {
      var T;
      return Ct((z(), ae(Ne, {
        id: `${o(n).id + C}`,
        key: `${o(n).id + C}`,
        autogrow: o(n).autoGrow,
        clearable: o(n).clearable,
        disable: o(s),
        filled: o(n).filled,
        "hide-hint": !o(n).persistentHint,
        hint: o(i).translated(o(n).id, "hint"),
        label: o(c)(C),
        "model-value": o(d)((T = o(n)) != null && T.repeatable ? C : S.parentIndex ?? C),
        outlined: o(n).outlined,
        placeholder: o(i).translated(o(n).id, "placeholder"),
        prefix: o(i).translated(o(n).id, "prefix"),
        required: o(m),
        rounded: o(n).rounded,
        rows: o(n).rows,
        rules: o(_),
        suffix: o(i).translated(o(n).id, "suffix"),
        type: "textarea",
        "onUpdate:modelValue": (I) => {
          var E;
          return o(p)(I, (E = o(n)) != null && E.repeatable ? C : S.parentIndex ?? C);
        }
      }, vl({ _: 2 }, [
        o(n).prependIcon ? {
          name: "prepend",
          fn: L(() => [
            ee("i", {
              class: Ft(o(u))
            }, null, 2)
          ]),
          key: "0"
        } : void 0,
        o(n).appendIcon ? {
          name: "append",
          fn: L(() => [
            ee("i", {
              class: Ft(o(r))
            }, null, 2)
          ]),
          key: "1"
        } : void 0,
        o(n).repeatable && !o(a) ? {
          name: "after",
          fn: L(() => [
            o(w)(C) ? (z(), ae(se, {
              key: 0,
              dense: "",
              flat: "",
              icon: "mdi-plus",
              round: "",
              onClick: o(v)
            }, null, 8, ["onClick"])) : o(M)(C) ? (z(), ae(se, {
              key: 1,
              dense: "",
              flat: "",
              icon: "mdi-minus",
              round: "",
              onClick: (I) => o(y)(C)
            }, null, 8, ["onClick"])) : ce("", !0)
          ]),
          key: "2"
        } : void 0
      ]), 1032, ["id", "autogrow", "clearable", "disable", "filled", "hide-hint", "hint", "label", "model-value", "outlined", "placeholder", "prefix", "required", "rounded", "rows", "rules", "suffix", "onUpdate:modelValue"])), [
        [Nt, o(a) || o(f)]
      ]);
    }), 128));
  }
});
const Cv = /* @__PURE__ */ Oe(kv, [["__scopeId", "data-v-dd8c0c75"]]), qv = /* @__PURE__ */ Ce({
  __name: "WYSIWYGComponent",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, { field: n, editorMode: a } = ct(l), i = st(), {
      appendIcon: r,
      fieldOnReadOnly: s,
      getValue: d,
      label: c,
      prependIcon: u,
      required: m,
      setValue: p,
      visible: f
    } = zt(n, t), { inputRules: _ } = Ul(n, a.value), { addRepeatField: v, removeRepeatField: y, minusButtonDisplayed: M, plusButtonDisplayed: w } = yl(n), { toolbar: S } = yo(n);
    return (h, C) => (z(!0), re(Ve, null, dt(o(n).repeatNumber || 1, (T) => {
      var I;
      return Ct((z(), ae(ha, {
        id: `${o(n).id + T}`,
        key: `${o(n).id + T}`,
        disable: o(s),
        "hide-hint": !o(n).persistentHint,
        hint: o(i).translated(o(n).id, "hint"),
        label: o(c)(T),
        "model-value": o(d)((I = o(n)) != null && I.repeatable ? T : h.parentIndex ?? T),
        required: o(m),
        rules: o(_),
        suffix: o(i).translated(o(n).id, "suffix"),
        "stack-label": ""
      }, vl({
        default: L(() => {
          var E;
          return [
            D(Pr, {
              disable: o(s),
              "model-value": o(d)((E = o(n)) != null && E.repeatable ? T : h.parentIndex ?? T),
              toolbar: o(S),
              class: "full-width",
              "onUpdate:modelValue": (A) => {
                var O;
                return o(p)(A, (O = o(n)) != null && O.repeatable ? T : h.parentIndex ?? T);
              }
            }, null, 8, ["disable", "model-value", "toolbar", "onUpdate:modelValue"])
          ];
        }),
        _: 2
      }, [
        o(n).prependIcon ? {
          name: "prepend",
          fn: L(() => [
            ee("i", {
              class: Ft(o(u))
            }, null, 2)
          ]),
          key: "0"
        } : void 0,
        o(n).appendIcon ? {
          name: "append",
          fn: L(() => [
            ee("i", {
              class: Ft(o(r))
            }, null, 2)
          ]),
          key: "1"
        } : void 0,
        o(n).repeatable && !o(a) ? {
          name: "after",
          fn: L(() => [
            o(w)(T) ? (z(), ae(se, {
              key: 0,
              dense: "",
              flat: "",
              icon: "mdi-plus",
              round: "",
              onClick: o(v)
            }, null, 8, ["onClick"])) : o(M)(T) ? (z(), ae(se, {
              key: 1,
              dense: "",
              flat: "",
              icon: "mdi-minus",
              round: "",
              onClick: (E) => o(y)(T)
            }, null, 8, ["onClick"])) : ce("", !0)
          ]),
          key: "2"
        } : void 0
      ]), 1032, ["id", "disable", "hide-hint", "hint", "label", "model-value", "required", "rules", "suffix"])), [
        [Nt, o(a) || o(f)]
      ]);
    }), 128));
  }
});
const Vv = /* @__PURE__ */ Oe(qv, [["__scopeId", "data-v-204ddc25"]]), Tv = /* @__PURE__ */ Ce({
  __name: "TextareaItem",
  props: {
    childExists: { type: Boolean, default: !1 },
    editorMode: { type: Boolean, default: !1 },
    field: {},
    parentIndex: {}
  },
  emits: ["update:child-exists"],
  setup(e, { emit: t }) {
    const l = e, { field: n, editorMode: a } = ct(l), { exist: i } = zt(n), { isWYSIWYG: r } = yo(n);
    return (s, d) => o(a) || o(i) ? (z(), re(Ve, { key: 0 }, [
      o(r) ? (z(), ae(Vv, {
        key: 0,
        "child-exists": s.childExists,
        "editor-mode": o(a),
        field: o(n),
        "parent-index": s.parentIndex,
        "onUpdate:childExists": d[0] || (d[0] = (c) => t("update:child-exists", c))
      }, null, 8, ["child-exists", "editor-mode", "field", "parent-index"])) : (z(), ae(Cv, {
        key: 1,
        "child-exists": s.childExists,
        "editor-mode": o(a),
        field: o(n),
        "parent-index": s.parentIndex,
        "onUpdate:childExists": d[1] || (d[1] = (c) => t("update:child-exists", c))
      }, null, 8, ["child-exists", "editor-mode", "field", "parent-index"]))
    ], 64)) : ce("", !0);
  }
}), Mv = {};
function Dv(e, t) {
  return z(), ae(Vl, { class: "bg-negative" }, {
    default: L(() => [
      ve(" Le composant demandé n'existe pas, vérifier votre paramétrage, ou contactez le responsable d'application. ")
    ]),
    _: 1
  });
}
const Iv = /* @__PURE__ */ Oe(Mv, [["render", Dv]]), fu = () => {
  const { componentsCustom: e } = ga();
  return {
    getFieldComponent: (l) => {
      switch (l) {
        case "UsfCheckboxSwitch":
          return Uf;
        case "UsfDateTime":
          return lv;
        case "UsfFile":
          return rv;
        case "UsfText":
          return sv;
        case "UsfRadioGroup":
          return cv;
        case "UsfSelect":
          return xv;
        case "UsfTextArea":
          return Tv;
        case "UsfAccordion":
          return Us;
        case "UsfRow":
          return _v;
        case "UsfCol":
          return du;
        case "UsfContent":
          return mv;
        default:
          return e.value(l) ?? Iv;
      }
    }
  };
}, wo = (e) => {
  const t = Ee(), l = sn(), n = Me("_uct"), a = b(() => e.value ? t.denormalizeField(e.value) : {
    component: "UsfText",
    exist: !0,
    parentId: "root",
    type: "text",
    visible: !0
  }), i = b(() => a.value ? l.controls[a.value.component] : null), { getFieldComponent: r } = fu(), s = b(() => {
    var m;
    return r((m = a.value) == null ? void 0 : m.component);
  }), d = [
    {
      label: n("builder.tabs.validation.fileSize.units.GB"),
      value: 1073741824
    },
    {
      label: n("builder.tabs.validation.fileSize.units.MB"),
      value: 1048572
    },
    {
      label: n("builder.tabs.validation.fileSize.units.kB"),
      value: 1024
    }
  ], c = b(() => {
    var m;
    for (const p of d)
      if (((m = a.value) == null ? void 0 : m.max) !== void 0 && a.value.max / p.value > 1)
        return p;
    return d[d.length - 1];
  }), u = b(() => {
    var m;
    return ((m = a.value) == null ? void 0 : m.max) !== void 0 ? Math.round(a.value.max / c.value.value) : 0;
  });
  return {
    control: i,
    field: a,
    fieldComponent: s,
    getFieldComponent: r,
    fileSizeMultipliers: d,
    getFileSizeMultiplier: c,
    convertFileSize: u
  };
};
let $v = 0;
const Fv = ["click", "keydown"], Av = {
  icon: String,
  label: [Number, String],
  alert: [Boolean, String],
  alertIcon: String,
  name: {
    type: [Number, String],
    default: () => `t_${$v++}`
  },
  noCaps: Boolean,
  tabindex: [String, Number],
  disable: Boolean,
  contentClass: String,
  ripple: {
    type: [Boolean, Object],
    default: !0
  }
};
function Ov(e, t, l, n) {
  const a = Me(dr, $a);
  if (a === $a)
    return console.error("QTab/QRouteTab component needs to be child of QTabs"), $a;
  const { proxy: i } = Ae(), r = G(null), s = G(null), d = G(null), c = b(() => e.disable === !0 || e.ripple === !1 ? !1 : Object.assign(
    { keyCodes: [13, 32], early: !0 },
    e.ripple === !0 ? {} : e.ripple
  )), u = b(() => a.currentModel.value === e.name), m = b(
    () => "q-tab relative-position self-stretch flex flex-center text-center" + (u.value === !0 ? " q-tab--active" + (a.tabProps.value.activeClass ? " " + a.tabProps.value.activeClass : "") + (a.tabProps.value.activeColor ? ` text-${a.tabProps.value.activeColor}` : "") + (a.tabProps.value.activeBgColor ? ` bg-${a.tabProps.value.activeBgColor}` : "") : " q-tab--inactive") + (e.icon && e.label && a.tabProps.value.inlineLabel === !1 ? " q-tab--full" : "") + (e.noCaps === !0 || a.tabProps.value.noCaps === !0 ? " q-tab--no-caps" : "") + (e.disable === !0 ? " disabled" : " q-focusable q-hoverable cursor-pointer") + (n !== void 0 ? n.linkClass.value : "")
  ), p = b(
    () => "q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable " + (a.tabProps.value.inlineLabel === !0 ? "row no-wrap q-tab__content--inline" : "column") + (e.contentClass !== void 0 ? ` ${e.contentClass}` : "")
  ), f = b(() => e.disable === !0 || a.hasFocus.value === !0 || u.value === !1 && a.hasActiveTab.value === !0 ? -1 : e.tabindex || 0);
  function _(S, h) {
    if (h !== !0 && r.value !== null && r.value.focus(), e.disable === !0) {
      n !== void 0 && n.hasRouterLink.value === !0 && Ze(S);
      return;
    }
    if (n === void 0) {
      a.updateModel({ name: e.name }), l("click", S);
      return;
    }
    if (n.hasRouterLink.value === !0) {
      const C = (T = {}) => {
        let I;
        const E = T.to === void 0 || cl(T.to, e.to) === !0 ? a.avoidRouteWatcher = wn() : null;
        return n.navigateToRouterLink(S, { ...T, returnRouterError: !0 }).catch((A) => {
          I = A;
        }).then((A) => {
          if (E === a.avoidRouteWatcher && (a.avoidRouteWatcher = !1, I === void 0 && (A === void 0 || A.message.startsWith("Avoided redundant navigation") === !0) && a.updateModel({ name: e.name })), T.returnRouterError === !0)
            return I !== void 0 ? Promise.reject(I) : A;
        });
      };
      l("click", S, C), S.defaultPrevented !== !0 && C();
      return;
    }
    l("click", S);
  }
  function v(S) {
    gl(S, [13, 32]) ? _(S, !0) : un(S) !== !0 && S.keyCode >= 35 && S.keyCode <= 40 && S.altKey !== !0 && S.metaKey !== !0 && a.onKbdNavigate(S.keyCode, i.$el) === !0 && Ze(S), l("keydown", S);
  }
  function y() {
    const S = a.tabProps.value.narrowIndicator, h = [], C = V("div", {
      ref: d,
      class: [
        "q-tab__indicator",
        a.tabProps.value.indicatorClass
      ]
    });
    e.icon !== void 0 && h.push(
      V(Qe, {
        class: "q-tab__icon",
        name: e.icon
      })
    ), e.label !== void 0 && h.push(
      V("div", { class: "q-tab__label" }, e.label)
    ), e.alert !== !1 && h.push(
      e.alertIcon !== void 0 ? V(Qe, {
        class: "q-tab__alert-icon",
        color: e.alert !== !0 ? e.alert : void 0,
        name: e.alertIcon
      }) : V("div", {
        class: "q-tab__alert" + (e.alert !== !0 ? ` text-${e.alert}` : "")
      })
    ), S === !0 && h.push(C);
    const T = [
      V("div", { class: "q-focus-helper", tabindex: -1, ref: r }),
      V("div", { class: p.value }, al(t.default, h))
    ];
    return S === !1 && T.push(C), T;
  }
  const M = {
    name: b(() => e.name),
    rootRef: s,
    tabIndicatorRef: d,
    routeData: n
  };
  _t(() => {
    a.unregisterTab(M);
  }), wt(() => {
    a.registerTab(M);
  });
  function w(S, h) {
    const C = {
      ref: s,
      class: m.value,
      tabindex: f.value,
      role: "tab",
      "aria-selected": u.value === !0 ? "true" : "false",
      "aria-disabled": e.disable === !0 ? "true" : void 0,
      onClick: _,
      onKeydown: v,
      ...h
    };
    return Ct(
      V(S, C, y()),
      [[ca, c.value]]
    );
  }
  return { renderTab: w, $tabs: a };
}
const qi = De({
  name: "QTab",
  props: Av,
  emits: Fv,
  setup(e, { slots: t, emit: l }) {
    const { renderTab: n } = Ov(e, t, l);
    return () => n("div");
  }
});
function Bv() {
  const e = G(!xn.value);
  return e.value === !1 && wt(() => {
    e.value = !0;
  }), e;
}
const vu = typeof ResizeObserver < "u", Vi = vu === !0 ? {} : {
  style: "display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;",
  url: "about:blank"
}, Lv = De({
  name: "QResizeObserver",
  props: {
    debounce: {
      type: [String, Number],
      default: 100
    }
  },
  emits: ["resize"],
  setup(e, { emit: t }) {
    let l = null, n, a = { width: -1, height: -1 };
    function i(d) {
      d === !0 || e.debounce === 0 || e.debounce === "0" ? r() : l === null && (l = setTimeout(r, e.debounce));
    }
    function r() {
      if (l !== null && (clearTimeout(l), l = null), n) {
        const { offsetWidth: d, offsetHeight: c } = n;
        (d !== a.width || c !== a.height) && (a = { width: d, height: c }, t("resize", a));
      }
    }
    const { proxy: s } = Ae();
    if (vu === !0) {
      let d;
      const c = (u) => {
        n = s.$el.parentNode, n ? (d = new ResizeObserver(i), d.observe(n), r()) : u !== !0 && lt(() => {
          c(!0);
        });
      };
      return wt(() => {
        c();
      }), _t(() => {
        l !== null && clearTimeout(l), d !== void 0 && (d.disconnect !== void 0 ? d.disconnect() : n && d.unobserve(n));
      }), In;
    } else {
      let u = function() {
        l !== null && (clearTimeout(l), l = null), c !== void 0 && (c.removeEventListener !== void 0 && c.removeEventListener("resize", i, $t.passive), c = void 0);
      }, m = function() {
        u(), n && n.contentDocument && (c = n.contentDocument.defaultView, c.addEventListener("resize", i, $t.passive), r());
      };
      const d = Bv();
      let c;
      return wt(() => {
        lt(() => {
          n = s.$el, n && m();
        });
      }), _t(u), s.trigger = i, () => {
        if (d.value === !0)
          return V("object", {
            style: Vi.style,
            tabindex: -1,
            // fix for Firefox
            type: "text/html",
            data: Vi.url,
            "aria-hidden": "true",
            onLoad: m
          });
      };
    }
  }
});
function Ev(e, t, l) {
  const n = l === !0 ? ["left", "right"] : ["top", "bottom"];
  return `absolute-${t === !0 ? n[0] : n[1]}${e ? ` text-${e}` : ""}`;
}
const Pv = ["left", "center", "right", "justify"], Rv = De({
  name: "QTabs",
  props: {
    modelValue: [Number, String],
    align: {
      type: String,
      default: "center",
      validator: (e) => Pv.includes(e)
    },
    breakpoint: {
      type: [String, Number],
      default: 600
    },
    vertical: Boolean,
    shrink: Boolean,
    stretch: Boolean,
    activeClass: String,
    activeColor: String,
    activeBgColor: String,
    indicatorColor: String,
    leftIcon: String,
    rightIcon: String,
    outsideArrows: Boolean,
    mobileArrows: Boolean,
    switchIndicator: Boolean,
    narrowIndicator: Boolean,
    inlineLabel: Boolean,
    noCaps: Boolean,
    dense: Boolean,
    contentClass: String,
    "onUpdate:modelValue": [Function, Array]
  },
  setup(e, { slots: t, emit: l }) {
    const { proxy: n } = Ae(), { $q: a } = n, { registerTick: i } = Jl(), { registerTick: r } = Jl(), { registerTick: s } = Jl(), { registerTimeout: d, removeTimeout: c } = qn(), { registerTimeout: u, removeTimeout: m } = qn(), p = G(null), f = G(null), _ = G(e.modelValue), v = G(!1), y = G(!0), M = G(!1), w = G(!1), S = [], h = G(0), C = G(!1);
    let T = null, I = null, E;
    const A = b(() => ({
      activeClass: e.activeClass,
      activeColor: e.activeColor,
      activeBgColor: e.activeBgColor,
      indicatorClass: Ev(
        e.indicatorColor,
        e.switchIndicator,
        e.vertical
      ),
      narrowIndicator: e.narrowIndicator,
      inlineLabel: e.inlineLabel,
      noCaps: e.noCaps
    })), O = b(() => {
      const ue = h.value, _e = _.value;
      for (let $e = 0; $e < ue; $e++)
        if (S[$e].name.value === _e)
          return !0;
      return !1;
    }), P = b(() => `q-tabs__content--align-${v.value === !0 ? "left" : w.value === !0 ? "justify" : e.align}`), $ = b(
      () => `q-tabs row no-wrap items-center q-tabs--${v.value === !0 ? "" : "not-"}scrollable q-tabs--${e.vertical === !0 ? "vertical" : "horizontal"} q-tabs__arrows--${e.outsideArrows === !0 ? "outside" : "inside"} q-tabs--mobile-with${e.mobileArrows === !0 ? "" : "out"}-arrows` + (e.dense === !0 ? " q-tabs--dense" : "") + (e.shrink === !0 ? " col-shrink" : "") + (e.stretch === !0 ? " self-stretch" : "")
    ), k = b(
      () => "q-tabs__content scroll--mobile row no-wrap items-center self-stretch hide-scrollbar relative-position " + P.value + (e.contentClass !== void 0 ? ` ${e.contentClass}` : "")
    ), g = b(() => e.vertical === !0 ? { container: "height", content: "offsetHeight", scroll: "scrollHeight" } : { container: "width", content: "offsetWidth", scroll: "scrollWidth" }), x = b(() => e.vertical !== !0 && a.lang.rtl === !0), B = b(() => Tn === !1 && x.value === !0);
    me(x, H), me(() => e.modelValue, (ue) => {
      q({ name: ue, setCurrent: !0, skipEmit: !0 });
    }), me(() => e.outsideArrows, Y);
    function q({ name: ue, setCurrent: _e, skipEmit: $e }) {
      _.value !== ue && ($e !== !0 && e["onUpdate:modelValue"] !== void 0 && l("update:modelValue", ue), (_e === !0 || e["onUpdate:modelValue"] === void 0) && (Q(_.value, ue), _.value = ue));
    }
    function Y() {
      i(() => {
        K({
          width: p.value.offsetWidth,
          height: p.value.offsetHeight
        });
      });
    }
    function K(ue) {
      if (g.value === void 0 || f.value === null)
        return;
      const _e = ue[g.value.container], $e = Math.min(
        f.value[g.value.scroll],
        Array.prototype.reduce.call(
          f.value.children,
          (Je, Re) => Je + (Re[g.value.content] || 0),
          0
        )
      ), tt = _e > 0 && $e > _e;
      v.value = tt, tt === !0 && r(H), w.value = _e < parseInt(e.breakpoint, 10);
    }
    function Q(ue, _e) {
      const $e = ue != null && ue !== "" ? S.find((Je) => Je.name.value === ue) : null, tt = _e != null && _e !== "" ? S.find((Je) => Je.name.value === _e) : null;
      if ($e && tt) {
        const Je = $e.tabIndicatorRef.value, Re = tt.tabIndicatorRef.value;
        T !== null && (clearTimeout(T), T = null), Je.style.transition = "none", Je.style.transform = "none", Re.style.transition = "none", Re.style.transform = "none";
        const Ue = Je.getBoundingClientRect(), bt = Re.getBoundingClientRect();
        Re.style.transform = e.vertical === !0 ? `translate3d(0,${Ue.top - bt.top}px,0) scale3d(1,${bt.height ? Ue.height / bt.height : 1},1)` : `translate3d(${Ue.left - bt.left}px,0,0) scale3d(${bt.width ? Ue.width / bt.width : 1},1,1)`, s(() => {
          T = setTimeout(() => {
            T = null, Re.style.transition = "transform .25s cubic-bezier(.4, 0, .2, 1)", Re.style.transform = "none";
          }, 70);
        });
      }
      tt && v.value === !0 && W(tt.rootRef.value);
    }
    function W(ue) {
      const { left: _e, width: $e, top: tt, height: Je } = f.value.getBoundingClientRect(), Re = ue.getBoundingClientRect();
      let Ue = e.vertical === !0 ? Re.top - tt : Re.left - _e;
      if (Ue < 0) {
        f.value[e.vertical === !0 ? "scrollTop" : "scrollLeft"] += Math.floor(Ue), H();
        return;
      }
      Ue += e.vertical === !0 ? Re.height - Je : Re.width - $e, Ue > 0 && (f.value[e.vertical === !0 ? "scrollTop" : "scrollLeft"] += Math.ceil(Ue), H());
    }
    function H() {
      const ue = f.value;
      if (ue === null)
        return;
      const _e = ue.getBoundingClientRect(), $e = e.vertical === !0 ? ue.scrollTop : Math.abs(ue.scrollLeft);
      x.value === !0 ? (y.value = Math.ceil($e + _e.width) < ue.scrollWidth - 1, M.value = $e > 0) : (y.value = $e > 0, M.value = e.vertical === !0 ? Math.ceil($e + _e.height) < ue.scrollHeight : Math.ceil($e + _e.width) < ue.scrollWidth);
    }
    function R(ue) {
      I !== null && clearInterval(I), I = setInterval(() => {
        j(ue) === !0 && oe();
      }, 5);
    }
    function ie() {
      R(B.value === !0 ? Number.MAX_SAFE_INTEGER : 0);
    }
    function te() {
      R(B.value === !0 ? 0 : Number.MAX_SAFE_INTEGER);
    }
    function oe() {
      I !== null && (clearInterval(I), I = null);
    }
    function fe(ue, _e) {
      const $e = Array.prototype.filter.call(
        f.value.children,
        (bt) => bt === _e || bt.matches && bt.matches(".q-tab.q-focusable") === !0
      ), tt = $e.length;
      if (tt === 0)
        return;
      if (ue === 36)
        return W($e[0]), $e[0].focus(), !0;
      if (ue === 35)
        return W($e[tt - 1]), $e[tt - 1].focus(), !0;
      const Je = ue === (e.vertical === !0 ? 38 : 37), Re = ue === (e.vertical === !0 ? 40 : 39), Ue = Je === !0 ? -1 : Re === !0 ? 1 : void 0;
      if (Ue !== void 0) {
        const bt = x.value === !0 ? -1 : 1, ht = $e.indexOf(_e) + Ue * bt;
        return ht >= 0 && ht < tt && (W($e[ht]), $e[ht].focus({ preventScroll: !0 })), !0;
      }
    }
    const Z = b(() => B.value === !0 ? { get: (ue) => Math.abs(ue.scrollLeft), set: (ue, _e) => {
      ue.scrollLeft = -_e;
    } } : e.vertical === !0 ? { get: (ue) => ue.scrollTop, set: (ue, _e) => {
      ue.scrollTop = _e;
    } } : { get: (ue) => ue.scrollLeft, set: (ue, _e) => {
      ue.scrollLeft = _e;
    } });
    function j(ue) {
      const _e = f.value, { get: $e, set: tt } = Z.value;
      let Je = !1, Re = $e(_e);
      const Ue = ue < Re ? -1 : 1;
      return Re += Ue * 5, Re < 0 ? (Je = !0, Re = 0) : (Ue === -1 && Re <= ue || Ue === 1 && Re >= ue) && (Je = !0, Re = ue), tt(_e, Re), H(), Je;
    }
    function he(ue, _e) {
      for (const $e in ue)
        if (ue[$e] !== _e[$e])
          return !1;
      return !0;
    }
    function we() {
      let ue = null, _e = { matchedLen: 0, queryDiff: 9999, hrefLen: 0 };
      const $e = S.filter((Ue) => Ue.routeData !== void 0 && Ue.routeData.hasRouterLink.value === !0), { hash: tt, query: Je } = n.$route, Re = Object.keys(Je).length;
      for (const Ue of $e) {
        const bt = Ue.routeData.exact.value === !0;
        if (Ue.routeData[bt === !0 ? "linkIsExactActive" : "linkIsActive"].value !== !0)
          continue;
        const { hash: ht, query: ne, matched: de, href: ke } = Ue.routeData.resolvedLink.value, Pe = Object.keys(ne).length;
        if (bt === !0) {
          if (ht !== tt || Pe !== Re || he(Je, ne) === !1)
            continue;
          ue = Ue.name.value;
          break;
        }
        if (ht !== "" && ht !== tt || Pe !== 0 && he(ne, Je) === !1)
          continue;
        const Ye = {
          matchedLen: de.length,
          queryDiff: Re - Pe,
          hrefLen: ke.length - ht.length
        };
        if (Ye.matchedLen > _e.matchedLen) {
          ue = Ue.name.value, _e = Ye;
          continue;
        } else if (Ye.matchedLen !== _e.matchedLen)
          continue;
        if (Ye.queryDiff < _e.queryDiff)
          ue = Ue.name.value, _e = Ye;
        else if (Ye.queryDiff !== _e.queryDiff)
          continue;
        Ye.hrefLen > _e.hrefLen && (ue = Ue.name.value, _e = Ye);
      }
      ue === null && S.some((Ue) => Ue.routeData === void 0 && Ue.name.value === _.value) === !0 || q({ name: ue, setCurrent: !0 });
    }
    function Ie(ue) {
      if (c(), C.value !== !0 && p.value !== null && ue.target && typeof ue.target.closest == "function") {
        const _e = ue.target.closest(".q-tab");
        _e && p.value.contains(_e) === !0 && (C.value = !0, v.value === !0 && W(_e));
      }
    }
    function ot() {
      d(() => {
        C.value = !1;
      }, 30);
    }
    function St() {
      Wt.avoidRouteWatcher === !1 ? u(we) : m();
    }
    function xt() {
      if (E === void 0) {
        const ue = me(() => n.$route.fullPath, St);
        E = () => {
          ue(), E = void 0;
        };
      }
    }
    function qt(ue) {
      S.push(ue), h.value++, Y(), ue.routeData === void 0 || n.$route === void 0 ? u(() => {
        if (v.value === !0) {
          const _e = _.value, $e = _e != null && _e !== "" ? S.find((tt) => tt.name.value === _e) : null;
          $e && W($e.rootRef.value);
        }
      }) : (xt(), ue.routeData.hasRouterLink.value === !0 && St());
    }
    function pt(ue) {
      S.splice(S.indexOf(ue), 1), h.value--, Y(), E !== void 0 && ue.routeData !== void 0 && (S.every((_e) => _e.routeData === void 0) === !0 && E(), St());
    }
    const Wt = {
      currentModel: _,
      tabProps: A,
      hasFocus: C,
      hasActiveTab: O,
      registerTab: qt,
      unregisterTab: pt,
      verifyRouteModel: St,
      updateModel: q,
      onKbdNavigate: fe,
      avoidRouteWatcher: !1
      // false | string (uid)
    };
    Bi(dr, Wt);
    function el() {
      T !== null && clearTimeout(T), oe(), E !== void 0 && E();
    }
    let ft;
    return _t(el), zl(() => {
      ft = E !== void 0, el();
    }), Mn(() => {
      ft === !0 && xt(), Y();
    }), () => V("div", {
      ref: p,
      class: $.value,
      role: "tablist",
      onFocusin: Ie,
      onFocusout: ot
    }, [
      V(Lv, { onResize: K }),
      V("div", {
        ref: f,
        class: k.value,
        onScroll: H
      }, We(t.default)),
      V(Qe, {
        class: "q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon" + (y.value === !0 ? "" : " q-tabs__arrow--faded"),
        name: e.leftIcon || a.iconSet.tabs[e.vertical === !0 ? "up" : "left"],
        onMousedownPassive: ie,
        onTouchstartPassive: ie,
        onMouseupPassive: oe,
        onMouseleavePassive: oe,
        onTouchendPassive: oe
      }),
      V(Qe, {
        class: "q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon" + (M.value === !0 ? "" : " q-tabs__arrow--faded"),
        name: e.rightIcon || a.iconSet.tabs[e.vertical === !0 ? "down" : "right"],
        onMousedownPassive: te,
        onTouchstartPassive: te,
        onMouseupPassive: oe,
        onMouseleavePassive: oe,
        onTouchendPassive: oe
      })
    ]);
  }
});
function zv(e) {
  const t = [0.06, 6, 50];
  return typeof e == "string" && e.length && e.split(":").forEach((l, n) => {
    const a = parseFloat(l);
    a && (t[n] = a);
  }), t;
}
const Uv = aa(
  {
    name: "touch-swipe",
    beforeMount(e, { value: t, arg: l, modifiers: n }) {
      if (n.mouse !== !0 && mt.has.touch !== !0)
        return;
      const a = n.mouseCapture === !0 ? "Capture" : "", i = {
        handler: t,
        sensitivity: zv(l),
        direction: ta(n),
        noop: In,
        mouseStart(r) {
          la(r, i) && Yi(r) && (Jt(i, "temp", [
            [document, "mousemove", "move", `notPassive${a}`],
            [document, "mouseup", "end", "notPassiveCapture"]
          ]), i.start(r, !0));
        },
        touchStart(r) {
          if (la(r, i)) {
            const s = r.target;
            Jt(i, "temp", [
              [s, "touchmove", "move", "notPassiveCapture"],
              [s, "touchcancel", "end", "notPassiveCapture"],
              [s, "touchend", "end", "notPassiveCapture"]
            ]), i.start(r);
          }
        },
        start(r, s) {
          mt.is.firefox === !0 && Gl(e, !0);
          const d = Cl(r);
          i.event = {
            x: d.left,
            y: d.top,
            time: Date.now(),
            mouse: s === !0,
            dir: !1
          };
        },
        move(r) {
          if (i.event === void 0)
            return;
          if (i.event.dir !== !1) {
            Ze(r);
            return;
          }
          const s = Date.now() - i.event.time;
          if (s === 0)
            return;
          const d = Cl(r), c = d.left - i.event.x, u = Math.abs(c), m = d.top - i.event.y, p = Math.abs(m);
          if (i.event.mouse !== !0) {
            if (u < i.sensitivity[1] && p < i.sensitivity[1]) {
              i.end(r);
              return;
            }
          } else if (window.getSelection().toString() !== "") {
            i.end(r);
            return;
          } else if (u < i.sensitivity[2] && p < i.sensitivity[2])
            return;
          const f = u / s, _ = p / s;
          i.direction.vertical === !0 && u < p && u < 100 && _ > i.sensitivity[0] && (i.event.dir = m < 0 ? "up" : "down"), i.direction.horizontal === !0 && u > p && p < 100 && f > i.sensitivity[0] && (i.event.dir = c < 0 ? "left" : "right"), i.direction.up === !0 && u < p && m < 0 && u < 100 && _ > i.sensitivity[0] && (i.event.dir = "up"), i.direction.down === !0 && u < p && m > 0 && u < 100 && _ > i.sensitivity[0] && (i.event.dir = "down"), i.direction.left === !0 && u > p && c < 0 && p < 100 && f > i.sensitivity[0] && (i.event.dir = "left"), i.direction.right === !0 && u > p && c > 0 && p < 100 && f > i.sensitivity[0] && (i.event.dir = "right"), i.event.dir !== !1 ? (Ze(r), i.event.mouse === !0 && (document.body.classList.add("no-pointer-events--children"), document.body.classList.add("non-selectable"), kn(), i.styleCleanup = (v) => {
            i.styleCleanup = void 0, document.body.classList.remove("non-selectable");
            const y = () => {
              document.body.classList.remove("no-pointer-events--children");
            };
            v === !0 ? setTimeout(y, 50) : y();
          }), i.handler({
            evt: r,
            touch: i.event.mouse !== !0,
            mouse: i.event.mouse,
            direction: i.event.dir,
            duration: s,
            distance: {
              x: u,
              y: p
            }
          })) : i.end(r);
        },
        end(r) {
          i.event !== void 0 && (fl(i, "temp"), mt.is.firefox === !0 && Gl(e, !1), i.styleCleanup !== void 0 && i.styleCleanup(!0), r !== void 0 && i.event.dir !== !1 && Ze(r), i.event = void 0);
        }
      };
      if (e.__qtouchswipe = i, n.mouse === !0) {
        const r = n.mouseCapture === !0 || n.mousecapture === !0 ? "Capture" : "";
        Jt(i, "main", [
          [e, "mousedown", "mouseStart", `passive${r}`]
        ]);
      }
      mt.has.touch === !0 && Jt(i, "main", [
        [e, "touchstart", "touchStart", `passive${n.capture === !0 ? "Capture" : ""}`],
        [e, "touchmove", "noop", "notPassiveCapture"]
        // cannot be passive (ex: iOS scroll)
      ]);
    },
    updated(e, t) {
      const l = e.__qtouchswipe;
      l !== void 0 && (t.oldValue !== t.value && (typeof t.value != "function" && l.end(), l.handler = t.value), l.direction = ta(t.modifiers));
    },
    beforeUnmount(e) {
      const t = e.__qtouchswipe;
      t !== void 0 && (fl(t, "main"), fl(t, "temp"), mt.is.firefox === !0 && Gl(e, !1), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchswipe);
    }
  }
), Hv = {
  name: { required: !0 },
  disable: Boolean
}, Ti = {
  setup(e, { slots: t }) {
    return () => V("div", {
      class: "q-panel scroll",
      role: "tabpanel"
    }, We(t.default));
  }
}, Yv = {
  modelValue: {
    required: !0
  },
  animated: Boolean,
  infinite: Boolean,
  swipeable: Boolean,
  vertical: Boolean,
  transitionPrev: String,
  transitionNext: String,
  transitionDuration: {
    type: [String, Number],
    default: 300
  },
  keepAlive: Boolean,
  keepAliveInclude: [String, Array, RegExp],
  keepAliveExclude: [String, Array, RegExp],
  keepAliveMax: Number
}, jv = ["update:modelValue", "beforeTransition", "transition"];
function Nv() {
  const { props: e, emit: t, proxy: l } = Ae(), { getCacheWithFn: n } = Kr();
  let a, i;
  const r = G(null), s = G(null);
  function d(k) {
    const g = e.vertical === !0 ? "up" : "left";
    I((l.$q.lang.rtl === !0 ? -1 : 1) * (k.direction === g ? 1 : -1));
  }
  const c = b(() => [[
    Uv,
    d,
    void 0,
    {
      horizontal: e.vertical !== !0,
      vertical: e.vertical,
      mouse: !0
    }
  ]]), u = b(
    () => e.transitionPrev || `slide-${e.vertical === !0 ? "down" : "right"}`
  ), m = b(
    () => e.transitionNext || `slide-${e.vertical === !0 ? "up" : "left"}`
  ), p = b(
    () => `--q-transition-duration: ${e.transitionDuration}ms`
  ), f = b(() => typeof e.modelValue == "string" || typeof e.modelValue == "number" ? e.modelValue : String(e.modelValue)), _ = b(() => ({
    include: e.keepAliveInclude,
    exclude: e.keepAliveExclude,
    max: e.keepAliveMax
  })), v = b(
    () => e.keepAliveInclude !== void 0 || e.keepAliveExclude !== void 0
  );
  me(() => e.modelValue, (k, g) => {
    const x = S(k) === !0 ? h(k) : -1;
    i !== !0 && T(
      x === -1 ? 0 : x < h(g) ? -1 : 1
    ), r.value !== x && (r.value = x, t("beforeTransition", k, g), lt(() => {
      t("transition", k, g);
    }));
  });
  function y() {
    I(1);
  }
  function M() {
    I(-1);
  }
  function w(k) {
    t("update:modelValue", k);
  }
  function S(k) {
    return k != null && k !== "";
  }
  function h(k) {
    return a.findIndex((g) => g.props.name === k && g.props.disable !== "" && g.props.disable !== !0);
  }
  function C() {
    return a.filter((k) => k.props.disable !== "" && k.props.disable !== !0);
  }
  function T(k) {
    const g = k !== 0 && e.animated === !0 && r.value !== -1 ? "q-transition--" + (k === -1 ? u.value : m.value) : null;
    s.value !== g && (s.value = g);
  }
  function I(k, g = r.value) {
    let x = g + k;
    for (; x > -1 && x < a.length; ) {
      const B = a[x];
      if (B !== void 0 && B.props.disable !== "" && B.props.disable !== !0) {
        T(k), i = !0, t("update:modelValue", B.props.name), setTimeout(() => {
          i = !1;
        });
        return;
      }
      x += k;
    }
    e.infinite === !0 && a.length !== 0 && g !== -1 && g !== a.length && I(k, k === -1 ? a.length : -1);
  }
  function E() {
    const k = h(e.modelValue);
    return r.value !== k && (r.value = k), !0;
  }
  function A() {
    const k = S(e.modelValue) === !0 && E() && a[r.value];
    return e.keepAlive === !0 ? [
      V(wu, _.value, [
        V(
          v.value === !0 ? n(f.value, () => ({ ...Ti, name: f.value })) : Ti,
          { key: f.value, style: p.value },
          () => k
        )
      ])
    ] : [
      V("div", {
        class: "q-panel scroll",
        style: p.value,
        key: f.value,
        role: "tabpanel"
      }, [k])
    ];
  }
  function O() {
    if (a.length !== 0)
      return e.animated === !0 ? [V(Qt, { name: s.value }, A)] : A();
  }
  function P(k) {
    return a = $u(
      We(k.default, [])
    ).filter(
      (g) => g.props !== null && g.props.slot === void 0 && S(g.props.name) === !0
    ), a.length;
  }
  function $() {
    return a;
  }
  return Object.assign(l, {
    next: y,
    previous: M,
    goTo: w
  }), {
    panelIndex: r,
    panelDirectives: c,
    updatePanelsList: P,
    updatePanelIndex: E,
    getPanelContent: O,
    getEnabledPanels: C,
    getPanels: $,
    isValidPanelName: S,
    keepAliveProps: _,
    needsUniqueKeepAliveWrapper: v,
    goToPanelByOffset: I,
    goToPanel: w,
    nextPanel: y,
    previousPanel: M
  };
}
const Mi = De({
  name: "QTabPanel",
  props: Hv,
  setup(e, { slots: t }) {
    return () => V("div", { class: "q-tab-panel", role: "tabpanel" }, We(t.default));
  }
}), Wv = De({
  name: "QTabPanels",
  props: {
    ...Yv,
    ...Tt
  },
  emits: jv,
  setup(e, { slots: t }) {
    const l = Ae(), n = Mt(e, l.proxy.$q), { updatePanelsList: a, getPanelContent: i, panelDirectives: r } = Nv(), s = b(
      () => "q-tab-panels q-panel-parent" + (n.value === !0 ? " q-tab-panels--dark q-dark" : "")
    );
    return () => (a(t), Ei(
      "div",
      { class: s.value },
      i(),
      "pan",
      e.swipeable,
      () => r.value
    ));
  }
}), mu = De({
  name: "QForm",
  props: {
    autofocus: Boolean,
    noErrorFocus: Boolean,
    noResetFocus: Boolean,
    greedy: Boolean,
    onSubmit: Function
  },
  emits: ["reset", "validationSuccess", "validationError"],
  setup(e, { slots: t, emit: l }) {
    const n = Ae(), a = G(null);
    let i = 0;
    const r = [];
    function s(f) {
      const _ = typeof f == "boolean" ? f : e.noErrorFocus !== !0, v = ++i, y = (S, h) => {
        l("validation" + (S === !0 ? "Success" : "Error"), h);
      }, M = (S) => {
        const h = S.validate();
        return typeof h.then == "function" ? h.then(
          (C) => ({ valid: C, comp: S }),
          (C) => ({ valid: !1, comp: S, err: C })
        ) : Promise.resolve({ valid: h, comp: S });
      };
      return (e.greedy === !0 ? Promise.all(r.map(M)).then((S) => S.filter((h) => h.valid !== !0)) : r.reduce(
        (S, h) => S.then(() => M(h).then((C) => {
          if (C.valid === !1)
            return Promise.reject(C);
        })),
        Promise.resolve()
      ).catch((S) => [S])).then((S) => {
        if (S === void 0 || S.length === 0)
          return v === i && y(!0), !0;
        if (v === i) {
          const { comp: h, err: C } = S[0];
          if (C !== void 0 && console.error(C), y(!1, h), _ === !0) {
            const T = S.find(({ comp: I }) => typeof I.focus == "function" && oa(I.$) === !1);
            T !== void 0 && T.comp.focus();
          }
        }
        return !1;
      });
    }
    function d() {
      i++, r.forEach((f) => {
        typeof f.resetValidation == "function" && f.resetValidation();
      });
    }
    function c(f) {
      f !== void 0 && Ze(f);
      const _ = i + 1;
      s().then((v) => {
        _ === i && v === !0 && (e.onSubmit !== void 0 ? l("submit", f) : f !== void 0 && f.target !== void 0 && typeof f.target.submit == "function" && f.target.submit());
      });
    }
    function u(f) {
      f !== void 0 && Ze(f), l("reset"), lt(() => {
        d(), e.autofocus === !0 && e.noResetFocus !== !0 && m();
      });
    }
    function m() {
      dn(() => {
        if (a.value === null)
          return;
        const f = a.value.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || a.value.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || a.value.querySelector("[autofocus], [data-autofocus]") || Array.prototype.find.call(a.value.querySelectorAll("[tabindex]"), (_) => _.tabIndex > -1);
        f != null && f.focus({ preventScroll: !0 });
      });
    }
    Bi(sr, {
      bindComponent(f) {
        r.push(f);
      },
      unbindComponent(f) {
        const _ = r.indexOf(f);
        _ > -1 && r.splice(_, 1);
      }
    });
    let p = !1;
    return zl(() => {
      p = !0;
    }), Mn(() => {
      p === !0 && e.autofocus === !0 && m();
    }), wt(() => {
      e.autofocus === !0 && m();
    }), Object.assign(n.proxy, {
      validate: s,
      resetValidation: d,
      submit: c,
      reset: u,
      focus: m,
      getValidationComponents: () => r
    }), () => V("form", {
      class: "q-form",
      ref: a,
      onSubmit: c,
      onReset: u
    }, We(t.default));
  }
}), Qv = /* @__PURE__ */ Ce({
  __name: "I18nSettings",
  setup(e) {
    const t = Me("_uct"), l = [
      {
        name: "locale",
        label: t("builder.tabs.internationalization.dataTable.headers.locale"),
        field: "locale",
        align: "center",
        sortable: !0
      },
      {
        name: "rtl",
        label: t("builder.tabs.internationalization.dataTable.headers.rtl"),
        field: "rtl",
        align: "center",
        sortable: !1
      },
      {
        name: "delete",
        label: t("builder.tabs.internationalization.dataTable.headers.delete"),
        field: "delete",
        align: "center",
        sortable: !1
      }
    ], n = st(), a = G(""), i = G(!1), r = async () => {
      await n.deleteLocale(a.value), i.value = !1, a.value = "";
    }, s = G(""), d = G(!1), c = G(!1), u = () => {
      n.addLocale(s.value, d.value), s.value = "", d.value = !1, c.value = !1;
    };
    return (m, p) => (z(), re(Ve, null, [
      D(ul, {
        modelValue: c.value,
        "onUpdate:modelValue": p[2] || (p[2] = (f) => c.value = f),
        "confirm-text": o(t)("builder.tabs.internationalization.buttonAdd"),
        title: o(t)("builder.tabs.internationalization.title"),
        "min-width": "500px",
        onCancel: p[3] || (p[3] = (f) => c.value = !1),
        onValid: u
      }, {
        default: L(() => [
          D(mu, {
            onSubmit: nl(u, ["prevent"])
          }, {
            default: L(() => [
              D(Ne, {
                modelValue: s.value,
                "onUpdate:modelValue": p[0] || (p[0] = (f) => s.value = f),
                label: o(t)("builder.tabs.internationalization.localeName"),
                autofocus: "",
                hint: "Ex: en"
              }, null, 8, ["modelValue", "label"]),
              D(Bt, {
                modelValue: d.value,
                "onUpdate:modelValue": p[1] || (p[1] = (f) => d.value = f)
              }, {
                default: L(() => [
                  ve(" RTL "),
                  D(Qe, { name: "mdi-help-circle-outline" }, {
                    default: L(() => [
                      D(nt, null, {
                        default: L(() => [
                          ve(J(o(t)("builder.tabs.internationalization.rtlHelp")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _: 1
      }, 8, ["modelValue", "confirm-text", "title"]),
      D(ul, {
        modelValue: i.value,
        "onUpdate:modelValue": p[4] || (p[4] = (f) => i.value = f),
        "confirm-text": o(t)("core.buttons.delete"),
        title: o(t)(""),
        onValid: r
      }, {
        default: L(() => [
          ve(J(o(t)("builder.tabs.internationalization.removeMessage")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "confirm-text", "title"]),
      ee("section", null, [
        D(an, {
          columns: l,
          "no-data-label": o(t)("builder.tabs.internationalization.dataTable.noTextMessage"),
          rows: o(n).locales
        }, {
          top: L(() => [
            D(Rt, {
              label: o(t)("builder.tabs.internationalization.dataTable.headers.fallback"),
              "model-value": o(n).messages.defaultLocale,
              options: o(n).listOfLocales,
              "onUpdate:modelValue": p[5] || (p[5] = (f) => o(n).messages.defaultLocale = f)
            }, null, 8, ["label", "model-value", "options"]),
            D(se, {
              label: o(t)("builder.tabs.internationalization.title"),
              color: "primary",
              onClick: p[6] || (p[6] = (f) => c.value = !0)
            }, null, 8, ["label"])
          ]),
          "body-cell-rtl": L((f) => [
            D(kt, {
              key: "rtl",
              props: f
            }, {
              default: L(() => [
                D(Bt, {
                  "model-value": f.row.rtl,
                  "onUpdate:modelValue": (_) => o(n).updateRltStatusOfLocale(_, f.row.locale)
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          "body-cell-delete": L((f) => [
            D(kt, {
              key: "delete",
              props: f
            }, {
              default: L(() => [
                ee("div", null, [
                  D(se, {
                    disable: f.row.locale === o(n).messages.defaultLocale,
                    color: "primary",
                    flat: "",
                    icon: "mdi-trash-can",
                    onClick: (_) => {
                      i.value = !0, a.value = f.row.locale;
                    }
                  }, null, 8, ["disable", "onClick"]),
                  f.row.locale === o(n).messages.defaultLocale ? (z(), ae(nt, { key: 0 }, {
                    default: L(() => [
                      ve(J(o(t)("builder.tabs.internationalization.removeDisabled")), 1)
                    ]),
                    _: 1
                  })) : ce("", !0)
                ])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["no-data-label", "rows"])
      ])
    ], 64));
  }
});
const Kv = /* @__PURE__ */ Oe(Qv, [["__scopeId", "data-v-2a44dca9"]]), Gv = /* @__PURE__ */ Ce({
  __name: "SettingsDialog",
  props: {
    display: { type: Boolean }
  },
  emits: ["update:display"],
  setup(e, { emit: t }) {
    const l = Me("_uct"), {
      control: n,
      field: a,
      isItem: i,
      tabLabel: r,
      tabSelected: s,
      tabSelectedName: d,
      tabs: c
    } = Ke(l), u = Ee(), m = Lt();
    return (p, f) => (z(), ae($n, {
      class: Ft({ minimized: !o(m).settingsDialogMaximized }),
      maximized: o(m).settingsDialogMaximized,
      "model-value": p.display,
      persistent: "",
      "transition-hide": "slide-down",
      "transition-show": "slide-up",
      onKeydown: f[5] || (f[5] = dl((_) => t("update:display", !1), ["esc"]))
    }, {
      default: L(() => [
        D(fn, {
          class: "usf_dialog_card",
          flat: ""
        }, {
          default: L(() => [
            D(fa, null, {
              default: L(() => [
                Sn(p.$slots, "title", {}, () => {
                  var _, v, y, M, w, S;
                  return [
                    D(Qe, {
                      name: (_ = o(n)) == null ? void 0 : _.icon
                    }, null, 8, ["name"]),
                    o(i) ? (z(), re(Ve, { key: 0 }, [
                      ve(J(o(u).getFieldDescription(
                        ((v = o(a)) == null ? void 0 : v.id) ?? "",
                        ((y = o(n)) == null ? void 0 : y.usfType) === "custom" ? ((M = o(n)) == null ? void 0 : M.name) ?? "" : (w = o(n)) != null && w.localeName ? o(l)(`builder.controls.fields.${(S = o(n)) == null ? void 0 : S.localeName}`) : ""
                      )), 1)
                    ], 64)) : (z(), re(Ve, { key: 1 }, [
                      ve(J(o(l)("builder.settings.form")), 1)
                    ], 64))
                  ];
                }, !0),
                D(va),
                D(se, {
                  dense: "",
                  flat: "",
                  icon: "mdi-close",
                  onClick: f[0] || (f[0] = (_) => t("update:display", !1))
                })
              ]),
              _: 3
            }),
            D(cn, null, {
              default: L(() => [
                Sn(p.$slots, "tab-panel", {}, () => [
                  D(Rv, {
                    modelValue: o(d),
                    "onUpdate:modelValue": f[1] || (f[1] = (_) => Gt(d) ? d.value = _ : null),
                    align: "justify",
                    dense: ""
                  }, {
                    default: L(() => [
                      o(i) ? (z(!0), re(Ve, { key: 0 }, dt(o(c), (_) => (z(), ae(qi, {
                        key: _.name,
                        label: o(r)(_.name),
                        name: _.name
                      }, null, 8, ["label", "name"]))), 128)) : (z(), ae(qi, {
                        key: 1,
                        label: o(l)("builder.tabs.names.internationalization"),
                        name: "Internationalization"
                      }, null, 8, ["label"]))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  D(Wv, {
                    modelValue: o(d),
                    "onUpdate:modelValue": f[3] || (f[3] = (_) => Gt(d) ? d.value = _ : null),
                    animated: ""
                  }, {
                    default: L(() => {
                      var _;
                      return [
                        o(i) ? (z(!0), re(Ve, { key: 0 }, dt(((_ = o(n)) == null ? void 0 : _.settingsModalTabs) ?? [], (v) => (z(), ae(Mi, {
                          key: v.name,
                          name: v.name
                        }, {
                          default: L(() => [
                            (z(), ae(eo(o(s)(v.component)), {
                              onCloseDialog: f[2] || (f[2] = (y) => t("update:display", !1))
                            }, null, 32))
                          ]),
                          _: 2
                        }, 1032, ["name"]))), 128)) : (z(), ae(Mi, {
                          key: 1,
                          name: "Internationalization"
                        }, {
                          default: L(() => [
                            D(Kv)
                          ]),
                          _: 1
                        }))
                      ];
                    }),
                    _: 1
                  }, 8, ["modelValue"])
                ], !0)
              ]),
              _: 3
            }),
            D(mo, { align: "right" }, {
              default: L(() => [
                D(se, {
                  label: o(l)("builder.tabs.actions.close"),
                  color: "primary",
                  onClick: f[4] || (f[4] = (_) => t("update:display", !1))
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["class", "maximized", "model-value"]));
  }
});
const xo = /* @__PURE__ */ Oe(Gv, [["__scopeId", "data-v-243aa732"]]), Zv = (e) => (Ai("data-v-7c25d461"), e = e(), Oi(), e), Xv = ["innerHTML"], Jv = { class: "descriptionContainer" }, em = {
  key: 1,
  class: "controlName"
}, tm = {
  key: 2,
  class: "controlName"
}, lm = {
  key: 3,
  class: "fieldName"
}, nm = /* @__PURE__ */ Zv(() => /* @__PURE__ */ ee("span", null, "- ", -1)), am = { class: "actionsContainer" }, om = /* @__PURE__ */ Ce({
  __name: "GenericItem",
  props: {
    index: {},
    parentId: { default: "root" }
  },
  setup(e) {
    const t = e, l = Me("_uct"), { index: n, parentId: a } = ct(t), i = Lt(), r = Ee(), s = b(() => {
      var C;
      return (a == null ? void 0 : a.value) !== "root" ? ((C = r.fields[a == null ? void 0 : a.value].fields) == null ? void 0 : C[n.value]) || "" : r.root[n.value];
    }), { control: d, field: c } = wo(s), { closeDialog: u, openDialog: m, settingsDialogDisplayed: p } = Ke(), f = G(!1), _ = G(!1), v = b(() => {
      var C;
      return !!((C = c.value) != null && C.name);
    }), y = G(!1);
    wt(() => {
      window.addEventListener("keydown", ({ altKey: C, key: T }) => {
        C && (T === "+" && (y.value = !1), (T === "-" || T === "-") && (y.value = !0));
      });
    });
    const M = G(!1), w = () => {
      r.fieldDependencies[s.value] ? M.value = !0 : f.value = !0;
    }, S = () => {
      var T;
      if (!r.fieldDependencies[s.value])
        return "";
      let C = "";
      for (const I in r.fieldDependencies[s.value])
        if (r.fieldDependencies[s.value][I])
          for (const E of r.fieldDependencies[s.value][I])
            C += "<li>", C += l("builder.delete.noDelete.dependency.start"), C += `« ${((T = r.fields[I]) == null ? void 0 : T.name) ?? I ?? ""} »`, C += l("builder.delete.noDelete.dependency.middle"), C += l(`builder.delete.noDelete.dependency.${E}`), C += "</li>";
      return C;
    }, h = b(() => {
      var C;
      return !!["UsfRow", "UsfAccordion"].includes(((C = c.value) == null ? void 0 : C.component) ?? "");
    });
    return (C, T) => (z(), ae(fn, {
      class: Ft({ collapse: y.value })
    }, {
      default: L(() => {
        var I;
        return [
          D(ul, {
            modelValue: M.value,
            "onUpdate:modelValue": T[0] || (T[0] = (E) => M.value = E),
            title: o(l)("builder.delete.noDelete.title"),
            "confirm-button-hidden": "",
            onCancel: T[1] || (T[1] = (E) => M.value = !1)
          }, {
            default: L(() => [
              ve(J(o(l)("builder.delete.noDelete.text")) + " : ", 1),
              ee("ul", {
                innerHTML: S()
              }, null, 8, Xv)
            ]),
            _: 1
          }, 8, ["modelValue", "title"]),
          D(ul, {
            modelValue: f.value,
            "onUpdate:modelValue": T[2] || (T[2] = (E) => f.value = E),
            "cancel-text": o(l)("core.buttons.cancel"),
            "confirm-text": o(l)("core.buttons.valid"),
            title: o(l)("builder.delete.dialog.title"),
            onCancel: T[3] || (T[3] = (E) => f.value = !1),
            onValid: T[4] || (T[4] = (E) => {
              o(r).removeField(s.value, o(a), o(n)), f.value = !1;
            })
          }, {
            default: L(() => [
              ve(J(o(l)("builder.delete.dialog.text")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "cancel-text", "confirm-text", "title"]),
          D(ul, {
            modelValue: _.value,
            "onUpdate:modelValue": T[5] || (T[5] = (E) => _.value = E),
            "confirm-text": o(l)("builder.duplicate.dialog.buttons.duplicate"),
            title: o(l)("builder.duplicate.dialog.title"),
            onCancel: T[6] || (T[6] = (E) => _.value = !1),
            onValid: T[7] || (T[7] = (E) => {
              o(r).duplicateField(s.value, o(n)), _.value = !1;
            })
          }, {
            default: L(() => [
              D(Vl, { class: "bg-info" }, {
                avatar: L(() => [
                  D(Qe, { name: "mdi-alert-circle-outline" })
                ]),
                default: L(() => [
                  ve(J(o(l)("builder.duplicate.dialog.information")) + " ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "confirm-text", "title"]),
          D(xo, {
            display: o(p),
            "onUpdate:display": T[8] || (T[8] = (E) => o(u)(E))
          }, null, 8, ["display"]),
          D(fa, {
            class: Ft([`group-${(I = o(d)) == null ? void 0 : I.usfType}`])
          }, {
            default: L(() => {
              var E, A, O, P, $, k, g, x, B;
              return [
                ee("div", Jv, [
                  (E = o(c)) != null && E.protected ? (z(), ae(Qe, {
                    key: 0,
                    name: "mdi-lock"
                  })) : ce("", !0),
                  D(Qe, {
                    name: (A = o(d)) == null ? void 0 : A.icon
                  }, null, 8, ["name"]),
                  ((O = o(d)) == null ? void 0 : O.usfType) === "custom" ? (z(), re("span", em, J(((P = o(d)) == null ? void 0 : P.name) ?? "") + " - " + J(($ = o(c)) == null ? void 0 : $.id), 1)) : (z(), re("span", tm, J(o(l)(`builder.controls.fields.${(k = o(d)) == null ? void 0 : k.localeName}`)) + " - " + J((g = o(c)) == null ? void 0 : g.id), 1)),
                  v.value ? (z(), re("span", lm, [
                    nm,
                    ve(J((x = o(c)) == null ? void 0 : x.name), 1)
                  ])) : ce("", !0)
                ]),
                ee("div", am, [
                  D(se, {
                    icon: `mdi-${y.value ? "unfold-more-horizontal" : "unfold-less-horizontal"}`,
                    dense: "",
                    flat: "",
                    onClick: T[9] || (T[9] = (q) => y.value = !y.value)
                  }, {
                    default: L(() => [
                      D(nt, null, {
                        default: L(() => [
                          ve(J(o(l)(`builder.actionButtons.${y.value ? "expand" : "collapse"}`)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  !((B = o(c)) != null && B.protected) || o(i).isAdmin ? (z(), re(Ve, { key: 0 }, [
                    ee("div", null, [
                      D(se, {
                        disable: h.value,
                        dense: "",
                        flat: "",
                        icon: "mdi-content-duplicate",
                        onClick: T[10] || (T[10] = (q) => {
                          _.value = !0;
                        })
                      }, {
                        default: L(() => [
                          h.value ? ce("", !0) : (z(), ae(nt, { key: 0 }, {
                            default: L(() => [
                              ve(J(o(l)("builder.actionButtons.duplicate")), 1)
                            ]),
                            _: 1
                          }))
                        ]),
                        _: 1
                      }, 8, ["disable"]),
                      h.value ? (z(), ae(nt, { key: 0 }, {
                        default: L(() => [
                          ve(J(o(l)("builder.actionButtons.duplicateDisabled")), 1)
                        ]),
                        _: 1
                      })) : ce("", !0)
                    ]),
                    D(se, {
                      dense: "",
                      flat: "",
                      icon: "mdi-cog",
                      onClick: T[11] || (T[11] = nl((q) => o(m)(s.value), ["stop"]))
                    }, {
                      default: L(() => [
                        D(nt, null, {
                          default: L(() => [
                            ve(J(o(l)("builder.actionButtons.settings")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    D(se, {
                      dense: "",
                      flat: "",
                      icon: "mdi-trash-can",
                      onClick: w
                    }, {
                      default: L(() => [
                        D(nt, null, {
                          default: L(() => [
                            ve(J(o(l)("builder.actionButtons.delete")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64)) : ce("", !0)
                ])
              ];
            }),
            _: 1
          }, 8, ["class"]),
          D(cn, null, {
            default: L(() => [
              o(c) ? (z(), ae(Vn, {
                key: 0,
                "editor-mode": !0,
                field: o(c)
              }, null, 8, ["field"])) : (z(), ae(qs, {
                key: 1,
                type: "QInput"
              }))
            ]),
            _: 1
          })
        ];
      }),
      _: 1
    }, 8, ["class"]));
  }
});
const ko = /* @__PURE__ */ Oe(om, [["__scopeId", "data-v-7c25d461"]]), im = { id: "builderButtons" }, rm = /* @__PURE__ */ Ce({
  __name: "BuilderButtons",
  emits: ["preview", "save"],
  setup(e, { emit: t }) {
    const l = Me("_uct"), n = Ee(), a = Lt(), i = st(), r = (u) => {
      if (n.hasFields) {
        const m = {
          fields: n.root.map((p) => n.denormalizeField(p)),
          messages: i.messages
        };
        t(u === "preview" ? "preview" : "save", m);
      }
    }, { closeDialog: s, openDialog: d, settingsDialogDisplayed: c } = Ke();
    return (u, m) => (z(), re("div", im, [
      D(xo, {
        display: o(c),
        "onUpdate:display": m[0] || (m[0] = (p) => o(s)(p))
      }, null, 8, ["display"]),
      ee("div", null, [
        o(a).hasPreviewButton ? (z(), ae(se, {
          key: 0,
          disable: !o(n).hasFields,
          label: o(l)("builder.actionButtons.preview"),
          class: "full-width",
          color: "primary",
          dense: "",
          "icon-right": "mdi-tooltip-image",
          outline: "",
          onClick: m[1] || (m[1] = (p) => r("preview"))
        }, {
          default: L(() => [
            o(a).previewIsSave && o(n).hasFields ? (z(), ae(nt, { key: 0 }, {
              default: L(() => [
                ve(J(o(l)("builder.actionButtons.previewInfo")), 1)
              ]),
              _: 1
            })) : ce("", !0)
          ]),
          _: 1
        }, 8, ["disable", "label"])) : ce("", !0),
        o(n).hasFields ? ce("", !0) : (z(), ae(nt, { key: 1 }, {
          default: L(() => [
            ve(J(o(l)("builder.actionButtons.previewDisabled")), 1)
          ]),
          _: 1
        }))
      ]),
      D(se, {
        label: o(l)("builder.actionButtons.i18n"),
        class: "full-width",
        color: "primary",
        dense: "",
        "icon-right": "mdi-translate",
        outline: "",
        onClick: m[2] || (m[2] = nl((p) => o(d)(), ["stop"]))
      }, null, 8, ["label"]),
      Sn(u.$slots, "default", {}, void 0, !0),
      ee("div", null, [
        D(se, {
          disabled: !o(n).hasFields,
          label: o(l)("builder.actionButtons.save"),
          class: "full-width",
          color: "primary",
          dense: "",
          "icon-right": "mdi-cloud-upload",
          onClick: m[3] || (m[3] = (p) => r("save"))
        }, null, 8, ["disabled", "label"]),
        o(n).hasFields ? ce("", !0) : (z(), ae(nt, { key: 0 }, {
          default: L(() => [
            ve(J(o(l)("builder.actionButtons.saveDisabled")), 1)
          ]),
          _: 1
        }))
      ])
    ]));
  }
});
const um = /* @__PURE__ */ Oe(rm, [["__scopeId", "data-v-a23ddbb1"]]), sm = { id: "usf_builder" }, dm = { id: "actionsContainer" }, cm = /* @__PURE__ */ Ce({
  __name: "BuilderContainer",
  props: {
    customComponents: { default: () => {
    } },
    customControls: { default: () => ({}) },
    customSettingsTabs: { default: () => {
    } },
    fields: {},
    hasPreviewButton: { type: Boolean, default: !1 },
    iconLibraryList: { default: () => [] },
    iconName: {},
    isAdmin: { type: Boolean, default: !1 },
    messages: {},
    optionValueIsId: { type: Boolean, default: !1 },
    previewIsSave: { type: Boolean, default: !1 },
    settingsDialogMaximized: { type: Boolean, default: !1 },
    templates: {}
  },
  emits: ["preview", "save"],
  setup(e, { emit: t }) {
    const l = e, {
      customComponents: n,
      customControls: a,
      customSettingsTabs: i,
      fields: r,
      messages: s,
      hasPreviewButton: d,
      previewIsSave: c
    } = ct(l), u = Me("_uct"), m = Me("defaultLocale"), p = (T) => {
      T.ctrlKey && T.key === "s" && (T.preventDefault(), t(
        "save",
        {
          fields: v.root.map((I) => v.denormalizeField(I)),
          messages: _.messages
        }
      ));
    }, f = Lt(), _ = st(), v = Ee(), y = sn(), { componentsCustom: M, settingsTabs: w } = ga(), S = G([]), h = () => {
      S.value = [...v.root];
    };
    wt(() => {
      window.addEventListener("keydown", p), v.$reset(), v.normalizeRootFields(r.value), h(), f.isAdmin = l.isAdmin || !1, f.templates = { ...l.templates }, f.hasPreviewButton = d.value, f.previewIsSave = c.value, f.iconLibraryList = l.iconLibraryList, f.iconNameFn = l.iconName ?? null, f.settingsDialogMaximized = l.settingsDialogMaximized, f.optionValueIsId = l.optionValueIsId, _.initMessages(s.value, m), Object.keys(a.value).forEach((T) => {
        y.addCustomControl(T, a.value[T]);
      }), w.value = i.value, M.value = n.value;
    }), $i(() => {
      window.removeEventListener("keydown", p);
    }), me(r, () => {
      v.normalizeRootFields(r.value);
    }), me(() => v.root, h, { deep: !0 }), me(s, () => {
      _.messages = s.value;
    });
    const C = b(() => S.value.length > 0);
    return (T, I) => (z(), re("section", sm, [
      D(o(na), {
        id: "root",
        list: S.value,
        "onUpdate:list": I[0] || (I[0] = (E) => S.value = E),
        group: "formbuilder",
        "item-key": "id",
        onAdd: o(v).onMoveFieldPositionToSubItem,
        onChange: o(v).onMoveFieldPosition
      }, vl({
        item: L(({ index: E }) => [
          D(ko, { index: E }, null, 8, ["index"])
        ]),
        _: 2
      }, [
        C.value ? void 0 : {
          name: "header",
          fn: L(() => [
            ee("p", null, J(o(u)("builder.builder.noItem")), 1)
          ]),
          key: "0"
        }
      ]), 1032, ["list", "onAdd", "onChange"]),
      ee("div", dm, [
        D(Yu),
        D(um, {
          onPreview: I[1] || (I[1] = (E) => t("preview", E)),
          onSave: I[2] || (I[2] = (E) => t("save", E))
        }, {
          default: L(() => [
            Sn(T.$slots, "actions", {}, void 0, !0)
          ]),
          _: 3
        })
      ])
    ]));
  }
});
const fm = /* @__PURE__ */ Oe(cm, [["__scopeId", "data-v-537c6312"]]), vm = { id: "usf_renderer" }, mm = { key: 0 }, pm = { key: 1 }, bm = /* @__PURE__ */ Ce({
  __name: "ReaderContainer",
  props: {
    autoCompletionIsActive: { type: Boolean, default: !1 },
    customComponents: { default: () => {
    } },
    fields: {},
    iconLibraryList: { default: () => [] },
    iconName: {},
    isHybridForm: { type: Boolean, default: !1 },
    isPreviewMode: { type: Boolean, default: !1 },
    isSubmitButtonDisabled: { type: Boolean, default: !1 },
    isSubmitButtonDisplayed: { type: Boolean, default: !0 },
    messages: {},
    radioEmitValue: { type: Boolean, default: !1 },
    selectEmitValue: { type: Boolean, default: !1 },
    selectOnlyArray: { type: Boolean, default: !1 },
    submitButtonColor: { default: "grey lighten-1" },
    submitButtonLoading: { type: Boolean, default: !1 },
    submitButtonText: { default: "" },
    submitButtonType: { default: "submit" },
    submittedData: { default: () => ({}) },
    templates: { default: () => ({}) },
    user: { default: () => ({}) }
  },
  emits: ["form-edition", "submit", "update:auto-completion-is-active", "update:submitted-data"],
  setup(e, { emit: t }) {
    const l = e, {
      autoCompletionIsActive: n,
      customComponents: a,
      fields: i,
      isHybridForm: r,
      messages: s,
      radioEmitValue: d,
      selectEmitValue: c,
      selectOnlyArray: u,
      submitButtonLoading: m,
      submitButtonText: p,
      submittedData: f,
      templates: _,
      user: v
    } = ct(l), y = Me("_uct"), M = Lt(), w = Ee(), S = st(), h = vn(), { componentsCustom: C } = ga();
    wt(() => {
      w.normalizeRootFields(i.value), M.isHybridForm = r.value, M.templates = _.value, M.radioEmitValue = d.value, M.selectEmitValue = c.value, M.selectOnlyArray = u.value, M.user = v.value, M.iconLibraryList = l.iconLibraryList ?? [], M.iconNameFn = l.iconName ?? null, S.messages = s.value, h.submission = f.value, C.value = a.value;
    }), me(i, () => {
      w.normalizeRootFields(i.value);
    }), me(r, () => {
      M.isHybridForm = r.value;
    }), me(_, () => {
      M.templates = _.value;
    }), me(s, () => {
      S.messages = s.value;
    }), me(() => h.submission, () => {
      t("update:submitted-data", h.submission);
    });
    const T = G(!1);
    me(m, async () => {
      var $;
      if (m.value) {
        T.value = !0;
        return;
      }
      T.value && (T.value = !1, await lt(), ($ = A.value) == null || $.resetValidation());
    });
    const I = b(() => !!Object.keys(M.user).length), E = b(() => w.root.map(($) => w.denormalizeField($))), A = G(), O = async () => {
      var $;
      ($ = A.value) == null || $.validate().then((k) => {
        k && t("submit", h.submission);
      });
    }, P = () => {
      M.autoCompletionIsActive = !n.value, t("update:auto-completion-is-active", M.autoCompletionIsActive);
    };
    return ($, k) => (z(), re("section", vm, [
      $.isPreviewMode ? (z(), ae(se, {
        key: 0,
        label: o(y)("renderer.edition.button"),
        color: "primary",
        onClick: k[0] || (k[0] = (g) => t("form-edition"))
      }, null, 8, ["label"])) : ce("", !0),
      D(mu, {
        ref_key: "form",
        ref: A,
        onSubmit: nl(O, ["prevent"])
      }, {
        default: L(() => [
          o(M).isHybridForm && !o(M).autoCompletionIsActive ? (z(), ae(se, {
            key: 0,
            color: "primary",
            onClick: P
          }, {
            default: L(() => [
              I.value ? (z(), re("span", mm, J(o(y)("renderer.autoCompletion.button")), 1)) : (z(), re("span", pm, J(o(y)("renderer.autoCompletion.connection")), 1))
            ]),
            _: 1
          })) : ce("", !0),
          (z(!0), re(Ve, null, dt(E.value, (g) => (z(), ae(Vn, {
            key: g.id,
            "editor-mode": !1,
            field: g
          }, null, 8, ["field"]))), 128)),
          $.isSubmitButtonDisplayed ? (z(), ae(se, {
            key: 1,
            color: $.submitButtonColor,
            disabled: $.isSubmitButtonDisabled,
            label: o(p) ?? o(y)("renderer.actions.submit"),
            loading: o(m),
            type: $.submitButtonType,
            block: ""
          }, null, 8, ["color", "disabled", "label", "loading", "type"])) : ce("", !0)
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]));
  }
});
const hm = /* @__PURE__ */ Oe(bm, [["__scopeId", "data-v-06c2d90d"]]), Di = {
  builder: {
    actionButtons: {
      collapse: "Réduire le champ",
      delete: "Supprimer le champ",
      duplicate: "Dupliquer le champ",
      duplicateDisabled: "Les lignes et les accordéons ne peuvent pas être dupliqués",
      expand: "Développer le champ",
      i18n: "Internationalisation",
      preview: "Visualisation",
      previewDisabled: "Vous ne pouvez pas visualiser un formulaire vide",
      previewInfo: "Si vous visualisez le formulaire, ce dernier sera enregistré dans son format actuel.",
      save: "Enregistrer",
      saveDisabled: "Vous ne pouvez pas enregistrer un formulaire vide",
      settings: "Ouvrir les paramètres du champ"
    },
    builder: {
      noItem: "Votre formulaire est vide. Glissez ici un élément de formulaire du menu de droite, pour commencer à construire votre formulaire."
    },
    controls: {
      fields: {
        checkboxSwitch: "Case à cocher & switch",
        column: "Colonne",
        content: "Texte enrichi",
        dateTime: "Date & Heure",
        file: "Fichier",
        panel: "Accordéon",
        radioGroup: "Groupe de boutons radio",
        row: "Ligne / Conteneur",
        select: "Liste d'options",
        text: "Texte",
        textArea: "Texte multiligne"
      },
      groups: {
        customs: "Champ(s) personnalisé(s)",
        inputs: "Champs",
        layouts: "Mise en page"
      }
    },
    delete: {
      dialog: {
        buttons: {
          cancel: "Annuler",
          delete: "Supprimer"
        },
        text: "Confirmez-vous la suppression de ce champ ?",
        title: "Supprimer un champ"
      },
      noDelete: {
        dependency: {
          conditional: "« Condition ».",
          dependsOn: "« Liste d'options imbriquée ».",
          middle: " de type ",
          start: "Dépendance au champ "
        },
        text: "Ce champ ne peut pas être supprimé, car il est utilisé dans une/des condition(s) ou dans une/des liste(s) d'options imbriquée(s).",
        title: "Impossible de supprimer ce champ"
      }
    },
    duplicate: {
      dialog: {
        buttons: {
          cancel: "Annuler",
          duplicate: "Dupliquer"
        },
        information: `Le mot-clé "copy" a été ajouté au nom du champ, pour plus de clarté lors de la soumission du formulaire vous pouvez modifier la valeur dans l'onglet "API".`,
        title: "Dupliquer un champ"
      }
    },
    settings: {
      form: "Internationalisation du formulaire"
    },
    tabs: {
      actions: {
        close: "Fermer"
      },
      api: {
        nameLabel: {
          error: "Ce champ est déjà utilisé dans le formulaire, veuillez en choisir un autre.",
          label: "Nom du champ",
          title: "Général"
        },
        protected: {
          title: "Administrateur",
          label: "Champ protégé"
        },
        switch: {
          title: "Commuter le champ",
          to: {
            select: "Passer en mode « Liste d'options »",
            radio: "Passer en mode « Groupe de boutons radio »"
          }
        }
      },
      conditional: {
        actions: {
          add: "Ajouter une nouvelle condition",
          cancel: "Annuler",
          cannotPaste: "Il n'y a pas de condition à coller.",
          copy: "Copier la condition",
          delete: "Supprimer la condition",
          paste: "Coller la condition",
          update: "Mettre à jour la condition",
          valid: "Valider"
        },
        emptyInformation: "Vide toutes les conditions pour ce type.",
        error: {
          format: "La condition n'a pas le bon format."
        },
        fieldSelection: {
          otherFields: "Les autres champs",
          user: "Données de l'utilisateur"
        },
        noValue: `Ce champ n'a pas de condition associée. Cliquer sur le bouton avec un "+" pour en ajouter une.`,
        operators: {
          and: "ET",
          or: "OU"
        },
        title: "Les conditions liées à ce champ",
        types: {
          error: "Vous devez sélectionner le type de condition",
          labelDisplayed: "Ce champ est affiché si...",
          labelExist: "Ce champ existe dans le DOM si...",
          labelRequired: "Ce champ est requis si...",
          label: "Type de condition"
        },
        valueLabels: {
          equal: "... la valeur est égale à...",
          in: "... la valeur est dans...",
          operator: "...opérateur..."
        }
      },
      core: {
        component: "composant"
      },
      data: {
        dataTable: {
          displayBy: {
            other: "autres",
            noDisplayed: "Jamais affiché",
            filter: "Filtrer"
          },
          headers: {
            actions: "Actions",
            defaultValue: "Par défaut",
            displayBy: "Affiché si...",
            label: "Libellé",
            userAttributeValue: "Valeur associée à l'utilisateur",
            value: "Valeur"
          }
        },
        dialogNewOption: {
          actions: {
            save: "Enregistrer"
          },
          autocompleteLabel: "Valeur auto-générée",
          label: "Libellé",
          title: "Nouvelle option",
          value: "Valeur"
        },
        dialogSort: {
          actions: {
            sort: "Trier"
          },
          title: "Trier les options",
          form: {
            direction: {
              label: "Direction",
              options: {
                asc: "Ascendant",
                desc: "Descendant"
              }
            },
            label: "Trier par"
          }
        },
        displayedBy: "Afficher par...",
        empty: {
          actions: {
            allRemove: "Tout supprimer"
          },
          information: "Confirmez-vous la suppression de toutes les options de ce champs ? Attention, cette action est irréversible.",
          title: "Supprimer toutes les options"
        },
        fileSystem: {
          emptyBefore: "Voulez-vous supprimer toutes les options pré-existantes de ce champ avant l'import ?",
          infoFormat: 'Les valeurs dans le CSV doivent être séparées par un ; et être entourées par des "',
          import: "Importer",
          myCSV: "Mon CSV",
          title: "Importer des options avec un fichier CSV",
          warning: "Attention ! Si vous importez des options avec un fichier CSV, les options actuelles seront supprimées."
        },
        filter: "Filtrer par...",
        localeRichText: {
          label: "Langue"
        },
        multiple: "Multiple",
        multipleTitle: "Sélection multiple",
        options: {
          APIOptions: {
            error: {
              arrayFormat: "Votre API doit renvoyer un tableau d'objet. Si nécessaire veuillez utiliser une clé dans l'API.",
              fieldEmpty: "Le champ ne peut pas être vide."
            },
            info: `Pour sélectionner les champs, cliquer sur le bouton "Label de l'option" ou "Valeur de l'option", puis cliquer sur le champ à sélectionner.`,
            inputLabel: "URL de l'API",
            keyInAPI: "Clé dans l'API",
            keyInAPIHint: `Ex: "user.data", si l'API renvoie un tableau laisser vide`,
            message: 'Attention passer au format "API" supprimera toutes les options actuelles et cette action est irréversible.',
            toggle: "Options chargées via une API",
            tree: {
              error: "Cette clé ne peut pas être sélectionnée, car elle n'est pas présente dans tous les objets ou elle est de type objet/tableau.",
              label: "Label de l'option",
              selectFirst: "Sélectionner d'abord le type de clé à utiliser",
              title: "Architecture de l'API",
              value: "Valeur de l'option"
            }
          },
          conditional: "Options conditionnels",
          dependsOn: "Dépend de...",
          search: "Rechercher dans les options",
          title: "Liste des options",
          tooltip: {
            noValue: "Pas d'info-bulle associée",
            tableHeader: "Info-bulle",
            toggle: "Ajouter des infos-bulles aux options"
          }
        },
        other: "Autre(s)",
        richText: {
          buttons: {
            close: "Fermer",
            delete: "Supprimer",
            save: "Enregistrer"
          },
          link: {
            hint: "Entrez le lien ici",
            titles: {
              add: "Ajouter un lien",
              update: "Modifier un lien"
            }
          }
        },
        richTextDefaultValue: "Entrez une nouvelle valeur ici.",
        selectAll: "Tout sélectionner",
        uniqueValue: "Valeur unique"
      },
      display: {
        accordion: {
          add: "Ajouter un Panneau",
          dialog: {
            label: "Titre du panneau",
            title: "Ajouter un nouveau panneau à l'accordéon"
          },
          empty: "Panneau vide",
          label: "Entête n°{num}",
          style: "Mode accordéon",
          title: "Entêtes"
        },
        content: {
          content: "Titre du panneau",
          fieldset: "Titre du cadre",
          hint: "Message d'information",
          hintPersistent: "Le message d'information reste toujours visible",
          label: "Libellé",
          placeholder: "Valeur exemple",
          prefix: "Préfixe",
          suffix: "Suffixe",
          title: "Contenu",
          tooltip: "Info-bulle",
          tooltipTitle: `Ces données sont liées aux valeurs dans l'onglet "Internationalisation" pour la langue par défaut.`
        },
        icon: {
          labels: {
            prepend: "Icône avant",
            append: "Icône après"
          },
          information: {
            material: "Material Design Icons",
            text: "Pour les icônes, copier le nom de cette dernière dans le champ souhaité. Vous pouvez utiliser la ou les librairie(s) suivante(s) :",
            unistra: "Icônes Unistra"
          },
          title: "Icônes"
        },
        layout: {
          add: {
            row: "Ajouter une ligne",
            column: "Ajouter une colonne"
          },
          content: {
            name: {
              columns: "Contenu de la colonne",
              rows: "Contenu de la ligne"
            },
            title: {
              columns: "Colonnes",
              rows: "Lignes"
            }
          },
          columns: "Colonnes",
          dialog: {
            actions: {
              add: "Ajouter",
              cancel: "Annuler"
            },
            title: "Ajouter une colonne"
          },
          empty: {
            columns: "Colonne vide",
            rows: "Ligne vide"
          },
          fieldset: {
            buttonLabel: "Ajouter un cadre",
            fieldsetText: "Titre du cadre",
            title: "Cadre"
          },
          maxSize: {
            cannotAdd: "Impossible d'ajouter une nouvelle colonne avec cette valeur, la somme de toute les tailles ne doit pas dépasser 12.",
            cannotOpenAdd: "Impossible d'ajouter une nouvelle colonne, la somme de toute les tailles ne doit pas dépasser 12.",
            cannotUpdate: "Impossible de modifier la taille de cette colonne, la somme de toute les tailles ne doit pas dépasser 12."
          },
          maxColumns: "Impossible d'ajouter une nouvelle colonne, la somme de toute les tailles ne doit pas dépasser 12.",
          type: {
            selectLabel: "Type de conteneur",
            title: "Style",
            types: {
              container: "Conteneur",
              row: "Ligne"
            }
          },
          width: "Largeur de la colonne"
        },
        repeatable: {
          disabled: "Un champ contenu dans une ligne ou un conteneur répétable ne peut pas l'être.",
          errors: {
            defaultMustBeNumeric: "Le nombre de répétition par défaut doit être un nombre",
            defaultMustBeInt: "Le nombre de répétition par défaut doit être un nombre entier",
            defaultMustBeAboveZero: "Le nombre de répétition par défaut doit être supérieur à 0",
            defaultMustBeBelowMaxRepeat: "Le nombre de répétition par défaut doit être inférieur ou égal à la valeur max : {maxRepeat}",
            mustBeNumeric: "Le nombre de répétition doit être un nombre",
            mustBeInt: "Le nombre de répétition doit être un nombre entier",
            mustBeAboveZero: "Le nombre de répétition doit être supérieur à 0"
          },
          initial: "Répétition initiale",
          interdependentFields: "Les valeurs de ce champ seront interdépendantes",
          maxRepeatIsOptionNumber: "Le nombre de répétition maximum doit être égal au nombre d'options",
          max: "Nombre maximal de champs",
          repeatable: "Ce champ est répétable",
          title: "Répétable",
          tooltips: {
            repeatMin: "Vous ne pouvez pas indiquer une valeur inférieure à 1",
            defaultRepeatMax: "Vous ne pouvez pas indiquer une valeur supérieure à la valeur de répétition max",
            defaultRepeatMin: "Vous ne pouvez pas indiquer une valeur inférieure à 0"
          }
        },
        style: {
          horizontal: "Horizontal",
          options: {
            autoGrow: "Taille automatique",
            chips: "Mode puce",
            clearable: "Effaçable",
            filled: "Fond plein",
            filterable: "Filtrable",
            outlined: "Avec bordure",
            rounded: "Arrondi",
            rows: "Nombre de ligne"
          },
          style: "Style prédéfini",
          title: "Style",
          type: "Type de composant",
          wysiwyg: {
            bold: "Gras",
            center: "Centrer",
            fontSize: "Taille de police",
            formatting: "Formatage",
            hr: "Ligne horizontale",
            indent: "Augmenter l'indentation",
            italic: "Italique",
            justify: "Justifier",
            left: "Aligner à gauche",
            link: "Lien",
            ordered: "Liste ordonnée",
            outdent: "Diminuer l'indentation",
            quote: "Citation",
            redo: "Rétablir",
            removeFormat: "Supprimer le formatage",
            right: "Aligner à droite",
            strike: "Barré",
            subscript: "Indice",
            superscript: "Exposant",
            undo: "Annuler",
            unordered: "Liste non ordonnée"
          }
        },
        type: {
          checkbox: "Case à cocher",
          birthday: "Anniversaire",
          date: "Date",
          email: "Email",
          number: "Nombre",
          password: "Mot de passe",
          standard: "Standard",
          switch: 'Bouton "On/Off"',
          tel: "Téléphone",
          text: "Texte",
          textarea: "Textearea",
          time: "Heure",
          url: "URL",
          wysiwyg: "Texte enrichi"
        },
        visibility: {
          exist: "Ce champ existe dans le DOM",
          title: "Visibilité",
          visible: "Ce champ est visible"
        }
      },
      error: {
        message: "Veuillez contacter le responsable d'application pour plus d'informations.",
        title: "Une erreur est survenue pour cet onglet"
      },
      internationalization: {
        buttonAdd: "Ajouter",
        dataTable: {
          noTextMessage: "Pas de langage créer. Rendez-vous dans les options de ce formulaire pour en ajouter un.",
          headers: {
            attribute: "Attributs",
            delete: "Supprimer",
            fallback: "Langue par défaut",
            locale: "Langues",
            rtl: "RTL",
            translation: "Traduction"
          }
        },
        localeName: "Initiales de la langue",
        noValue: "Cliquer ici pour ajouter une traduction",
        removeDisabled: "Vous ne pouvez pas supprimer la langue par défaut",
        removeMessage: "Confirmez-vous la suppression de cette langue ?",
        rtlHelp: "RTL = Right To Left = pour les langues qui s'écrivent de droite à gauche",
        title: "Ajouter une langue"
      },
      names: {
        api: "Paramètres",
        conditional: "Conditions",
        data: "Données",
        display: "Affichage",
        internationalization: "Internationalisation",
        validation: "Validation"
      },
      validation: {
        customRules: "Règles personnalisées",
        date: {
          days: "Jour(s)",
          isRelativeValidationDate: "Date de validation relative",
          list: {
            title: "Liste de dates autorisées"
          },
          months: "Mois",
          multiple: "L'utilisateur peut saisir plusieurs dates ou plusieurs périodes",
          period: "Sélection d'une période",
          title: "Validation des dates",
          weeks: "Semaine(s)",
          years: "Année(s)"
        },
        defaultValue: "Valeur par défaut",
        fieldSize: "Taille du champ",
        fileSize: {
          max: "Taille de fichier maximale",
          title: "Taille du fichier",
          units: {
            GB: "Go",
            MB: "Mo",
            kB: "Ko"
          }
        },
        fileType: {
          isCustomList: "Liste personnalisée",
          title: "Type de fichier",
          types: {
            all: "Tous",
            audio: "Audio",
            file: "Fichier",
            image: "Image",
            video: "Vidéo"
          }
        },
        futureLabel: "dans le futur",
        mask: {
          banner: {
            core: "Pour créer le masque, vous pouvez utiliser les caractères suivants :",
            example: "N° de téléphone : +(##) # ## ## ## ##",
            table: {
              descriptions: {
                alpha: "Lettre majuscule ou minuscule",
                alphanumeric: "Lettre majuscule ou minuscule, ou chiffre",
                alphanumericLower: "Lettre minuscule, ou chiffre",
                alphanumericUpper: "Lettre majuscule, ou chiffre",
                lowercase: "Lettre minuscule",
                numeric: "Chiffre",
                uppercase: "Lettre majuscule"
              },
              headers: {
                description: "Description",
                token: "Caractère"
              }
            },
            warning: "Attention, le masque ne marche pas avec les lettres accentuées."
          },
          filling: "Afficher comme aide au remplissage",
          modelUnmasked: {
            hint: 'Valeur non masquée exemple : masque = +(##) # ## ## ## ##", valeur renvoyée = 33388888888"',
            label: "Valeur non masquée"
          },
          title: "Masque de saisie"
        },
        maxValue: "Valeur maximale",
        maximum: "Maximum",
        minValue: "Valeur minimale",
        minimum: "Minimum",
        required: {
          label: "Champ requis",
          title: "Status"
        },
        step: "Valeur d'incrémentation",
        tokenField: {
          selectLabel: "Champ du token associé",
          switchLabel: "La valeur de ce champ est associée au token.",
          title: "Valeur par défaut"
        },
        unit: "Unité"
      }
    }
  },
  core: {
    buttons: {
      cancel: "Annuler",
      close: "Fermer",
      delete: "Supprimer",
      valid: "Valider"
    }
  },
  renderer: {
    actions: {
      submit: "Valider"
    },
    autoCompletion: {
      button: "Préremplir le formulaire",
      connection: "Me connecter pour préremplir le formulaire"
    },
    edition: {
      button: "Éditer le formulaire"
    },
    fields: {
      UsfAccordion: {
        noItem: "Votre panneau ne contient aucun élément. Glissez ici un élément du menu de Droite."
      },
      UsfCol: {
        noItem: "Votre colonne est vide. Glissez ici un élément du menu de droite."
      },
      UsfDateHour: {
        date: {
          placeholder: "Format: JJ/MM/AAAA"
        },
        errors: {
          max: "La date doit être inférieure ou égale à la date du {max}",
          min: "La date doit être supérieure ou égale à la date du {min}"
        },
        hour: {
          placeholder: "Format: HH:MM"
        }
      },
      UsfFile: {
        errors: {
          max: "Le poids du fichier doit être inférieur ou égal à {max}"
        }
      },
      UsfSelect: {
        noOption: "Le formulaire ne contient aucune option car il dépend du champ : "
      },
      UsfText: {
        errors: {
          emailFormat: "Veuillez saisir une adresse électronique valide",
          numberFormat: "La valeur doit être un nombre",
          numberMax: "Ce champ doit être inférieur ou égal à {max}",
          numberMin: "Ce champ doit être supérieur ou égal à {min}",
          textMax: "Ce champ doit comporter {max} caractères ou moins",
          textMin: "Ce champ doit comporter {min} caractères ou plus",
          urlFormat: "Veuillez saisir une URL valide"
        }
      },
      core: {
        errors: {
          required: "Ce champ est requis"
        }
      }
    }
  }
};
var pu = { exports: {} };
(function(e, t) {
  (function(l, n) {
    e.exports = n();
  })(ru, function() {
    var l = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, n = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, a = /\d\d/, i = /\d\d?/, r = /\d*[^-_:/,()\s\d]+/, s = {}, d = function(v) {
      return (v = +v) + (v > 68 ? 1900 : 2e3);
    }, c = function(v) {
      return function(y) {
        this[v] = +y;
      };
    }, u = [/[+-]\d\d:?(\d\d)?|Z/, function(v) {
      (this.zone || (this.zone = {})).offset = function(y) {
        if (!y || y === "Z")
          return 0;
        var M = y.match(/([+-]|\d\d)/g), w = 60 * M[1] + (+M[2] || 0);
        return w === 0 ? 0 : M[0] === "+" ? -w : w;
      }(v);
    }], m = function(v) {
      var y = s[v];
      return y && (y.indexOf ? y : y.s.concat(y.f));
    }, p = function(v, y) {
      var M, w = s.meridiem;
      if (w) {
        for (var S = 1; S <= 24; S += 1)
          if (v.indexOf(w(S, 0, y)) > -1) {
            M = S > 12;
            break;
          }
      } else
        M = v === (y ? "pm" : "PM");
      return M;
    }, f = { A: [r, function(v) {
      this.afternoon = p(v, !1);
    }], a: [r, function(v) {
      this.afternoon = p(v, !0);
    }], S: [/\d/, function(v) {
      this.milliseconds = 100 * +v;
    }], SS: [a, function(v) {
      this.milliseconds = 10 * +v;
    }], SSS: [/\d{3}/, function(v) {
      this.milliseconds = +v;
    }], s: [i, c("seconds")], ss: [i, c("seconds")], m: [i, c("minutes")], mm: [i, c("minutes")], H: [i, c("hours")], h: [i, c("hours")], HH: [i, c("hours")], hh: [i, c("hours")], D: [i, c("day")], DD: [a, c("day")], Do: [r, function(v) {
      var y = s.ordinal, M = v.match(/\d+/);
      if (this.day = M[0], y)
        for (var w = 1; w <= 31; w += 1)
          y(w).replace(/\[|\]/g, "") === v && (this.day = w);
    }], M: [i, c("month")], MM: [a, c("month")], MMM: [r, function(v) {
      var y = m("months"), M = (m("monthsShort") || y.map(function(w) {
        return w.slice(0, 3);
      })).indexOf(v) + 1;
      if (M < 1)
        throw new Error();
      this.month = M % 12 || M;
    }], MMMM: [r, function(v) {
      var y = m("months").indexOf(v) + 1;
      if (y < 1)
        throw new Error();
      this.month = y % 12 || y;
    }], Y: [/[+-]?\d+/, c("year")], YY: [a, function(v) {
      this.year = d(v);
    }], YYYY: [/\d{4}/, c("year")], Z: u, ZZ: u };
    function _(v) {
      var y, M;
      y = v, M = s && s.formats;
      for (var w = (v = y.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(A, O, P) {
        var $ = P && P.toUpperCase();
        return O || M[P] || l[P] || M[$].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(k, g, x) {
          return g || x.slice(1);
        });
      })).match(n), S = w.length, h = 0; h < S; h += 1) {
        var C = w[h], T = f[C], I = T && T[0], E = T && T[1];
        w[h] = E ? { regex: I, parser: E } : C.replace(/^\[|\]$/g, "");
      }
      return function(A) {
        for (var O = {}, P = 0, $ = 0; P < S; P += 1) {
          var k = w[P];
          if (typeof k == "string")
            $ += k.length;
          else {
            var g = k.regex, x = k.parser, B = A.slice($), q = g.exec(B)[0];
            x.call(O, q), A = A.replace(q, "");
          }
        }
        return function(Y) {
          var K = Y.afternoon;
          if (K !== void 0) {
            var Q = Y.hours;
            K ? Q < 12 && (Y.hours += 12) : Q === 12 && (Y.hours = 0), delete Y.afternoon;
          }
        }(O), O;
      };
    }
    return function(v, y, M) {
      M.p.customParseFormat = !0, v && v.parseTwoDigitYear && (d = v.parseTwoDigitYear);
      var w = y.prototype, S = w.parse;
      w.parse = function(h) {
        var C = h.date, T = h.utc, I = h.args;
        this.$u = T;
        var E = I[1];
        if (typeof E == "string") {
          var A = I[2] === !0, O = I[3] === !0, P = A || O, $ = I[2];
          O && ($ = I[2]), s = this.$locale(), !A && $ && (s = M.Ls[$]), this.$d = function(B, q, Y) {
            try {
              if (["x", "X"].indexOf(q) > -1)
                return new Date((q === "X" ? 1e3 : 1) * B);
              var K = _(q)(B), Q = K.year, W = K.month, H = K.day, R = K.hours, ie = K.minutes, te = K.seconds, oe = K.milliseconds, fe = K.zone, Z = /* @__PURE__ */ new Date(), j = H || (Q || W ? 1 : Z.getDate()), he = Q || Z.getFullYear(), we = 0;
              Q && !W || (we = W > 0 ? W - 1 : Z.getMonth());
              var Ie = R || 0, ot = ie || 0, St = te || 0, xt = oe || 0;
              return fe ? new Date(Date.UTC(he, we, j, Ie, ot, St, xt + 60 * fe.offset * 1e3)) : Y ? new Date(Date.UTC(he, we, j, Ie, ot, St, xt)) : new Date(he, we, j, Ie, ot, St, xt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(C, E, T), this.init(), $ && $ !== !0 && (this.$L = this.locale($).$L), P && C != this.format(E) && (this.$d = /* @__PURE__ */ new Date("")), s = {};
        } else if (E instanceof Array)
          for (var k = E.length, g = 1; g <= k; g += 1) {
            I[1] = E[g - 1];
            var x = M.apply(this, I);
            if (x.isValid()) {
              this.$d = x.$d, this.$L = x.$L, this.init();
              break;
            }
            g === k && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          S.call(this, h);
      };
    };
  });
})(pu);
var gm = pu.exports;
const ym = /* @__PURE__ */ uu(gm);
ut.extend(ym);
const km = {
  install: (e, t) => {
    e.component("UsfBuilder", fm), e.component("UsfRenderer", hm), e.component("UsfSettingsDialog", xo);
    const l = vn();
    e.provide("resetSubmission", l.$reset);
    const n = { fr: Di }, a = (t == null ? void 0 : t.locale) || "fr";
    e.provide("defaultLocale", a), ut.locale(a);
    const i = (r, s = {}) => {
      const d = (u) => {
        if (typeof u == "string") {
          const m = u.match(/{(?<options>\S*)}/g);
          if (m)
            for (const p of m)
              u = u.replace(
                new RegExp(p, "g"),
                s[p.split(/[{|}]/)[1]]
              );
        }
        return u;
      }, c = (u) => r.split(".").reduce((m, p) => {
        if (typeof m == "string")
          return m;
        let f = m[p];
        if (f === void 0)
          throw Error();
        return f = d(f), f;
      }, u);
      try {
        return c(n[a]);
      } catch {
        try {
          return c(Di);
        } catch {
          return r;
        }
      }
    };
    e.provide("_uct", i), e.provide("locale", a);
  }
};
export {
  km as FormbuilderPlugin,
  fm as UsfBuilder,
  ko as UsfGenericItem,
  hm as UsfRenderer,
  xo as UsfSettingsDialog,
  zt as useFieldReader,
  Ee as useFormStore,
  Ul as useRules,
  Ke as useSettingDialog,
  vn as useSubmissionStore
};
